import React from 'react'

import { IconBase, type IconBaseProps } from './IconBase'
import { makeIcon } from './makeIcon'
import {
  AddReactionSmallIcon,
  AIGeneratedDirectorySmallIcon,
  ApplyFormatSmallIcon,
  ArchiveSmallIcon,
  ArobaseSmallIcon,
  ArrowBottomSmallIcon,
  ArrowTopSmallIcon,
  AttachmentSmallIcon,
  AudioSmallIcon,
  BackArrowSmallIcon,
  BlockCodeSmallIcon,
  BoldSmallIcon,
  BucketSmallIcon,
  BulletListSmallIcon,
  CalendarSmallIcon,
  CaretDownSmallIcon,
  ChannelAddSmallIcon,
  ChannelSmallIcon,
  CheckboxSmallIcon,
  CheckmarkSmallIcon,
  ChevronDownSmallIcon,
  ChevronLeftSmallIcon,
  ChevronRightSmallIcon,
  ChevronUpSmallIcon,
  CircleDashedSmallIcon,
  CircledCrossFilledSmallIcon,
  CirclularArrowsSmallIcon,
  ClockFilledSmallIcon,
  ClockSmallIcon,
  CloseSmallIcon,
  CollapsedBlockSmallIcon,
  CollectionBoardSmallIcon,
  CollectionLinkSmallIcon,
  CollectionSmallIcon,
  CollectionTableSmallIcon,
  CommentsAddSmallIcon,
  CommentsEmptySmallIcon,
  CommentsFullSmallIcon,
  CommentsSmallIcon,
  CreateNoteSmallIcon,
  DeleteSmallIcon,
  DiagramSmallIcon,
  DirectorySmallIcon,
  DiscussionDecisionSmallIcon,
  DiscussionOpenSmallIcon,
  DiscussionSmallIcon,
  DocCardSmallIcon,
  DuplicateSmallIcon,
  EmbedSmallIcon,
  EmojiSmallIcon,
  EraserSmallIcon,
  ExpandSmallIcon,
  ExpandTwoCornersSmallIcon,
  ExternalLinkSmallIcon,
  EyeCrossedSmallIcon,
  EyeSmallIcon,
  FilterSmallIcon,
  FilterSortAscSmallIcon,
  FilterSortDescSmallIcon,
  FormatSmallIcon,
  GlobeSmallIcon,
  GlobeStrikedThroughSmallIcon,
  GrabSmallIcon,
  HeaderFourSmallIcon,
  HeaderOneSmallIcon,
  HeaderThreeSmallIcon,
  HeaderTwoSmallIcon,
  HighlightSmallIcon,
  IdCodeSmallIcon,
  ImageSmallIcon,
  InfoSmallIcon,
  InlineCodeSmallIcon,
  InviteSmallIcon,
  ItalicSmallIcon,
  LinkSmallIcon,
  LockSmallIcon,
  MagicPenSmallIcon,
  MathSmallIcon,
  MentionSmallIcon,
  MinimizeSmallIcon,
  MoreSmallIcon,
  NoteSmallIcon,
  NumberSmallIcon,
  OrderedListSmallIcon,
  OutlineSmallIcon,
  PenSmallIcon,
  PeopleSmallIcon,
  PianoSmallIcon,
  PlaceholderSmallIcon,
  PlusSmallIcon,
  QuoteSmallIcon,
  RecycleSmallIcon,
  ReduceTwoCornersSmallIcon,
  RequestVerificationSmallIcon,
  ScissorsSmallIcon,
  SearchSmallIcon,
  SeparatorSmallIcon,
  SettingsSmallIcon,
  SortingSmallIcon,
  SpellcheckSmallIcon,
  StrikethroughSmallIcon,
  SubscriptSmallIcon,
  SuccessCircledSmallIcon,
  SuccessFilledSmallIcon,
  SuperscriptSmallIcon,
  TableSmallIcon,
  TagSmallIcon,
  TagsSmallIcon,
  TextPlaceholderSmallIcon,
  TextSmallIcon,
  TranslateSmallIcon,
  TwoPeopleSmallIcon,
  UnderlineSmallIcon,
  UserAddSmallIcon,
  UserGroupSmallIcon,
  VideoSmallIcon,
  WarningSmallIcon,
} from './SmallCoreIcons'

export const SliteAgentIcon = makeIcon({
  displayName: 'SliteAgentIcon',
  viewBox: 34,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9117 3.18943C26.8664 2.72975 30.5964 3.61277 32.6558 6.43162C34.1456 8.47142 34.4038 11.0585 33.8101 13.6855C33.2175 16.3067 31.7645 19.0615 29.6792 21.6367C29.1463 22.2945 28.1945 22.4312 27.5533 21.9433C26.9122 21.4553 26.8252 20.5261 27.3579 19.8681C29.2145 17.5751 30.3994 15.2514 30.8638 13.1982C31.3265 11.1515 31.0596 9.46693 30.1695 8.24802C28.9485 6.57673 26.4931 5.74131 23.1011 6.13572C19.7444 6.52619 15.7486 8.1118 11.9702 10.872C8.19169 13.6326 5.46623 16.9578 4.07376 20.0371C2.66682 23.1486 2.71508 25.7418 3.93606 27.4131C5.59473 29.6826 9.60545 30.3924 14.8062 28.6494C15.6075 28.3814 16.4439 28.7908 16.6734 29.5644C16.9025 30.338 16.4382 31.1832 15.6372 31.4521C10.0399 33.328 4.24557 33.0537 1.45071 29.2295C-0.608775 26.4104 -0.314774 22.588 1.32571 18.9599C2.98077 15.3 6.10468 11.5585 10.2564 8.52537C14.408 5.4925 18.9219 3.65341 22.9117 3.18943ZM20.8472 25.7178C21.7708 25.7178 22.52 26.466 22.5201 27.3896C22.5201 28.3133 21.7709 29.0625 20.8472 29.0625C19.9235 29.0625 19.1743 28.3133 19.1743 27.3896C19.1744 26.466 19.9236 25.7178 20.8472 25.7178ZM25.3072 22.4785C26.2308 22.4785 26.98 23.2277 26.98 24.1513C26.98 25.075 26.2308 25.8242 25.3072 25.8242C24.3835 25.8242 23.6343 25.075 23.6343 24.1513C23.6343 23.2277 24.3835 22.4785 25.3072 22.4785Z"
    />
  ),
})

export const AppsIcon = makeIcon({
  displayName: 'AppsIcon',
  content: (
    <path d="M7.99619 9.23077C7.68385 9.23077 7.38674 9.11956 6.9906 8.89713L1.40655 5.74606C0.781869 5.39018 0.5 5.08619 0.5 4.61168C0.5 4.14458 0.781869 3.83318 1.40655 3.47729L6.9906 0.326228C7.38674 0.111214 7.68385 0 7.99619 0C8.31615 0 8.61326 0.111214 9.00178 0.326228L14.5934 3.47729C15.2105 3.83318 15.4924 4.14458 15.4924 4.61168C15.4924 5.08619 15.2105 5.39018 14.5934 5.74606L9.00178 8.89713C8.61326 9.11956 8.31615 9.23077 7.99619 9.23077ZM7.99619 7.65894C8.08761 7.65894 8.17141 7.62929 8.28568 7.56997L13.5041 4.67841C13.5345 4.66358 13.5574 4.64133 13.5574 4.61168C13.5574 4.58202 13.5345 4.55978 13.5041 4.54495L8.28568 1.65338C8.17141 1.59407 8.08761 1.56441 7.99619 1.56441C7.90477 1.56441 7.82098 1.59407 7.71432 1.65338L2.48832 4.54495C2.45785 4.55978 2.44261 4.58202 2.44261 4.61168C2.44261 4.64133 2.45785 4.66358 2.48832 4.67841L7.71432 7.56997C7.82098 7.62929 7.90477 7.65894 7.99619 7.65894ZM7.99619 12.7081C7.7067 12.7081 7.44769 12.582 7.08964 12.3744L1.08659 8.9342C0.705688 8.71918 0.5 8.42261 0.5 8.08156C0.5 7.71826 0.728542 7.43652 1.00279 7.2734L7.53149 10.9657C7.71432 11.0695 7.85907 11.1362 7.99619 11.1362C8.14093 11.1362 8.27806 11.0695 8.46851 10.9657L14.9972 7.2734C15.2638 7.43652 15.5 7.71826 15.5 8.08156C15.5 8.42261 15.2943 8.71177 14.9134 8.9342L8.90274 12.3744C8.54469 12.582 8.2933 12.7081 7.99619 12.7081ZM7.99619 16C7.7067 16 7.44769 15.874 7.08964 15.6664L1.08659 12.2261C0.705688 12.0111 0.5 11.7146 0.5 11.3735C0.5 11.0102 0.728542 10.7285 1.00279 10.5653L7.53149 14.2576C7.71432 14.3614 7.85907 14.4282 7.99619 14.4282C8.14093 14.4282 8.27806 14.3614 8.46851 14.2576L14.9972 10.5653C15.2638 10.7285 15.5 11.0102 15.5 11.3735C15.5 11.7146 15.2943 12.0111 14.9134 12.2261L8.90274 15.6664C8.54469 15.874 8.2933 16 7.99619 16Z" />
  ),
})

export const HourglassIcon = makeIcon({
  displayName: 'HourglassIcon',
  content: (
    <path d="M5.16614 13.4392H10.8339L11.086 11.4303C11.086 10.6866 10.8092 10.0515 10.2556 9.52499C9.70195 8.99852 8.78204 8.73529 8 8.73529C7.21796 8.73529 6.20665 8.99852 5.65304 9.52499C5.09945 10.0515 4.82265 10.6866 4.82265 11.4303L5.16614 13.4392ZM8 7.26473C8.78204 7.26473 9.70195 7.0015 10.2556 6.47503C10.8092 5.94855 11.0859 5.31345 11.0859 4.56973L10.8339 2.56079H5.16614L4.92099 3.56526L4.82265 4.56973C4.82265 5.31345 5.09945 5.94855 5.65304 6.47503C6.20665 7.0015 7.21796 7.26473 8 7.26473ZM1.82062 15C1.59033 15 1.39599 14.9247 1.23759 14.7741C1.0792 14.6234 1 14.4386 1 14.2196C1 14.0006 1.0792 13.8158 1.23759 13.6652C1.39599 13.5145 1.59033 13.4392 1.82062 13.4392L3.44345 13.4392L3.18144 11.4303C3.18144 10.7437 3.34486 10.096 3.67172 9.48696C3.99858 8.87797 4.79915 8.38231 5.38647 8.00001C4.79915 7.6177 3.99858 7.12205 3.67172 6.51305C3.34486 5.90405 3.18144 5.24746 3.18144 4.56973L3.41016 2.56079L1.82062 2.56079C1.59033 2.56079 1.39599 2.48547 1.23759 2.33484C1.0792 2.1842 1 1.99939 1 1.7804C1 1.5614 1.0792 1.37659 1.23759 1.22595C1.39599 1.07532 1.59033 1 1.82062 1H14.1794C14.4097 1 14.604 1.07532 14.7624 1.22595C14.9208 1.37659 15 1.5614 15 1.7804C15 1.99939 14.9208 2.1842 14.7624 2.33484C14.604 2.48547 14.4097 2.56079 14.1794 2.56079L12.5 2.56079L12.7272 4.56973C12.7272 5.26953 12.5645 5.90405 12.239 6.51305C11.9136 7.12205 11.2037 7.6177 10.6135 8.00001C11.2037 8.38231 11.9136 8.87797 12.239 9.48696C12.5645 10.096 12.7272 10.7437 12.7272 11.4303L12.5582 13.4392L14.1794 13.4392C14.4097 13.4392 14.604 13.5145 14.7624 13.6652C14.9208 13.8158 15 14.0006 15 14.2196C15 14.4386 14.9208 14.6234 14.7624 14.7741C14.604 14.9247 14.4097 15 14.1794 15H1.82062Z" />
  ),
})

export const NoteRemoveIcon = makeIcon({
  displayName: 'NoteRemoveIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.75C2 1.50736 3.00736 0.5 4.25 0.5H7.25C7.66421 0.5 8 0.835786 8 1.25C8 1.66421 7.66421 2 7.25 2H4.25C3.83579 2 3.5 2.33579 3.5 2.75V13.25C3.5 13.6642 3.83579 14 4.25 14H11.75C12.1642 14 12.5 13.6642 12.5 13.25V7.75C12.5 7.33579 12.8358 7 13.25 7C13.6642 7 14 7.33579 14 7.75V13.25C14 14.4926 12.9926 15.5 11.75 15.5H4.25C3.00736 15.5 2 14.4926 2 13.25V2.75ZM14.3943 0.798097C14.6872 1.09099 14.6872 1.56586 14.3943 1.85876L13.1569 3.09619L14.3943 4.33363C14.6872 4.62652 14.6872 5.1014 14.3943 5.39429C14.1014 5.68718 13.6265 5.68718 13.3336 5.39429L12.0962 4.15685L10.8588 5.39429C10.5659 5.68718 10.091 5.68718 9.79809 5.39429C9.5052 5.1014 9.5052 4.62652 9.79809 4.33363L11.0355 3.09619L9.79809 1.85876C9.5052 1.56586 9.5052 1.09099 9.79809 0.798097C10.091 0.505203 10.5659 0.505204 10.8588 0.798097L12.0962 2.03553L13.3336 0.798097C13.6265 0.505204 14.1014 0.505204 14.3943 0.798097Z"
    />
  ),
})

export const ReferralIcon = makeIcon({
  displayName: 'ReferralIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49802 7.123C8.38379 7.24273 8.23417 7.3001 8.05914 7.3001C7.89136 7.3001 7.74573 7.24112 7.62851 7.1239C7.5106 7.00599 7.45232 6.85757 7.45232 6.68593V6.41687C7.24695 6.39461 7.06044 6.35978 6.89316 6.31199C6.6506 6.24269 6.44969 6.17259 6.29185 6.10131C6.14746 6.03466 6.03743 5.93643 5.9718 5.80515L5.97014 5.80184C5.9144 5.67921 5.8915 5.55182 5.90285 5.42124L5.90323 5.41695C5.92015 5.28723 5.96842 5.1685 6.04684 5.06208C6.12797 4.95198 6.23443 4.87735 6.36408 4.84167C6.50604 4.79892 6.66055 4.82063 6.82083 4.89008L6.82948 4.89383C6.9179 4.94246 7.05615 4.99663 7.2491 5.05457C7.43851 5.1052 7.67601 5.13158 7.96365 5.13158C8.16468 5.13158 8.314 5.11222 8.41681 5.07795L8.41796 5.07757C8.53168 5.04117 8.59511 4.99809 8.62626 4.95759L8.62688 4.95678C8.66856 4.90374 8.68632 4.85162 8.68632 4.79821C8.68632 4.7434 8.67211 4.70535 8.64947 4.67705L8.6427 4.66858C8.62213 4.63626 8.58197 4.59998 8.50869 4.5655L8.50443 4.5635C8.43209 4.5252 8.3267 4.48839 8.18428 4.4551L7.35401 4.27876C6.88695 4.1733 6.52569 3.99492 6.28214 3.73549L6.2807 3.73396C6.041 3.46762 5.92451 3.12649 5.92451 2.71951C5.92451 2.40882 5.99984 2.12835 6.15242 1.88106C6.30882 1.63083 6.52502 1.42809 6.79792 1.27362C6.99418 1.16458 7.21302 1.0841 7.45232 1.03224V0.714263C7.45232 0.542623 7.5106 0.394208 7.62851 0.276292C7.74573 0.159077 7.89136 0.100098 8.05914 0.100098C8.23078 0.100098 8.3792 0.158376 8.49711 0.276292C8.61503 0.394208 8.67331 0.542623 8.67331 0.714263V0.997963C8.77278 1.0143 8.8752 1.03687 8.98055 1.06557C9.20248 1.12114 9.39936 1.19989 9.56998 1.30288C9.69804 1.37037 9.7929 1.46615 9.84701 1.59118C9.903 1.70955 9.92354 1.83313 9.90666 1.95977C9.89462 2.08198 9.84762 2.19251 9.76811 2.28957C9.68949 2.39168 9.58165 2.45889 9.45059 2.49308L9.44753 2.49388C9.31171 2.52475 9.15948 2.49776 8.99738 2.42978L8.99618 2.42927C8.89087 2.38349 8.77029 2.34619 8.63384 2.31796L8.62983 2.31713C8.50364 2.28558 8.33632 2.26862 8.12525 2.26862C7.87609 2.26862 7.69765 2.31354 7.57842 2.39138C7.46512 2.46849 7.41727 2.55921 7.41727 2.66809C7.41727 2.73422 7.44172 2.79001 7.49814 2.84036C7.56389 2.8894 7.69408 2.94129 7.90466 2.98918L8.74163 3.17272C9.21756 3.27793 9.58218 3.45601 9.82148 3.71614C10.0669 3.97264 10.1864 4.30466 10.1864 4.70272C10.1864 5.01339 10.1111 5.2918 9.958 5.53464C9.80631 5.77526 9.59519 5.96999 9.32753 6.11933C9.13212 6.2304 8.91378 6.31221 8.67331 6.36554V6.68593C8.67331 6.85713 8.61533 7.00523 8.49802 7.123ZM6.14398 8.72408C4.48714 7.90229 2.47712 8.47132 1.49692 10.0396L0.36398 11.8523C0.144447 12.2036 0.251227 12.6663 0.602479 12.8858C0.953732 13.1054 1.41644 12.9986 1.63598 12.6473L2.76892 10.8346C3.34023 9.92054 4.51177 9.58888 5.47746 10.0679C5.71605 10.1862 5.98093 10.2416 6.24696 10.2289L9.50172 10.0726C9.90904 10.0531 10.25 10.378 10.25 10.7858C10.25 11.1802 9.9303 11.4998 9.53596 11.4998H6.99998C6.58576 11.4998 6.24998 11.8356 6.24998 12.2498C6.24998 12.6641 6.58576 12.9998 6.99998 12.9998H9.53596C10.4808 12.9998 11.2874 12.408 11.6053 11.5748L13.5125 10.865C13.8131 10.7531 14.15 10.8815 14.2998 11.1651C14.4604 11.4692 14.3514 11.8458 14.0533 12.0171L9.99047 14.3507C9.82031 14.4484 9.62751 14.4998 9.43128 14.4998H3.49998C3.08576 14.4998 2.74998 14.8356 2.74998 15.2498C2.74998 15.6641 3.08576 15.9998 3.49998 15.9998H9.43128C9.88968 15.9998 10.3401 15.8797 10.7376 15.6514L14.8004 13.3178C15.799 12.7442 16.1641 11.4827 15.6261 10.4644C15.1243 9.51468 13.9959 9.0845 12.9893 9.45918L11.5978 9.97709C11.2615 9.12041 10.4073 8.52743 9.42981 8.57435L6.17504 8.73058C6.1643 8.7311 6.15361 8.72886 6.14398 8.72408Z"
      />
    </g>
  ),
})

export const AddImageIcon = makeIcon({
  displayName: 'AddImage',
  content: (
    <g>
      <path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9.5 3.25a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z" />
      <path d="M12.75 6.5a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-.75.75Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 1.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V8.5a.75.75 0 0 1 1.5 0v5.25A2.25 2.25 0 0 1 13.75 16H2.25A2.25 2.25 0 0 1 0 13.75V2.25A2.25 2.25 0 0 1 2.25 0H7.5a.75.75 0 0 1 0 1.5H2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m.915 10.13-.458-.6L0 8.93v-.001l.003-.001.004-.003.009-.007a1.26 1.26 0 0 1 .088-.057 2.61 2.61 0 0 1 .213-.115c.18-.088.433-.19.768-.28.673-.178 1.661-.299 3.022-.147 1.479.165 2.641.926 3.64 1.58l.006.003c1.045.685 1.923 1.258 3 1.421 2.283.345 3.747-.653 3.935-.832l1.062 1.078c-.49.466-2.42 1.66-5.228 1.237-1.419-.215-2.547-.954-3.516-1.59l-.1-.065c-1.037-.679-1.909-1.223-2.972-1.342-1.184-.132-1.978-.02-2.45.106-.238.063-.397.13-.489.174a1.089 1.089 0 0 0-.087.047l-.008.005.005-.003.005-.004.002-.002.003-.001Z"
      />
    </g>
  ),
})

export const AllChannelsIcon = makeIcon({
  displayName: 'AllChannels',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.37113e-08 2C4.37113e-08 1.44772 0.447715 1 1 1H15C15.5523 1 16 1.44772 16 2C16 2.55228 15.5523 3 15 3H1C0.447715 3 4.37114e-08 2.55228 4.37113e-08 2Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.66667C-4.82822e-08 7.11438 0.447715 6.66667 1 6.66667L15 6.66667C15.5523 6.66667 16 7.11438 16 7.66667C16 8.21895 15.5523 8.66667 15 8.66667L1 8.66667C0.447715 8.66667 4.82823e-08 8.21895 0 7.66667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.37116e-08 13.3333C4.37116e-08 12.7811 0.419733 12.3333 0.9375 12.3333H9.0625C9.58027 12.3333 10 12.7811 10 13.3333C10 13.8856 9.58027 14.3333 9.0625 14.3333H0.9375C0.419733 14.3333 4.37116e-08 13.8856 4.37116e-08 13.3333Z"
      />
    </g>
  ),
})

export const AnalyticsIcon = makeIcon({
  displayName: 'AnalyticsIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0062 0.954267C15.1773 1.0713 15.2923 1.2539 15.3239 1.45873L15.9078 5.23816C15.9532 5.53214 15.8206 5.82518 15.5698 5.98509C15.3189 6.14499 14.9973 6.14155 14.75 5.9763L13.1591 4.91348L9.05716 10.5048C8.93442 10.6721 8.74785 10.7811 8.54183 10.8058C8.3358 10.8306 8.12874 10.7688 7.96989 10.6353L6.11639 9.07753L1.59406 14.9447C1.34119 15.2728 0.870244 15.3338 0.542175 15.0809C0.214105 14.828 0.153144 14.3571 0.406015 14.029L5.40598 7.54213C5.53077 7.38023 5.71623 7.27628 5.91946 7.25433C6.12269 7.23238 6.32607 7.29433 6.48255 7.42584L8.32165 8.97154L11.9246 4.06029C11.673 3.88184 11.4151 3.69995 11.1855 3.53849C10.9719 3.38821 10.7834 3.25605 10.6484 3.16147L10.4323 3.01025C10.4323 3.01025 10.4321 3.01009 10.8615 2.39523L10.4323 3.01025C10.1883 2.8398 10.0679 2.54101 10.1259 2.24906C10.1839 1.95711 10.4091 1.72709 10.6998 1.66289L14.3839 0.849078V0.849078L14.4209 0.8409C14.6233 0.796196 14.8352 0.837231 15.0062 0.954267ZM12.6848 2.76055C12.7216 2.78661 12.7584 2.81268 12.7951 2.83869L12.8788 2.71771L12.6848 2.76055ZM14.1288 3.54739L14.0294 3.69099L14.165 3.78153L14.1288 3.54739Z"
      />
    </g>
  ),
})

export const ArchiveIcon = makeIcon({
  displayName: 'ArchiveIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.5C0 1.5335 0.783502 0.75 1.75 0.75H14.25C15.2165 0.75 16 1.5335 16 2.5V4.5C16 5.29276 15.4729 5.96239 14.75 6.17753V13C14.75 14.2426 13.7426 15.25 12.5 15.25H3.5C2.25736 15.25 1.25 14.2426 1.25 13V6.17753C0.527128 5.96239 0 5.29276 0 4.5V2.5ZM2.75 6.25H13.25V13C13.25 13.4142 12.9142 13.75 12.5 13.75H3.5C3.08579 13.75 2.75 13.4142 2.75 13V6.25ZM1.75 2.25C1.61193 2.25 1.5 2.36193 1.5 2.5V4.5C1.5 4.63807 1.61193 4.75 1.75 4.75H14.25C14.3881 4.75 14.5 4.63807 14.5 4.5V2.5C14.5 2.36193 14.3881 2.25 14.25 2.25H1.75ZM6.25 8.5C5.83579 8.5 5.5 8.83579 5.5 9.25C5.5 9.66421 5.83579 10 6.25 10H9.75C10.1642 10 10.5 9.66421 10.5 9.25C10.5 8.83579 10.1642 8.5 9.75 8.5H6.25Z"
      />
    </g>
  ),
  smallAlternative: ArchiveSmallIcon,
})

export const ArobaseIcon = makeIcon({
  displayName: 'ArobaseIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 9.1702 1.80923 10.2682 2.35044 11.2167C2.35748 11.2275 2.36428 11.2387 2.37083 11.25C2.95881 12.2684 3.78095 13.0676 4.73 13.6188C5.5152 14.0748 6.38726 14.361 7.28548 14.4612C7.52013 14.4868 7.75853 14.5 8 14.5C8.01418 14.5 8.02826 14.5004 8.04224 14.5012C8.7798 14.4971 9.52343 14.3673 10.2406 14.1029C10.6292 13.9596 11.0604 14.1585 11.2037 14.5472C11.347 14.9358 11.1481 15.367 10.7594 15.5103C9.6222 15.9295 8.43108 16.0742 7.27155 15.9673C6.09552 15.8611 4.9929 15.5005 4.01919 14.9408C3.0496 14.3859 2.18578 13.6217 1.5024 12.6681C0.556901 11.3543 0 9.74219 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 10.4681 14.8081 12.0777 13.2759 12.3924C12.5238 12.5469 11.7448 12.3591 11.1585 11.8241C10.9403 11.625 10.7585 11.3871 10.6164 11.1165C9.94906 11.8129 9.03398 12.25 8 12.25C5.87354 12.25 4.25 10.4015 4.25 8.25C4.25 6.09851 5.87354 4.25 8 4.25C8.86632 4.25 9.64916 4.5568 10.2728 5.06591C10.3548 4.7407 10.6493 4.5 11 4.5C11.4142 4.5 11.75 4.83579 11.75 5.25V9.5C11.75 10.1484 11.9584 10.5233 12.1696 10.7161C12.3802 10.9083 12.6637 10.9869 12.9741 10.9231C13.5669 10.8013 14.5 10.0359 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 5.75C9.18725 5.75 10.25 6.81164 10.25 8.25C10.25 9.68837 9.18725 10.75 8 10.75C6.81275 10.75 5.75 9.68837 5.75 8.25C5.75 6.81164 6.81275 5.75 8 5.75Z"
    />
  ),
  smallAlternative: ArobaseSmallIcon,
})

export const ArrowLeftIcon = makeIcon({
  displayName: 'ArrowLeftIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.83032 4.99417C7.12321 4.70128 7.12321 4.22641 6.83032 3.93351C6.53743 3.64062 6.06255 3.64062 5.76966 3.93351L2.31616 7.38701C2.12483 7.52292 2 7.74632 2 7.99887C2 8.24986 2.12329 8.47206 2.31262 8.6082L5.76966 12.0652C6.06255 12.3581 6.53743 12.3581 6.83032 12.0652C7.12321 11.7723 7.12321 11.2975 6.83032 11.0046L4.57461 8.74887L13.25 8.74887C13.6642 8.74887 14 8.41309 14 7.99887C14 7.58466 13.6642 7.24887 13.25 7.24887L4.57562 7.24887L6.83032 4.99417Z"
    />
  ),
})

export const ArrowRightIcon = makeIcon({
  displayName: 'ArrowRightIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16968 11.0046C8.87679 11.2975 8.87679 11.7724 9.16968 12.0653C9.46258 12.3582 9.93745 12.3582 10.2303 12.0653L13.6837 8.61193C13.8751 8.47603 14 8.25258 14 7.99995C14 7.74903 13.8768 7.52689 13.6875 7.39074L10.2303 3.93354C9.93745 3.64064 9.46258 3.64064 9.16968 3.93354C8.87679 4.22643 8.87679 4.7013 9.16968 4.9942L11.4254 7.24995H2.75C2.33579 7.24995 2 7.58574 2 7.99995C2 8.41417 2.33579 8.74995 2.75 8.74995H11.4243L9.16968 11.0046Z"
    />
  ),
})

export const ArrowUpIcon = makeIcon({
  displayName: 'ArrowUpIcon',
  viewBox: 16,
  content: (
    <path d="M11.0052 6.82983C11.2981 7.12272 11.773 7.12272 12.0659 6.82983C12.3588 6.53694 12.3588 6.06206 12.0659 5.76917L8.61246 2.31575C8.47656 2.12438 8.25313 1.99951 8.00054 1.99951C7.74958 1.99951 7.52742 2.12277 7.39127 2.31205L3.93415 5.76917C3.64125 6.06206 3.64125 6.53694 3.93415 6.82983C4.22704 7.12272 4.70191 7.12272 4.99481 6.82983L7.25054 4.5741V13.2495C7.25054 13.6637 7.58633 13.9995 8.00054 13.9995C8.41475 13.9995 8.75054 13.6637 8.75054 13.2495V4.57516L11.0052 6.82983Z" />
  ),
})

export const ArrowUpRightIcon = makeIcon({
  displayName: 'ArrowUpRightIcon',
  viewBox: 16,
  content: (
    <g transform="translate(8 8) rotate(45) scale(1.3) translate(-8 -8)">
      <path d="M11.0052 6.82983C11.2981 7.12272 11.773 7.12272 12.0659 6.82983C12.3588 6.53694 12.3588 6.06206 12.0659 5.76917L8.61246 2.31575C8.47656 2.12438 8.25313 1.99951 8.00054 1.99951C7.74958 1.99951 7.52742 2.12277 7.39127 2.31205L3.93415 5.76917C3.64125 6.06206 3.64125 6.53694 3.93415 6.82983C4.22704 7.12272 4.70191 7.12272 4.99481 6.82983L7.25054 4.5741V13.2495C7.25054 13.6637 7.58633 13.9995 8.00054 13.9995C8.41475 13.9995 8.75054 13.6637 8.75054 13.2495V4.57516L11.0052 6.82983Z" />
    </g>
  ),
})

export const ArrowDownIcon = makeIcon({
  displayName: 'ArrowDownIcon',
  viewBox: 16,
  content: (
    <path d="M4.99481 9.16919C4.70191 8.8763 4.22704 8.8763 3.93415 9.16919C3.64125 9.46209 3.64125 9.93696 3.93415 10.2299L7.38756 13.6833C7.52347 13.8746 7.74689 13.9995 7.99948 13.9995C8.25044 13.9995 8.47261 13.8763 8.60875 13.687L12.0659 10.2299C12.3588 9.93696 12.3588 9.46209 12.0659 9.16919C11.773 8.8763 11.2981 8.8763 11.0052 9.16919L8.74948 11.4249L8.74948 2.74951C8.74948 2.3353 8.4137 1.99951 7.99948 1.99951C7.58527 1.99951 7.24948 2.3353 7.24948 2.74951L7.24948 11.4239L4.99481 9.16919Z" />
  ),
})

export const BackArrow = makeIcon({
  displayName: 'BackArrow',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 3.25a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h5a.75.75 0 100-1.5H2.522A6.002 6.002 0 018.502 2a6 6 0 11-4.33 10.154.75.75 0 10-1.083 1.038A7.5 7.5 0 101.5 5.305l.001-2.055z"
      />
    </g>
  ),
  smallAlternative: BackArrowSmallIcon,
})

export const BillingIcon = makeIcon({
  displayName: 'Billing',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.75C0 3.50736 1.00736 2.5 2.25 2.5H13.75C14.9926 2.5 16 3.50736 16 4.75V11.75C16 12.9926 14.9926 14 13.75 14H2.25C1.00736 14 0 12.9926 0 11.75V4.75ZM2.25 4C1.83579 4 1.5 4.33579 1.5 4.75V11.75C1.5 12.1642 1.83579 12.5 2.25 12.5H13.75C14.1642 12.5 14.5 12.1642 14.5 11.75V4.75C14.5 4.33579 14.1642 4 13.75 4H2.25Z"
      />
      <path d="M1.5 5.75H14.5V8.25H1.5V5.75Z" />
    </g>
  ),
})

export const CollectionGalleryIcon = makeIcon({
  displayName: 'CollectionGalleryIcon',
  viewBox: 16,
  content: (
    <g width="16" height="16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 0.25C1.2835 0.25 0.5 1.0335 0.5 2V5.5C0.5 6.4665 1.2835 7.25 2.25 7.25H5.75C6.7165 7.25 7.5 6.4665 7.5 5.5V2C7.5 1.0335 6.7165 0.25 5.75 0.25H2.25ZM2 2C2 1.86193 2.11193 1.75 2.25 1.75H5.75C5.88807 1.75 6 1.86193 6 2V5.5C6 5.63807 5.88807 5.75 5.75 5.75H2.25C2.11193 5.75 2 5.63807 2 5.5V2Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 0.25C9.2835 0.25 8.5 1.0335 8.5 2V5.5C8.5 6.4665 9.2835 7.25 10.25 7.25H13.75C14.7165 7.25 15.5 6.4665 15.5 5.5V2C15.5 1.0335 14.7165 0.25 13.75 0.25H10.25ZM10 2C10 1.86193 10.1119 1.75 10.25 1.75H13.75C13.8881 1.75 14 1.86193 14 2V5.5C14 5.63807 13.8881 5.75 13.75 5.75H10.25C10.1119 5.75 10 5.63807 10 5.5V2Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 8.25C9.2835 8.25 8.5 9.0335 8.5 10V13.5C8.5 14.4665 9.2835 15.25 10.25 15.25H13.75C14.7165 15.25 15.5 14.4665 15.5 13.5V10C15.5 9.0335 14.7165 8.25 13.75 8.25H10.25ZM10 10C10 9.86193 10.1119 9.75 10.25 9.75H13.75C13.8881 9.75 14 9.86193 14 10V13.5C14 13.6381 13.8881 13.75 13.75 13.75H10.25C10.1119 13.75 10 13.6381 10 13.5V10Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 8.25C1.2835 8.25 0.5 9.0335 0.5 10V13.5C0.5 14.4665 1.2835 15.25 2.25 15.25H5.75C6.7165 15.25 7.5 14.4665 7.5 13.5V10C7.5 9.0335 6.7165 8.25 5.75 8.25H2.25ZM2 10C2 9.86193 2.11193 9.75 2.25 9.75H5.75C5.88807 9.75 6 9.86193 6 10V13.5C6 13.6381 5.88807 13.75 5.75 13.75H2.25C2.11193 13.75 2 13.6381 2 13.5V10Z"
      />
    </g>
  ),
})

export const CollectionBoardIcon = makeIcon({
  displayName: 'CollectionBoardIcon',
  viewBox: 16,
  content: (
    <g width="16" height="16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2C1 0.895431 1.89543 0 3 0H7.5H9H13C14.1046 0 15 0.895431 15 2V10C15 11.1046 14.1046 12 13 12H9V14C9 15.1046 8.10457 16 7 16H3C1.89543 16 1 15.1046 1 14V2ZM9 2.75H13.5V10C13.5 10.2761 13.2761 10.5 13 10.5H9V2.75ZM7.5 2.75V14C7.5 14.2761 7.27614 14.5 7 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2.75H7.5Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: CollectionBoardSmallIcon,
})

export const BoldIcon = makeIcon({
  displayName: 'BoldIcon',
  content: (
    <g>
      <path d="M2.5 0.955224C2.5 0.427669 2.42767 0 2.95522 0H5.34328V8.5V16H2.95522C2.42767 16 2.5 15.5723 2.5 15.0448V0.955224Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49824 0H3.43284V8H9.99824C12.1939 8 13.4916 6.37374 13.5562 4.17905C13.6235 1.89117 11.7871 0 9.49824 0ZM7.41113 1.5H5.34328V7H7.41113C8.99995 7 10.5373 6.25 10.5373 4.35687C10.5373 2.46374 9.24995 1.45522 7.41113 1.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7164 7.16418H3.43284V16H10.2164C12.6564 16 14.6343 14.022 14.6343 11.5821C14.6343 9.14214 13.1564 7.16418 10.7164 7.16418ZM8.23347 8.5H5.34328V14.5H8.23347C9.85418 14.5 11.2177 13.75 11.2177 11.4149C11.2177 9.25 9.91012 8.5 8.23347 8.5Z"
      />
      <path d="M1.5 0.75C1.5 0.335786 1.83579 0 2.25 0H3.25C3.66421 0 4 0.335786 4 0.75C4 1.16421 3.66421 1.5 3.25 1.5H2.25C1.83579 1.5 1.5 1.16421 1.5 0.75Z" />
      <path d="M1.5 15.25C1.5 14.8358 1.83579 14.5 2.25 14.5H3.25C3.66421 14.5 4 14.8358 4 15.25C4 15.6642 3.66421 16 3.25 16H2.25C1.83579 16 1.5 15.6642 1.5 15.25Z" />
    </g>
  ),
  smallAlternative: BoldSmallIcon,
})

export const BulletListIcon = makeIcon({
  displayName: 'BulletListIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 4.5C1.94036 4.5 2.5 3.94036 2.5 3.25C2.5 2.55964 1.94036 2 1.25 2C0.559644 2 0 2.55964 0 3.25C0 3.94036 0.559644 4.5 1.25 4.5ZM1.25 14C1.94036 14 2.5 13.4404 2.5 12.75C2.5 12.0596 1.94036 11.5 1.25 11.5C0.559644 11.5 0 12.0596 0 12.75C0 13.4404 0.559644 14 1.25 14ZM2.5 8C2.5 8.69036 1.94036 9.25 1.25 9.25C0.559644 9.25 0 8.69036 0 8C0 7.30964 0.559644 6.75 1.25 6.75C1.94036 6.75 2.5 7.30964 2.5 8ZM5.75 2.5C5.33579 2.5 5 2.83579 5 3.25C5 3.66421 5.33579 4 5.75 4H15.25C15.6642 4 16 3.66421 16 3.25C16 2.83579 15.6642 2.5 15.25 2.5H5.75ZM5.75 7.25C5.33579 7.25 5 7.58579 5 8C5 8.41421 5.33579 8.75 5.75 8.75H15.25C15.6642 8.75 16 8.41421 16 8C16 7.58579 15.6642 7.25 15.25 7.25H5.75ZM5.75 12C5.33579 12 5 12.3358 5 12.75C5 13.1642 5.33579 13.5 5.75 13.5H15.25C15.6642 13.5 16 13.1642 16 12.75C16 12.3358 15.6642 12 15.25 12H5.75Z"
      />
    </g>
  ),
  smallAlternative: BulletListSmallIcon,
})

export const CalendarIcon = makeIcon({
  displayName: 'CalendarIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0.75C5 0.335786 4.66421 0 4.25 0C3.83579 0 3.5 0.335786 3.5 0.75V2H2.25C1.00736 2 0 3.00736 0 4.25V13.75C0 14.9926 1.00736 16 2.25 16H13.75C14.9926 16 16 14.9926 16 13.75V4.25C16 3.00736 14.9926 2 13.75 2H12.5V0.75C12.5 0.335786 12.1642 0 11.75 0C11.3358 0 11 0.335786 11 0.75V2H5V0.75ZM11 4.75V3.5H5V4.75C5 5.16421 4.66421 5.5 4.25 5.5C3.83579 5.5 3.5 5.16421 3.5 4.75V3.5H2.25C1.83579 3.5 1.5 3.83579 1.5 4.25V7C5.83333 7 10.1667 7 14.5 7V4.25C14.5 3.83579 14.1642 3.5 13.75 3.5H12.5V4.75C12.5 5.16421 12.1642 5.5 11.75 5.5C11.3358 5.5 11 5.16421 11 4.75ZM14.5 8.5C10.1667 8.5 5.83333 8.5 1.5 8.5V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H13.75C14.1642 14.5 14.5 14.1642 14.5 13.75V8.5Z"
      />
    </g>
  ),
  smallAlternative: CalendarSmallIcon,
})

export const CaretBottomIcon = makeIcon({
  displayName: 'CaretBottomIcon',
  content: (
    <path d="M4.51263 7.16821C3.92731 6.52755 4.38413 5.5 5.25427 5.5H10.7457C11.6159 5.5 12.0727 6.52755 11.4874 7.1682L8.74164 10.1735C8.34397 10.6088 7.65603 10.6088 7.25836 10.1735L4.51263 7.16821Z" />
  ),
})

export const CaretNavigationRightIcon = makeIcon({
  displayName: 'CaretNavigationRightIcon',
  content: (
    <path d="M7.16821 11.4874C6.52755 12.0727 5.5 11.6159 5.5 10.7457V5.25427C5.5 4.38413 6.52755 3.92731 7.1682 4.51263L10.1735 7.25836C10.6088 7.65603 10.6088 8.34397 10.1735 8.74164L7.16821 11.4874Z" />
  ),
})

export const ChannelAddIcon = makeIcon({
  displayName: 'ChannelAddIcon',
  smallAlternative: ChannelAddSmallIcon,
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 0.5C2.00736 0.5 1 1.50736 1 2.75V13.25C1 14.4926 2.00736 15.5 3.25 15.5H7.5C7.91421 15.5 8.25 15.1642 8.25 14.75C8.25 14.3358 7.91421 14 7.5 14H6.25V2H12.75C13.1642 2 13.5 2.33579 13.5 2.75V6.75C13.5 7.16421 13.8358 7.5 14.25 7.5C14.6642 7.5 15 7.16421 15 6.75V2.75C15 1.50736 13.9926 0.5 12.75 0.5H3.25ZM2.5 2.75C2.5 2.33579 2.83579 2 3.25 2H4.75V14H3.25C2.83579 14 2.5 13.6642 2.5 13.25V2.75ZM8.25 5C7.83579 5 7.5 5.33579 7.5 5.75C7.5 6.16421 7.83579 6.5 8.25 6.5H11.5C11.9142 6.5 12.25 6.16421 12.25 5.75C12.25 5.33579 11.9142 5 11.5 5H8.25ZM12 9C12.4142 9 12.75 9.33579 12.75 9.75V11.5H14.5C14.9142 11.5 15.25 11.8358 15.25 12.25C15.25 12.6642 14.9142 13 14.5 13H12.75V14.75C12.75 15.1642 12.4142 15.5 12 15.5C11.5858 15.5 11.25 15.1642 11.25 14.75V13H9.5C9.08579 13 8.75 12.6642 8.75 12.25C8.75 11.8358 9.08579 11.5 9.5 11.5H11.25V9.75C11.25 9.33579 11.5858 9 12 9Z"
    />
  ),
})

export const ChannelRemoveIcon = makeIcon({
  displayName: 'ChannelRemoveIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25.5A2.25 2.25 0 0 0 1 2.75v10.5a2.25 2.25 0 0 0 2.25 2.25H7.5a.75.75 0 0 0 0-1.5H6.25V2h6.5a.75.75 0 0 1 .75.75v4a.75.75 0 0 0 1.5 0v-4A2.25 2.25 0 0 0 12.75.5h-9.5ZM2.5 2.75A.75.75 0 0 1 3.25 2h1.5v12h-1.5a.75.75 0 0 1-.75-.75V2.75ZM8.25 5a.75.75 0 0 0 0 1.5h3.25a.75.75 0 0 0 0-1.5H8.25Z"
      />
      <path d="M9.702 9.952a.75.75 0 0 1 1.06 0L12 11.189l1.237-1.237a.75.75 0 0 1 1.061 1.06l-1.237 1.238 1.237 1.237a.75.75 0 0 1-1.06 1.061L12 13.311l-1.237 1.237a.75.75 0 1 1-1.061-1.06l1.237-1.238-1.237-1.237a.75.75 0 0 1 0-1.061Z" />
    </g>
  ),
})

export const ChannelSettingsIcon = makeIcon({
  displayName: 'ChannelSettingsIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.25.5A2.25 2.25 0 0 0 1 2.75v10.5a2.25 2.25 0 0 0 2.25 2.25H7.5a.75.75 0 0 0 0-1.5H6.25V2h6.5a.75.75 0 0 1 .75.75v4a.75.75 0 0 0 1.5 0v-4A2.25 2.25 0 0 0 12.75.5h-9.5ZM2.5 2.75A.75.75 0 0 1 3.25 2h1.5v12h-1.5a.75.75 0 0 1-.75-.75V2.75ZM8.25 5a.75.75 0 0 0 0 1.5h3.25a.75.75 0 0 0 0-1.5H8.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.564 9.732a.636.636 0 0 1 .618-.482h.636c.292 0 .547.199.618.482l.188.753.746-.213c.281-.08.58.04.727.293l.318.551a.636.636 0 0 1-.109.776l-.558.54.558.54c.21.202.255.522.109.775l-.318.551a.636.636 0 0 1-.727.294l-.746-.214-.188.754a.636.636 0 0 1-.618.482h-.636a.636.636 0 0 1-.618-.482l-.188-.754-.746.214a.636.636 0 0 1-.726-.294l-.319-.55a.636.636 0 0 1 .11-.776l.557-.54-.558-.54a.636.636 0 0 1-.109-.776l.318-.55a.636.636 0 0 1 .727-.294l.746.213.188-.753Zm.936 1.745a.955.955 0 1 0 0 1.91.955.955 0 0 0 0-1.91Z"
        clipRule="evenodd"
      />
    </g>
  ),
})

export const ChannelClosedIcon = makeIcon({
  displayName: 'ChannelClosedIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2.75C1 1.50736 2.00736 0.5 3.25 0.5H12.75C13.9926 0.5 15 1.50736 15 2.75V13.25C15 14.4926 13.9926 15.5 12.75 15.5H3.25C2.00736 15.5 1 14.4926 1 13.25V2.75ZM3.25 2C2.83579 2 2.5 2.33579 2.5 2.75V13.25C2.5 13.6642 2.83579 14 3.25 14H4.75V2H3.25ZM12.75 14H6.25V2H12.75C13.1642 2 13.5 2.33579 13.5 2.75V13.25C13.5 13.6642 13.1642 14 12.75 14ZM8.25 5C7.83579 5 7.5 5.33579 7.5 5.75C7.5 6.16421 7.83579 6.5 8.25 6.5H11.5C11.9142 6.5 12.25 6.16421 12.25 5.75C12.25 5.33579 11.9142 5 11.5 5H8.25Z"
    />
  ),
})

export const ChannelOpenIcon = makeIcon({
  displayName: 'ChannelOpenIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 2.22346C9.5 1.72747 9.02716 1.36808 8.54927 1.50082L2.54927 3.16749C2.22465 3.25766 2 3.55322 2 3.89013V12.1099C2 12.4468 2.22465 12.7423 2.54927 12.8325L8.54927 14.4992C9.02716 14.6319 9.5 14.2725 9.5 13.7765V2.22346ZM8.1478 0.0555478C9.58149 -0.342699 11 0.735487 11 2.22346V13.7765C11 15.2645 9.58149 16.3427 8.1478 15.9445L2.1478 14.2778C1.17396 14.0073 0.5 13.1206 0.5 12.1099V3.89013C0.5 2.87941 1.17396 1.99273 2.1478 1.72221L8.1478 0.0555478ZM12 2.25C12 1.83579 12.3358 1.5 12.75 1.5H13.25C14.4926 1.5 15.5 2.50736 15.5 3.75V12.25C15.5 13.4926 14.4926 14.5 13.25 14.5H12.75C12.3358 14.5 12 14.1642 12 13.75C12 13.3358 12.3358 13 12.75 13H13.25C13.6642 13 14 12.6642 14 12.25V3.75C14 3.33579 13.6642 3 13.25 3H12.75C12.3358 3 12 2.66421 12 2.25ZM7.6627 6.09325C8.06705 6.0034 8.322 5.60276 8.23214 5.19841C8.14228 4.79406 7.74165 4.53912 7.3373 4.62897L3.8373 5.40675C3.43295 5.4966 3.178 5.89724 3.26786 6.30159C3.35772 6.70594 3.75835 6.96089 4.1627 6.87103L7.6627 6.09325Z"
    />
  ),
})

export const ChatIcon = makeIcon({
  displayName: 'ChatIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 0C3.02208 0 0 3.02208 0 6.75V14.75C0 15.7565 1.12878 16.3503 1.95816 15.7801L4.79099 13.632C4.91601 13.546 5.06416 13.5 5.21589 13.5H9.25C12.9779 13.5 16 10.4779 16 6.75C16 3.02208 12.9779 0 9.25 0H6.75ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5H9.25C12.1495 1.5 14.5 3.85051 14.5 6.75C14.5 9.6495 12.1495 12 9.25 12H5.21589C4.76072 12 4.31627 12.138 3.94119 12.3959L1.5 14.25V6.75ZM4.75 8C5.30228 8 5.75 7.55228 5.75 7C5.75 6.44772 5.30228 6 4.75 6C4.19772 6 3.75 6.44772 3.75 7C3.75 7.55228 4.19772 8 4.75 8ZM9 7C9 7.55228 8.55229 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6C8.55229 6 9 6.44772 9 7ZM11.25 8C11.8023 8 12.25 7.55228 12.25 7C12.25 6.44772 11.8023 6 11.25 6C10.6977 6 10.25 6.44772 10.25 7C10.25 7.55228 10.6977 8 11.25 8Z"
      />
    </g>
  ),
})

export const CheckboxEmptyIcon = makeIcon({
  displayName: 'CheckboxEmptyIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.25C0 1.00736 1.00736 0 2.25 0H13.75C14.9926 0 16 1.00736 16 2.25V13.75C16 14.9926 14.9926 16 13.75 16H2.25C1.00736 16 0 14.9926 0 13.75V2.25ZM2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H13.75C14.1642 14.5 14.5 14.1642 14.5 13.75V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H2.25Z"
      />
    </g>
  ),
})

export const CheckboxIcon = makeIcon({
  displayName: 'CheckboxIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H11.25C11.6642 1.5 12 1.16421 12 0.75C12 0.335786 11.6642 0 11.25 0H2.25C1.00736 0 0 1.00736 0 2.25V13.75C0 14.9926 1.00736 16 2.25 16H13.75C14.9926 16 16 14.9926 16 13.75V9.25C16 8.83579 15.6642 8.5 15.25 8.5C14.8358 8.5 14.5 8.83579 14.5 9.25V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5H2.25C1.83579 14.5 1.5 14.1642 1.5 13.75V2.25ZM15.7803 3.78033C16.0732 3.48744 16.0732 3.01256 15.7803 2.71967C15.4874 2.42678 15.0126 2.42678 14.7197 2.71967L7.5 9.93934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.96967 11.5303C7.26256 11.8232 7.73744 11.8232 8.03033 11.5303L15.7803 3.78033Z"
      />
    </g>
  ),
  smallAlternative: CheckboxSmallIcon,
})

export const CheckMarkRoundIcon = makeIcon({
  displayName: 'CheckMarkRoundIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967C12.2374 5.17678 11.7626 5.17678 11.4697 5.46967L7 9.93934L5.03033 7.96967C4.73744 7.67678 4.26256 7.67678 3.96967 7.96967C3.67678 8.26256 3.67678 8.73744 3.96967 9.03033L6.46967 11.5303C6.76256 11.8232 7.23744 11.8232 7.53033 11.5303L12.5303 6.53033Z"
    />
  ),
})

export const ChevronIcon = makeIcon({
  displayName: 'ChevronIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.96967 13.7809C4.67678 13.488 4.67678 13.0131 4.96967 12.7202L9.68961 8.00027L4.96967 3.28033C4.67678 2.98744 4.67678 2.51256 4.96967 2.21967C5.26256 1.92678 5.73744 1.92678 6.03033 2.21967L11.2806 7.46994C11.5735 7.76283 11.5735 8.2377 11.2806 8.5306L6.03033 13.7809C5.73744 14.0738 5.26256 14.0738 4.96967 13.7809Z"
    />
  ),
})

export const CircleDashedIcon = makeIcon({
  displayName: 'CircleDashed',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.808.088a8.058 8.058 0 012.384 0 .75.75 0 01-.222 1.484 6.557 6.557 0 00-1.94 0A.75.75 0 016.808.088zm4.894 1.632a.75.75 0 011.05-.157 8.042 8.042 0 011.685 1.686.75.75 0 01-1.206.891 6.545 6.545 0 00-1.371-1.37.75.75 0 01-.158-1.05zm-7.404 0a.75.75 0 01-.158 1.05 6.542 6.542 0 00-1.37 1.37.75.75 0 01-1.207-.891A8.042 8.042 0 013.25 1.563a.75.75 0 011.049.157zM.94 6.177a.75.75 0 01.63.853 6.557 6.557 0 000 1.94.75.75 0 01-1.483.222 8.058 8.058 0 010-2.384.75.75 0 01.853-.63zm14.118 0a.75.75 0 01.853.631 8.056 8.056 0 010 2.384.75.75 0 11-1.484-.222 6.55 6.55 0 000-1.94.75.75 0 01.631-.853zm-.78 5.525a.75.75 0 01.158 1.05 8.042 8.042 0 01-1.686 1.685.75.75 0 01-.891-1.206 6.547 6.547 0 001.37-1.371.75.75 0 011.05-.158zm-12.559 0a.75.75 0 011.05.158c.385.522.848.985 1.37 1.37a.75.75 0 11-.891 1.207 8.042 8.042 0 01-1.686-1.686.75.75 0 01.157-1.049zm4.457 3.357a.75.75 0 01.853-.63 6.55 6.55 0 001.94 0 .75.75 0 01.222 1.483 8.056 8.056 0 01-2.384 0 .75.75 0 01-.63-.853z"
      fill="currentColor"
    />
  ),
  smallAlternative: CircleDashedSmallIcon,
})

export const CircleIcon = makeIcon({
  displayName: 'CircleIcon',
  content: (
    <path d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z" />
  ),
})
export const CirclularArrowsIcon = makeIcon({
  displayName: 'CirclularArrowsIcon',
  content: (
    <path
      d="M15.251.5a.75.75 0 00-.75.75v2.788A7.25 7.25 0 008 0a7.23 7.23 0 00-5.125 2.122c-1 .999-1.71 2.29-1.991 3.735a.75.75 0 101.472.286 5.736 5.736 0 011.58-2.96A5.753 5.753 0 0113.48 5.5H10.25a.75.75 0 000 1.5h5a.75.75 0 00.75-.75v-5a.75.75 0 00-.75-.75zM.75 15.5a.75.75 0 00.75-.75v-2.788A7.25 7.25 0 008.001 16a7.23 7.23 0 005.125-2.122c1-.999 1.71-2.29 1.991-3.735a.75.75 0 10-1.472-.286 5.736 5.736 0 01-1.579 2.96A5.753 5.753 0 012.522 10.5H5.75a.75.75 0 000-1.5h-5a.75.75 0 00-.75.75v5c0 .414.336.75.75.75z"
      fill="currentColor"
    />
  ),
  smallAlternative: CirclularArrowsSmallIcon,
})

export const CloseIcon = makeIcon({
  displayName: 'CloseIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2803 1.71967C14.5732 2.01256 14.5732 2.48744 14.2803 2.78033L2.78033 14.2803C2.48744 14.5732 2.01256 14.5732 1.71967 14.2803C1.42678 13.9874 1.42678 13.5126 1.71967 13.2197L13.2197 1.71967C13.5126 1.42678 13.9874 1.42678 14.2803 1.71967Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2803 14.2803C14.5732 13.9874 14.5732 13.5126 14.2803 13.2197L2.78033 1.71967C2.48744 1.42678 2.01256 1.42678 1.71967 1.71967C1.42678 2.01256 1.42678 2.48744 1.71967 2.78033L13.2197 14.2803C13.5126 14.5732 13.9874 14.5732 14.2803 14.2803Z"
      />
    </g>
  ),
  smallAlternative: CloseSmallIcon,
})

export const CloudStrikeThroughIcon = makeIcon({
  displayName: 'CloudStrikeThroughIcon',
  content: (
    <g>
      <path d="M3.78076 7.75C3.78076 5.69118 5.48269 4 7.60971 4C8.27755 4 8.90403 4.16711 9.4491 4.46013C9.78999 4.64339 10.2222 4.62621 10.4959 4.35254C10.8111 4.03727 10.7912 3.51495 10.4105 3.28285C9.59574 2.78609 8.6357 2.5 7.60971 2.5C4.67896 2.5 2.28076 4.83826 2.28076 7.75C2.28076 7.82965 2.28257 7.90892 2.28614 7.98777C0.986539 8.21976 0 9.35564 0 10.7219C0 11.6072 0.414159 12.3957 1.05929 12.9043C1.36321 13.1439 1.78902 13.0594 2.06268 12.7857C2.35284 12.4956 2.13919 11.8666 1.85459 11.5709C1.6373 11.3453 1.5 11.0478 1.5 10.7219C1.5 10.0164 2.07195 9.44445 2.77749 9.44445L4.06227 9.44444L3.86467 8.53517C3.80978 8.2826 3.78076 8.02003 3.78076 7.75Z" />
      <path d="M4.9703 11.9994L3.4703 13.4994L8.0079 13.4994C8.03009 13.4998 8.05231 13.5 8.07456 13.5H12.25C14.3211 13.5 16 11.8211 16 9.75C16 7.81148 14.5291 6.21651 12.6425 6.0203C12.5004 5.61891 12.3105 5.24007 12.0795 4.89026L10.9874 5.98229C11.147 6.27392 11.2681 6.58829 11.3444 6.91873L11.4786 7.5H12.25C13.4926 7.5 14.5 8.50736 14.5 9.75C14.5 10.9926 13.4926 12 12.25 12H8.07456C8.05947 12 8.04444 11.9999 8.02947 11.9996L8.02214 11.9994L4.9703 11.9994Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50006 14.5303C3.20717 14.2374 3.20717 13.7626 3.50006 13.4697L12.9394 4.03034C13.2323 3.73744 13.7072 3.73744 14.0001 4.03034C14.293 4.32323 14.293 4.7981 14.0001 5.091L4.56072 14.5303C4.26783 14.8232 3.79296 14.8232 3.50006 14.5303Z"
      />
    </g>
  ),
})

export const BlockCodeIcon = makeIcon({
  displayName: 'BlockCodeIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.49199 3.76525e-08H5.5C5.91421 -8.15568e-08 6.25 0.335786 6.25 0.75C6.25 1.16421 5.91421 1.5 5.5 1.5C5.05087 1.5 4.67078 1.50304 4.33696 1.55895C4.01093 1.61356 3.80207 1.70817 3.66203 1.83829C3.40257 2.07937 3.0678 2.76475 3.48544 4.85291C3.74623 6.15687 3.68011 7.21314 3.06944 7.92559C3.04753 7.95116 3.02519 7.97596 3.00244 8C3.02519 8.02405 3.04753 8.04884 3.06944 8.07441C3.68011 8.78686 3.74623 9.84313 3.48544 11.1471C3.0678 13.2353 3.40257 13.9206 3.66203 14.1617C3.80207 14.2918 4.01093 14.3864 4.33696 14.441C4.67078 14.497 5.05087 14.5 5.5 14.5C5.91421 14.5 6.25 14.8358 6.25 15.25C6.25 15.6642 5.91421 16 5.5 16H5.49199C5.06778 16 4.56424 16 4.08918 15.9204C3.60334 15.8391 3.07547 15.6643 2.64101 15.2606C1.75149 14.4341 1.58625 12.9945 2.01456 10.8529C2.25377 9.65687 2.06989 9.21314 1.93056 9.05059C1.78728 8.88343 1.47142 8.75 0.75 8.75C0.335786 8.75 0 8.41421 0 8C0 7.58579 0.335786 7.25 0.75 7.25C1.47142 7.25 1.78728 7.11657 1.93056 6.94941C2.06989 6.78686 2.25377 6.34313 2.01456 5.14709C1.58625 3.00553 1.75149 1.56591 2.64101 0.739413C3.07547 0.335748 3.60334 0.160934 4.08918 0.0795612C4.56424 -6.69807e-06 5.06778 -3.00218e-06 5.49199 3.76525e-08ZM11.663 1.55895C11.3292 1.50304 10.9491 1.5 10.5 1.5C10.0858 1.5 9.75 1.16421 9.75 0.75C9.75 0.335786 10.0858 -8.15568e-08 10.5 3.76525e-08H10.508C10.9322 -3.00218e-06 11.4358 -6.63847e-06 11.9108 0.0795612C12.3967 0.160934 12.9245 0.335748 13.359 0.739413C14.2485 1.56591 14.4137 3.00553 13.9854 5.14709C13.7462 6.34313 13.9301 6.78686 14.0694 6.94941C14.2127 7.11657 14.5286 7.25 15.25 7.25C15.6642 7.25 16 7.58579 16 8C16 8.41421 15.6642 8.75 15.25 8.75C14.5286 8.75 14.2127 8.88343 14.0694 9.05059C13.9301 9.21314 13.7462 9.65687 13.9854 10.8529C14.4137 12.9945 14.2485 14.4341 13.359 15.2606C12.9245 15.6643 12.3967 15.8391 11.9108 15.9204C11.4358 16 10.9322 16 10.508 16H10.5C10.0858 16 9.75 15.6642 9.75 15.25C9.75 14.8358 10.0858 14.5 10.5 14.5C10.9491 14.5 11.3292 14.497 11.663 14.441C11.9891 14.3864 12.1979 14.2918 12.338 14.1617C12.5974 13.9206 12.9322 13.2353 12.5146 11.1471C12.2538 9.84313 12.3199 8.78686 12.9306 8.07441C12.9525 8.04884 12.9748 8.02405 12.9976 8C12.9748 7.97596 12.9525 7.95116 12.9306 7.92559C12.3199 7.21314 12.2538 6.15687 12.5146 4.85291C12.9322 2.76475 12.5974 2.07937 12.338 1.83829C12.1979 1.70817 11.9891 1.61356 11.663 1.55895Z"
    />
  ),
  smallAlternative: BlockCodeSmallIcon,
})

export const CogIcon = makeIcon({
  displayName: 'CogIcon',
  content: (
    <g>
      <g>
        <path
          d="M8.98487 16H7.10488C6.05488 16 5.18488 15.16 5.12488 14.1L5.10488 13.64L4.71488 13.41L4.37488 13.59C3.42488 14.11 2.25488 13.77 1.71488 12.83L0.764876 11.16C0.234876 10.24 0.524875 9.07 1.41488 8.5L1.77488 8.27V7.75L1.42488 7.53C0.524876 6.95 0.234876 5.75 0.764876 4.84L1.69488 3.18C2.24487 2.23 3.40488 1.89 4.35488 2.41L4.69488 2.59L5.08488 2.36V1.96C5.09488 0.88 5.98488 0 7.07488 0H8.95487C10.0049 0 10.8749 0.84 10.9349 1.9L10.9549 2.36L11.3449 2.59L11.6849 2.41C12.6349 1.89 13.8049 2.23 14.3449 3.17L15.2949 4.86C15.8149 5.78 15.5249 6.95 14.6349 7.52L14.2849 7.74V8.27L14.6349 8.49C15.5349 9.07 15.8249 10.27 15.2949 11.18L14.3649 12.84C13.8149 13.79 12.6449 14.13 11.7049 13.61L11.3749 13.43L10.9749 13.67L10.9549 14.1C10.8949 15.17 10.0349 16 8.97488 16H8.98487ZM5.04488 11.86L6.41488 12.75C6.51488 12.83 6.55488 12.91 6.58488 13.06L6.60488 13.27L6.63488 14.03C6.64488 14.26 6.83488 14.51 7.11488 14.51H8.99487C9.32487 14.51 9.46487 14.22 9.47487 14.03L9.57487 13C9.60487 12.86 9.67488 12.7 9.94488 12.55L11.0949 11.87L11.1749 11.82C11.4349 11.65 11.6449 11.82 11.7549 11.9C11.7849 11.92 11.9449 12.02 11.9449 12.02L12.4449 12.3C12.6949 12.44 12.9649 12.31 13.0849 12.11L14.0249 10.44C14.1749 10.19 14.0649 9.9 13.8649 9.77L12.9949 9.16C12.8349 9 12.8049 8.91 12.8149 8.63L12.8749 7.1C12.9049 6.95 12.9949 6.84 13.1149 6.75L13.8549 6.27C14.0449 6.15 14.1649 5.87 14.0149 5.61L13.0649 3.93C12.9449 3.73 12.6749 3.6 12.4249 3.74L11.6249 4.17C11.4549 4.25 11.1949 4.23 11.0349 4.15L9.67488 3.27C9.54488 3.17 9.49487 2.94 9.48487 2.75L9.45488 1.99C9.44488 1.76 9.25488 1.51 8.97488 1.51H7.09488C6.83488 1.51 6.61488 1.72 6.61488 1.99L6.53488 3.03C6.49488 3.24 6.40488 3.34 6.16488 3.48L5.02488 4.16C4.83488 4.27 4.58488 4.23 4.33488 4.1L3.66488 3.74C3.41488 3.6 3.14488 3.73 3.02488 3.93L2.08488 5.6C1.93488 5.85 2.04487 6.14 2.23487 6.27L3.10488 6.87C3.23488 6.99 3.29488 7.2 3.29488 7.41L3.22488 8.93C3.19488 9.12 3.08488 9.24 2.87488 9.36L2.23487 9.76C2.04487 9.88 1.92488 10.16 2.07488 10.42L3.04488 12.13C3.14488 12.29 3.41488 12.42 3.66488 12.28L4.46488 11.85C4.65488 11.76 4.84488 11.76 5.05488 11.87L5.04488 11.86ZM8.03488 10.86C7.55488 10.86 7.07488 10.73 6.64488 10.48C5.31488 9.69 4.85488 7.94 5.63488 6.58C6.01488 5.91 6.62488 5.44 7.35488 5.25C8.06488 5.06 8.80488 5.17 9.43488 5.54C10.7649 6.34 11.2149 8.09 10.4549 9.44C10.0749 10.11 9.46487 10.58 8.73487 10.78C8.50488 10.84 8.27488 10.87 8.04488 10.87L8.03488 10.86ZM8.04488 6.65C7.94488 6.65 7.83488 6.66 7.73488 6.69C7.39488 6.78 7.11488 7 6.93488 7.32C6.56488 7.96 6.78488 8.82 7.41488 9.19C7.69488 9.36 8.02488 9.4 8.34488 9.32C8.67488 9.23 8.96487 9.01 9.14487 8.7C9.51487 8.05 9.29488 7.21 8.66488 6.83C8.47487 6.72 8.26488 6.66 8.04488 6.66V6.65Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <defs>
          <clipPath id="clip0_183_259">
            <rect width="16" height="16" />
          </clipPath>
        </defs>
      </defs>
    </g>
  ),
})

export const ColdNoteIcon = makeIcon({
  displayName: 'ColdNote',
  content: (
    <g>
      <path d="M11.4 0a.75.75 0 0 0 0 1.5h1.545l-2.098 2.289a.75.75 0 0 0 .553 1.256h3.25a.75.75 0 0 0 0-1.5h-1.545l2.098-2.288A.75.75 0 0 0 14.65 0H11.4Z" />
      <path d="m11.031 14.691 1.076 1.077a.75.75 0 0 0 1.061-1.06l-.964-.965A6.728 6.728 0 0 0 14.15 9a6.76 6.76 0 0 0-.212-1.687.75.75 0 0 0-1.453.374A5.25 5.25 0 1 1 8.372 3.84a.75.75 0 1 0 .276-1.475 6.75 6.75 0 0 0-6.05 11.377l-.965.965a.75.75 0 1 0 1.06 1.06l1.077-1.076A6.718 6.718 0 0 0 7.4 15.75a6.718 6.718 0 0 0 3.631-1.059Z" />
      <path d="M8.15 6v2.25h2.25a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 6.65 9V6a.75.75 0 0 1 1.5 0Z" />
    </g>
  ),
})

export const CommentsAddIcon = makeIcon({
  displayName: 'CommentsAdd',
  smallAlternative: CommentsAddSmallIcon,
  content: (
    <g>
      <path d="M12 0.5C12.4142 0.5 12.75 0.835786 12.75 1.25V2.5H14C14.4142 2.5 14.75 2.83579 14.75 3.25C14.75 3.66421 14.4142 4 14 4H12.75V5.25C12.75 5.66421 12.4142 6 12 6C11.5858 6 11.25 5.66421 11.25 5.25V4H10C9.58579 4 9.25 3.66421 9.25 3.25C9.25 2.83579 9.58579 2.5 10 2.5H11.25V1.25C11.25 0.835786 11.5858 0.5 12 0.5Z" />
      <path d="M2 7.5C2 4.73858 4.23858 2.5 7 2.5C7.41421 2.5 7.75 2.16421 7.75 1.75C7.75 1.33579 7.41421 1 7 1C3.41015 1 0.5 3.91015 0.5 7.5V14.3514C0.5 15.3313 1.57625 15.9302 2.40895 15.4136L5.47177 13.5136C5.59049 13.4399 5.72743 13.4009 5.86714 13.4009H9.4741C12.8021 13.4009 15.5 10.703 15.5 7.375V7.20045C15.5 6.78624 15.1642 6.45045 14.75 6.45045C14.3358 6.45045 14 6.78624 14 7.20045V7.375C14 9.87459 11.9737 11.9009 9.4741 11.9009H5.86714C5.448 11.9009 5.03719 12.018 4.68102 12.2389L2 13.9021V7.5Z" />
    </g>
  ),
})

export const CommentsEmptyIcon = makeIcon({
  displayName: 'CommentsEmpty',
  smallAlternative: CommentsEmptySmallIcon,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6.75C0 3.02208 3.02208 0 6.75 0H9.25C12.9779 0 16 3.02208 16 6.75C16 10.4779 12.9779 13.5 9.25 13.5H5.21589C5.06416 13.5 4.91601 13.546 4.79099 13.632L1.95816 15.7801C1.12878 16.3503 0 15.7565 0 14.75V6.75ZM6.75 1.5C3.85051 1.5 1.5 3.85051 1.5 6.75V14.25L3.94119 12.3959C4.31627 12.138 4.76072 12 5.21589 12H9.25C12.1495 12 14.5 9.6495 14.5 6.75C14.5 3.85051 12.1495 1.5 9.25 1.5H6.75Z"
    />
  ),
})
export const CommentsFullIcon = makeIcon({
  displayName: 'CommentsFullIcon',
  smallAlternative: CommentsFullSmallIcon,
  content: (
    <g>
      <path d="M1.25 7.5a6 6 0 016-6H9.3a5.45 5.45 0 010 10.9H5.867a1.5 1.5 0 00-.79.226l-3.063 1.9a.5.5 0 01-.764-.425V7.5z" />
      <path d="M.5 7.5A6.75 6.75 0 017.25.75H9.3a6.2 6.2 0 110 12.4H5.867a.75.75 0 00-.395.114l-3.063 1.9A1.25 1.25 0 01.5 14.1V7.5zm6.75-5.25A5.25 5.25 0 002 7.5v6.152l2.681-1.663a2.25 2.25 0 011.186-.338H9.3a4.7 4.7 0 000-9.401H7.25z" />
    </g>
  ),
})

export const ContextualButtonIcon = makeIcon({
  displayName: 'ContextualButtonIcon',
  content: (
    <g fill="none">
      <g stroke="currentColor" strokeWidth="1.5">
        <path
          strokeLinecap="round"
          d="M15 4.5V3.262a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1"
        />
        <path d="m6.886 6.266.11.026 6.894 2.216.106.043a.76.76 0 0 1 .194 1.223l-.087.074-1.537 1.112 1.991 1.96.053.057a.76.76 0 0 1 .004.964l-.052.059-1.081 1.081a.76.76 0 0 1-1.026.045l-.058-.054-1.822-1.88-.694 1.405a.761.761 0 0 1-1.354.02l-.048-.114-2.436-7.244a.76.76 0 0 1 .843-.993Z" />
      </g>
    </g>
  ),
})

export const CreateNoteIcon = makeIcon({
  displayName: 'CreateNoteIcon',
  smallAlternative: CreateNoteSmallIcon,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 0.5C2.50736 0.5 1.5 1.50736 1.5 2.75V13.25C1.5 14.4926 2.50736 15.5 3.75 15.5H11.75C12.9926 15.5 14 14.4926 14 13.25V8.75C14 8.33579 13.6642 8 13.25 8C12.8358 8 12.5 8.33579 12.5 8.75V13.25C12.5 13.6642 12.1642 14 11.75 14H3.75C3.33579 14 3 13.6642 3 13.25V2.75C3 2.33579 3.33579 2 3.75 2H6.75C7.16421 2 7.5 1.66421 7.5 1.25C7.5 0.835786 7.16421 0.5 6.75 0.5H3.75ZM12 1.25C12 0.835787 11.6642 0.5 11.25 0.5C10.8358 0.5 10.5 0.835787 10.5 1.25V3H8.75C8.33579 3 8 3.33579 8 3.75C8 4.16421 8.33579 4.5 8.75 4.5H10.5V6.25C10.5 6.66421 10.8358 7 11.25 7C11.6642 7 12 6.66421 12 6.25V4.5H13.75C14.1642 4.5 14.5 4.16421 14.5 3.75C14.5 3.33579 14.1642 3 13.75 3H12V1.25Z"
    />
  ),
})

export const CrossIcon = makeIcon({
  displayName: 'CrossIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
})

export const DeleteForeverIcon = makeIcon({
  displayName: 'DeleteForeverIcon',
  content: (
    <g>
      <path d="M3.5 1.35A.75.75 0 014.25.6h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75zM.75 4.1a.75.75 0 100 1.5h1.36l1.515 8.525A1.75 1.75 0 005.354 15.6h.896a.75.75 0 000-1.5h-.896a.25.25 0 01-.247-.21L3.629 5.6h7.742l-.401 2.252c-.07.39.23.748.627.748.44 0 .816-.315.893-.749l.4-2.251h1.36a.75.75 0 000-1.5H.75z" />
      <path
        d="M13 10.6l-4 4M9 10.6l4 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
})

export const DeleteIcon = makeIcon({
  displayName: 'DeleteIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 0.5C4.33579 0.5 4 0.835786 4 1.25C4 1.66421 4.33579 2 4.75 2H11.25C11.6642 2 12 1.66421 12 1.25C12 0.835786 11.6642 0.5 11.25 0.5H4.75ZM0.5 4.75C0.5 4.33579 0.835786 4 1.25 4H14.75C15.1642 4 15.5 4.33579 15.5 4.75C15.5 5.16421 15.1642 5.5 14.75 5.5H13.3901L11.8748 14.025C11.7396 14.8746 11.0069 15.5 10.1465 15.5H5.85351C4.99315 15.5 4.26042 14.8746 4.12524 14.025L2.60991 5.5H1.25C0.835786 5.5 0.5 5.16421 0.5 4.75ZM4.12877 5.5H11.8713L10.3934 13.7893C10.3741 13.9107 10.2694 14 10.1465 14H8.00002H5.85351C5.7306 14 5.62592 13.9107 5.60661 13.7893L4.12877 5.5Z"
    />
  ),
  smallAlternative: DeleteSmallIcon,
})

export const DiscussionIcon = makeIcon({
  displayName: 'DiscussionIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 2.75c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v5.075c0 .69-.56 1.25-1.25 1.25H13V6a2.75 2.75 0 00-2.75-2.75H4.5v-.5zm-1.5.5v-.5A2.75 2.75 0 015.75 0h7.5A2.75 2.75 0 0116 2.75v5.075a2.75 2.75 0 01-2.75 2.75h-.261a2.75 2.75 0 01-2.739 2.5H8.794a.75.75 0 00-.48.175L5.23 15.825a.75.75 0 01-1.22-.449l-.394-2.301H2.75A2.75 2.75 0 010 10.325V6a2.75 2.75 0 012.75-2.75H3zm8.5 6.575V6c0-.69-.56-1.25-1.25-1.25h-7.5c-.69 0-1.25.56-1.25 1.25v4.325c0 .69.56 1.25 1.25 1.25h1.5a.75.75 0 01.74.624l.28 1.64 2.081-1.74a2.25 2.25 0 011.443-.524h1.456c.69 0 1.25-.56 1.25-1.25v-.5z"
      fill="currentColor"
    />
  ),
  smallAlternative: DiscussionSmallIcon,
})

export const DiscussionDraftIcon = makeIcon({
  displayName: 'DiscussionDraftIcon',
  viewBox: 16,
  content: (
    <>
      <path d="M3.25 1.5A1.75 1.75 0 001.5 3.25v6.47c0 .967.784 1.75 1.75 1.75h1.125a.75.75 0 01.74.624l.297 1.744 2.207-1.844a2.25 2.25 0 011.443-.524h3.688a1.75 1.75 0 001.75-1.75V8.519a.75.75 0 011.5 0V9.72a3.25 3.25 0 01-3.25 3.25H9.062a.75.75 0 00-.48.174l-3.208 2.68a.75.75 0 01-1.22-.449l-.412-2.405H3.25A3.25 3.25 0 010 9.72V3.25A3.25 3.25 0 013.25 0h4.232a.75.75 0 110 1.5H3.25z" />
      <path d="M11.54 1.177a1.75 1.75 0 012.476 0l.707.707a1.75 1.75 0 010 2.475L9.868 9.214a.75.75 0 01-.473.217l-2.297.176a.75.75 0 01-.805-.805l.175-2.297a.75.75 0 01.218-.473l4.855-4.855zm1.415 1.06a.25.25 0 00-.354 0l-4.658 4.66-.088 1.147 1.148-.087 4.66-4.659a.25.25 0 000-.353l-.708-.707z" />
    </>
  ),
})

export const DiscussionOpenIcon = makeIcon({
  displayName: 'DiscussionOpenIcon',
  viewBox: 16,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 1.5A1.75 1.75 0 001.5 3.25v6.47c0 .967.784 1.75 1.75 1.75h1.125a.75.75 0 01.74.624l.297 1.744 2.207-1.844a2.25 2.25 0 011.443-.524h3.688a1.75 1.75 0 001.75-1.75V3.25a1.75 1.75 0 00-1.75-1.75h-9.5zM0 3.25A3.25 3.25 0 013.25 0h9.5A3.25 3.25 0 0116 3.25v6.47a3.25 3.25 0 01-3.25 3.25H9.062a.75.75 0 00-.48.175l-3.208 2.68a.75.75 0 01-1.22-.449l-.412-2.405H3.25A3.25 3.25 0 010 9.72V3.25z"
      />
      <path d="M5.75 4.5a.75.75 0 000 1.5H11a.75.75 0 000-1.5H5.75zM5 7.75A.75.75 0 015.75 7H9.5a.75.75 0 010 1.5H5.75A.75.75 0 015 7.75z" />
    </>
  ),
  smallAlternative: DiscussionOpenSmallIcon,
})

export const DiscussionClosedIcon = makeIcon({
  displayName: 'DiscussionClosedIcon',
  viewBox: 16,
  content: (
    <>
      <path d="M14.576 2.52a.75.75 0 01-.096 1.056l-6 5A.75.75 0 017.4 8.45l-2-2.667a.75.75 0 111.2-.9l1.526 2.035 5.394-4.494a.75.75 0 011.056.096z" />
      <path d="M3.25 1.5A1.75 1.75 0 001.5 3.25v6.47c0 .967.784 1.75 1.75 1.75h1.125a.75.75 0 01.74.624l.297 1.744 2.207-1.844a2.25 2.25 0 011.443-.524h3.688a1.75 1.75 0 001.75-1.75V8A.75.75 0 0116 8v1.72a3.25 3.25 0 01-3.25 3.25H9.062a.75.75 0 00-.48.175l-3.208 2.68a.75.75 0 01-1.22-.449l-.412-2.405H3.25A3.25 3.25 0 010 9.72V3.25A3.25 3.25 0 013.25 0h4.232a.75.75 0 110 1.5H3.25z" />
    </>
  ),
})

export const DiscussionDecisionIcon = makeIcon({
  displayName: 'DiscussionDecisionIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3.25c0-.966.784-1.75 1.75-1.75H6A.75.75 0 006 0H3.25A3.25 3.25 0 000 3.25v6.47a3.25 3.25 0 003.25 3.25h.492l.412 2.406a.75.75 0 001.22.45l3.207-2.681a.75.75 0 01.481-.175h3.688A3.25 3.25 0 0016 9.72V8.519a.75.75 0 00-1.5 0V9.72a1.75 1.75 0 01-1.75 1.75H9.062a2.25 2.25 0 00-1.443.523l-2.207 1.844-.298-1.744a.75.75 0 00-.739-.623H3.25A1.75 1.75 0 011.5 9.72V3.25zm10-2.895a.75.75 0 011.045.015l2.588 2.588a.75.75 0 01.015 1.046l-3.622 3.833.015.015a.75.75 0 01-1.06 1.06L9.065 7.498 7.475 9.089a.75.75 0 01-1.06-1.06l1.59-1.592-1.414-1.414a.75.75 0 111.06-1.06l.015.014L11.5.355zm.5 1.591L8.728 5.038l1.737 1.738 3.092-3.273L12 1.946z"
      fill="currentColor"
    />
  ),
  smallAlternative: DiscussionDecisionSmallIcon,
})

export const DlIcon = makeIcon({
  displayName: 'DlIcon',
  content: (
    <g>
      <path d="M16 15.25C16 15.6642 15.6642 16 15.25 16H0.75C0.335787 16 0 15.6642 0 15.25C0 14.8358 0.335787 14.5 0.75 14.5H15.25C15.6642 14.5 16 14.8358 16 15.25Z" />
      <path d="M12.0663 7.67971C11.7734 7.38682 11.2985 7.38682 11.0056 7.67971L8.74995 9.93541V0.749996C8.74995 0.335783 8.41416 -3.8147e-06 7.99995 -3.8147e-06C7.58574 -3.8147e-06 7.24995 0.335783 7.24995 0.749996V9.93442L4.99524 7.67971C4.70235 7.38682 4.22748 7.38682 3.93458 7.67971C3.64169 7.9726 3.64169 8.44748 3.93458 8.74037L7.47012 12.2759C7.76301 12.5688 8.23788 12.5688 8.53078 12.2759L12.0663 8.74037C12.3592 8.44748 12.3592 7.9726 12.0663 7.67971Z" />
    </g>
  ),
})

export const DotIcon = makeIcon({
  displayName: 'DotIcon',
  content: (
    <g>
      <circle cx="8" cy="8" r="3" />
    </g>
  ),
})

export const EmojiIcon = makeIcon({
  displayName: 'EmojiIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8ZM10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44771 6 9 6.44772 9 7C9 7.55228 9.44771 8 10 8ZM8 11.5C9.10457 11.5 10 10.6046 10 9.5H6C6 10.6046 6.89543 11.5 8 11.5Z"
    />
  ),
  smallAlternative: EmojiSmallIcon,
})

export const EvernoteIcon = makeIcon({
  displayName: 'EvernoteIcon',
  content: (
    <>
      <g clipPath="url(#clip0_2074_28452)">
        <path
          d="M5.4732 4.0799C5.50972 4.5876 5.18027 4.85039 4.70098 4.85039C3.81126 4.85039 2.17244 4.87695 2.02143 4.87695C1.87042 4.87695 1.70121 4.95837 1.70301 4.95662L5.57945 1.01716C5.5819 1.01465 5.49976 1.17001 5.49976 1.33553C5.49976 2.24958 5.4732 3.16507 5.4732 4.0799ZM8.16563 14.1173C8.23869 13.4661 8.64689 12.8703 9.22794 12.567C9.59577 12.375 10.2455 12.1696 10.5895 12.5148C10.9396 12.8662 10.7064 13.4569 10.2297 13.5392C9.65825 13.5828 9.31601 14.2114 9.76759 14.6667C10.3317 15.2325 11.2817 15.1013 11.8228 14.5613C12.7738 13.6121 12.1677 12.0636 11.0416 11.563C9.94649 11.1158 8.50057 11.501 8.16267 9.62625C8.16267 9.62625 7.75144 11.4821 6.92898 11.9873C5.55833 12.6562 3.56014 11.7755 2.59075 10.7804C2.59075 10.7804 1.92734 10.2364 1.58236 8.71114C1.42559 7.97736 1.24641 7.24551 1.18457 6.49599C1.18457 5.85254 1.58236 5.4081 2.08064 5.3441H4.78323C5.54053 5.3441 5.96411 4.94977 5.96411 4.19029V1.39696C6.09545 0.353211 7.46388 0.401663 8.2286 0.605998C9.03794 0.807578 9.21043 1.62734 9.21043 1.62734L11.5056 2.02506C12.2353 2.15785 14.0396 2.2772 14.3858 4.0943C15.1949 8.41869 14.7059 12.6103 14.6643 12.6103C14.0927 16.6969 10.6963 16.4995 10.6963 16.4995C9.40249 16.4856 8.00512 15.5483 8.16563 14.1173ZM11.1847 7.76211C11.1464 7.83602 11.1078 7.97772 11.2151 8.01169C11.6798 8.17451 12.3656 8.31366 12.8536 8.20943C12.9657 8.20043 12.963 8.05345 12.9425 7.97201C12.8853 7.61653 12.541 7.34958 12.1332 7.30008C11.958 7.27881 11.3931 7.25218 11.1847 7.76211Z"
          fill="#00A82D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2074_28452">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

export const EvernoteIconMonochrome = makeIcon({
  displayName: 'EvernoteIconMonochrome',
  content: (
    <path
      fill="currentColor"
      d="M5.473 3.579c.036.508-.293.77-.773.77-.89 0-2.528.027-2.68.027-.15 0-.32.081-.318.08L5.58.516c.002-.002-.08.153-.08.318 0 .915-.026 1.83-.026 2.745Zm2.692 10.037a2.027 2.027 0 0 1 1.062-1.55c.368-.192 1.018-.397 1.362-.052.35.351.117.942-.36 1.024-.571.044-.914.672-.462 1.128.564.566 1.514.434 2.055-.106.951-.949.345-2.497-.781-2.998C9.946 10.615 8.5 11 8.162 9.125c0 0-.411 1.856-1.234 2.361-1.37.67-3.368-.212-4.338-1.207 0 0-.663-.544-1.008-2.069-.157-.734-.336-1.466-.398-2.215 0-.644.398-1.088.896-1.152h2.703c.757 0 1.18-.394 1.18-1.154V.896C6.096-.148 7.464-.1 8.229.105c.81.202.982 1.021.982 1.021l2.295.398c.73.133 2.534.252 2.88 2.07.81 4.324.32 8.515.279 8.515-.572 4.087-3.968 3.89-3.968 3.89-1.294-.014-2.691-.952-2.53-2.383Zm3.02-6.355c-.04.074-.078.216.03.25.464.162 1.15.302 1.638.197.112-.009.11-.156.089-.237-.057-.356-.402-.622-.81-.672-.175-.021-.74-.048-.948.462Z"
    />
  ),
})

export const ErrorIcon = makeIcon({
  displayName: 'ErrorIcon',
  content: (
    <g>
      <path d="M8.75 9.75C8.75 10.1642 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.1642 7.25 9.75L7.25 5.75C7.25 5.33579 7.58579 5 8 5C8.41421 5 8.75 5.33579 8.75 5.75V9.75Z" />
      <path d="M7.25 12.25C7.25 11.8358 7.58579 11.5 8 11.5C8.41421 11.5 8.75 11.8358 8.75 12.25C8.75 12.6642 8.41421 13 8 13C7.58579 13 7.25 12.6642 7.25 12.25Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.81339 1.24377C6.64257 -0.414591 9.00913 -0.414589 9.83831 1.24377L15.4113 12.3897C16.1593 13.8857 15.0714 15.6459 13.3988 15.6459H2.2529C0.580293 15.6459 -0.507572 13.8857 0.240442 12.3897L5.81339 1.24377ZM8.49667 1.91459C8.22028 1.3618 7.43142 1.3618 7.15503 1.91459L1.58208 13.0605C1.33274 13.5592 1.69537 14.1459 2.2529 14.1459H13.3988C13.9563 14.1459 14.319 13.5592 14.0696 13.0605L8.49667 1.91459Z"
      />
    </g>
  ),
})

export const ExpandIcon = makeIcon({
  displayName: 'ExpandIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2493 6.5C14.8351 6.5 14.4993 6.16421 14.4993 5.75V2.55984L10.8655 6.1936C10.5517 6.50741 10.0599 6.52437 9.76698 6.23148C9.47409 5.93859 9.49105 5.44675 9.80486 5.13294L13.4378 1.5L10.2493 1.5C9.83506 1.5 9.49928 1.16421 9.49928 0.750001C9.49928 0.335787 9.83506 0 10.2493 0H15.2493C15.6635 0 15.9993 0.335787 15.9993 0.75L15.9993 5.75C15.9993 6.16421 15.6635 6.5 15.2493 6.5ZM0.750601 9.5C1.16481 9.5 1.5006 9.83579 1.5006 10.25L1.5006 13.4402L5.13436 9.8064C5.44817 9.49259 5.94 9.47563 6.2329 9.76852C6.52579 10.0614 6.50883 10.5532 6.19502 10.8671L2.56208 14.5H5.7506C6.16481 14.5 6.5006 14.8358 6.5006 15.25C6.5006 15.6642 6.16481 16 5.7506 16H0.750601C0.336387 16 0.000600807 15.6642 0.000600865 15.25L0.000600949 10.25C0.000600933 9.83579 0.336387 9.5 0.750601 9.5ZM10.2499 14.4993C9.83573 14.4993 9.49994 14.8351 9.49994 15.2493C9.49994 15.6636 9.83573 15.9993 10.2499 15.9993L15.2499 15.9993C15.6642 15.9993 15.9999 15.6636 15.9999 15.2493L15.9999 10.2493C15.9999 9.83512 15.6642 9.49934 15.2499 9.49934C14.8357 9.49934 14.4999 9.83512 14.4999 10.2493V13.4379L10.867 9.80489C10.5532 9.49108 10.0613 9.47412 9.76843 9.76701C9.47553 10.0599 9.49249 10.5517 9.80631 10.8656L13.4401 14.4993H10.2499ZM6.49994 0.750662C6.49994 1.16488 6.16415 1.50066 5.74994 1.50066L2.55978 1.50066L6.19357 5.13445C6.50738 5.44826 6.52434 5.9401 6.23145 6.23299C5.93856 6.52588 5.44672 6.50892 5.13291 6.19511L1.49994 2.56214L1.49994 5.75066C1.49994 6.16488 1.16415 6.50066 0.749939 6.50066C0.335725 6.50066 -6.12037e-05 6.16488 -6.10352e-05 5.75066L-6.08455e-05 0.750662C-6.10299e-05 0.336449 0.335725 0.000662369 0.749939 0.000662259L5.74994 0.000662364C6.16415 0.000662348 6.49994 0.336449 6.49994 0.750662Z"
      />
    </g>
  ),
  smallAlternative: ExpandSmallIcon,
})

export const ExpandTwoCornersIcon = makeIcon({
  displayName: 'ExpandTwoCorners',
  content: (
    <g>
      <path
        d="M9.5 0.75061C9.5 1.16483 9.83579 1.50061 10.25 1.50061L13.4401 1.50061L9.80636 5.13437C9.49255 5.44819 9.47559 5.94002 9.76848 6.23291C10.0614 6.52581 10.5532 6.50885 10.867 6.19503L14.5 2.56205L14.5 5.75061C14.5 6.16482 14.8358 6.50061 15.25 6.50061C15.6642 6.50061 16 6.16482 16 5.75061L16 0.750611C16 0.336397 15.6642 0.000610588 15.25 0.00061057L10.25 0.000610352C9.83579 0.000612241 9.5 0.336397 9.5 0.75061Z"
        fill="currentColor"
      />
      <path
        d="M6.5 15.2493C6.5 14.8351 6.16421 14.4993 5.75 14.4993H2.55987L6.19364 10.8656C6.50745 10.5517 6.52441 10.0599 6.23152 9.76702C5.93862 9.47412 5.44679 9.49108 5.13298 9.8049L1.5 13.4379L1.5 10.2493C1.5 9.83511 1.16421 9.49932 0.749998 9.49932C0.335784 9.49932 -1.90735e-06 9.83511 -1.90735e-06 10.2493V15.2493C-1.90735e-06 15.6635 0.335783 15.9993 0.749997 15.9993L5.75 15.9993C6.16421 15.9993 6.5 15.6635 6.5 15.2493Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: ExpandTwoCornersSmallIcon,
})

export const RSSIcon = makeIcon({
  displayName: 'RSSIcon',
  content: (
    <g>
      <path d="M0 5.4375C2.91235 5.44375 5.54983 6.62478 7.45605 8.53711C9.36855 10.4559 10.5566 13.0875 10.5566 16H7.4873V15.9941C7.4873 13.9941 6.70645 12.1059 5.29395 10.6934C3.88146 9.28092 1.9937 8.49414 0 8.49414V5.4375ZM0.00585938 0C4.41836 0 8.41289 1.79336 11.3066 4.69336C14.2066 7.59336 16 11.5875 16 16H12.9375C12.9312 8.86875 7.13711 3.06289 0.00585938 3.05664V0ZM2.125 11.7441C2.7125 11.7441 3.2375 11.9816 3.625 12.3691C4.01238 12.7566 4.25 13.2817 4.25 13.8691C4.24989 14.4502 4.01236 14.9749 3.625 15.3623C3.2375 15.7498 2.7125 15.9814 2.125 15.9814C1.5375 15.9814 1.0125 15.7436 0.625 15.3623C0.237644 14.9749 0.000106476 14.4502 0 13.8691C0 13.2817 0.237616 12.7566 0.625 12.3691C1.0125 11.9816 1.5375 11.7441 2.125 11.7441Z" />
    </g>
  ),
  smallAlternative: ReduceTwoCornersSmallIcon,
})

export const ReduceTwoCornersIcon = makeIcon({
  displayName: 'ReduceTwoCorners',
  content: (
    <g>
      <path
        d="M16.005 5.74438C16.005 5.33017 15.6692 4.99438 15.255 4.99438H12.0649L15.6986 1.36062C16.0125 1.04681 16.0294 0.554972 15.7365 0.262079C15.4436 -0.0308149 14.9518 -0.013851 14.638 0.299959L11.005 3.93294L11.005 0.744383C11.005 0.33017 10.6692 -0.00561522 10.255 -0.00561523C9.84079 -0.00561525 9.50501 0.33017 9.50501 0.744385V5.74438C9.50501 6.1586 9.84079 6.49438 10.255 6.49438H15.255C15.6692 6.49438 16.005 6.1586 16.005 5.74438Z"
        fill="currentColor"
      />
      <path
        d="M0.00500774 10.2557C0.00500774 10.6699 0.340794 11.0057 0.755008 11.0057H3.94513L0.31137 14.6394C-0.00244522 14.9532 -0.0194054 15.4451 0.273489 15.738C0.566381 16.0309 1.05822 16.0139 1.37203 15.7001L5.00501 12.0671L5.00501 15.2557C5.00501 15.6699 5.34079 16.0057 5.75501 16.0057C6.16922 16.0057 6.50501 15.6699 6.50501 15.2557L6.50501 10.2557C6.50501 9.84146 6.16922 9.50567 5.75501 9.50567L0.755007 9.50567C0.340794 9.50567 0.00500679 9.84146 0.00500774 10.2557Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: ReduceTwoCornersSmallIcon,
})

export const ExternalLinkIcon = makeIcon({
  displayName: 'ExternalLinkIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.2035 0C15.6176 4.59875e-05 15.9535 0.335815 15.9535 0.75V4.75C15.9535 5.16419 15.6176 5.49995 15.2035 5.5C14.7892 5.5 14.4535 5.16421 14.4535 4.75V2.44727C14.4508 2.45058 14.4493 2.45473 14.4466 2.45801L14.3958 2.51465L10.1302 6.78027C9.83735 7.07312 9.36256 7.07306 9.06966 6.78027C8.77678 6.48738 8.77678 6.01262 9.06966 5.71973L13.2894 1.5H11.2035C10.7892 1.5 10.4535 1.16421 10.4535 0.75C10.4535 0.335786 10.7892 9.05292e-09 11.2035 0H15.2035ZM14.4535 1.52344V1.5H14.4339C14.4406 1.50779 14.4472 1.51544 14.4535 1.52344Z"
        fill="currentColor"
      />
      <path
        d="M1.5 3.25L1.5 12.75C1.5 13.7165 2.2835 14.5 3.25 14.5L12.75 14.5C13.7165 14.5 14.5 13.7165 14.5 12.75V10.5C14.5 10.0858 14.8358 9.75 15.25 9.75C15.6642 9.75 16 10.0858 16 10.5V12.75C16 14.5449 14.5449 16 12.75 16L3.25 16C1.45507 16 -1.32758e-07 14.5449 0 12.75L8.30516e-07 3.25C9.87434e-07 1.45507 1.45508 6.8411e-07 3.25 7.92708e-07L5.5 9.89409e-07C5.91421 1.02562e-06 6.25 0.335788 6.25 0.750001C6.25 1.16421 5.91421 1.5 5.5 1.5L3.25 1.5C2.2835 1.5 1.5 2.2835 1.5 3.25Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: ExternalLinkSmallIcon,
})

export const EyeIcon = makeIcon({
  displayName: 'EyeIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0303 5.09467C14.6694 5.73374 15.1389 6.37112 15.4494 6.84946L15.9278 7.67894C16.0241 7.88216 16.0241 8.11784 15.9278 8.32106C15.7802 8.60497 15.6238 8.88186 15.4494 9.15054C15.1389 9.62888 14.6694 10.2663 14.0303 10.9053C12.752 12.1837 10.7597 13.5 8 13.5C5.24029 13.5 3.24804 12.1837 1.96967 10.9053C1.3306 10.2663 0.861107 9.62888 0.550603 9.15054C0.394953 8.91076 0.278132 8.7092 0.198971 8.56497L0.0721966 8.32106C-0.0240655 8.11784 -0.0240655 7.88216 0.0721966 7.67894L0.198971 7.43503C0.278132 7.2908 0.394953 7.08924 0.550603 6.84946C0.861107 6.37112 1.3306 5.73374 1.96967 5.09467C3.24804 3.8163 5.24029 2.5 8 2.5C10.7597 2.5 12.752 3.8163 14.0303 5.09467ZM1.60278 8C1.65821 8.09491 1.72681 8.20758 1.80876 8.33383C2.07638 8.74612 2.48189 9.29624 3.03032 9.84467C4.12694 10.9413 5.75969 12 7.99999 12C10.2403 12 11.873 10.9413 12.9697 9.84467C13.5181 9.29624 13.9236 8.74612 14.1912 8.33383C14.2732 8.20758 14.3418 8.09491 14.3972 8C14.3418 7.90508 14.2732 7.79242 14.1912 7.66617C13.9236 7.25388 13.5181 6.70376 12.9697 6.15533C11.873 5.0587 10.2403 4 7.99999 4C5.75969 4 4.12694 5.0587 3.03032 6.15533C2.48189 6.70376 2.07638 7.25388 1.80876 7.66617C1.72681 7.79242 1.65821 7.90508 1.60278 8ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      />
    </g>
  ),
  smallAlternative: EyeSmallIcon,
})

export const FavoriteEmptyIcon = makeIcon({
  displayName: 'FavoriteIcon',
  content: (
    <path d="M8 0.350006C8.30049 0.350006 8.57286 0.526798 8.6952 0.801258L10.6192 5.11752L15.3187 5.61353C15.6176 5.64507 15.8699 5.84948 15.9627 6.13526C16.0556 6.42104 15.9716 6.73471 15.7484 6.93588L12.2379 10.0995L13.2184 14.7223C13.2808 15.0163 13.1643 15.3194 12.9212 15.496C12.6781 15.6726 12.3539 15.6897 12.0936 15.5396L8 13.1785L3.90643 15.5396C3.64614 15.6897 3.32187 15.6726 3.07877 15.496C2.83567 15.3194 2.71923 15.0163 2.78158 14.7223L3.76209 10.0995L0.251619 6.93588C0.0283977 6.73471 -0.0555759 6.42104 0.0372811 6.13526C0.130138 5.84948 0.382443 5.64507 0.681275 5.61353L5.38083 5.11752L7.3048 0.801258C7.42714 0.526798 7.69951 0.350006 8 0.350006ZM8 2.98064L6.59249 6.13826C6.48187 6.38641 6.24737 6.55679 5.97718 6.58531L2.53916 6.94817L5.10729 9.26255C5.30912 9.44444 5.39869 9.72011 5.34232 9.98589L4.62502 13.3678L7.61972 11.6405C7.85507 11.5048 8.14493 11.5048 8.38028 11.6405L11.375 13.3678L10.6577 9.98589C10.6013 9.72011 10.6909 9.44444 10.8927 9.26255L13.4608 6.94817L10.0228 6.58531C9.75263 6.55679 9.51812 6.38641 9.40751 6.13826L8 2.98064Z" />
  ),
})

export const FavoriteIcon = makeIcon({
  displayName: 'FavoriteIcon',
  content: (
    <path d="M8 0.350006C8.30049 0.350006 8.57286 0.526798 8.6952 0.801258L10.6192 5.11752L15.3187 5.61353C15.6176 5.64507 15.8699 5.84948 15.9627 6.13526C16.0556 6.42104 15.9716 6.73471 15.7484 6.93588L12.2379 10.0995L13.2184 14.7223C13.2808 15.0163 13.1643 15.3194 12.9212 15.496C12.6781 15.6726 12.3539 15.6897 12.0936 15.5396L8 13.1785L3.90643 15.5396C3.64614 15.6897 3.32187 15.6726 3.07877 15.496C2.83567 15.3194 2.71923 15.0163 2.78158 14.7223L3.76209 10.0995L0.251619 6.93588C0.0283977 6.73471 -0.0555759 6.42104 0.0372811 6.13526C0.130138 5.84948 0.382443 5.64507 0.681275 5.61353L5.38083 5.11752L7.3048 0.801258C7.42714 0.526798 7.69951 0.350006 8 0.350006Z" />
  ),
})

export const FileHtmlIcon = makeIcon({
  displayName: 'FileHtmlIcon',
  content: (
    <g>
      <path
        d="M9.12012 0.00390625C9.9448 0.0430671 10.7374 0.374816 11.3398 0.953125L13.9814 3.48926C14.6261 4.10827 15 4.96149 15 5.86426V12.6719C15 14.5667 13.4176 16 11.5957 16H4.4043C2.58236 16 1 14.5667 1 12.6719V3.32812C1 1.43326 2.58236 0 4.4043 0H8.95508L9.12012 0.00390625ZM4.4043 1.5C3.35283 1.5 2.5 2.31848 2.5 3.32812V12.6719C2.5 13.6815 3.35283 14.5 4.4043 14.5H11.5957C12.6472 14.5 13.5 13.6815 13.5 12.6719V5.86426C13.5 5.84139 13.497 5.81867 13.4961 5.7959H10.8848C9.76428 5.7959 8.75 4.90875 8.75 3.68652V1.5H4.4043ZM10.25 3.68652C10.25 4.02307 10.5343 4.2959 10.8848 4.2959H12.6553L10.3008 2.03516C10.2845 2.01949 10.2668 2.00527 10.25 1.99023V3.68652Z"
        fill="currentColor"
      />
      <path
        d="M3.37913 12V9.16H4.02313V10.496L3.79913 10.284H5.00713L4.78313 10.496V9.16H5.42713V12H4.78313V10.648L5.00713 10.86H3.79913L4.02313 10.648V12H3.37913ZM6.47756 12V9.732H5.76156V9.16H7.84156V9.732H7.12556V12H6.47756ZM9.024 11.584L8.664 10.056L8.748 10.036V12H8.168V9.16H8.848L9.272 10.78H9.128L9.552 9.16H10.232V12H9.652V10.036L9.736 10.056L9.376 11.584H9.024ZM10.7664 12V9.16H11.4104V11.836L10.9104 11.428H12.5904V12H10.7664Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const FileMDIcon = makeIcon({
  displayName: 'FileMDIcon',
  content: (
    <g>
      <path
        d="M9.12012 0.00390625C9.9448 0.0430671 10.7374 0.374816 11.3398 0.953125L13.9814 3.48926C14.6261 4.10827 15 4.96149 15 5.86426V12.6719C15 14.5667 13.4176 16 11.5957 16H4.4043C2.58236 16 1 14.5667 1 12.6719V3.32812C1 1.43326 2.58236 0 4.4043 0H8.95508L9.12012 0.00390625ZM4.4043 1.5C3.35283 1.5 2.5 2.31848 2.5 3.32812V12.6719C2.5 13.6815 3.35283 14.5 4.4043 14.5H11.5957C12.6472 14.5 13.5 13.6815 13.5 12.6719V5.86426C13.5 5.84139 13.497 5.81867 13.4961 5.7959H10.8848C9.76428 5.7959 8.75 4.90875 8.75 3.68652V1.5H4.4043ZM10.25 3.68652C10.25 4.02307 10.5343 4.2959 10.8848 4.2959H12.6553L10.3008 2.03516C10.2845 2.01949 10.2668 2.00527 10.25 1.99023V3.68652Z"
        fill="currentColor"
      />
      <path
        d="M4.94434 11.412L4.34434 8.868L4.44634 8.844V12H3.66634V7.74H4.62634L5.31634 10.44H5.08834L5.77834 7.74H6.73834V12H5.95834V8.844L6.06034 8.868L5.46034 11.412H4.94434ZM7.408 12V7.74H8.506C8.906 7.74 9.246 7.822 9.526 7.986C9.81 8.15 10.028 8.392 10.18 8.712C10.332 9.028 10.408 9.414 10.408 9.87C10.408 10.326 10.332 10.712 10.18 11.028C10.028 11.344 9.81 11.586 9.526 11.754C9.246 11.918 8.906 12 8.506 12H7.408ZM8.266 11.232H8.512C8.844 11.232 9.096 11.12 9.268 10.896C9.444 10.668 9.532 10.326 9.532 9.87C9.532 9.418 9.444 9.078 9.268 8.85C9.096 8.622 8.844 8.508 8.512 8.508H8.266V11.232Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const FilePDFIcon = makeIcon({
  displayName: 'FilePDFIcon',
  content: (
    <g>
      <path
        d="M9.12012 0.00390625C9.9448 0.0430671 10.7374 0.374816 11.3398 0.953125L13.9814 3.48926C14.6261 4.10827 15 4.96149 15 5.86426V12.6719C15 14.5667 13.4176 16 11.5957 16H4.4043C2.58236 16 1 14.5667 1 12.6719V3.32812C1 1.43326 2.58236 0 4.4043 0H8.95508L9.12012 0.00390625ZM4.4043 1.5C3.35283 1.5 2.5 2.31848 2.5 3.32812V12.6719C2.5 13.6815 3.35283 14.5 4.4043 14.5H11.5957C12.6472 14.5 13.5 13.6815 13.5 12.6719V5.86426C13.5 5.84139 13.497 5.81867 13.4961 5.7959H10.8848C9.76428 5.7959 8.75 4.90875 8.75 3.68652V1.5H4.4043ZM10.25 3.68652C10.25 4.02307 10.5343 4.2959 10.8848 4.2959H12.6553L10.3008 2.03516C10.2845 2.01949 10.2668 2.00527 10.25 1.99023V3.68652Z"
        fill="currentColor"
      />
      <path
        d="M3.87293 12V8.45H5.04293C5.28626 8.45 5.50126 8.5 5.68793 8.6C5.87793 8.69667 6.02626 8.83167 6.13293 9.005C6.2396 9.17833 6.29293 9.38 6.29293 9.61C6.29293 9.84 6.2396 10.0417 6.13293 10.215C6.02626 10.385 5.87793 10.52 5.68793 10.62C5.50126 10.7167 5.28626 10.765 5.04293 10.765H4.67793V12H3.87293ZM4.67793 10.05H4.95793C5.12793 10.05 5.2546 10.0133 5.33793 9.94C5.4246 9.86333 5.46793 9.75333 5.46793 9.61C5.46793 9.46333 5.4246 9.35333 5.33793 9.28C5.2546 9.20333 5.12793 9.165 4.95793 9.165H4.67793V10.05ZM6.80598 12V8.45H7.74098C8.08431 8.45 8.37431 8.51833 8.61098 8.655C8.85098 8.79167 9.03431 8.99333 9.16098 9.26C9.28764 9.52333 9.35098 9.845 9.35098 10.225C9.35098 10.605 9.28764 10.9267 9.16098 11.19C9.03431 11.4533 8.85098 11.655 8.61098 11.795C8.37431 11.9317 8.08431 12 7.74098 12H6.80598ZM7.61098 11.285H7.76098C8.01098 11.285 8.20098 11.1967 8.33098 11.02C8.46098 10.8433 8.52598 10.5783 8.52598 10.225C8.52598 9.87167 8.46098 9.60667 8.33098 9.43C8.20098 9.25333 8.01098 9.165 7.76098 9.165H7.61098V11.285ZM9.95902 12V8.45H12.239V9.165H10.234L10.764 8.655V10.28L10.234 9.91H12.149V10.61H10.234L10.764 10.25V12H9.95902Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const FlagIcon = makeIcon({
  viewBox: 16,
  displayName: 'FlagIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 15.25C3.5 15.6642 3.83579 16 4.25 16C4.66421 16 5 15.6642 5 15.25L5 9.75H13C13.2734 9.75 13.5252 9.60122 13.657 9.3617C13.7889 9.12219 13.7799 8.8299 13.6337 8.59888L11.8305 5.75L13.6337 2.90112C13.7799 2.6701 13.7889 2.37781 13.657 2.1383C13.5252 1.89878 13.2734 1.75 13 1.75H5V0.75C5 0.335787 4.66421 0 4.25 0C3.83579 0 3.5 0.335787 3.5 0.75V15.25ZM5 3.25L5 8.25H11.6377L10.3091 6.15112C10.1541 5.90618 10.1541 5.59382 10.3091 5.34888L11.6377 3.25H5Z"
    />
  ),
})

export const GlobeIcon = makeIcon({
  displayName: 'GlobeIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00002 1.72415C4.53395 1.72415 1.72415 4.53395 1.72415 8.00002C1.72415 11.4661 4.53395 14.2759 8.00002 14.2759C11.4661 14.2759 14.2759 11.4661 14.2759 8.00002C14.2759 4.53395 11.4661 1.72415 8.00002 1.72415ZM0.275879 8.00002C0.275879 3.73409 3.73409 0.275879 8.00002 0.275879C12.2659 0.275879 15.7242 3.73409 15.7242 8.00002C15.7242 12.2659 12.2659 15.7242 8.00002 15.7242C3.73409 15.7242 0.275879 12.2659 0.275879 8.00002Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 8.50002H0.500017V7.00002H15.5V8.50002Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.61969 3.2803C6.14213 4.41922 5.82764 6.06869 5.82764 8.00002C5.82764 9.93134 6.14213 11.5808 6.61969 12.7197C6.859 13.2905 7.12511 13.6991 7.38259 13.9546C7.63614 14.2061 7.84382 14.2759 8.00002 14.2759C8.15621 14.2759 8.36396 14.2061 8.61751 13.9546C8.87499 13.6991 9.1411 13.2905 9.38041 12.7197C9.85798 11.5808 10.1725 9.93134 10.1725 8.00002C10.1725 6.06869 9.85798 4.41922 9.38041 3.2803C9.1411 2.70957 8.87499 2.30088 8.61751 2.04543C8.36396 1.79388 8.15621 1.72415 8.00002 1.72415C7.84382 1.72415 7.63614 1.79388 7.38259 2.04543C7.12511 2.30088 6.859 2.70957 6.61969 3.2803ZM6.36257 1.0173C6.8021 0.581236 7.35635 0.275879 8.00002 0.275879C8.64368 0.275879 9.198 0.581236 9.63753 1.0173C10.0731 1.44945 10.4312 2.0409 10.716 2.72026C11.2868 4.08151 11.6207 5.93204 11.6207 8.00002C11.6207 10.068 11.2868 11.9185 10.716 13.2798C10.4312 13.9591 10.0731 14.5506 9.63753 14.9827C9.198 15.4188 8.64368 15.7242 8.00002 15.7242C7.35635 15.7242 6.8021 15.4188 6.36257 14.9827C5.92698 14.5506 5.56893 13.9591 5.28407 13.2798C4.71329 11.9185 4.37936 10.068 4.37936 8.00002C4.37936 5.93204 4.71329 4.08151 5.28407 2.72026C5.56893 2.0409 5.92698 1.44945 6.36257 1.0173Z"
      />
    </g>
  ),
  smallAlternative: GlobeSmallIcon,
})

export const GlobeStrikedThroughIcon = makeIcon({
  displayName: 'GlobeStrikedThroughIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.46967 14.4697C0.176777 14.7626 0.176777 15.2374 0.46967 15.5303C0.762563 15.8232 1.23744 15.8232 1.53033 15.5303L3.09419 13.9665C4.42829 15.0647 6.13714 15.7242 8.00002 15.7242C12.2659 15.7242 15.7242 12.2659 15.7242 8.00002C15.7242 6.13714 15.0647 4.42829 13.9665 3.09419L15.5303 1.53033C15.8232 1.23744 15.8232 0.762563 15.5303 0.46967C15.2374 0.176777 14.7626 0.176777 14.4697 0.46967L0.46967 14.4697ZM12.9364 4.12424L11.4611 5.59957C11.5233 6.04829 11.5681 6.51641 11.5942 7.00002H14.1966C14.0247 5.92605 13.5802 4.94308 12.9364 4.12424ZM8.56064 8.50002L6.10096 10.9597C6.23458 11.6307 6.41166 12.2236 6.61969 12.7197C6.859 13.2905 7.12511 13.6991 7.38259 13.9546C7.63614 14.2061 7.84382 14.2759 8.00002 14.2759C8.15621 14.2759 8.36396 14.2061 8.61751 13.9546C8.87499 13.6991 9.1411 13.2905 9.38041 12.7197C9.81622 11.6804 10.1162 10.2159 10.1654 8.50002H8.56064ZM4.89915 12.1615L4.12424 12.9364C4.54481 13.2671 5.00868 13.5452 5.50594 13.7608C5.42758 13.6064 5.35364 13.4457 5.28407 13.2798C5.1402 12.9367 5.01137 12.5624 4.89915 12.1615ZM10.716 13.2798C10.6465 13.4457 10.5725 13.6063 10.4942 13.7607C12.5742 12.8589 14.0699 10.8636 14.2563 8.50002H11.6142C11.5649 10.3657 11.2404 12.0292 10.716 13.2798Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.38593 8.50002C4.39196 8.72801 4.40209 8.95298 4.4162 9.17455L6.59073 7.00002H5.85648C5.94435 5.4995 6.22685 4.21717 6.61969 3.2803C6.859 2.70957 7.12511 2.30088 7.38259 2.04543C7.63614 1.79388 7.84382 1.72415 8.00002 1.72415C8.15621 1.72415 8.36396 1.79388 8.61751 2.04543C8.87499 2.30088 9.1411 2.70957 9.38041 3.2803C9.46873 3.49091 9.55147 3.71899 9.62767 3.96308L10.761 2.82974C10.7462 2.79291 10.7312 2.75641 10.716 2.72026C10.6465 2.55436 10.5725 2.3937 10.4942 2.23932C10.6906 2.32449 10.8819 2.41941 11.0673 2.52348L12.1234 1.46736C10.9303 0.712703 9.51616 0.275879 8.00002 0.275879C3.73409 0.275879 0.275879 3.73409 0.275879 8.00002C0.275879 9.51616 0.712703 10.9303 1.46736 12.1234L2.52348 11.0673C2.09133 10.2973 1.81685 9.427 1.74378 8.50002H4.38593ZM1.80339 7.00002C2.1465 4.85725 3.5743 3.07671 5.50594 2.23928C5.42758 2.39367 5.35364 2.55434 5.28407 2.72026C4.80702 3.85797 4.49542 5.33746 4.40595 7.00002H1.80339Z"
      />
    </g>
  ),
  smallAlternative: GlobeStrikedThroughSmallIcon,
})
export const AppleIcon = makeIcon({
  displayName: 'AppleIcon',
  viewBox: 56,
  content: (
    <g fillRule="evenodd" id="BlackLogo-Square">
      <path
        stroke="null"
        fillRule="nonzero"
        id=""
        d="m29.050146,13.488659c2.325902,0 5.241477,-1.620777 6.977706,-3.781775c1.572443,-1.95844 2.719027,-4.693456 2.719027,-7.428501c0,-0.371404 -0.032763,-0.742836 -0.098288,-1.04673c-2.587976,0.101307 -5.700099,1.789594 -7.567379,4.051899c-1.474155,1.722056 -2.817287,4.423332 -2.817287,7.192117c0,0.405201 0.065497,0.810374 0.09826,0.945451c0.163814,0.033769 0.425887,0.067538 0.687961,0.067538zm-8.189815,40.85663c3.177649,0 4.586279,-2.194767 8.550149,-2.194767c4.029396,0 4.913906,2.127229 8.451889,2.127229c3.472486,0 5.798388,-3.309035 7.993267,-6.550561c2.456925,-3.714237 3.472458,-7.360963 3.537983,-7.52978c-0.229311,-0.067538 -6.879446,-2.870093 -6.879446,-10.737536c0,-6.820685 5.241477,-9.893393 5.536314,-10.129749c-3.472486,-5.132399 -8.746698,-5.267447 -10.188118,-5.267447c-3.898345,0 -7.075994,2.431123 -9.074297,2.431123c-2.162116,0 -5.012166,-2.296075 -8.386364,-2.296075c-6.420824,0 -12.939907,5.470062 -12.939907,15.802397c0,6.415512 2.42419,13.202456 5.405263,17.591991c2.555241,3.714264 4.782855,6.753175 7.993267,6.753175z"
      />
    </g>
  ),
})

export const TextIcon = makeIcon({
  displayName: 'TextIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1.25C1 0.835786 1.33579 0.5 1.75 0.5H14.25C14.6642 0.5 15 0.835786 15 1.25V4.77703C15 5.19124 14.6642 5.52703 14.25 5.52703C13.8358 5.52703 13.5 5.19124 13.5 4.77703V2H8.75V14H11.625C12.0392 14 12.375 14.3358 12.375 14.75C12.375 15.1642 12.0392 15.5 11.625 15.5H4.375C3.96079 15.5 3.625 15.1642 3.625 14.75C3.625 14.3358 3.96079 14 4.375 14H7.25V2H2.5V4.77703C2.5 5.19124 2.16421 5.52703 1.75 5.52703C1.33579 5.52703 1 5.19124 1 4.77703V1.25Z"
    />
  ),
  smallAlternative: TextSmallIcon,
})

export const FormatIcon = makeIcon({
  displayName: 'FormatIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.738 0a.75.75 0 0 0-.705.495L1.795 14.959a.75.75 0 0 0 1.41.51l1.373-3.79h6.844l1.373 3.79a.75.75 0 0 0 1.41-.51L8.967.495A.75.75 0 0 0 8.262 0h-.524Zm3.141 10.179L8 2.229l-2.879 7.95h5.758Z"
      fill="currentColor"
    />
  ),
  smallAlternative: FormatSmallIcon,
})

export const BucketIcon = makeIcon({
  displayName: 'BucketIcon',
  viewBox: 16,
  content: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.709.23A.75.75 0 0 1 3.769.21l1.843 1.766L6.84.747a1.788 1.788 0 0 1 2.529 0l4.884 4.884c.699.699.699 1.831 0 2.53l-6.135 6.135a1.789 1.789 0 0 1-2.53 0L.704 9.412a1.788 1.788 0 0 1 0-2.53l3.847-3.846-1.82-1.745a.75.75 0 0 1-.022-1.06Zm3.335 4.238-.41-.394-3.468 3.468 8.445 2.14L13.193 7.1a.289.289 0 0 0 0-.408L8.308 1.808a.288.288 0 0 0-.408 0L6.695 3.013l.387.372a.75.75 0 1 1-1.038 1.083Z"
      />
      <path d="M14.274 11a.34.34 0 0 0-.548 0l-1.413 2.178c-.558.805-.352 1.868.475 2.446.716.501 1.708.501 2.424 0 .827-.578 1.033-1.641.475-2.447L14.274 11Z" />
    </g>
  ),
  smallAlternative: BucketSmallIcon,
})

export const HeaderOneIcon = makeIcon({
  displayName: 'HeaderOneIcon',
  content: (
    <g>
      <path d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V15.25C0 15.6642 0.335786 16 0.75 16C1.16421 16 1.5 15.6642 1.5 15.25V8.75H8.75V15.25C8.75 15.6642 9.08579 16 9.5 16C9.91421 16 10.25 15.6642 10.25 15.25V0.75C10.25 0.335786 9.91421 0 9.5 0C9.08579 0 8.75 0.335786 8.75 0.75V7.25H1.5V0.75Z" />
      <path d="M16.0001 9.25C16.0001 8.98145 15.8565 8.7334 15.6237 8.59964C15.3908 8.46589 15.1042 8.46685 14.8722 8.60217L12.6222 9.91467C12.2644 10.1234 12.1436 10.5826 12.3523 10.9404C12.561 11.2982 13.0202 11.419 13.378 11.2103L14.5001 10.5558V15.25C14.5001 15.6642 14.8359 16 15.2501 16C15.6643 16 16.0001 15.6642 16.0001 15.25V9.25Z" />
    </g>
  ),
  smallAlternative: HeaderOneSmallIcon,
})

export const HeaderTwoIcon = makeIcon({
  displayName: 'HeaderTwoIcon',
  content: (
    <g>
      <path d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V15.25C0 15.6642 0.335786 16 0.75 16C1.16421 16 1.5 15.6642 1.5 15.25V8.75H8.75V15.25C8.75 15.6642 9.08579 16 9.5 16C9.91421 16 10.25 15.6642 10.25 15.25V0.75C10.25 0.335786 9.91421 0 9.5 0C9.08579 0 8.75 0.335786 8.75 0.75V7.25H1.5V0.75Z" />
      <path d="M13.0396 11.2582C13.2652 10.9637 13.6717 10.9166 13.9536 11.1412C14.2442 11.3727 14.3005 11.8109 14.0682 12.114C13.8538 12.3938 13.2772 13.0357 12.7249 13.6372C12.4549 13.9312 12.1995 14.2061 12.0116 14.4076C11.9176 14.5083 11.8406 14.5905 11.7871 14.6476L11.7041 14.736C11.499 14.9539 11.443 15.2728 11.5617 15.5475C11.6804 15.8222 11.951 16.0001 12.2502 16.0001L15.2502 16.0001C15.6644 16.0001 16.0002 15.6643 16.0002 15.2501C16.0002 14.8359 15.6644 14.5001 15.2502 14.5001L13.9687 14.5001C14.4696 13.9526 15.0171 13.3418 15.2589 13.0262C15.9843 12.0795 15.8232 10.7129 14.8882 9.96796C13.9444 9.21603 12.581 9.3905 11.8489 10.3459C11.7253 10.5072 11.6271 10.6814 11.5542 10.8629C11.3999 11.2473 11.5863 11.684 11.9707 11.8384C12.3551 11.9928 12.7918 11.8063 12.9462 11.422C12.9691 11.365 13 11.3099 13.0396 11.2582Z" />
    </g>
  ),
  smallAlternative: HeaderTwoSmallIcon,
})

export const HeaderThreeIcon = makeIcon({
  displayName: 'HeaderThreeIcon',
  content: (
    <g>
      <path d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V15.25C0 15.6642 0.335786 16 0.75 16C1.16421 16 1.5 15.6642 1.5 15.25V8.75H8.75V15.25C8.75 15.6642 9.08579 16 9.5 16C9.91421 16 10.25 15.6642 10.25 15.25V0.75C10.25 0.335786 9.91421 0 9.5 0C9.08579 0 8.75 0.335786 8.75 0.75V7.25H1.5V0.75Z" />
      <path d="M13.962 9.49988C13.4522 9.49988 12.9818 9.68464 12.6221 9.99274C12.3681 10.2103 12.1674 10.4909 12.0474 10.8132C11.9028 11.2013 12.1003 11.6332 12.4884 11.7778C12.8766 11.9224 13.3085 11.7249 13.453 11.3367C13.4814 11.2604 13.5307 11.1895 13.5978 11.132C13.6923 11.0511 13.8185 10.9999 13.962 10.9999C14.2807 10.9999 14.5002 11.2448 14.5002 11.4999C14.5002 11.7549 14.2807 11.9999 13.962 11.9999C13.5478 11.9999 13.212 12.3357 13.212 12.7499C13.212 13.1641 13.5478 13.4999 13.962 13.4999C14.2807 13.4999 14.5002 13.7448 14.5002 13.9999C14.5002 14.2549 14.2807 14.4999 13.962 14.4999C13.8185 14.4999 13.6923 14.4486 13.5978 14.3677C13.5307 14.3103 13.4814 14.2393 13.453 14.163C13.3085 13.7749 12.8766 13.5774 12.4884 13.722C12.1003 13.8665 11.9028 14.2984 12.0474 14.6866C12.1674 15.0089 12.3681 15.2895 12.6221 15.507C12.9818 15.8151 13.4522 15.9999 13.962 15.9999C15.0663 15.9999 16.0002 15.1256 16.0002 13.9999C16.0002 13.522 15.8319 13.0895 15.5537 12.7499C15.8319 12.4103 16.0002 11.9777 16.0002 11.4999C16.0002 10.3742 15.0663 9.49988 13.962 9.49988Z" />
    </g>
  ),
  smallAlternative: HeaderThreeSmallIcon,
})

export const HeaderFourIcon = makeIcon({
  displayName: 'HeaderFourIcon',
  content: (
    <g fill="currentColor">
      <path d="M.75 0a.75.75 0 0 1 .75.75v6.5h7.25V.75a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-1.5 0v-6.5H1.5v6.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 .75 0Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.15 9.5a.6.6 0 0 0-.493.258l-2.25 3.25a.6.6 0 0 0-.107.342v.25a.6.6 0 0 0 .6.6h1.9v1.15a.6.6 0 1 0 1.2 0V14.2h.4a.6.6 0 1 0 0-1.2H15v-2.9a.6.6 0 0 0-.6-.6h-.25Zm-.35 2.16V13h-.928l.928-1.34Z"
      />
    </g>
  ),
  smallAlternative: HeaderFourSmallIcon,
})

export const FilterIcon = makeIcon({
  displayName: 'FilterIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.75C0 0.335786 0.335786 0 0.75 0H15.25C15.6642 0 16 0.335786 16 0.75V2.66823C16 3.22963 15.7901 3.77075 15.4116 4.18533L10.9461 9.07607C10.82 9.21427 10.75 9.39464 10.75 9.58177V12.3229C10.75 13.1752 10.2685 13.9543 9.50623 14.3354L6.33541 15.9208C6.10292 16.0371 5.82681 16.0246 5.6057 15.888C5.38459 15.7513 5.25 15.5099 5.25 15.25V9.58177C5.25 9.39464 5.18004 9.21427 5.05386 9.07607L0.588407 4.18533C0.209872 3.77075 0 3.22963 0 2.66823V0.75ZM1.5 1.5V2.66823C1.5 2.85536 1.56996 3.03573 1.69614 3.17393L6.16159 8.06467C6.54013 8.47925 6.75 9.02037 6.75 9.58177V14.0365L8.83541 12.9938C9.0895 12.8667 9.25 12.607 9.25 12.3229V9.58177C9.25 9.02037 9.45987 8.47925 9.83841 8.06467L14.3039 3.17393C14.43 3.03573 14.5 2.85536 14.5 2.66823V1.5H1.5Z"
      />
    </g>
  ),
  smallAlternative: FilterSmallIcon,
})

export const HideSubdocsIcon = makeIcon({
  displayName: 'HideSubdocsIcon',
  content: (
    <g>
      <path
        fill="currentColor"
        d="M3.75 4.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM4.5 6a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H4.5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 0A1.75 1.75 0 0 0 1 1.75V11c0 .966.784 1.75 1.75 1.75h7.5A1.75 1.75 0 0 0 12 11V1.75A1.75 1.75 0 0 0 10.25 0h-7.5ZM2.5 1.75a.25.25 0 0 1 .25-.25h7.5a.25.25 0 0 1 .25.25V11a.25.25 0 0 1-.25.25h-7.5A.25.25 0 0 1 2.5 11V1.75Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M15.25 3.807a.75.75 0 0 0-1.5 0v.51a.75.75 0 0 0 1.5 0v-.51ZM15.25 6.87a.75.75 0 0 0-1.5 0v.51a.75.75 0 0 0 1.5 0v-.51ZM15.25 9.932a.75.75 0 0 0-1.5 0v.51a.75.75 0 1 0 1.5 0v-.51ZM15.25 12.995a.75.75 0 0 0-1.5 0v.255c0 .056-.004.11-.01.164a.75.75 0 0 0 1.487.194c.015-.117.023-.237.023-.358v-.255ZM12.858 15.977a.75.75 0 1 0-.194-1.488c-.053.007-.108.01-.164.01h-.25a.75.75 0 0 0 0 1.5h.25c.121 0 .24-.007.358-.022ZM6.25 14.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 1 0 0-1.5h-.5ZM9.25 14.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 1 0 0-1.5h-.5Z"
      />
    </g>
  ),
})

export const HighlightIcon = makeIcon({
  displayName: 'Highlight',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15.25C-7.53896e-10 14.8357 0.335786 14.5 0.75 14.5H7.5C7.91421 14.5 8.25 14.8357 8.25 15.25C8.25 15.6642 7.91421 16 7.5 16H0.75C0.335786 16 7.53896e-10 15.6642 0 15.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8396 0.512263C8.20891 0.699847 8.35622 1.15129 8.16864 1.5206L5.67518 6.42958L13.3993 10.0314L14.5929 7.86139C14.7925 7.49845 15.2486 7.36606 15.6115 7.56569C15.9744 7.76531 16.1068 8.22136 15.9072 8.5843L14.2532 11.5914L9.41638 13.7261L8.47893 15.7365C8.30388 16.1119 7.85764 16.2743 7.48224 16.0992C7.10683 15.9242 6.94442 15.478 7.11947 15.1026L7.85905 13.5165L6.49959 12.8826L5.12608 15.8281C4.95103 16.2035 4.50479 16.3659 4.12939 16.1909C3.75398 16.0158 3.59157 15.5696 3.76662 15.1942L5.338 11.8243L3.85235 6.70602L6.83127 0.841297C7.01885 0.471993 7.4703 0.324679 7.8396 0.512263ZM6.76223 11.35L8.86427 12.3302L11.9034 10.9889L5.83623 8.15974L6.76223 11.35Z"
      />
    </g>
  ),
  smallAlternative: HighlightSmallIcon,
})

export const HorizontalArrowsIcon = makeIcon({
  displayName: 'HorizontalArrowsIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83032 0.433492C5.12321 0.726384 5.12321 1.20126 4.83032 1.49415L2.57565 3.74882H11.25C11.6642 3.74882 12 4.08461 12 4.49882C12 4.91304 11.6642 5.24882 11.25 5.24882H2.57458L4.83032 7.50456C5.12321 7.79745 5.12321 8.27233 4.83032 8.56522C4.53743 8.85811 4.06255 8.85811 3.76966 8.56522L0.312511 5.10807C0.123246 4.97193 0 4.74977 0 4.49882C0 4.24622 0.124876 4.02279 0.316261 3.88689L3.76966 0.433492C4.06255 0.140599 4.53743 0.140599 4.83032 0.433492ZM11.1697 15.5652C10.8768 15.2723 10.8768 14.7975 11.1697 14.5046L13.4244 12.2499H4.75C4.33579 12.2499 4 11.9141 4 11.4999C4 11.0857 4.33579 10.7499 4.75 10.7499H13.4254L11.1697 8.49418C10.8768 8.20128 10.8768 7.72641 11.1697 7.43351C11.4626 7.14062 11.9374 7.14062 12.2303 7.43351L15.6874 10.8906C15.8767 11.0267 16 11.2489 16 11.4999C16 11.7524 15.8752 11.9758 15.6838 12.1117L12.2303 15.5652C11.9374 15.8581 11.4626 15.8581 11.1697 15.5652Z"
      />
    </g>
  ),
})

export const RelatedDocIcon = makeIcon({
  displayName: 'RelatedDocIcon',
  content: (
    <g>
      <path d="M2.25 16C1.00736 16 0 14.9926 0 13.75V2.25C0 1.00736 1.00736 0 2.25 0H7.75C8.69864 0 9 1.5 7.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H10.75C11.1642 14.5 11.5 14.1642 11.5 13.75V11.75C11.5 11.3358 11.8358 11 12.25 11C12.6642 11 13 11.3358 13 11.75V13.75C13 14.9926 11.9926 16 10.75 16H2.25Z" />
      <path d="M7.95283 4.25008C7.95283 3.86076 8.26843 3.54515 8.65775 3.54515H13.1872L12.0671 2.4434C11.7895 2.1704 11.7895 1.72776 12.0671 1.45476C12.3447 1.18175 12.7947 1.18175 13.0722 1.45476L15.334 3.6795C15.3632 3.70051 15.3911 3.72398 15.4175 3.74991C15.5578 3.8879 15.6272 4.06922 15.6256 4.25008C15.6272 4.43093 15.5578 4.61226 15.4175 4.75025C15.3911 4.77618 15.3632 4.79965 15.334 4.82065L13.0722 7.0454C12.7947 7.31841 12.3447 7.31841 12.0671 7.0454C11.7895 6.77239 11.7895 6.32976 12.0671 6.05675L13.1872 4.95501H8.65775C8.26843 4.95501 7.95283 4.6394 7.95283 4.25008Z" />
      <path d="M10.7951 9.45485C11.1844 9.45485 11.5 9.13924 11.5 8.74992C11.5 8.3606 11.1844 8.04499 10.7951 8.04499H6.31423L7.43433 6.94325C7.71189 6.67024 7.71189 6.22761 7.43433 5.9546C7.15678 5.68159 6.70677 5.68159 6.42921 5.9546L4.16739 8.17935C4.13821 8.20035 4.11029 8.22382 4.08393 8.24975C3.94364 8.38774 3.87425 8.56907 3.87578 8.74992C3.87425 8.93077 3.94364 9.1121 4.08393 9.25009C4.11029 9.27602 4.13821 9.29949 4.16739 9.3205L6.42921 11.5452C6.70677 11.8183 7.15678 11.8183 7.43433 11.5452C7.71189 11.2722 7.71189 10.8296 7.43433 10.5566L6.31423 9.45485H10.7951Z" />
    </g>
  ),
})
export const InactiveNoteIcon = makeIcon({
  displayName: 'InactiveNoteIcon',
  content: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 0a.75.75 0 0 0 0 1.5h1.545l-2.098 2.289A.75.75 0 0 0 12 5.045h3.25a.75.75 0 0 0 0-1.5h-1.545l2.098-2.288A.75.75 0 0 0 15.25 0H12Zm-.37 14.691 1.077 1.077a.75.75 0 1 0 1.06-1.06l-.964-.965A6.728 6.728 0 0 0 14.75 9a6.76 6.76 0 0 0-.213-1.687.75.75 0 1 0-1.452.374A5.25 5.25 0 1 1 8.972 3.84a.75.75 0 1 0 .276-1.475 6.75 6.75 0 0 0-6.05 11.377l-.966.965a.75.75 0 1 0 1.06 1.06l1.077-1.076A6.718 6.718 0 0 0 8 15.75a6.718 6.718 0 0 0 3.63-1.059ZM8.75 6v2.25H11a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 9V6a.75.75 0 0 1 1.5 0Z"
      clipRule="evenodd"
    />
  ),
})

export const IndentedListIcon = makeIcon({
  displayName: 'IndentedList',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.75C0 2.33579 0.335786 2 0.75 2H7.25C7.66421 2 8 2.33579 8 2.75C8 3.16421 7.66421 3.5 7.25 3.5H0.75C0.335786 3.5 0 3.16421 0 2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C4 7.58579 4.33579 7.25 4.75 7.25H11.25C11.6642 7.25 12 7.58579 12 8C12 8.41421 11.6642 8.75 11.25 8.75H4.75C4.33579 8.75 4 8.41421 4 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 13.25C8 12.8358 8.33579 12.5 8.75 12.5H15.25C15.6642 12.5 16 12.8358 16 13.25C16 13.6642 15.6642 14 15.25 14H8.75C8.33579 14 8 13.6642 8 13.25Z"
      />
    </g>
  ),
})

export const IndentIcon = makeIcon({
  displayName: 'IndentIcon',
  viewBox: 16,
  content: (
    <path
      d="M0 .75C0 .336.341 0 .762 0h14.476c.42 0 .762.336.762.75s-.341.75-.762.75H.762A.756.756 0 0 1 0 .75ZM8.682 4.75c-.377 0-.682.336-.682.75s.305.75.682.75h6.636c.377 0 .682-.336.682-.75s-.305-.75-.682-.75H8.682ZM.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 0 10.5v-5a.5.5 0 0 1 .271-.445ZM8.682 9.75c-.377 0-.682.336-.682.75s.305.75.682.75h6.636c.377 0 .682-.336.682-.75s-.305-.75-.682-.75H8.682ZM.762 14.5a.756.756 0 0 0-.762.75c0 .414.341.75.762.75h14.476c.42 0 .762-.336.762-.75a.756.756 0 0 0-.762-.75H.762Z"
      fill="currentColor"
    />
  ),
})

export const OutdentIcon = makeIcon({
  displayName: 'OutdentIcon',
  viewBox: 16,
  content: (
    <path
      d="M.762 0A.756.756 0 0 0 0 .75c0 .414.341.75.762.75h14.476c.42 0 .762-.336.762-.75a.756.756 0 0 0-.762-.75H.762ZM8.682 4.75c-.377 0-.682.336-.682.75s.305.75.682.75h6.636c.377 0 .682-.336.682-.75s-.305-.75-.682-.75H8.682ZM8 10.5c0-.414.305-.75.682-.75h6.636c.377 0 .682.336.682.75s-.305.75-.682.75H8.682c-.377 0-.682-.336-.682-.75ZM0 15.25c0-.414.341-.75.762-.75h14.476c.42 0 .762.336.762.75s-.341.75-.762.75H.762A.756.756 0 0 1 0 15.25ZM4.229 5.055a.5.5 0 0 0-.52.038l-3.5 2.5a.5.5 0 0 0 0 .814l3.5 2.5A.5.5 0 0 0 4.5 10.5v-5a.5.5 0 0 0-.271-.445Z"
      fill="currentColor"
    />
  ),
})

export const InfoIcon = makeIcon({
  displayName: 'InfoIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="currentColor"
      />
      <rect
        x="7.25"
        y="6.5"
        width="1.5"
        height="5.5"
        rx="0.75"
        fill="currentColor"
      />
      <circle cx="8" cy="4.75" r="0.75" fill="currentColor" />
    </g>
  ),
  smallAlternative: InfoSmallIcon,
})

export const InlineCodeIcon = makeIcon({
  displayName: 'InlineCodeIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.28033 4.46959C4.57322 4.76248 4.57322 5.23736 4.28033 5.53025L1.81066 7.99992L4.28033 10.4696C4.57322 10.7625 4.57322 11.2374 4.28033 11.5303C3.98744 11.8231 3.51256 11.8231 3.21967 11.5303L0.21967 8.53025C-0.0732233 8.23736 -0.0732233 7.76248 0.21967 7.46959L3.21967 4.46959C3.51256 4.1767 3.98744 4.1767 4.28033 4.46959Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7197 4.46959C11.4268 4.76248 11.4268 5.23736 11.7197 5.53025L14.1893 7.99992L11.7197 10.4696C11.4268 10.7625 11.4268 11.2374 11.7197 11.5303C12.0126 11.8231 12.4874 11.8231 12.7803 11.5303L15.7803 8.53025C16.0732 8.23736 16.0732 7.76248 15.7803 7.46959L12.7803 4.46959C12.4874 4.1767 12.0126 4.1767 11.7197 4.46959Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16459 11.6707C5.7941 11.4855 5.64394 11.035 5.82918 10.6645L8.82918 4.66451C9.01442 4.29403 9.46493 4.14386 9.83541 4.3291C10.2059 4.51434 10.3561 4.96485 10.1708 5.33533L7.17082 11.3353C6.98558 11.7058 6.53507 11.856 6.16459 11.6707Z"
      />
    </g>
  ),
  smallAlternative: InlineCodeSmallIcon,
})

export const IOSIcon = makeIcon({
  displayName: 'IOSIcon',
  viewBox: 24,
  content: (
    <path d="M3.169 23.194A1.714 1.714 0 0 1 .26 21.377l.463-.74c.297-.038.617-.065.991-.065 1.035 0 1.894.327 2.616.762l-1.162 1.86zm-1.454-4.337a1.715 1.715 0 0 1 0-3.428h2.264l6-9.6-2.004-3.205c-.5-.802-.257-1.86.545-2.362.803-.5 1.86-.255 2.363.545L12 2.595 13.118.807A1.712 1.712 0 0 1 15.48.262a1.713 1.713 0 0 1 .545 2.362L8.022 15.43h5.463c.437.314.92.8 1.431 1.613.38.602.564 1.215.667 1.815H1.715zm22.024 2.52A1.716 1.716 0 0 1 22.287 24c-.57 0-1.13-.286-1.455-.806l-7.748-12.397c.137-.34.313-.708.576-1.126a4.97 4.97 0 0 1 1.726-1.66l4.635 7.418h2.265a1.715 1.715 0 0 1 0 3.428h-.122l1.575 2.52z" />
  ),
})

export const ItalicIcon = makeIcon({
  displayName: 'ItalicIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0.75C6 0.335786 6.33579 0 6.75 0H14.25C14.6642 0 15 0.335786 15 0.75C15 1.16421 14.6642 1.5 14.25 1.5H11.0347L6.55196 14.5H9.25C9.66421 14.5 10 14.8358 10 15.25C10 15.6642 9.66421 16 9.25 16H1.75C1.33579 16 1 15.6642 1 15.25C1 14.8358 1.33579 14.5 1.75 14.5H4.96528L9.44804 1.5H6.75C6.33579 1.5 6 1.16421 6 0.75Z"
    />
  ),
  smallAlternative: ItalicSmallIcon,
})

export const KeyIcon = makeIcon({
  displayName: 'Key',
  viewBox: 13,
  content: (
    <>
      <path d="M5.25 5.03564C5.25 3.5859 6.42525 2.41064 7.875 2.41064C9.32475 2.41064 10.5 3.5859 10.5 5.03564C10.5 6.48539 9.32475 7.66064 7.875 7.66064C7.46079 7.66064 7.125 7.99643 7.125 8.41064C7.125 8.82486 7.46079 9.16064 7.875 9.16064C10.1532 9.16064 12 7.31382 12 5.03564C12 2.75747 10.1532 0.910645 7.875 0.910645C5.59683 0.910645 3.75 2.75747 3.75 5.03564C3.75 5.52408 3.86976 5.98538 3.97599 6.30407L3.98507 6.33107L0 9.95387V12.9106H2.91015L6.49827 9.7212C6.80786 9.44601 6.83575 8.97196 6.56056 8.66237C6.28537 8.35278 5.81131 8.3249 5.50173 8.60009L2.33985 11.4106H1.5V10.6174L5.79991 6.70841L5.54687 6.20234L5.54591 6.20037L5.53852 6.18479C5.53134 6.1694 5.51996 6.14443 5.50576 6.1113C5.47721 6.04467 5.43815 5.94714 5.39901 5.82972C5.31774 5.58591 5.25 5.29721 5.25 5.03564Z" />
      <path d="M7.875 6.16064C8.49632 6.16064 9 5.65697 9 5.03564C9 4.41432 8.49632 3.91064 7.875 3.91064C7.25368 3.91064 6.75 4.41432 6.75 5.03564C6.75 5.65697 7.25368 6.16064 7.875 6.16064Z" />
    </>
  ),
})

export const LeaveIcon = makeIcon({
  displayName: 'LeaveIcon',
  content: (
    <>
      <path d="M11.182 4.994a.75.75 0 1 1 1.061-1.06l3.537 3.535a.75.75 0 0 1 0 1.06l-3.537 3.536a.75.75 0 0 1-1.06-1.06l2.255-2.255H4.25a.75.75 0 1 1 0-1.5h9.189l-2.257-2.256Z" />
      <path
        fillRule="evenodd"
        d="M6.25 16A2.75 2.75 0 0 0 9 13.25v-1.5a.75.75 0 0 0-1.5 0v1.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25V2.75c0-.69.56-1.25 1.25-1.25h3.5c.69 0 1.25.56 1.25 1.25v1.5a.75.75 0 0 0 1.5 0v-1.5A2.75 2.75 0 0 0 6.25 0h-3.5A2.75 2.75 0 0 0 0 2.75v10.5A2.75 2.75 0 0 0 2.75 16h3.5Z"
        clipRule="evenodd"
      />
    </>
  ),
})

export const LinkIcon = makeIcon({
  displayName: 'LinkIcon',
  content: (
    <g>
      <path d="M14.8942 1.1058C13.4298 -0.35867 11.0554 -0.35867 9.59094 1.1058L6.05541 4.64133C4.59094 6.1058 4.59094 8.48016 6.05541 9.94463L6.09076 9.97999C6.38366 10.2729 6.85853 10.2729 7.15142 9.97999C7.44432 9.68709 7.44432 9.21222 7.15142 8.91933L7.11607 8.88397C6.23739 8.00529 6.23739 6.58067 7.11607 5.70199L10.6516 2.16646C11.5303 1.28778 12.9549 1.28778 13.8336 2.16646C14.7123 3.04514 14.7123 4.46976 13.8336 5.34844L12.0658 7.1162C11.7729 7.4091 11.7729 7.88397 12.0658 8.17686C12.3587 8.46976 12.8336 8.46976 13.1265 8.17686L14.8942 6.4091C16.3587 4.94463 16.3587 2.57026 14.8942 1.1058Z" />
      <path d="M9.90915 6.02019C9.61626 5.7273 9.14138 5.7273 8.84849 6.02019C8.5556 6.31309 8.5556 6.78796 8.84849 7.08085L8.88385 7.11621C9.76253 7.99489 9.76252 9.41951 8.88385 10.2982L5.34831 13.8337C4.46963 14.7124 3.04501 14.7124 2.16633 13.8337C1.28765 12.955 1.28766 11.5304 2.16633 10.6517L3.9341 8.88397C4.22699 8.59108 4.22699 8.11621 3.9341 7.82331C3.64121 7.53042 3.16633 7.53042 2.87344 7.82331L1.10567 9.59108C-0.358792 11.0555 -0.358792 13.4299 1.10567 14.8944C2.57014 16.3588 4.94451 16.3588 6.40897 14.8944L9.9445 11.3588C11.409 9.89438 11.409 7.52001 9.94451 6.05555L9.90915 6.02019Z" />
    </g>
  ),
  smallAlternative: LinkSmallIcon,
})

export const LockFilledIcon = makeIcon({
  displayName: 'LockFilledIcon',
  content: (
    <path d="M12 4V4.81057L10 4.81023V4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V4.80919H4V4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4ZM4 6.5C2.89543 6.5 2 7.39543 2 8.5V13.5C2 14.6046 2.89543 15.5 4 15.5H12C13.1046 15.5 14 14.6046 14 13.5V8.5C14 7.39543 13.1046 6.5 12 6.5H4Z" />
  ),
})

export const LockIcon = makeIcon({
  displayName: 'LockIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C6.7984 1.5 5.75 2.54502 5.75001 3.75L5.75 5.65745C7.24226 5.44206 8.75774 5.44206 10.25 5.65745V3.75C10.25 2.53689 9.2435 1.5 8 1.5ZM4.25001 3.75L4.25 5.91951L3.59751 6.03815C2.52765 6.23267 1.75 7.16446 1.75 8.25186V13.2481C1.75 14.3355 2.52766 15.2673 3.59751 15.4618L5.18255 15.75C7.04558 16.0888 8.95442 16.0888 10.8174 15.75L12.4025 15.4618C13.4723 15.2673 14.25 14.3355 14.25 13.2481V8.25186C14.25 7.16446 13.4723 6.23267 12.4025 6.03815L11.75 5.91952V3.75C11.75 1.72311 10.0865 0 8 0C5.97159 0 4.25001 1.71499 4.25001 3.75ZM10.5491 7.22576C8.86352 6.91929 7.13648 6.91929 5.45088 7.22576L3.86584 7.51395C3.50922 7.57879 3.25 7.88939 3.25 8.25186V13.2481C3.25 13.6106 3.50922 13.9212 3.86584 13.986L5.45088 14.2742C7.13648 14.5807 8.86352 14.5807 10.5491 14.2742L12.1342 13.986C12.4908 13.9212 12.75 13.6106 12.75 13.2481V8.25186C12.75 7.88939 12.4908 7.57879 12.1342 7.51395L10.5491 7.22576ZM8 11.75C8.55228 11.75 9 11.3023 9 10.75C9 10.1977 8.55228 9.75 8 9.75C7.44772 9.75 7 10.1977 7 10.75C7 11.3023 7.44772 11.75 8 11.75Z"
    />
  ),
  smallAlternative: LockSmallIcon,
})

export const LogoutIcon = makeIcon({
  displayName: 'LogoutIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1824 4.99444C10.8894 4.70155 10.8894 4.22668 11.1824 3.93378C11.4754 3.64089 11.9505 3.64089 12.2435 3.93378L15.7803 7.46932C16.0732 7.76221 16.0732 8.23708 15.7803 8.52998L12.2435 12.0655C11.9505 12.3584 11.4754 12.3584 11.1824 12.0655C10.8894 11.7726 10.8894 11.2977 11.1824 11.0048L13.4379 8.75013L4.25025 8.75013C3.83589 8.75013 3.49998 8.41435 3.49998 8.00013C3.49998 7.58592 3.83589 7.25013 4.25025 7.25013L13.4389 7.25013L11.1824 4.99444Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 16C7.76878 16 9 14.7688 9 13.25L9 11.75C9 11.3358 8.66421 11 8.25 11C7.83579 11 7.5 11.3358 7.5 11.75L7.5 13.25C7.5 13.9404 6.94036 14.5 6.25 14.5L2.75 14.5C2.05964 14.5 1.5 13.9404 1.5 13.25L1.5 2.75C1.5 2.05964 2.05964 1.5 2.75 1.5L6.25 1.5C6.94036 1.5 7.5 2.05964 7.5 2.75L7.5 4.25C7.5 4.66421 7.83579 5 8.25 5C8.66421 5 9 4.66421 9 4.25L9 2.75C9 1.23122 7.76878 -5.38182e-08 6.25 -1.20206e-07L2.75 -2.73196e-07C1.23122 -3.39584e-07 6.45564e-07 1.23122 5.79176e-07 2.75L1.20206e-07 13.25C5.38182e-08 14.7688 1.23122 16 2.75 16L6.25 16Z"
      />
    </g>
  ),
})

export const MathIcon = makeIcon({
  displayName: 'MathIcon',
  content: (
    <g>
      <path d="M7.5 1.5C6.80964 1.5 6.25 2.05964 6.25 2.75L6.25 6H7.75C8.16421 6 8.5 6.33579 8.5 6.75C8.5 7.16421 8.16421 7.5 7.75 7.5H6.25V13.25C6.25 14.7688 5.01878 16 3.5 16C1.98122 16 0.75 14.7688 0.75 13.25C0.75 12.8358 1.08579 12.5 1.5 12.5C1.91421 12.5 2.25 12.8358 2.25 13.25C2.25 13.9404 2.80964 14.5 3.5 14.5C4.19036 14.5 4.75 13.9404 4.75 13.25L4.75 7.5H3.25C2.83579 7.5 2.5 7.16421 2.5 6.75C2.5 6.33579 2.83579 6 3.25 6H4.75V2.75C4.75 1.23122 5.98122 0 7.5 0C9.01878 0 10.25 1.23122 10.25 2.75C10.25 3.16421 9.91421 3.5 9.5 3.5C9.08579 3.5 8.75 3.16421 8.75 2.75C8.75 2.05964 8.19036 1.5 7.5 1.5Z" />
      <path d="M12.25 13.1213L13.841 11.5303C14.1339 11.2374 14.1339 10.7626 13.841 10.4697C13.5481 10.1768 13.0732 10.1768 12.7803 10.4697L11.1893 12.0607L9.59832 10.4697C9.30542 10.1768 8.83055 10.1768 8.53766 10.4697C8.24477 10.7626 8.24477 11.2374 8.53766 11.5303L10.1287 13.1213L8.53769 14.7123C8.2448 15.0052 8.2448 15.4801 8.53769 15.773C8.83059 16.0659 9.30546 16.0659 9.59835 15.773L11.1893 14.182L12.7803 15.773C13.0732 16.0659 13.5481 16.0659 13.841 15.773C14.1339 15.4801 14.1339 15.0052 13.841 14.7123L12.25 13.1213Z" />
    </g>
  ),
  smallAlternative: MathSmallIcon,
})

export const DiagramIcon = makeIcon({
  displayName: 'DiagramIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1.5V3.5H7.44102L7.44255 3.49829L7.44445 3.5H8.55555L8.55745 3.49829L8.55898 3.5H10V1.5L6 1.5ZM9.90898 5H10.5C11.0523 5 11.5 4.55228 11.5 4V1C11.5 0.447715 11.0523 0 10.5 0L5.5 0C4.94772 0 4.5 0.447715 4.5 1V4C4.5 4.55228 4.94772 5 5.5 5H6.09102L2.94255 8.49829L2.94445 8.5H1C0.447715 8.5 0 8.94771 0 9.5L0 12.5C0 13.0523 0.447715 13.5 1 13.5H6C6.55228 13.5 7 13.0523 7 12.5V9.5C7 8.94772 6.55228 8.5 6 8.5H4.95906L8 5.12118L11.0409 8.5H10C9.44772 8.5 9 8.94771 9 9.5V12.5C9 13.0523 9.44771 13.5 10 13.5H15C15.5523 13.5 16 13.0523 16 12.5V9.5C16 8.94772 15.5523 8.5 15 8.5H13.0555L13.0574 8.49829L9.90898 5ZM1.5 10V12H5.5V10H1.5ZM10.5 12V10H14.5V12H10.5Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: DiagramSmallIcon,
})

export const MaximizeIcon = makeIcon({
  displayName: 'MaximizeIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
})

export const MinimizeIcon = makeIcon({
  displayName: 'MinimizeIcon',
  viewBox: 16,
  content: (
    <g>
      <rect x="1" y="7" width="14" height="1.5" rx="0.75" fill="currentColor" />
    </g>
  ),
  smallAlternative: MinimizeSmallIcon,
})

export const MoreIcon = makeIcon({
  displayName: 'MoreIcon',
  content: (
    <g>
      <path d="M8 3.5C7.17157 3.5 6.5 2.82843 6.5 2C6.5 1.17157 7.17157 0.5 8 0.5C8.82843 0.5 9.5 1.17157 9.5 2C9.5 2.82843 8.82843 3.5 8 3.5Z" />
      <path d="M8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8C9.5 8.82843 8.82843 9.5 8 9.5Z" />
      <path d="M8 15.5C7.17157 15.5 6.5 14.8284 6.5 14C6.5 13.1716 7.17157 12.5 8 12.5C8.82843 12.5 9.5 13.1716 9.5 14C9.5 14.8284 8.82843 15.5 8 15.5Z" />
    </g>
  ),
  smallAlternative: MoreSmallIcon,
})

export const MoreIconSide = makeIcon({
  displayName: 'MoreIconSide',
  content: (
    <g>
      <circle cx="1.5" cy="8" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="14.5" cy="8" r="1.5" />
    </g>
  ),
})

export const NoteIcon = makeIcon({
  displayName: 'NoteIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 2.75C1.5 1.50736 2.50736 0.5 3.75 0.5H12.25C13.4926 0.5 14.5 1.50736 14.5 2.75V13.25C14.5 14.4926 13.4926 15.5 12.25 15.5H3.75C2.50736 15.5 1.5 14.4926 1.5 13.25V2.75ZM3.75 2C3.33579 2 3 2.33579 3 2.75V13.25C3 13.6642 3.33579 14 3.75 14H12.25C12.6642 14 13 13.6642 13 13.25V8V2.75C13 2.33579 12.6642 2 12.25 2H3.75ZM5.75 4.5C5.33579 4.5 5 4.83579 5 5.25C5 5.66421 5.33579 6 5.75 6H10.25C10.6642 6 11 5.66421 11 5.25C11 4.83579 10.6642 4.5 10.25 4.5H5.75ZM5 7.75C5 7.33579 5.33579 7 5.75 7H8.75C9.16421 7 9.5 7.33579 9.5 7.75C9.5 8.16421 9.16421 8.5 8.75 8.5H5.75C5.33579 8.5 5 8.16421 5 7.75Z"
    />
  ),
  smallAlternative: NoteSmallIcon,
})

export const NotionIconMonochrome = makeIcon({
  displayName: 'NotionIconMonochrome',
  viewBox: 16,
  content: (
    <g fill="currentColor">
      <path d="M5.86.502C3.417.684 1.34.85 1.242.87a.897.897 0 0 0-.64.48L.5 1.565l.01 5.137.014 5.137.157.319c.088.176.684.999 1.334 1.846 1.285 1.67 1.377 1.763 1.866 1.812.142.014 1.207-.034 2.36-.103 1.158-.073 3.015-.186 4.129-.25 4.759-.289 4.514-.265 4.788-.5.342-.284.318.182.332-6.062.01-5.294.005-5.641-.073-5.803-.093-.181-.26-.309-2.429-1.837C11.538.243 11.435.19 10.785.18 10.516.17 8.298.316 5.86.502Zm5.492.671c.205.093 1.705 1.141 1.925 1.342.058.059.078.108.049.137-.069.06-9.353.613-9.621.573a1.21 1.21 0 0 1-.406-.161c-.425-.29-1.48-1.156-1.48-1.22 0-.166-.034-.166 4.104-.465.792-.054 2.092-.152 2.883-.215 1.715-.138 2.228-.133 2.546.01Zm2.95 2.679c.07.068.128.2.147.328.015.118.025 2.311.015 4.868-.015 4.387-.02 4.662-.103 4.789a.494.494 0 0 1-.22.186c-.205.084-9.933.637-10.133.578a.754.754 0 0 1-.288-.171l-.118-.127-.014-4.731c-.01-3.32 0-4.79.039-4.922a.515.515 0 0 1 .166-.254c.088-.059.665-.108 2.649-.225 1.392-.079 3.547-.21 4.783-.284 2.941-.182 2.931-.182 3.078-.035Z" />
      <path d="M11.689 5.473c-.528.034-.997.083-1.05.113a.494.494 0 0 0-.28.377c-.014.161.035.181.563.245l.229.03v2.09c0 1.244-.02 2.067-.044 2.042-.024-.03-.718-1.087-1.544-2.35a310.785 310.785 0 0 0-1.52-2.321c-.01-.01-.547.02-1.192.063-.791.054-1.226.103-1.314.152-.142.074-.298.333-.298.505 0 .102.185.156.576.156h.205v6.014l-.332.103c-.259.078-.347.127-.39.225-.079.166-.074.318.004.318.03 0 .582-.034 1.217-.073 1.256-.074 1.397-.108 1.53-.368a.753.753 0 0 0 .072-.186c0-.02-.17-.078-.376-.127l-.464-.108c-.083-.024-.088-.176-.088-2.282V7.834l1.485 2.336c1.559 2.448 1.754 2.727 1.994 2.85.298.156 1.055.049 1.436-.201l.118-.074.01-3.34.014-3.344.26-.049c.307-.059.449-.2.449-.445 0-.157-.01-.167-.157-.162a99.2 99.2 0 0 0-1.113.068Z" />
    </g>
  ),
})

export const NotionIcon = makeIcon({
  displayName: 'NotionIcon',
  viewBox: 16,
  content: (
    <g clipPath="url(#clip0_2074_28449)">
      <path
        d="M5.85988 1.00345C3.41694 1.18462 1.34017 1.35123 1.24252 1.37074C0.96875 1.41967 0.719698 1.6058 0.602587 1.85076L0.5 2.06631L0.509888 7.20345L0.524411 12.3406L0.680764 12.659C0.768828 12.8352 1.36489 13.658 2.01471 14.505C3.29983 16.1749 3.39253 16.2681 3.88106 16.317C4.02289 16.3316 5.088 16.2826 6.24118 16.2142C7.39931 16.1408 9.25577 16.0281 10.37 15.9646C15.1289 15.675 14.8845 15.6995 15.1579 15.4644C15.5 15.1805 15.4756 15.6456 15.4901 9.40194C15.5 4.1081 15.4951 3.76062 15.4169 3.59896C15.3242 3.41779 15.1579 3.29051 12.9885 1.7625C11.5374 0.743929 11.4348 0.690043 10.7847 0.680133C10.5162 0.670533 8.29787 0.817326 5.85988 1.00345ZM11.3517 1.67424C11.5569 1.76715 13.0571 2.81514 13.2768 3.01613C13.3355 3.07497 13.3549 3.1239 13.3256 3.15332C13.2573 3.21216 3.97345 3.76558 3.70493 3.72625C3.58287 3.70674 3.40211 3.63334 3.29952 3.56459C2.87434 3.27565 1.81911 2.40882 1.81911 2.34534C1.81911 2.17872 1.78481 2.17872 5.92353 1.88018C6.71519 1.8263 8.01483 1.72843 8.80648 1.66464C10.5211 1.52745 11.0344 1.5324 11.3517 1.67424ZM14.3029 4.35306C14.3712 4.4215 14.4299 4.55374 14.4494 4.68102C14.4639 4.7987 14.4738 6.99255 14.4639 9.54873C14.4494 13.9364 14.4445 14.2108 14.3613 14.3381C14.3125 14.4164 14.2149 14.4998 14.1413 14.5242C13.9365 14.6075 4.20829 15.1609 4.00805 15.1021C3.91536 15.0776 3.78805 14.9993 3.71976 14.9308L3.60234 14.8036L3.58782 10.073C3.57793 6.75285 3.58782 5.28368 3.62706 5.15144C3.65641 5.05358 3.72965 4.9359 3.7933 4.89687C3.88137 4.83803 4.45796 4.7891 6.44172 4.67173C7.83438 4.59338 9.98902 4.46114 11.2253 4.38774C14.1661 4.20627 14.1565 4.20627 14.3029 4.35306Z"
        fill="black"
      />
      <path
        d="M11.3519 1.67201C11.5571 1.76492 13.0573 2.81291 13.277 3.0139C13.3357 3.07274 13.3552 3.12167 13.3258 3.15109C13.2575 3.20993 3.97368 3.76335 3.70516 3.72402C3.58311 3.70451 3.40234 3.63111 3.29975 3.56236C2.87457 3.27342 1.81935 2.40659 1.81935 2.34311C1.81935 2.17649 1.78505 2.17649 5.92377 1.87795C6.71542 1.82407 8.01506 1.7262 8.80672 1.66241C10.5213 1.52521 11.0346 1.53017 11.3519 1.67201ZM14.3032 4.35083C14.3715 4.41927 14.4302 4.55151 14.4496 4.67879C14.4642 4.79647 14.4741 6.99032 14.4642 9.5465C14.4496 13.9342 14.4447 14.2086 14.3616 14.3359C14.3128 14.4142 14.2151 14.4975 14.1416 14.522C13.9367 14.6053 4.20852 15.1587 4.00829 15.0999C3.91559 15.0754 3.78828 14.9971 3.71999 14.9286L3.60257 14.8013L3.58805 10.0708C3.57816 6.75062 3.58805 5.28145 3.62729 5.14921C3.65665 5.05135 3.72988 4.93367 3.79353 4.89464C3.8816 4.8358 4.45819 4.78687 6.44196 4.6695C7.83461 4.59115 9.98925 4.45891 11.2256 4.38551C14.1663 4.20404 14.1567 4.20404 14.3032 4.35083Z"
        fill="white"
      />
      <path
        d="M11.6893 5.97499C11.1615 6.00937 10.6925 6.0583 10.6387 6.08772C10.4774 6.17102 10.3797 6.30822 10.3603 6.46492C10.3458 6.62657 10.3946 6.64608 10.922 6.70988L11.1516 6.7393V8.83031C11.1516 10.074 11.1322 10.8968 11.1077 10.8724C11.0833 10.843 10.3896 9.78538 9.56368 8.52186C8.73804 7.25369 8.05392 6.21035 8.04403 6.20075C8.03415 6.19084 7.4968 6.22026 6.85192 6.26455C6.06027 6.31843 5.62551 6.36737 5.53744 6.4163C5.39561 6.48969 5.23926 6.74921 5.23926 6.92078C5.23926 7.02359 5.42497 7.07748 5.81585 7.07748H6.02102V13.091L5.68885 13.1938C5.42991 13.2721 5.34184 13.3211 5.29797 13.4189C5.21979 13.5856 5.22473 13.7373 5.30291 13.7373C5.33227 13.7373 5.88445 13.7029 6.51944 13.6639C7.7752 13.5905 7.91673 13.5561 8.04867 13.2966C8.08791 13.2183 8.1219 13.135 8.1219 13.1105C8.1219 13.091 7.95102 13.0321 7.74554 12.9832C7.53542 12.9343 7.3253 12.8853 7.28143 12.8754C7.19831 12.851 7.19336 12.6992 7.19336 10.5934V8.33574L8.67871 10.6717C10.2373 13.1201 10.4329 13.3994 10.6724 13.5218C10.9706 13.6785 11.7279 13.5707 12.1089 13.3211L12.2263 13.2477L12.2362 9.90802L12.2507 6.5634L12.5097 6.51447C12.8174 6.45563 12.9593 6.31379 12.9593 6.06883C12.9593 5.91213 12.9494 5.90222 12.8029 5.90717C12.7155 5.9112 12.2121 5.94062 11.6893 5.97499Z"
        fill="black"
      />
    </g>
  ),
})

export const OrderedListIcon = makeIcon({
  displayName: 'OrderedListIcon',
  content: (
    <g>
      <path d="M5 3.25C5 2.83579 5.33579 2.5 5.75 2.5H15.25C15.6642 2.5 16 2.83579 16 3.25C16 3.66421 15.6642 4 15.25 4H5.75C5.33579 4 5 3.66421 5 3.25ZM5 8C5 7.58579 5.33579 7.25 5.75 7.25H15.25C15.6642 7.25 16 7.58579 16 8C16 8.41421 15.6642 8.75 15.25 8.75H5.75C5.33579 8.75 5 8.41421 5 8ZM5 12.75C5 12.3358 5.33579 12 5.75 12H15.25C15.6642 12 16 12.3358 16 12.75C16 13.1642 15.6642 13.5 15.25 13.5H5.75C5.33579 13.5 5 13.1642 5 12.75Z" />
      <path d="M0.936786 4.09237V7.15064H1.92151V2.90002H1.71959L0 3.53026V4.38964L0.936786 4.09237ZM0 12.5435V13.2266H3.03543V12.3872H1.44075L2.19333 11.5984C2.39983 11.3736 2.60242 11.1324 2.7404 10.8581C2.99214 10.3576 2.97664 9.68412 2.52724 9.29662C2.05959 8.89338 1.25619 8.87414 0.723685 9.15933C0.494521 9.28207 0.315426 9.4527 0.188842 9.67066C0.0414869 9.92439 0 10.1995 0 10.4878H1.00066C1.00066 10.303 1.00782 10.1139 1.13314 9.96505C1.28528 9.78438 1.6306 9.74906 1.79496 9.93411C1.97141 10.1328 1.91369 10.439 1.79059 10.6469C1.71004 10.7829 1.58323 10.9462 1.4073 11.1374L0 12.5435Z" />
    </g>
  ),
  smallAlternative: OrderedListSmallIcon,
})

export const OutlineIcon = makeIcon({
  displayName: 'OutlineIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.75C0 2.33579 0.335786 2 0.75 2H12.25C12.6642 2 13 2.33579 13 2.75C13 3.16421 12.6642 3.5 12.25 3.5H0.75C0.335786 3.5 0 3.16421 0 2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8C3 7.58579 3.33579 7.25 3.75 7.25H15.25C15.6642 7.25 16 7.58579 16 8C16 8.41421 15.6642 8.75 15.25 8.75H3.75C3.33579 8.75 3 8.41421 3 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.25C0 12.8358 0.335786 12.5 0.75 12.5H12.25C12.6642 12.5 13 12.8358 13 13.25C13 13.6642 12.6642 14 12.25 14H0.75C0.335786 14 0 13.6642 0 13.25Z"
      />
    </g>
  ),
  smallAlternative: OutlineSmallIcon,
})

export const PaperplaneIcon = makeIcon({
  displayName: 'PaperplaneIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0041 0.444732C15.2108 0.632395 15.2962 0.919335 15.2257 1.18946L12.4499 11.8219C12.1581 12.9398 10.8821 13.4731 9.88157 12.8953L8.28288 11.9721L6.38821 15.0465C5.74751 16.0862 4.14937 15.6846 4.07629 14.4655L3.7751 9.44147L1.42214 8.0417C0.155739 7.28832 0.33049 5.40271 1.71378 4.89491L14.2415 0.295957C14.5036 0.199747 14.7974 0.25707 15.0041 0.444732ZM5.3304 10.3189L5.52627 13.5861L6.97649 11.2329L5.3304 10.3189ZM4.87382 8.34973L8.39636 10.3055L10.6317 11.5963C10.7746 11.6789 10.9569 11.6027 10.9986 11.443L13.2182 2.9409L7.20912 7.59306C6.88159 7.84663 6.41051 7.78667 6.15694 7.45914C5.90337 7.13162 5.96333 6.66054 6.29086 6.40697L10.2075 3.37473L2.23071 6.30302C2.03309 6.37557 2.00813 6.64494 2.18904 6.75256L4.87382 8.34973Z"
    />
  ),
})

export const PenCrossedIcon = makeIcon({
  displayName: 'PenCrossedIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7497 0.654005L7.4246 3.97915C7.1317 4.27204 7.1317 4.74692 7.4246 5.03981V5.03981C7.71749 5.3327 8.19236 5.3327 8.48526 5.03981L9.94455 3.58052L12.4194 6.05539L10.9601 7.51468C10.6672 7.80758 10.6672 8.28245 10.9601 8.57534V8.57534C11.253 8.86824 11.7279 8.86824 12.0208 8.57534L15.3459 5.2502C16.2246 4.37152 16.2246 2.9469 15.3459 2.06822L13.9317 0.654005C13.053 -0.224675 11.6284 -0.224675 10.7497 0.654005ZM12.8711 1.71466C12.5782 1.42177 12.1033 1.42177 11.8104 1.71466L11.0052 2.51986L13.4801 4.99473L14.2853 4.18954C14.5782 3.89664 14.5782 3.42177 14.2853 3.12888L12.8711 1.71466Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8816 14.6182C15.1745 14.9111 15.1745 15.386 14.8816 15.6789C14.5888 15.9718 14.1139 15.9718 13.821 15.6789L9.36912 11.227L5.53769 15.0584C5.25639 15.3397 4.87485 15.4978 4.47703 15.4978L1.25217 15.4978C0.837953 15.4978 0.502168 15.162 0.502168 14.7478L0.502159 11.5229C0.502157 11.1251 0.660192 10.7436 0.941499 10.4622L4.77292 6.63082L0.320988 2.17889C0.028095 1.886 0.028095 1.41112 0.320988 1.11823C0.613881 0.825336 1.08876 0.825336 1.38165 1.11823L14.8816 14.6182ZM5.83358 7.69148L8.30846 10.1664L4.47703 13.9978L2.00217 13.9978L2.00216 11.5229L5.83358 7.69148Z"
      />
    </g>
  ),
})

export const PenIcon = makeIcon({
  displayName: 'PenIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8482 2.56851C15.727 3.44731 15.727 4.87212 14.8482 5.75093L5.53849 15.0606C5.25715 15.3419 4.87556 15.5 4.47768 15.5L1.25237 15.5C0.8381 15.5 0.502268 15.1642 0.502268 14.7499L0.502258 11.5246C0.502258 11.1267 0.660314 10.7451 0.941659 10.4638L10.2513 1.1541C11.1301 0.275295 12.555 0.275295 13.4338 1.1541L14.8482 2.56851ZM13.7874 4.69012C14.0803 4.39719 14.0803 3.92225 13.7874 3.62931L12.3729 2.2149C12.08 1.92197 11.6051 1.92197 11.3121 2.2149L10.5068 3.02022L12.982 5.49544L13.7874 4.69012ZM11.9212 6.55624L4.47768 13.9998L2.00247 13.9998L2.00247 11.5246L9.44602 4.08103L11.9212 6.55624Z"
      />
    </g>
  ),
  smallAlternative: PenSmallIcon,
})

export const TwoPeopleIcon = makeIcon({
  displayName: 'TwoPeopleIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM1.5 9.854c0-.24.164-.449.397-.506 1.874-.46 3.832-.46 5.706 0A.521.521 0 0 1 8 9.854v3.792c0 .24-.164.449-.397.506-1.874.46-3.832.46-5.706 0a.521.521 0 0 1-.397-.506V9.854Zm6.46-1.963a13.464 13.464 0 0 0-6.42 0A2.021 2.021 0 0 0 0 9.854v3.792c0 .93.636 1.741 1.54 1.963 2.108.518 4.312.518 6.42 0a2.022 2.022 0 0 0 1.54-1.963V9.854c0-.93-.636-1.741-1.54-1.963ZM10.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-.75 7.25a.75.75 0 1 0 .002 1.5l.26.019a377.607 377.607 0 0 1 2.312.207.747.747 0 0 1 .676.745v2.558c0 .387-.294.71-.677.745a369.104 369.104 0 0 1-2.312.207l-.259.019h-.002a.75.75 0 0 0 0 1.5c.118 0 .554-.037 1.03-.08.506-.044 1.131-.101 1.682-.153A2.247 2.247 0 0 0 16 13.28V10.72c0-1.16-.882-2.13-2.038-2.238-.55-.052-1.176-.11-1.682-.154-.476-.042-.912-.079-1.03-.079Z"
      />
    </g>
  ),
  smallAlternative: TwoPeopleSmallIcon,
})

export const PeopleIcon = makeIcon({
  displayName: 'PeopleIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74994 3.75C5.74994 2.50736 6.7573 1.5 7.99994 1.5C9.24258 1.5 10.2499 2.50736 10.2499 3.75C10.2499 4.99264 9.24258 6 7.99994 6C6.7573 6 5.74994 4.99264 5.74994 3.75ZM7.99994 0C5.92887 0 4.24994 1.67893 4.24994 3.75C4.24994 5.82107 5.92887 7.5 7.99994 7.5C10.071 7.5 11.7499 5.82107 11.7499 3.75C11.7499 1.67893 10.071 0 7.99994 0ZM3.03024 11.7803C3.5067 11.3039 4.27925 10.9703 5.22268 10.7639C6.15066 10.5609 7.15448 10.5 7.99991 10.5C8.84534 10.5 9.84916 10.5609 10.7771 10.7639C11.7206 10.9703 12.4931 11.3039 12.9696 11.7803C13.4231 12.2338 13.7948 12.9966 14.0678 13.7686C14.1331 13.9533 14.0955 14.1195 13.9912 14.2527C13.8814 14.393 13.691 14.5 13.4526 14.5H2.54723C2.30884 14.5 2.11843 14.393 2.00863 14.2527C1.90431 14.1195 1.86669 13.9533 1.932 13.7686C2.20497 12.9966 2.57675 12.2338 3.03024 11.7803ZM7.99991 9C7.09534 9 5.97416 9.06407 4.90214 9.29858C3.84557 9.5297 2.74312 9.94613 1.96958 10.7197C1.27066 11.4186 0.808767 12.4457 0.517813 13.2685C0.0055243 14.7172 1.17979 16 2.54723 16H13.4526C14.82 16 15.9943 14.7172 15.482 13.2685C15.1911 12.4457 14.7292 11.4186 14.0302 10.7197C13.2567 9.94613 12.1543 9.5297 11.0977 9.29858C10.0257 9.06407 8.90448 9 7.99991 9Z"
      />
    </g>
  ),
  smallAlternative: PeopleSmallIcon,
})

export const PinIcon = makeIcon({
  displayName: 'PinIcon',
  content: (
    <g>
      <g clipPath="url(#clip0_244_26663)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.06.612a.75.75 0 00-1.045-.015l-7.006 6.62-.773-.772a.75.75 0 00-1.06 1.06l3.2 3.201-3.134 3.134a.75.75 0 101.06 1.06l3.135-3.133L8.6 14.93a.75.75 0 001.06-1.06l-.735-.736 6.62-7.006a.75.75 0 00-.015-1.046L11.06.612zM4.07 8.278l6.445-6.09 3.439 3.44-6.09 6.445L4.07 8.278z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_244_26663">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const PlugIcon = makeIcon({
  displayName: 'PlugIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 0V1.5C14 2.74264 12.9926 3.75 11.75 3.75H9.5C9.08579 3.75 8.75 4.08579 8.75 4.5V5.25H9C10.5188 5.25 11.75 6.48122 11.75 8V11.5H13.25C13.6642 11.5 14 11.8358 14 12.25C14 12.6642 13.6642 13 13.25 13L10.75 13V15.25C10.75 15.6642 10.4142 16 10 16C9.58579 16 9.25 15.6642 9.25 15.25V13H6.75V15.25C6.75 15.6642 6.41421 16 6 16C5.58579 16 5.25 15.6642 5.25 15.25V13H2.75C2.33579 13 2 12.6642 2 12.25C2 11.8358 2.33579 11.5 2.75 11.5H4.25V8C4.25 6.48122 5.48122 5.25 7 5.25H7.25V4.5C7.25 3.25736 8.25736 2.25 9.5 2.25H11.75C12.1642 2.25 12.5 1.91421 12.5 1.5V0H14ZM5.75 11.5H10.25V8C10.25 7.30964 9.69036 6.75 9 6.75H7C6.30964 6.75 5.75 7.30964 5.75 8V11.5Z"
    />
  ),
})

export const PlugWithSparklesIcon = makeIcon({
  displayName: 'PlugWithSparklesIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1.25C14 0.835786 13.6642 0.5 13.25 0.5C12.8358 0.5 12.5 0.835786 12.5 1.25V2.75C12.5 3.16421 12.1642 3.5 11.75 3.5H9.5C8.25736 3.5 7.25 4.50736 7.25 5.75V6.25H7C5.48122 6.25 4.25 7.48122 4.25 9V12H2.75C2.33579 12 2 12.3358 2 12.75C2 13.1642 2.33579 13.5 2.75 13.5L5.25 13.5V15.75C5.25 16.1642 5.58579 16.5 6 16.5C6.41421 16.5 6.75 16.1642 6.75 15.75V13.5H9.25V15.75C9.25 16.1642 9.58579 16.5 10 16.5C10.4142 16.5 10.75 16.1642 10.75 15.75V13.5L13.25 13.5C13.6642 13.5 14 13.1642 14 12.75C14 12.3358 13.6642 12 13.25 12H11.75V9C11.75 7.48122 10.5188 6.25 9 6.25H8.75V5.75C8.75 5.33579 9.08579 5 9.5 5H11.75C12.9926 5 14 3.99264 14 2.75V1.25ZM10.25 12V9C10.25 8.30964 9.69036 7.75 9 7.75H7C6.30964 7.75 5.75 8.30964 5.75 9V12L10.25 12Z"
        fill="currentColor"
      />
      <path
        d="M2.86566 0.606286C2.8994 0.464572 3.10105 0.464571 3.13479 0.606285L3.31318 1.35554C3.56566 2.41602 4.41737 3.22935 5.48835 3.4327L5.88748 3.50848C6.03751 3.53697 6.03751 3.75178 5.88748 3.78027L5.48835 3.85605C4.41737 4.0594 3.56566 4.87274 3.31318 5.93321L3.13479 6.68247C3.10105 6.82418 2.8994 6.82418 2.86566 6.68247L2.68729 5.93328C2.4348 4.87277 1.58304 4.05942 0.512013 3.85611L0.112525 3.78027C-0.0375084 3.75179 -0.0375084 3.53696 0.112525 3.50848L0.512013 3.43264C1.58304 3.22933 2.4348 2.41598 2.68729 1.35547L2.86566 0.606286Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const PlusIcon = makeIcon({
  displayName: 'PlusIcon',
  content: (
    <g>
      <path d="M7.25 1.75C7.25 1.33579 7.58579 1 8 1V1C8.41421 1 8.75 1.33579 8.75 1.75V14.25C8.75 14.6642 8.41421 15 8 15V15C7.58579 15 7.25 14.6642 7.25 14.25V1.75Z" />
      <path d="M14.25 7.25C14.6642 7.25 15 7.58579 15 8V8C15 8.41421 14.6642 8.75 14.25 8.75L1.75 8.75C1.33579 8.75 1 8.41421 1 8V8C1 7.58579 1.33579 7.25 1.75 7.25L14.25 7.25Z" />
    </g>
  ),
  smallAlternative: PlusSmallIcon,
})

export const QuestionIcon = makeIcon({
  displayName: 'QuestionIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 4.75C4.75 2.95507 6.20507 1.5 8 1.5C9.79493 1.5 11.25 2.95507 11.25 4.75C11.25 5.83059 10.5939 6.36364 9.54619 7.21487L9.52706 7.23041C8.51584 8.05203 7.25 9.12487 7.25 11.25C7.25 11.6642 7.58579 12 8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 9.87513 9.48416 9.19797 10.4729 8.39459C10.5239 8.35319 10.576 8.3112 10.629 8.2685C11.5548 7.52243 12.75 6.5593 12.75 4.75C12.75 2.12665 10.6234 0 8 0C5.37665 0 3.25 2.12665 3.25 4.75C3.25 5.16421 3.58579 5.5 4 5.5C4.41421 5.5 4.75 5.16421 4.75 4.75ZM7.75 14C7.33579 14 7 14.3358 7 14.75V15.25C7 15.6642 7.33579 16 7.75 16H8.25C8.66421 16 9 15.6642 9 15.25V14.75C9 14.3358 8.66421 14 8.25 14H7.75Z"
    />
  ),
})

export const QuoteIcon = makeIcon({
  displayName: 'QuoteIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.80146 3.14892C6.87427 3.55669 6.60275 3.94627 6.19498 4.01909C3.29456 4.53702 1.7627 6.74516 1.53067 8.81144C1.4142 9.8487 1.63173 10.796 2.10876 11.4627C2.56857 12.1053 3.31174 12.5509 4.42082 12.5509C4.83504 12.5509 5.17082 12.8867 5.17082 13.3009C5.17082 13.7151 4.83504 14.0509 4.42082 14.0509C2.85011 14.0509 1.64308 13.3896 0.888868 12.3355C0.151883 11.3055 -0.10842 9.96619 0.0400433 8.64406C0.337894 5.99156 2.30699 3.18964 5.9313 2.54245C6.33906 2.46963 6.72864 2.74116 6.80146 3.14892Z"
      />
      <path d="M7.45016 11.2663C7.45016 12.8107 6.09388 14.0626 4.42083 14.0626C2.74777 14.0626 1.39149 12.8107 1.39149 11.2663C1.39149 9.72196 2.74777 8.47001 4.42083 8.47001C6.09388 8.47001 7.45016 9.72196 7.45016 11.2663Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3015 3.14892C15.3743 3.55669 15.1027 3.94627 14.695 4.01909C11.7946 4.53702 10.2627 6.74516 10.0307 8.81144C9.9142 9.8487 10.1317 10.796 10.6088 11.4627C11.0686 12.1053 11.8117 12.5509 12.9208 12.5509C13.335 12.5509 13.6708 12.8867 13.6708 13.3009C13.6708 13.7151 13.335 14.0509 12.9208 14.0509C11.3501 14.0509 10.1431 13.3896 9.38887 12.3355C8.65188 11.3055 8.39158 9.96619 8.54004 8.64406C8.83789 5.99156 10.807 3.18964 14.4313 2.54245C14.8391 2.46963 15.2286 2.74116 15.3015 3.14892Z"
      />
      <path d="M15.9502 11.2663C15.9502 12.8107 14.5939 14.0626 12.9208 14.0626C11.2478 14.0626 9.89149 12.8107 9.89149 11.2663C9.89149 9.72196 11.2478 8.47001 12.9208 8.47001C14.5939 8.47001 15.9502 9.72196 15.9502 11.2663Z" />
    </g>
  ),
  smallAlternative: QuoteSmallIcon,
})

export const ClockIcon = makeIcon({
  displayName: 'ClockIcon',
  content: (
    <g>
      <path d="M8.5 4C8.5 3.58579 8.16421 3.25 7.75 3.25C7.33579 3.25 7 3.58579 7 4V8.25C7 8.66421 7.33579 9 7.75 9H12C12.4142 9 12.75 8.66421 12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5H8.5V4Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8Z"
      />
    </g>
  ),
  smallAlternative: ClockSmallIcon,
})

export const RecurringIcon = makeIcon({
  displayName: 'RecurringIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2512 3.5C14.837 3.5 14.5012 3.83579 14.5012 4.25V5.30557C13.4187 2.49462 10.6929 0.5 7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5C9.62685 15.5 11.548 14.6137 12.912 13.1924C13.1988 12.8935 13.189 12.4187 12.8901 12.1319C12.5913 11.8451 12.1165 11.8549 11.8297 12.1538C10.7368 13.2926 9.20166 14 7.5 14C4.18629 14 1.5 11.3137 1.5 8C1.5 4.68629 4.18629 2 7.5 2C10.4182 2 12.8513 4.08405 13.3891 6.84532C13.4309 7.0595 13.4612 7.27793 13.4795 7.5H11.2512C10.837 7.5 10.5012 7.83579 10.5012 8.25C10.5012 8.66421 10.837 9 11.2512 9H15.2512C15.6654 9 16.0012 8.66421 16.0012 8.25V4.25C16.0012 3.83579 15.6654 3.5 15.2512 3.5ZM8.5 4.75C8.5 4.33579 8.16422 4 7.75 4C7.33579 4 7 4.33579 7 4.75V7.85951L4.81991 9.38558C4.48057 9.62311 4.39804 10.0908 4.63558 10.4301C4.87312 10.7694 5.34076 10.852 5.6801 10.6144L8.1801 8.86442C8.3806 8.72408 8.5 8.49474 8.5 8.25V4.75Z"
      />
    </g>
  ),
})

export const RecurringFlippedIcon = makeIcon({
  displayName: 'RecurringFlippedIcon',
  content: (
    <g>
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M.75 3.5a.75.75 0 0 1 .75.75v1.056A7.502 7.502 0 0 1 16.001 8 7.5 7.5 0 0 1 3.09 13.192a.75.75 0 0 1 1.083-1.038A6 6 0 1 0 2.522 7.5H4.75a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 0 8.25v-4a.75.75 0 0 1 .75-.75Zm6.751 1.25a.75.75 0 1 1 1.5 0v3.11l2.18 1.526a.75.75 0 1 1-.86 1.228l-2.5-1.75a.75.75 0 0 1-.32-.614v-3.5Z"
          clipRule="evenodd"
        />
      </g>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </g>
  ),
})

export const RecycleIcon = makeIcon({
  viewBox: 16,
  displayName: 'Recycle',
  content: (
    <g>
      <path d="M15.2512 0.499948C14.837 0.499948 14.5012 0.835734 14.5012 1.24995V4.0379C13.3169 1.6453 10.8513 -0.00012207 8 -0.00012207C5.9989 -0.00012207 4.18596 0.811593 2.8749 2.12193C1.87556 3.12072 1.1654 4.41136 0.883901 5.85655C0.804708 6.26313 1.0701 6.65692 1.47667 6.73611C1.88325 6.8153 2.27704 6.54991 2.35623 6.14334C2.57894 4.99997 3.14109 3.97662 3.93527 3.18288C4.97654 2.14218 6.41255 1.49988 8 1.49988C10.5648 1.49988 12.7388 3.17975 13.4791 5.49995L10.2512 5.49995C9.83701 5.49995 9.50122 5.83573 9.50122 6.24995C9.50122 6.66416 9.83701 6.99995 10.2512 6.99995H15.2512C15.6654 6.99995 16.0012 6.66416 16.0012 6.24995V1.24995C16.0012 0.835734 15.6654 0.499948 15.2512 0.499948Z" />
      <path d="M0.75 15.4999C1.16421 15.4999 1.5 15.1642 1.5 14.7499L1.5 11.962C2.68429 14.3546 5.14997 16 8.00122 16C10.0023 16 11.8153 15.1883 13.1263 13.878C14.1257 12.8792 14.8358 11.5885 15.1173 10.1433C15.1965 9.73677 14.9311 9.34298 14.5245 9.26378C14.118 9.18459 13.7242 9.44998 13.645 9.85656C13.4223 10.9999 12.8601 12.0233 12.066 12.817C11.0247 13.8577 9.58867 14.5 8.00122 14.5C5.43644 14.5 3.26238 12.8201 2.52213 10.4999L5.75 10.4999C6.16421 10.4999 6.5 10.1642 6.5 9.74995C6.5 9.33574 6.16421 8.99995 5.75 8.99995H0.750001C0.335787 8.99995 0 9.33574 0 9.74995V14.7499C0 15.1642 0.335786 15.4999 0.75 15.4999Z" />
    </g>
  ),
  smallAlternative: RecycleSmallIcon,
})

export const RedoIcon = makeIcon({
  displayName: 'Redo',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5012 3.25C14.5012 2.83579 14.837 2.5 15.2512 2.5C15.6654 2.5 16.0012 2.83579 16.0012 3.25L16.0012 8.25C16.0012 8.66421 15.6654 9 15.2512 9L10.2512 9C9.83701 9 9.50122 8.66421 9.50122 8.25C9.50122 7.83579 9.83701 7.5 10.2512 7.5L13.4795 7.5C13.4612 7.27793 13.4309 7.0595 13.3891 6.84532C12.8513 4.08405 10.4182 2 7.5 2C4.18629 2 1.5 4.68629 1.5 8C1.5 11.3137 4.18629 14 7.5 14C9.20166 14 10.7368 13.2926 11.8297 12.1538C12.1165 11.8549 12.5913 11.8451 12.8901 12.1319C13.189 12.4187 13.1988 12.8935 12.912 13.1924C11.548 14.6137 9.62685 15.5 7.5 15.5C3.35786 15.5 4.00419e-08 12.1421 8.94364e-08 8C1.38831e-07 3.85786 3.35786 0.499999 7.5 0.5C10.6929 0.5 13.4187 2.49462 14.5012 5.30557L14.5012 3.25Z"
      />
    </g>
  ),
})

export const NewTemplateIcon = makeIcon({
  displayName: 'NewTemplateIcon',
  content: (
    <g>
      <g fill="currentColor" clipPath="url(#a)">
        <path
          fillRule="evenodd"
          d="M.5 2c0-.966.784-1.75 1.75-1.75h3.5C6.717.25 7.5 1.034 7.5 2v3.5a1.75 1.75 0 0 1-1.75 1.75h-3.5A1.75 1.75 0 0 1 .5 5.5V2Zm1.75-.25A.25.25 0 0 0 2 2v3.5c0 .138.112.25.25.25h3.5A.25.25 0 0 0 6 5.5V2a.25.25 0 0 0-.25-.25h-3.5ZM2.763 8.677a1.75 1.75 0 0 1 2.474 0l2.087 2.086a1.75 1.75 0 0 1 0 2.475l-2.087 2.086a1.75 1.75 0 0 1-2.474 0L.676 13.238a1.75 1.75 0 0 1 0-2.475l2.087-2.086Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.086 2.087a.25.25 0 0 0 0 .353l2.086 2.087a.25.25 0 0 0 .354 0l2.086-2.087a.25.25 0 0 0 0-.353L4.177 9.738ZM12.25 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
          clipRule="evenodd"
        />
        <path d="M8.75 3.75c0-.446.362-.808.808-.808h1.884V1.058a.808.808 0 1 1 1.616 0v1.884h1.884a.808.808 0 0 1 0 1.616h-1.884v1.884a.808.808 0 1 1-1.616 0V4.558H9.558a.808.808 0 0 1-.808-.808Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const SearchAllIcon = makeIcon({
  displayName: 'SearchAllIcon',
  content: (
    <path d="M4.594 4.25a4.594 4.594 0 1 0 2.681 8.324c.023.03.048.06.075.087l3.12 3.12a.75.75 0 1 0 1.06-1.06L8.41 11.6a.76.76 0 0 0-.086-.075 4.594 4.594 0 0 0-3.73-7.276ZM1.5 8.844a3.094 3.094 0 1 1 6.188 0 3.094 3.094 0 0 1-6.188 0ZM6.75 1.75A.75.75 0 0 1 7.5 1h7.75a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75ZM10 5.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75ZM11.25 9.75A.75.75 0 0 1 12 9h3.25a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Z" />
  ),
})

export const SearchIcon = makeIcon({
  displayName: 'SearchIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13C8.02469 13 9.42677 12.475 10.5354 11.596L14.7197 15.7803C15.0126 16.0732 15.4875 16.0732 15.7803 15.7803C16.0732 15.4874 16.0732 15.0126 15.7803 14.7197L11.596 10.5353C12.475 9.42676 13 8.02469 13 6.5C13 2.91015 10.0899 0 6.5 0ZM1.5 6.5C1.5 3.73858 3.73858 1.5 6.5 1.5C9.26142 1.5 11.5 3.73858 11.5 6.5C11.5 9.26142 9.26142 11.5 6.5 11.5C3.73858 11.5 1.5 9.26142 1.5 6.5Z"
      />
    </g>
  ),
  smallAlternative: SearchSmallIcon,
})

export const SearchWithPaddingIcon = makeIcon({
  displayName: 'SearchWithPaddingIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 3C4.67893 3 3 4.67893 3 6.75C3 8.82107 4.67893 10.5 6.75 10.5C8.82107 10.5 10.5 8.82107 10.5 6.75C10.5 4.67893 8.82107 3 6.75 3ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5C9.6495 1.5 12 3.85051 12 6.75C12 9.6495 9.6495 12 6.75 12C3.85051 12 1.5 9.6495 1.5 6.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.71967 9.71967C10.0126 9.42678 10.4874 9.42678 10.7803 9.71967L14.2803 13.2197C14.5732 13.5126 14.5732 13.9874 14.2803 14.2803C13.9874 14.5732 13.5126 14.5732 13.2197 14.2803L9.71967 10.7803C9.42678 10.4874 9.42678 10.0126 9.71967 9.71967Z"
      />
    </g>
  ),
})

export const SearchWithSparkleIcon = makeIcon({
  displayName: 'SearchIcon',
  content: (
    <g>
      <path d="M12.4185 0.144864C12.3763 -0.0482888 12.1243 -0.0482877 12.0821 0.144865L11.8591 1.16599C11.5435 2.61144 10.4788 3.72001 9.14002 3.99713L8.64066 4.10049C8.45311 4.13931 8.45311 4.43212 8.64066 4.47094L9.14002 4.5743C10.4788 4.85142 11.5435 5.95999 11.8591 7.40544L12.0821 8.42656C12.1243 8.61972 12.3763 8.61972 12.4185 8.42656L12.6415 7.40534C12.9571 5.95994 14.0217 4.85139 15.3604 4.57423L15.8593 4.47094C16.0469 4.43211 16.0469 4.13932 15.8594 4.10049L15.3604 3.9972C14.0217 3.72004 12.9571 2.61149 12.6415 1.16609L12.4185 0.144864Z" />
      <path d="M6.25 2.75C3.62665 2.75 1.5 4.87665 1.5 7.5C1.5 10.1234 3.62665 12.25 6.25 12.25C7.99853 12.25 9.52733 11.3056 10.3527 9.89552C10.562 9.53805 11.0214 9.41789 11.3789 9.62713C11.7364 9.83638 11.8565 10.2958 11.6473 10.6533C11.5034 10.8991 11.3431 11.1343 11.1679 11.3573L14.5303 14.7197C14.8232 15.0126 14.8232 15.4874 14.5303 15.7803C14.2374 16.0732 13.7626 16.0732 13.4697 15.7803L10.1073 12.4179C9.04528 13.252 7.70597 13.75 6.25 13.75C2.79822 13.75 0 10.9518 0 7.5C0 4.04822 2.79822 1.25 6.25 1.25C6.73753 1.25 7.21293 1.30596 7.66978 1.41214C8.07324 1.5059 8.3243 1.90898 8.23053 2.31244C8.13677 2.71591 7.73368 2.96696 7.33022 2.8732C6.98392 2.79272 6.62242 2.75 6.25 2.75Z" />
    </g>
  ),
})

export const SeparatorIcon = makeIcon({
  displayName: 'Separator',
  content: (
    <g>
      <rect
        x="16"
        y="7.25"
        width="1.5"
        height="16"
        rx="0.75"
        transform="rotate(90 16 7.25)"
      />
    </g>
  ),
  smallAlternative: SeparatorSmallIcon,
})

export const TemplateIcon = makeIcon({
  displayName: 'TemplateIcon',
  content: (
    <g>
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipPath="url(#a)"
        clipRule="evenodd"
      >
        <path d="M13.804 1.117c-.653-1.259-2.455-1.259-3.107 0L8.84 4.695a1.75 1.75 0 0 0 1.554 2.555h3.71a1.75 1.75 0 0 0 1.554-2.555l-1.855-3.578Zm-1.776.69a.25.25 0 0 1 .444 0l1.855 3.578a.25.25 0 0 1-.222.365h-3.71a.25.25 0 0 1-.222-.365l1.855-3.577ZM2.25.25A1.75 1.75 0 0 0 .5 2v3.5c0 .966.784 1.75 1.75 1.75h3.5A1.75 1.75 0 0 0 7.5 5.5V2A1.75 1.75 0 0 0 5.75.25h-3.5ZM2 2a.25.25 0 0 1 .25-.25h3.5A.25.25 0 0 1 6 2v3.5a.25.25 0 0 1-.25.25h-3.5A.25.25 0 0 1 2 5.5V2ZM2.763 8.677a1.75 1.75 0 0 1 2.474 0l2.087 2.086a1.75 1.75 0 0 1 0 2.475l-2.087 2.086a1.75 1.75 0 0 1-2.474 0L.676 13.238a1.75 1.75 0 0 1 0-2.475l2.087-2.086Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.086 2.087a.25.25 0 0 0 0 .353l2.086 2.087a.25.25 0 0 0 .354 0l2.086-2.087a.25.25 0 0 0 0-.353L4.177 9.738ZM12.25 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const TranslateIcon = makeIcon({
  displayName: 'TranslateIcon',
  content: (
    <g>
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5.441-.008a.75.75 0 0 1 .75.75v.973h3.941a.75.75 0 1 1 0 1.5H8.417a.756.756 0 0 1-.01.117c-.235 1.492-.828 2.753-1.683 3.77.237.14.486.266.746.38l.513.218a.2.2 0 0 1 .104.266l-.451.993a.2.2 0 0 1-.263.1l-.499-.218a8.413 8.413 0 0 1-1.248-.675c-1.05.83-2.326 1.408-3.734 1.717a.75.75 0 0 1-.322-1.465c1.084-.238 2.051-.651 2.859-1.227-.998-1.004-1.69-2.297-1.946-3.856a.747.747 0 0 1-.01-.12H.75a.75.75 0 0 1 0-1.5h3.941V.742a.75.75 0 0 1 .75-.75Zm.087 6.2c.696-.81 1.174-1.806 1.379-2.977H3.968c.22 1.198.765 2.195 1.56 2.977Zm1.034 8.769a.75.75 0 0 0 1.377.594l.842-1.952h4.852l.843 1.952a.75.75 0 1 0 1.377-.594l-3.92-9.082a.748.748 0 0 0-.726-.55.747.747 0 0 0-.726.55L6.56 14.96Zm4.645-6.98 1.779 4.122H9.429l1.778-4.122Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
  smallAlternative: TranslateSmallIcon,
})

export const ShareIcon = makeIcon({
  displayName: 'ShareIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99438 4.81757C4.70149 5.11057 4.22661 5.11057 3.93372 4.81757C3.64083 4.52457 3.64083 4.04953 3.93372 3.75653L7.46926 0.219748C7.76215 -0.0732488 8.23702 -0.0732488 8.52992 0.219748L12.0654 3.75653C12.3583 4.04953 12.3583 4.52457 12.0654 4.81757C11.7726 5.11056 11.2977 5.11056 11.0048 4.81757L8.75007 2.56205L8.75007 11.7498C8.75007 12.1641 8.41429 12.5 8.00007 12.5C7.58586 12.5 7.25007 12.1641 7.25007 11.7498L7.25007 2.56108L4.99438 4.81757Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9.75C16 8.23122 14.7688 7 13.25 7L11.75 7C11.3358 7 11 7.33579 11 7.75C11 8.16421 11.3358 8.5 11.75 8.5L13.25 8.5C13.9404 8.5 14.5 9.05964 14.5 9.75L14.5 13.25C14.5 13.9404 13.9404 14.5 13.25 14.5L2.75 14.5C2.05964 14.5 1.5 13.9404 1.5 13.25L1.5 9.75C1.5 9.05964 2.05964 8.5 2.75 8.5L4.25 8.5C4.66421 8.5 5 8.16421 5 7.75C5 7.33579 4.66421 7 4.25 7L2.75 7C1.23122 7 0 8.23122 0 9.75L0 13.25C0 14.7688 1.23122 16 2.75 16L13.25 16C14.7688 16 16 14.7688 16 13.25L16 9.75Z"
      />
    </g>
  ),
})

export const ImportIcon = makeIcon({
  displayName: 'ImportIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 6.75C0.5 5.23122 1.73122 4 3.25 4H3.75C4.16421 4 4.5 4.33579 4.5 4.75C4.5 5.16421 4.16421 5.5 3.75 5.5H3.25C2.55964 5.5 2 6.05964 2 6.75V13.25C2 13.9404 2.55964 14.5 3.25 14.5H12.75C13.4404 14.5 14 13.9404 14 13.25V6.75C14 6.05964 13.4404 5.5 12.75 5.5H12.25C11.8358 5.5 11.5 5.16421 11.5 4.75C11.5 4.33579 11.8358 4 12.25 4H12.75C14.2688 4 15.5 5.23122 15.5 6.75V13.25C15.5 14.7688 14.2688 16 12.75 16H3.25C1.73122 16 0.5 14.7688 0.5 13.25V6.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.46967 8.46967C4.76256 8.17678 5.23744 8.17678 5.53033 8.46967L8 10.9393L10.4697 8.46967C10.7626 8.17678 11.2374 8.17678 11.5303 8.46967C11.8232 8.76256 11.8232 9.23744 11.5303 9.53033L8.53033 12.5303C8.23744 12.8232 7.76256 12.8232 7.46967 12.5303L4.46967 9.53033C4.17678 9.23744 4.17678 8.76256 4.46967 8.46967Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.41421 -1.81058e-08 8.75 0.335786 8.75 0.75V10.5C8.75 10.9142 8.41421 11.25 8 11.25C7.58579 11.25 7.25 10.9142 7.25 10.5L7.25 0.75C7.25 0.335786 7.58579 1.81058e-08 8 0Z"
      />
    </g>
  ),
})

export const SortIcon = makeIcon({
  displayName: 'SortIcon',
  content: (
    <g>
      <g clipPath="url(#clip0_1033_12247)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.566 4.83a.75.75 0 01-1.06 0L12.25 2.576v8.674a.75.75 0 11-1.5 0V2.575L8.495 4.83a.75.75 0 01-1.06-1.06L10.89.313a.749.749 0 011.221.003l3.454 3.454a.75.75 0 010 1.06zM.434 11.17a.75.75 0 011.06 0l2.255 2.254V4.75a.75.75 0 011.5 0v8.675l2.256-2.255a.75.75 0 011.06 1.06L5.11 15.687a.75.75 0 01-1.221-.003L.434 12.23a.75.75 0 010-1.06z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1033_12247">
          <path d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const SparklesIcon = makeIcon({
  displayName: 'SparklesIcon',
  content: (
    <g>
      <path d="M10.8789 0.509683C10.9093 0.381863 11.0912 0.381863 11.1216 0.509684L11.171 0.716952C11.3744 1.57133 12.0606 2.2266 12.9234 2.39043C13.0443 2.41338 13.0443 2.58645 12.9234 2.6094C12.0606 2.77323 11.3744 3.4285 11.171 4.28288L11.1216 4.49015C11.0912 4.61797 10.9093 4.61797 10.8789 4.49015L10.8296 4.28309C10.6261 3.42859 9.93982 2.77324 9.07684 2.60941C8.95595 2.58647 8.95595 2.41337 9.07684 2.39042C9.93982 2.2266 10.6261 1.57124 10.8296 0.716736L10.8789 0.509683Z" />
      <path d="M6.36729 2.05408C6.29418 1.64463 5.70685 1.64463 5.63374 2.05408L5.4532 3.06523C5.04855 5.33155 3.35435 7.15095 1.12258 7.71588C0.827792 7.7905 0.827792 8.20933 1.12258 8.28395C3.35435 8.84888 5.04855 10.6683 5.4532 12.9346L5.63374 13.9458C5.70685 14.3552 6.29418 14.3552 6.36729 13.9458L6.54794 12.934C6.95253 10.668 8.64641 8.84887 10.8778 8.28391C11.1726 8.20929 11.1726 7.79054 10.8778 7.71592C8.64641 7.15096 6.95253 5.3318 6.54794 3.06583L6.36729 2.05408Z" />
      <path d="M12.6771 8.84849C12.6372 8.65683 12.3635 8.65683 12.3235 8.84849L12.2235 9.32878C11.9618 10.5848 10.9855 11.5692 9.73175 11.8412C9.56108 11.8782 9.56108 12.1216 9.73175 12.1587C10.9855 12.4307 11.9618 13.4151 12.2235 14.671L12.3235 15.1513C12.3635 15.343 12.6372 15.343 12.6771 15.1513L12.7772 14.6707C13.0388 13.4149 14.015 12.4307 15.2685 12.1586C15.4392 12.1216 15.4392 11.8782 15.2685 11.8412C14.015 11.5692 13.0388 10.5849 12.7772 9.32911L12.6771 8.84849Z" />
    </g>
  ),
})

export const SparklesOutlineIcon = makeIcon({
  displayName: 'SparklesOutlineIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.65119 0.515097C10.0898 0.515097 10.6995 0.759134 10.8361 1.40055L11.0403 2.3588C11.4495 4.27953 12.9773 6.31277 15.137 6.77102C15.6512 6.88012 16 7.28884 16 7.7622C16 8.23556 15.6512 8.64428 15.137 8.75338C12.9773 9.21163 11.4495 11.2476 11.0403 13.1684L10.8361 14.1266C10.6995 14.768 10.0898 15.0121 9.6512 15.0121C9.21256 15.0121 8.60293 14.768 8.46628 14.1266L8.26224 13.1689C7.85296 11.2479 6.08576 9.21166 3.92562 8.75342C3.41139 8.64433 3.06259 8.23558 3.06259 7.7622C3.06259 7.28881 3.41139 6.88007 3.92562 6.77098C6.08576 6.31273 7.85296 4.27923 8.26224 2.35824L8.46628 1.40055C8.60293 0.759136 9.21256 0.515098 9.65119 0.515097ZM9.65117 3.24523C9.14456 4.94096 7.47389 6.97115 5.6883 7.7622C7.47389 8.55325 9.14456 10.5862 9.65117 12.2819C10.1576 10.5863 11.589 8.5533 13.3745 7.7622C11.589 6.9711 10.1576 4.94089 9.65117 3.24523Z"
      />
      <path d="M2.6489 0.329281C2.68009 0.203391 2.86648 0.203391 2.89767 0.32928L3.06256 0.994872C3.29595 1.93692 4.08324 2.65943 5.0732 2.84007L5.44214 2.90739C5.58082 2.9327 5.58082 3.12353 5.44214 3.14883L5.0732 3.21616C4.08323 3.3968 3.29595 4.11931 3.06256 5.06136L2.89767 5.72695C2.86648 5.85284 2.68009 5.85284 2.6489 5.72695L2.48402 5.06142C2.25063 4.11934 1.46329 3.39682 0.473283 3.2162L0.104014 3.14883C-0.0346712 3.12353 -0.0346712 2.93269 0.104014 2.90739L0.473283 2.84003C1.46329 2.65941 2.25063 1.93689 2.48402 0.994808L2.6489 0.329281Z" />
    </g>
  ),
})

export const SpinnerIcon = makeIcon({
  displayName: 'Spinner',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 7.58579 14.8358 7.25 15.25 7.25C15.6642 7.25 16 7.58579 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C8.41421 0 8.75 0.335786 8.75 0.75C8.75 1.16421 8.41421 1.5 8 1.5Z"
    />
  ),
})

export const SquareIcon = makeIcon({
  displayName: 'SquareIcon',
  content: <rect x="2" y="2" width="12" height="12" rx="1" />,
})

export const PlaceholderIcon = makeIcon({
  displayName: 'PlaceholderIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.25C0 1.00736 1.00736 0 2.25 0H2.5C2.91421 0 3.25 0.335786 3.25 0.75C3.25 1.16421 2.91421 1.5 2.5 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V2.5625C1.5 2.97671 1.16421 3.3125 0.75 3.3125C0.335786 3.3125 0 2.97671 0 2.5625V2.25ZM4.875 0.75C4.875 0.335786 5.21079 0 5.625 0H10.3125C10.7267 0 11.0625 0.335786 11.0625 0.75C11.0625 1.16421 10.7267 1.5 10.3125 1.5H5.625C5.21079 1.5 4.875 1.16421 4.875 0.75ZM12.6875 0.75C12.6875 0.335786 13.0233 0 13.4375 0H13.75C14.9926 0 16 1.00736 16 2.25V2.5625C16 2.97671 15.6642 3.3125 15.25 3.3125C14.8358 3.3125 14.5 2.97671 14.5 2.5625V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H13.4375C13.0233 1.5 12.6875 1.16421 12.6875 0.75ZM0.75 4.9375C1.16421 4.9375 1.5 5.27329 1.5 5.6875V10.3125C1.5 10.7267 1.16421 11.0625 0.75 11.0625C0.335786 11.0625 0 10.7267 0 10.3125V5.6875C0 5.27329 0.335786 4.9375 0.75 4.9375ZM15.25 4.9375C15.6642 4.9375 16 5.27329 16 5.6875V10.3125C16 10.7267 15.6642 11.0625 15.25 11.0625C14.8358 11.0625 14.5 10.7267 14.5 10.3125V5.6875C14.5 5.27329 14.8358 4.9375 15.25 4.9375ZM0.75 12.6875C1.16421 12.6875 1.5 13.0233 1.5 13.4375V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H2.5625C2.97671 14.5 3.3125 14.8358 3.3125 15.25C3.3125 15.6642 2.97671 16 2.5625 16H2.25C1.00736 16 0 14.9926 0 13.75V13.4375C0 13.0233 0.335786 12.6875 0.75 12.6875ZM15.25 12.6875C15.6642 12.6875 16 13.0233 16 13.4375V13.75C16 14.9926 14.9926 16 13.75 16H13.4375C13.0233 16 12.6875 15.6642 12.6875 15.25C12.6875 14.8358 13.0233 14.5 13.4375 14.5H13.75C14.1642 14.5 14.5 14.1642 14.5 13.75V13.4375C14.5 13.0233 14.8358 12.6875 15.25 12.6875ZM4.9375 15.25C4.9375 14.8358 5.27329 14.5 5.6875 14.5H10.3125C10.7267 14.5 11.0625 14.8358 11.0625 15.25C11.0625 15.6642 10.7267 16 10.3125 16H5.6875C5.27329 16 4.9375 15.6642 4.9375 15.25Z"
    />
  ),
  smallAlternative: PlaceholderSmallIcon,
})

export const StrikethroughIcon = makeIcon({
  displayName: 'Strikethrough',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.75C0 7.33579 0.335786 7 0.75 7H15.25C15.6642 7 16 7.33579 16 7.75C16 8.16421 15.6642 8.5 15.25 8.5H0.75C0.335786 8.5 0 8.16421 0 7.75Z"
      />
      <path d="M11.7206 11C11.7206 12.4455 10.3837 14.25 7.47064 14.25C6.05742 14.25 5.1101 13.7124 4.51153 13.1865C4.20834 12.9202 3.99252 12.6543 3.85444 12.4585C3.78565 12.3609 3.70256 12.2199 3.67273 12.1686C3.48974 11.7992 3.04173 11.6449 2.67084 11.826C2.29863 12.0078 2.14423 12.4568 2.32598 12.8291C2.32598 12.8291 2.34521 12.867 2.35219 12.8801C2.36615 12.9064 2.38544 12.9415 2.41027 12.9842C2.4599 13.0696 2.53201 13.1859 2.62845 13.3227C2.82081 13.5956 3.1133 13.9548 3.52154 14.3134C4.34583 15.0376 5.63387 15.75 7.47064 15.75C11.0576 15.75 13.2206 13.4204 13.2206 11C13.2206 10.6488 13.1854 10.315 13.1151 10H11.5535C11.6608 10.2807 11.7206 10.6104 11.7206 11Z" />
      <path d="M11.1094 8.5H12.4011C12.3733 8.46549 12.3447 8.43143 12.3154 8.39782C12.0433 8.08552 11.5695 8.05294 11.2572 8.32505C11.1978 8.37688 11.1484 8.43604 11.1094 8.5Z" />
      <path d="M3.75 4.75C3.75 3.30447 5.08696 1.5 8 1.5C9.41323 1.5 10.3605 2.03761 10.9591 2.56345C11.2623 2.82981 11.4781 3.09563 11.6162 3.29151C11.685 3.38908 11.7336 3.4681 11.7635 3.51942C11.7784 3.54504 11.794 3.57398 11.794 3.57398C11.977 3.94331 12.4289 4.10504 12.7998 3.92395C13.172 3.7422 13.3264 3.29313 13.1447 2.92092L13.1397 2.91154C13.122 2.87813 13.0828 2.80426 13.0604 2.76573C13.0107 2.68034 12.9386 2.56404 12.8422 2.42724C12.6498 2.15437 12.3573 1.79519 11.9491 1.43655C11.1248 0.712393 9.83677 0 8 0C4.41304 0 2.25 2.32954 2.25 4.75C2.25 6.20439 2.85578 7.32204 3.94955 8.0395C4.22612 8.22091 4.52891 8.37358 4.85406 8.5H8.70732C8.73496 8.42181 8.75 8.33766 8.75 8.25C8.75 7.83579 8.41421 7.5 8 7.5C6.54824 7.5 5.46774 7.24144 4.77227 6.78525C4.12544 6.36096 3.75 5.72861 3.75 4.75Z" />
    </g>
  ),
  smallAlternative: StrikethroughSmallIcon,
})

export const TagIcon = makeIcon({
  displayName: 'TagIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1374 1.56156C12.359 1.54141 12.5782 1.62076 12.7356 1.77815L14.2169 3.25945C14.3743 3.41684 14.4536 3.63601 14.4335 3.85768L14.1927 6.50625C14.1768 6.68098 14.1002 6.84461 13.9761 6.96868L6.69975 14.1997C6.40685 14.4926 5.93198 14.4926 5.63909 14.1997L1.75 10.3107C1.45711 10.0178 1.45711 9.54289 1.75 9.25L9.02638 2.01893C9.15044 1.89487 9.31407 1.81823 9.48881 1.80234L12.1374 1.56156ZM13.7963 0.717492C13.3241 0.245319 12.6666 0.00726691 12.0016 0.0677226L9.353 0.308501C8.82881 0.356156 8.33791 0.58608 7.96572 0.958271L0.68934 8.18934C-0.18934 9.06802 -0.18934 10.4926 0.68934 11.3713L4.57843 15.2604C5.45711 16.1391 6.88173 16.1391 7.76041 15.2604L15.0368 8.02934C15.409 7.65715 15.6389 7.16625 15.6866 6.64205L15.9273 3.99349C15.9878 3.32848 15.7497 2.67097 15.2776 2.19879L13.7963 0.717492ZM11.8839 5.52638C11.4934 5.91691 10.8602 5.91691 10.4697 5.52638C10.0792 5.13586 10.0792 4.50269 10.4697 4.11217C10.8602 3.72164 11.4934 3.72164 11.8839 4.11217C12.2744 4.50269 12.2744 5.13586 11.8839 5.52638Z"
    />
  ),
  smallAlternative: TagSmallIcon,
})

export const UnderlineIcon = makeIcon({
  displayName: 'Underline',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 15.25C2.25 14.8358 2.58579 14.5 3 14.5H13C13.4142 14.5 13.75 14.8358 13.75 15.25C13.75 15.6642 13.4142 16 13 16H3C2.58579 16 2.25 15.6642 2.25 15.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0C3.41421 0 3.75 0.335786 3.75 0.75V6.75C3.75 9.09721 5.65279 11 8 11C10.3472 11 12.25 9.09721 12.25 6.75V0.75C12.25 0.335786 12.5858 0 13 0C13.4142 0 13.75 0.335786 13.75 0.75V6.75C13.75 9.92564 11.1756 12.5 8 12.5C4.82436 12.5 2.25 9.92564 2.25 6.75V0.75C2.25 0.335786 2.58579 0 3 0Z"
      />
    </g>
  ),
  smallAlternative: UnderlineSmallIcon,
})

export const UndoIcon = makeIcon({
  displayName: 'Undo',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 3.25C1.5 2.83579 1.16421 2.5 0.75 2.5C0.335787 2.5 -5.5357e-07 2.83579 -5.35465e-07 3.25L-3.16907e-07 8.25C-2.98801e-07 8.66422 0.335787 9 0.750001 9L5.75 9C6.16422 9 6.5 8.66421 6.5 8.25C6.5 7.83579 6.16421 7.5 5.75 7.5L2.52172 7.5C2.54001 7.27793 2.57036 7.0595 2.61208 6.84532C3.14996 4.08405 5.58303 2 8.50122 2C11.8149 2 14.5012 4.68629 14.5012 8C14.5012 11.3137 11.8149 14 8.50122 14C6.79956 14 5.26439 13.2926 4.17153 12.1538C3.88473 11.8549 3.40995 11.8451 3.11109 12.1319C2.81223 12.4187 2.80245 12.8935 3.08926 13.1924C4.45325 14.6137 6.37437 15.5 8.50122 15.5C12.6434 15.5 16.0012 12.1421 16.0012 8C16.0012 3.85786 12.6434 0.499999 8.50122 0.5C5.30832 0.5 2.58254 2.49462 1.5 5.30556L1.5 3.25Z"
      />
    </g>
  ),
})

export const UserGroupIcon = makeIcon({
  displayName: 'UserGroupIcon',
  viewBox: 16,
  content: (
    <React.Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 3C3.25 2.17157 3.92157 1.5 4.75 1.5C5.57843 1.5 6.25 2.17157 6.25 3C6.25 3.82843 5.57843 4.5 4.75 4.5C3.92157 4.5 3.25 3.82843 3.25 3ZM4.75 0C3.09315 0 1.75 1.34315 1.75 3C1.75 4.65685 3.09315 6 4.75 6C6.40685 6 7.75 4.65685 7.75 3C7.75 1.34315 6.40685 0 4.75 0ZM1.5 9.85415C1.5 9.61407 1.66393 9.40502 1.89709 9.34777C3.7712 8.88761 5.7288 8.88761 7.60291 9.34777C7.83607 9.40502 8 9.61407 8 9.85415V13.6458C8 13.8859 7.83607 14.095 7.60291 14.1522C5.7288 14.6124 3.7712 14.6124 1.89709 14.1522C1.66393 14.095 1.5 13.8859 1.5 13.6458V9.85415ZM7.96059 7.89104C5.85152 7.37319 3.64848 7.37319 1.53941 7.89104C0.635521 8.11297 0 8.92341 0 9.85415V13.6458C0 14.5766 0.635521 15.387 1.53941 15.609C3.64848 16.1268 5.85152 16.1268 7.96059 15.609C8.86448 15.387 9.5 14.5766 9.5 13.6458V9.85415C9.5 8.92342 8.86448 8.11298 7.96059 7.89104Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4C10.5 3.17157 11.1716 2.5 12 2.5C12.8284 2.5 13.5 3.17157 13.5 4C13.5 4.82843 12.8284 5.5 12 5.5C11.1716 5.5 10.5 4.82843 10.5 4ZM12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1ZM11.25 8.25C10.8358 8.24999 10.5 8.58578 10.5 8.99999C10.5 9.4142 10.8358 9.75 11.25 9.75C11.25 9.75 11.2506 9.75004 11.252 9.75012C11.265 9.75091 11.3436 9.75564 11.5111 9.76904C11.6768 9.78229 11.8968 9.80115 12.1483 9.82335C12.6508 9.86773 13.2727 9.92495 13.8227 9.97617C14.2061 10.0119 14.5 10.334 14.5 10.7211V13.2789C14.5 13.666 14.2061 13.9881 13.8227 14.0238C13.2727 14.0751 12.6508 14.1323 12.1483 14.1767C11.8968 14.1989 11.6768 14.2177 11.5111 14.231C11.3436 14.2444 11.2651 14.2491 11.252 14.2499C11.2506 14.25 11.25 14.25 11.25 14.25C10.8358 14.25 10.5 14.5858 10.5 15C10.5 15.4142 10.8358 15.75 11.25 15.75C11.3678 15.75 11.8041 15.7129 12.2802 15.6708C12.7864 15.6261 13.4111 15.5687 13.9618 15.5174C15.1184 15.4097 16 14.4385 16 13.2789V10.7211C16 9.56147 15.1184 8.59036 13.9618 8.48264C13.4111 8.43135 12.7864 8.37387 12.2802 8.32917C11.8041 8.28713 11.3678 8.25 11.25 8.25Z"
      />
    </React.Fragment>
  ),
  smallAlternative: UserGroupSmallIcon,
})

export const UserAddIcon = makeIcon({
  displayName: 'UserAddIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M13.4999 10.25C13.4999 9.83579 13.1641 9.5 12.7499 9.5C12.3357 9.5 11.9999 9.83579 11.9999 10.25V12H10.2499C9.88491 12 9.49991 12.385 9.49991 12.75C9.49991 13.165 9.88491 13.5 10.2499 13.5H11.9999V15.25C11.9999 15.6642 12.3357 16 12.7499 16C13.1641 16 13.4999 15.6642 13.4999 15.25V13.5H15.2499C15.6641 13.5 15.9999 13.1642 15.9999 12.75C15.9999 12.3358 15.6641 12 15.2499 12H13.4999V10.25Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74991 3.75C5.74991 2.50736 6.75727 1.5 7.99991 1.5C9.24255 1.5 10.2499 2.50736 10.2499 3.75C10.2499 4.99264 9.24255 6 7.99991 6C6.75727 6 5.74991 4.99264 5.74991 3.75ZM7.99991 0C5.92884 0 4.24991 1.67893 4.24991 3.75C4.24991 5.82107 5.92884 7.5 7.99991 7.5C10.071 7.5 11.7499 5.82107 11.7499 3.75C11.7499 1.67893 10.071 0 7.99991 0ZM3.03024 11.7803C3.5067 11.3039 4.27925 10.9703 5.22268 10.7639C6.15066 10.5609 7.15448 10.5 7.99991 10.5C8.2281 10.5 8.46907 10.5044 8.71793 10.5151C9.13177 10.5327 9.48157 10.2115 9.49923 9.79771C9.51689 9.38387 9.19572 9.03407 8.78188 9.01642C8.50974 9.0048 8.24736 9 7.99991 9C7.09534 9 5.97416 9.06407 4.90214 9.29858C3.84557 9.5297 2.74312 9.94613 1.96958 10.7197C1.27066 11.4186 0.808767 12.4457 0.517813 13.2685C0.00552431 14.7172 1.17979 16 2.54723 16H8.74991C9.16412 16 9.49991 15.6642 9.49991 15.25C9.49991 14.8358 9.16412 14.5 8.74991 14.5H2.54723C2.30884 14.5 2.11843 14.393 2.00863 14.2527C1.90431 14.1195 1.86669 13.9533 1.932 13.7686C2.20497 12.9966 2.57675 12.2338 3.03024 11.7803Z"
      />
    </g>
  ),
  smallAlternative: UserAddSmallIcon,
})

export const SuccessCircledIcon = makeIcon({
  displayName: 'SuccessCircledIcon',
  content: (
    <path
      fillRule="evenodd"
      d="M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-3.47-1.47a.75.75 0 0 0-1.06-1.06L7 9.94 5.03 7.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5Z"
    />
  ),
  smallAlternative: SuccessCircledSmallIcon,
})

export const HandDrawnCheckedIcon = makeIcon({
  displayName: 'HandDrawnCheckedIcon',
  viewBox: 18,
  content: (
    <>
      <path d="M17.26 5.96c.03.06 0 .17.01.25.08.32.06.45.1.74.08.44.23 1.74-.24 1.74-.1 0-.19-.11-.29-.13-.1 0-.72.01-.76-.12-.05-.19.07-.66.05-.76-.02-.07-.09-.15-.11-.24-.08-.27-.08-.43-.3-.64l.16-.37c-.08-.12-.05-.35-.08-.43-.03-.06-.1-.07-.14-.14-.03-.07-.01-.21-.09-.34-.11-.21-.28-.17-.37-.29s-.12-.36-.27-.48l-.08-.03-.08.1c-.07-.06-.02-.14-.06-.21-.06-.09-.15-.08-.2-.13-.02-.05-.02-.15-.06-.2-.07-.08-.13 0-.18-.04l-.33-.3c-.12-.12-.04-.22-.13-.33-.25-.3-.63-.48-.93-.66l-.4-.28c.4-.14.05-.66-.04-.1-.11-.16-.3-.1-.43-.2-.09-.07-.12-.17-.26-.23-.26-.12-.6-.03-.56-.4-.33-.05-.57-.26-.76.03-.09 0-.25-.24-.34-.28a5 5 0 0 0-.88-.23 1 1 0 0 0-.42 0q-.06.02-.1.09c-.09.08-.17.15-.32-.1a2 2 0 0 1-.58.01c-.04 0-.05-.06-.08-.06-.05.01-.13.07-.22.08-.15.04-.25-.07-.2.11l-.27.16-.13-.08-.12.15c0-.28-.32-.02-.16.1l-.6.02c-.08-.3-.4.12-.3.26l-.05.03c-.2 0-.34.14-.56.2-.23.07-.23.03-.36-.05q-.08.05-.13.11c-.03.48-.38-.1-.6.44-.28-.1-.51.27-.65.51-.01.03.02.06 0 .1-.04.1-.26.24-.14.34l-.27.1-.08.22.12.09c-.22 0-.3.22-.4.3-.02 0-.08-.03-.13.02s-.13.19-.2.26l.13.2c-.05.17-.25.13-.31.2l-.16.34c-.03.15.13.18-.06.54-.03.07-.1.1-.13.16-.05.11-.03.5.07.55-.18.09-.21.47-.27.57-.02.03-.12.02-.16.12-.03.08.01.31-.01.41-.03.12-.11.15-.12.2s.05.1.04.16c-.02.2-.13.4-.13.56 0 .25.2.45.3.63 0 .05-.04.1-.04.15.06.62.19 1.32.39 1.92.07.28.19 1.06.48.69.1.05.33.76.42.88s.21.15.28.24c.21.25.32.47.66.7.09.06.23.07.27.11.06.05.06.17.13.23.16.16.52.4.7.52.03.02 0 .1.03.15.14.2.37.32.45.08.18.26.48.26.73.35.5.21 1.48.5 1.97.44.31-.04.3-.15.74-.05h.02q.14.05.3.07c.28.05.57.23.75-.05.32.02.55-.08.83.07l.04-.17.11-.04.08.13c.27-.06.54-.38.75-.47a14 14 0 0 0 1.6-.78c.18-.1.12-.18.35-.1l.07-.12-.03-.16c.2-.17.46-.33.62-.52.3-.33.59-.95.88-1.3.07-.08.22-.16.27-.26.07-.15-.05-.25.03-.43.13-.32.52-.88.57-1.22.02-.1-.03-.15-.02-.22.03-.29.07-.52 0-.8.18-.27.37-.24.58-.33.15-.06.5-.3.64-.33.09-.02.2.07.31.04.08.42-.03.6-.2.91q-.1.94-.39 1.81l-.21.1c-.14.2-.05.34-.07.48-.12 1.3-1.92 3.15-3.1 3.79a4 4 0 0 1-1.26.67c-.06 0-.1-.07-.16-.05a8 8 0 0 1-1.34.6c-.66.07-1.32.17-2 .2q-.53.02-1.05-.03a8.5 8.5 0 0 1-6.6-4.4 7 7 0 0 1-.68-1.57c-.04-.22.06-.34-.1-.59l.1-.03c-.1-.23-.2-.37-.26-.64A10 10 0 0 1 0 8.92c0-.1.08-.07.08-.17V8.7c-.03-.19-.1-.5-.07-.71.01-.21.14-.56.16-.72.05-.59.1-1.26.38-1.84.07-.16.25-.33.27-.38.04-.1-.03-.16 0-.23.1-.36.49-.8.7-1.1a9 9 0 0 1 2.56-2.44C4.7.87 5.84.38 6.51.29c.15-.02.13.09.25.06.13-.03.19-.11.25-.13a5 5 0 0 1 1.8-.2c.08.02.13.1.18.1.02 0 .08-.05.15-.05.66 0 1.14.1 1.76.28 1.18.33 2.53.93 3.48 1.84.2.2.24.44.26.47.07.05.18.02.32.13.47.37.86 1.08 1.17 1.54.17.22.46.5.6.75.11.19.25.7.33.77.05.05.16.04.2.1m-5.63-3.97c.1-.14-.28-.14-.2 0 .03.02.17.04.2 0M1.25 10.35l.14-.04-.09-.13-.07.1z" />
      <path d="M3.76 10.73c-.02 0 .02-.06 0-.08-.02-.08 0-.14-.03-.22-.02-.11-.3-.42.1-.64h.02l.26-.1c.09-.03.64-.33.69-.31.06.01-.01.2.01.23s.08 0 .1.03c.07.05.06.11.23.1l-.15.2c.05.02 0 .13.01.15h.1c0 .02-.03.1 0 .12.05.05.2-.03.24 0 .05.02 0 .13.09.15l.06-.02.1-.08c.02.01-.04.07-.03.1s.1-.01.1 0c.02.02-.03.08-.01.1.02.01.1-.04.12-.04l.13.08c.03.05-.07.12-.06.17.05.11.2.15.3.22a.2.2 0 0 1 .08.13c-.32.13-.43.42-.04.07-.03.08.1.03.12.09 0 .04-.04.1-.01.13.05.07.27.02-.01.26.11.04.06.19.33.02.04 0-.08.17-.08.21s.05.24.07.27c.02.02.05.07.08.06.05 0 .3-.24.05.07q.02 0 0-.01c-.02-.01-.02-.04-.24-.05v.09l-.01-.04-.03-.07-.05-.08.07.08-.06-.1c.16.22.1.06-.02-.04q.08.05.18.05c.23.2.1-.05-.05-.14v-.02c.1.02.07-.06.15-.08s.1 0 .23.06v-.05c-.29-.27.28.09.1-.2.24.09.18-.08.15-.18l-.05-.05c-.02-.04.07-.08-.07-.15h.16l-.05-.1-.12-.07c.16.04.13-.05.19-.06 0 0 .06.02.09.01l.07-.08-.18-.13c-.02-.06.16.01.2-.01l.03-.1c-.01-.06-.16-.12-.07-.22.01-.02.07-.01.08-.03.03-.03-.04-.19-.14-.25.15.03.15-.1.2-.12.02 0 .11.04.14.02s0-.11.02-.14c.03-.02.1 0 .12-.01s-.04-.05-.03-.07c.03-.06.15-.06.18-.1.03-.07-.1-.22-.15-.31q.05 0 .07-.02.17-.27.38-.5c.07-.08.4-.15 0-.32-.05-.06.23-.18.25-.22.03-.03-.02-.1 0-.14.05-.09.14-.13.15-.27 0-.04-.05-.12-.04-.14s.1.01.12-.01c.06-.06.1-.2.16-.24l.1.03c.13-.01.16-.08-.05-.21.17 0 .11-.14.15-.22.1-.16.34-.4.35-.59 0-.12-.08-.19.08-.25l.13-.04c.1-.04.32.02.17-.19.11-.04.13-.13.34-.06l-.1-.12.02-.03.12.08c.07-.06-.01-.28.04-.33.08-.1.36-.31.49-.35.07-.03 0-.1.18.01v-.06l-.1-.11c.06-.07.18-.1.24-.15.09-.1.14-.36.3-.4.05-.02.15.02.17 0 .04-.04-.07-.17-.02-.21.07-.09.35-.11.42-.2.02-.02-.01-.07 0-.1.04-.07.1-.12.1-.25.18.04.3.2.47.32.12.1.4.3.5.4.07.05.14.16.21.23-.02.13-.11.1-.28.05l-.33.35-.15-.08c-.09 0 0 .12 0 .16 0 .44-.6.74-.86.98-.06.05-.16.29-.26.27-.03 0-.1-.06-.1-.05q-.08.2-.13.4c-.27.12-.35.4-.5.63-.37.61-.7 1.24-1.08 1.83-.07.12-.1.3-.2.4-.04.04-.17-.01-.12.1l-.1-.05c0 .08.06.16.04.22-.03.06-.1.2-.14.24-.01.02-.07-.02-.08 0-.02.05.02.17-.01.23s-.14.1-.15.14c-.04.15 0 .35-.11.49-.03.04-.14.05-.14.06 0 .03.07.08.07.1 0 .11-.16.2-.2.28-.16.27-.28.59-.48.88-.12.18-.34.54-.66.69-.06.03-.1-.06-.15-.03-.06.03-.06.1-.1.13a1 1 0 0 1-.46.15c-.35-.02-.38-.1-.46-.13l-.12-.1L5.8 13c-.01-.03.03-.1.02-.1h-.07c-.18-.13-.24-.25-.34-.4-.18-.3-.49-.56-.65-.88-.03-.07.06-.2.05-.2-.01-.03-.1.02-.15 0-.16-.1-.19-.33-.31-.43-.07-.05-.23-.07-.3-.12-.04-.04-.08-.18-.14-.17-.04 0-.13.05-.15.04m2.5.67c-.15.1.02.1.07 0 .02-.01-.04-.02-.08 0m1.98-2.06-.13-.07q0 .04.03.07l.09.02z" />
    </>
  ),
})

export const CircledInfoIcon = makeIcon({
  displayName: 'CircledInfoIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.25 7.25C7.25 6.83579 7.58579 6.5 8 6.5C8.41421 6.5 8.75 6.83579 8.75 7.25V11.25C8.75 11.6642 8.41421 12 8 12C7.58579 12 7.25 11.6642 7.25 11.25V7.25ZM8 5.5C8.41421 5.5 8.75 5.16421 8.75 4.75C8.75 4.33579 8.41421 4 8 4C7.58579 4 7.25 4.33579 7.25 4.75C7.25 5.16421 7.58579 5.5 8 5.5Z"
    />
  ),
})
export const WarningIcon = makeIcon({
  displayName: 'WarningIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <rect
        x="8.75"
        y="9.5"
        width="1.5"
        height="5.5"
        rx="0.75"
        transform="rotate(-180 8.75 9.5)"
      />
      <circle cx="8" cy="11.25" r="0.75" transform="rotate(-180 8 11.25)" />
    </g>
  ),
  smallAlternative: WarningSmallIcon,
})

export const WindowsIcon = makeIcon({
  displayName: 'WindowIcon',
  viewBox: 9,
  content: (
    <path d="M0 1.3L3.7.8v3.5H0v-3zm3.7 3.4v3.5L0 7.7v-3h3.7zm.4-4L8.9 0v4.2H4.1V.7zm4.8 4V9l-4.8-.7V4.8l4.8-.1z" />
  ),
})

export const DuplicateIcon = makeIcon({
  displayName: 'DuplicateIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.25C5.5 1.00736 6.50736 0 7.75 0H13.75C14.9926 0 16 1.00736 16 2.25V8.25C16 9.49264 14.9926 10.5 13.75 10.5H12.8232C12.409 10.5 12.0732 10.1642 12.0732 9.75C12.0732 9.33579 12.409 9 12.8232 9H13.75C14.1642 9 14.5 8.66421 14.5 8.25V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H7.75C7.33579 1.5 7 1.83579 7 2.25V3.11585C7 3.53007 6.66421 3.86585 6.25 3.86585C5.83579 3.86585 5.5 3.53007 5.5 3.11585V2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.75C0 6.50736 1.00736 5.5 2.25 5.5H8.25C9.49264 5.5 10.5 6.50736 10.5 7.75V13.75C10.5 14.9926 9.49264 16 8.25 16H2.25C1.00736 16 0 14.9926 0 13.75V7.75ZM2.25 7C1.83579 7 1.5 7.33579 1.5 7.75V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H8.25C8.66421 14.5 9 14.1642 9 13.75V7.75C9 7.33579 8.66421 7 8.25 7H2.25Z"
      />
    </g>
  ),
  smallAlternative: DuplicateSmallIcon,
})

export const AddReactionIcon = makeIcon({
  displayName: 'AddReactionIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 7.58579 14.8358 7.25 15.25 7.25C15.6642 7.25 16 7.58579 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C8.41421 0 8.75 0.335786 8.75 0.75C8.75 1.16421 8.41421 1.5 8 1.5ZM7 7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7C5 6.44772 5.44772 6 6 6C6.55228 6 7 6.44772 7 7ZM11 7C11 7.55228 10.5523 8 10 8C9.44772 8 9 7.55228 9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7ZM8 11.5C9.10457 11.5 10 10.6046 10 9.5H6C6 10.6046 6.89543 11.5 8 11.5ZM12.75 0C13.1642 0 13.5 0.335787 13.5 0.75V2.5H15.25C15.6642 2.5 16 2.83579 16 3.25C16 3.66421 15.6642 4 15.25 4H13.5V5.75C13.5 6.16421 13.1642 6.5 12.75 6.5C12.3358 6.5 12 6.16421 12 5.75V4H10.25C9.885 4 9.5 3.665 9.5 3.25C9.5 2.885 9.885 2.5 10.25 2.5H12V0.75C12 0.335787 12.3358 0 12.75 0Z"
      />
    </g>
  ),
  smallAlternative: AddReactionSmallIcon,
})

export const ReplyIcon = makeIcon({
  displayName: 'ReplyIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6119 1.68449C3.83157 1.46482 3.83157 1.10867 3.6119 0.888996C3.39223 0.669326 3.03607 0.669326 2.8164 0.888996L0.164752 3.54065C-0.0549175 3.76032 -0.0549174 4.11647 0.164752 4.33614L2.8164 6.98779C3.03607 7.20746 3.39223 7.20746 3.6119 6.98779C3.83157 6.76812 3.83157 6.41197 3.6119 6.1923L1.91958 4.49998H8.05166C9.60496 4.49998 10.8642 5.75918 10.8642 7.31248C10.8642 8.86578 9.60496 10.125 8.05166 10.125H5.43751C5.12685 10.125 4.87501 10.3768 4.87501 10.6875C4.87501 10.9981 5.12685 11.25 5.43751 11.25H8.05166C10.2263 11.25 11.9892 9.4871 11.9892 7.31248C11.9892 5.13786 10.2263 3.37498 8.05166 3.37498H1.92141L3.6119 1.68449Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ThumbsUpIcon = makeIcon({
  displayName: 'ThumbsUpIcon',
  viewBox: 16,
  content: (
    <g fill="none">
      <path
        d="M4.66683 14.6667H2.66683C2.31321 14.6667 1.97407 14.5262 1.72402 14.2762C1.47397 14.0261 1.3335 13.687 1.3335 13.3333V8.66668C1.3335 8.31306 1.47397 7.97392 1.72402 7.72387C1.97407 7.47382 2.31321 7.33334 2.66683 7.33334H4.66683M9.3335 6.00001V3.33334C9.3335 2.80291 9.12278 2.2942 8.74771 1.91913C8.37264 1.54406 7.86393 1.33334 7.3335 1.33334L4.66683 7.33334V14.6667H12.1868C12.5084 14.6703 12.8204 14.5576 13.0654 14.3493C13.3105 14.1411 13.4719 13.8513 13.5202 13.5333L14.4402 7.53334C14.4692 7.34225 14.4563 7.14713 14.4024 6.96151C14.3485 6.77589 14.2549 6.60421 14.1281 6.45835C14.0012 6.3125 13.8442 6.19596 13.6679 6.11682C13.4915 6.03768 13.3001 5.99782 13.1068 6.00001H9.3335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
})

export const ThumbsUpMarginIcon = makeIcon({
  displayName: 'ThumbsUpMarginIcon',
  viewBox: 14,
  content: (
    <g fill="none">
      <path
        d="M3.53333 11.5333H1.93333C1.65043 11.5333 1.37912 11.421 1.17908 11.2209C0.979045 11.0209 0.866665 10.7496 0.866665 10.4667V6.73333C0.866665 6.45044 0.979045 6.17912 1.17908 5.97909C1.37912 5.77905 1.65043 5.66667 1.93333 5.66667H3.53333M7.26667 4.6V2.46667C7.26667 2.04232 7.09809 1.63535 6.79804 1.3353C6.49798 1.03524 6.09101 0.866666 5.66667 0.866666L3.53333 5.66667V11.5333H9.54933C9.80657 11.5362 10.0562 11.4461 10.2522 11.2795C10.4482 11.1129 10.5774 10.881 10.616 10.6267L11.352 5.82667C11.3752 5.67379 11.3649 5.5177 11.3218 5.3692C11.2787 5.2207 11.2038 5.08336 11.1023 4.96667C11.0009 4.84999 10.8752 4.75676 10.7342 4.69345C10.5931 4.63013 10.4399 4.59825 10.2853 4.6H7.26667Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
})

/** @deprecated use the LeftSidebarIcon and RightSidebarIcon instead ideally
 */
export const ShowSidebarIcon = makeIcon({
  displayName: 'ShowSidebarIcon',
  content: (
    <g>
      <path d="M9.40652 10.5934C9.66037 10.8472 10.0719 10.8472 10.3258 10.5934L12.4596 8.45954C12.7135 8.2057 12.7135 7.79414 12.4596 7.5403L10.3258 5.40645C10.0719 5.1526 9.66037 5.1526 9.40652 5.40645C9.15268 5.66029 9.15268 6.07184 9.40652 6.32568L10.4307 7.34982H6.73228C6.37329 7.34982 6.08228 7.64084 6.08228 7.99982C6.08228 8.35881 6.37329 8.64982 6.73228 8.64982H10.4309L9.40652 9.67416C9.15268 9.928 9.15268 10.3396 9.40652 10.5934Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 2.0335 0.783502 1.25 1.75 1.25H14.25C15.2165 1.25 16 2.0335 16 3V13C16 13.9665 15.2165 14.75 14.25 14.75H1.75C0.783501 14.75 0 13.9665 0 13V3ZM1.75 2.75H3.5V13.25H1.75C1.61193 13.25 1.5 13.1381 1.5 13V3C1.5 2.86193 1.61193 2.75 1.75 2.75ZM5 2.75V13.25H14.25C14.3881 13.25 14.5 13.1381 14.5 13V3C14.5 2.86193 14.3881 2.75 14.25 2.75H5Z"
      />
    </g>
  ),
})

/** @deprecated use the LeftSidebarIcon and RightSidebarIcon instead ideally
 */
export const HideSidebarIcon = makeIcon({
  displayName: 'HideSidebarIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M9.32575 10.5934C9.07191 10.8472 8.66035 10.8472 8.40651 10.5934L6.27266 8.45954C6.01882 8.2057 6.01882 7.79414 6.27266 7.5403L8.40651 5.40645C8.66035 5.1526 9.07191 5.1526 9.32575 5.40645C9.57959 5.66029 9.57959 6.07184 9.32575 6.32568L8.30161 7.34982H12C12.359 7.34982 12.65 7.64084 12.65 7.99982C12.65 8.35881 12.359 8.64982 12 8.64982H8.30142L9.32575 9.67416C9.57959 9.928 9.57959 10.3396 9.32575 10.5934Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 2.0335 0.783502 1.25 1.75 1.25H14.25C15.2165 1.25 16 2.0335 16 3V13C16 13.9665 15.2165 14.75 14.25 14.75H1.75C0.783501 14.75 0 13.9665 0 13V3ZM1.75 2.75H3.5V13.25H1.75C1.61193 13.25 1.5 13.1381 1.5 13V3C1.5 2.86193 1.61193 2.75 1.75 2.75ZM5 2.75V13.25H14.25C14.3881 13.25 14.5 13.1381 14.5 13V3C14.5 2.86193 14.3881 2.75 14.25 2.75H5Z"
      />
    </g>
  ),
})

export const LeftSidebarIcon = makeIcon({
  displayName: 'LeftSidebarIcon',
  content: (
    <g>
      <path
        d="M13.25 1.5C14.7688 1.5 16 2.73122 16 4.25V11.75C16 13.2688 14.7688 14.5 13.25 14.5H2.75C1.23122 14.5 2.0133e-08 13.2688 0 11.75V4.25C1.12747e-07 2.73122 1.23122 1.5 2.75 1.5H13.25ZM5.75 13H13.25C13.9404 13 14.5 12.4404 14.5 11.75V4.25C14.5 3.55964 13.9404 3 13.25 3H5.75V13ZM2.75 3C2.05964 3 1.5 3.55964 1.5 4.25V11.75C1.5 12.4404 2.05964 13 2.75 13H4.25V3H2.75Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const RightSidebarIcon = makeIcon({
  displayName: 'RightSidebarIcon',
  content: (
    <g>
      <path
        d="M13.25 1.5C14.7688 1.5 16 2.73122 16 4.25V11.75C16 13.2688 14.7688 14.5 13.25 14.5H2.75C1.23122 14.5 2.0133e-08 13.2688 0 11.75V4.25C1.12747e-07 2.73122 1.23122 1.5 2.75 1.5H13.25ZM11.75 13H13.25C13.9404 13 14.5 12.4404 14.5 11.75V4.25C14.5 3.55964 13.9404 3 13.25 3H11.75V13ZM2.75 3C2.05964 3 1.5 3.55964 1.5 4.25V11.75C1.5 12.4404 2.05964 13 2.75 13H10.25V3H2.75Z"
        fill="currentColor"
      />
    </g>
  ),
})

/** @deprecated Irrelevant name, use DuplicateSquareIcon instead
 */
export const AllNotesIcon = makeIcon({
  displayName: 'AllNotesIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.25C5.5 1.00736 6.50736 0 7.75 0H13.75C14.9926 0 16 1.00736 16 2.25V8.25C16 9.49264 14.9926 10.5 13.75 10.5H12.8232C12.409 10.5 12.0732 10.1642 12.0732 9.75C12.0732 9.33579 12.409 9 12.8232 9H13.75C14.1642 9 14.5 8.66421 14.5 8.25V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H7.75C7.33579 1.5 7 1.83579 7 2.25V3.11585C7 3.53007 6.66421 3.86585 6.25 3.86585C5.83579 3.86585 5.5 3.53007 5.5 3.11585V2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.75C0 6.50736 1.00736 5.5 2.25 5.5H8.25C9.49264 5.5 10.5 6.50736 10.5 7.75V13.75C10.5 14.9926 9.49264 16 8.25 16H2.25C1.00736 16 0 14.9926 0 13.75V7.75ZM2.25 7C1.83579 7 1.5 7.33579 1.5 7.75V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H8.25C8.66421 14.5 9 14.1642 9 13.75V7.75C9 7.33579 8.66421 7 8.25 7H2.25Z"
      />
    </g>
  ),
})

export const DuplicateSquareIcon = makeIcon({
  displayName: 'DuplicateSquareIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.25C5.5 1.00736 6.50736 0 7.75 0H13.75C14.9926 0 16 1.00736 16 2.25V8.25C16 9.49264 14.9926 10.5 13.75 10.5H12.8232C12.409 10.5 12.0732 10.1642 12.0732 9.75C12.0732 9.33579 12.409 9 12.8232 9H13.75C14.1642 9 14.5 8.66421 14.5 8.25V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H7.75C7.33579 1.5 7 1.83579 7 2.25V3.11585C7 3.53007 6.66421 3.86585 6.25 3.86585C5.83579 3.86585 5.5 3.53007 5.5 3.11585V2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.75C0 6.50736 1.00736 5.5 2.25 5.5H8.25C9.49264 5.5 10.5 6.50736 10.5 7.75V13.75C10.5 14.9926 9.49264 16 8.25 16H2.25C1.00736 16 0 14.9926 0 13.75V7.75ZM2.25 7C1.83579 7 1.5 7.33579 1.5 7.75V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H8.25C8.66421 14.5 9 14.1642 9 13.75V7.75C9 7.33579 8.66421 7 8.25 7H2.25Z"
      />
    </g>
  ),
})

export const FileIcon = makeIcon({
  displayName: 'FileIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M9.47 1.47a3.578 3.578 0 115.06 5.06l-.5.5a.75.75 0 11-1.06-1.06l.5-.5a2.078 2.078 0 10-2.94-2.94l-8 8a2.078 2.078 0 102.94 2.94l1.875-1.875 1.06 1.06L6.53 14.53a3.578 3.578 0 11-5.06-5.06l8-8z" />
      <path d="M7.97 6.97a2.164 2.164 0 113.06 3.06l-3 3-1.06-1.06 3-3a.664.664 0 10-.94-.94l-3.75 3.75a.75.75 0 11-1.06-1.06l3.75-3.75z" />
    </g>
  ),
})

export const CaretRightIcon = makeIcon({
  displayName: 'CaretRightIcon',
  viewBox: 16,
  content: (
    <path d="M7.16821 11.4874C6.52755 12.0727 5.5 11.6159 5.5 10.7457V5.25427C5.5 4.38413 6.52755 3.92731 7.1682 4.51263L10.1735 7.25836C10.6088 7.65603 10.6088 8.34397 10.1735 8.74164L7.16821 11.4874Z" />
  ),
})

export const CommentsIcon = makeIcon({
  displayName: 'CommentsIcon',
  viewBox: 16,
  content: (
    <path d="M14.275 12.553c0-.648.197-1.28.565-1.815.758-1.1 1.16-2.355 1.16-3.665C16 3.23 12.477 0 8 0S0 3.23 0 7.073c0 3.842 3.523 7.074 8 7.074.597 0 1.184-.058 1.754-.17.543-.11 1.104-.074 1.63.1l2.89.96v-2.484z" />
  ),
  smallAlternative: CommentsSmallIcon,
})

export const EmbedIcon = makeIcon({
  displayName: 'EmbedIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M13.75 0A2.25 2.25 0 0 1 16 2.25v11.5A2.25 2.25 0 0 1 13.75 16H2.25A2.25 2.25 0 0 1 0 13.75V2.25A2.25 2.25 0 0 1 2.25 0h11.5Zm.75 2.25a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V2.25Z" />
      <path d="m10.706 8.545-3.81 2.367C6.5 11.16 6 10.855 6 10.368V5.632c0-.487.5-.791.896-.544l3.81 2.367a.651.651 0 0 1 0 1.09Z" />
    </g>
  ),
  smallAlternative: EmbedSmallIcon,
})

export const ImageIcon = makeIcon({
  displayName: 'ImageIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M12.2061 0.00488281C14.3194 0.112115 16 1.85996 16 4V12L15.9951 12.2061C15.8879 14.3194 14.14 16 12 16H4C1.79086 16 0 14.2091 0 12V4C0 1.79086 1.79086 0 4 0H12L12.2061 0.00488281ZM4.35254 8.73535C3.22981 8.51085 2.34826 8.62563 1.75977 8.78613C1.66586 8.81175 1.57914 8.83832 1.5 8.86523V12C1.5 13.3807 2.61929 14.5 4 14.5H12C13.3807 14.5 14.5 13.3807 14.5 12V10.9951C14.4204 11.0351 14.3394 11.0777 14.2549 11.1172C13.2554 11.5836 11.8299 12.0308 10.3525 11.7354C8.92607 11.4499 7.93186 10.7299 7.06445 10.1104C6.18203 9.48007 5.42564 8.95002 4.35254 8.73535ZM4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V7.30566C2.27739 7.11242 3.34705 7.00454 4.64746 7.26465C6.07387 7.55005 7.06817 8.2701 7.93555 8.88965C8.8179 9.51989 9.57439 10.05 10.6475 10.2646C11.6699 10.469 12.7447 10.1663 13.6201 9.75781C13.9656 9.5966 14.2652 9.42471 14.5 9.27832V4C14.5 2.61929 13.3807 1.5 12 1.5H4ZM11 3.5C11.8284 3.5 12.5 4.17157 12.5 5C12.5 5.82843 11.8284 6.5 11 6.5C10.1716 6.5 9.5 5.82843 9.5 5C9.5 4.17157 10.1716 3.5 11 3.5Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: ImageSmallIcon,
})

export const QuestionRoundIcon = makeIcon({
  displayName: 'QuestionRoundIcon',
  viewBox: 16,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.849c-.805 0-1.458.653-1.458 1.458a.625.625 0 0 1-1.25 0 2.708 2.708 0 1 1 5.416 0c0 1.058-.708 1.627-1.185 2.01l-.087.07c-.512.416-.811.707-.811 1.306a.625.625 0 0 1-1.25 0c0-1.224.742-1.845 1.273-2.276.57-.463.81-.673.81-1.11 0-.805-.653-1.458-1.458-1.458Z"
        fill="currentColor"
      />
      <path
        d="M7.48 11.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
        fill="currentColor"
      />
    </>
  ),
})

export const SliteIcon = makeIcon({
  displayName: 'SliteIcon',
  viewBox: 16,
  content: (
    <path d="M15.76 6.29659C15.76 7.37827 14.9608 8.27597 13.9238 8.43141C13.4291 7.66693 12.5792 7.15306 11.6089 7.13085C11.501 6.87391 11.4408 6.5916 11.4408 6.29659C11.4408 5.10389 12.4112 4.13641 13.6004 4.13641C14.7896 4.13641 15.76 5.10706 15.76 6.29659ZM13.3657 0.881847C12.1733 0.881847 11.2061 1.85251 11.2061 3.04204C11.2061 3.50199 11.352 3.93022 11.5993 4.28232C12.1131 3.77162 12.8203 3.45758 13.6004 3.45758C14.2346 3.45758 14.8213 3.66694 15.2938 4.01904C15.4429 3.72721 15.5285 3.39414 15.5285 3.04521C15.5253 1.8525 14.5581 0.881847 13.3657 0.881847ZM8.78329 10.636C8.62472 10.5979 8.45982 10.5789 8.29174 10.5789C7.09936 10.5789 6.13214 11.5496 6.13214 12.7391C6.13214 13.9286 7.10253 14.8993 8.29174 14.8993C9.48096 14.8993 10.4514 13.9286 10.4514 12.7391C10.4514 12.6915 10.4482 12.6471 10.445 12.5995C9.62049 12.2538 8.99259 11.5242 8.78329 10.636ZM5.45032 12.7391C5.45032 12.3807 5.51692 12.0381 5.64059 11.7209C5.5074 11.6955 5.37104 11.6796 5.22833 11.6796C4.03595 11.6796 3.06873 12.6503 3.06873 13.8398C3.06873 15.0325 4.03912 16 5.22833 16C5.90064 16 6.5 15.6923 6.8964 15.2102C6.03383 14.7248 5.45032 13.7986 5.45032 12.7391ZM0.439777 12.8089C0.439777 14.0016 1.41017 14.9691 2.59939 14.9691C2.60573 14.9691 2.61524 14.9691 2.62158 14.9691C2.47254 14.6233 2.38691 14.2427 2.38691 13.843C2.38691 12.682 3.08458 11.686 4.08352 11.245C3.69663 10.8771 3.17338 10.6487 2.59939 10.6487C1.41017 10.6487 0.439777 11.6194 0.439777 12.8089ZM2.3996 7.24505C1.20722 7.24505 0.23999 8.2157 0.23999 9.40524C0.23999 9.89691 0.404894 10.3505 0.683962 10.7153C1.18819 10.2522 1.86049 9.96987 2.59939 9.96987C3.21778 9.96987 3.79177 10.1697 4.25794 10.5059C4.45138 10.1824 4.56238 9.80492 4.56238 9.40524C4.56238 8.21253 3.59198 7.24505 2.3996 7.24505ZM5.06343 3.20381C3.9313 3.20381 3.01165 4.12372 3.01165 5.25615C3.01165 6.38858 3.9313 7.30849 5.06343 7.30849C6.19556 7.30849 7.11522 6.38858 7.11522 5.25615C7.11522 4.12372 6.19556 3.20381 5.06343 3.20381ZM11.5486 7.82554C10.3562 7.82554 9.39216 8.79303 9.39216 9.98256C9.39216 11.1721 10.3594 12.1396 11.5486 12.1396C12.7378 12.1396 13.705 11.1721 13.705 9.98256C13.705 8.79303 12.741 7.82554 11.5486 7.82554ZM8.23783 2.15702C8.23783 3.34973 9.20823 4.31721 10.3974 4.31721C10.537 4.31721 10.6733 4.30453 10.8065 4.27915C10.6258 3.90484 10.5243 3.48613 10.5243 3.04521C10.5243 2.01428 11.0761 1.11024 11.9006 0.61222C11.5105 0.234742 10.9809 7.77797e-06 10.3943 7.77797e-06C9.20823 -0.00316431 8.23783 0.964321 8.23783 2.15702Z" />
  ),
})

export const SliteLogoInCircleIcon = makeIcon({
  displayName: 'SliteLogoInCircleIcon',
  viewBox: 16,
  content: (
    <g>
      <circle cx="8" cy="8" r="8" fill="#2F2F30" />
      <path
        d="M12 7.1483C12 7.68914 11.5881 8.13799 11.0535 8.2157C10.7985 7.83347 10.3604 7.57653 9.86024 7.56543C9.80466 7.43696 9.7736 7.2958 9.7736 7.1483C9.7736 6.55195 10.2738 6.0682 10.8868 6.0682C11.4998 6.0682 12 6.55353 12 7.1483ZM10.7658 4.44092C10.1512 4.44092 9.65264 4.92625 9.65264 5.52102C9.65264 5.75099 9.72783 5.96511 9.85533 6.14116C10.1201 5.88581 10.4847 5.72879 10.8868 5.72879C11.2137 5.72879 11.5161 5.83347 11.7597 6.00952C11.8365 5.8636 11.8807 5.69707 11.8807 5.5226C11.879 4.92625 11.3805 4.44092 10.7658 4.44092ZM8.40376 9.318C8.32203 9.29897 8.23703 9.28945 8.15039 9.28945C7.53576 9.28945 7.03719 9.77478 7.03719 10.3695C7.03719 10.9643 7.53739 11.4496 8.15039 11.4496C8.76338 11.4496 9.26359 10.9643 9.26359 10.3695C9.26359 10.3458 9.26195 10.3236 9.26032 10.2998C8.83531 10.1269 8.51165 9.76209 8.40376 9.318ZM6.68574 10.3695C6.68574 10.1903 6.72007 10.019 6.78382 9.86043C6.71516 9.84774 6.64487 9.83981 6.57131 9.83981C5.95668 9.83981 5.45811 10.3251 5.45811 10.9199C5.45811 11.5163 5.95832 12 6.57131 12C6.91786 12 7.22681 11.8462 7.43114 11.6051C6.98651 11.3624 6.68574 10.8993 6.68574 10.3695ZM4.10298 10.4044C4.10298 11.0008 4.60319 11.4845 5.21618 11.4845C5.21945 11.4845 5.22436 11.4845 5.22763 11.4845C5.1508 11.3117 5.10666 11.1213 5.10666 10.9215C5.10666 10.341 5.46629 9.84298 5.9812 9.62252C5.78177 9.43854 5.51206 9.32435 5.21618 9.32435C4.60319 9.32435 4.10298 9.80968 4.10298 10.4044ZM5.1132 7.62252C4.49857 7.62252 4 8.10785 4 8.70262C4 8.94845 4.085 9.17526 4.22885 9.35765C4.48876 9.12609 4.83531 8.98493 5.21618 8.98493C5.53494 8.98493 5.83081 9.08485 6.07111 9.25298C6.17082 9.0912 6.22803 8.90246 6.22803 8.70262C6.22803 8.10627 5.72783 7.62252 5.1132 7.62252ZM6.48631 5.60191C5.90274 5.60191 5.42869 6.06186 5.42869 6.62808C5.42869 7.19429 5.90274 7.65424 6.48631 7.65424C7.06988 7.65424 7.54393 7.19429 7.54393 6.62808C7.54393 6.06186 7.06988 5.60191 6.48631 5.60191ZM9.82918 7.91277C9.21455 7.91277 8.71761 8.39651 8.71761 8.99128C8.71761 9.58604 9.21618 10.0698 9.82918 10.0698C10.4422 10.0698 10.9407 9.58604 10.9407 8.99128C10.9407 8.39651 10.4438 7.91277 9.82918 7.91277ZM8.1226 5.07851C8.1226 5.67486 8.6228 6.15861 9.2358 6.15861C9.30772 6.15861 9.37801 6.15226 9.44667 6.13957C9.35349 5.95242 9.30118 5.74306 9.30118 5.5226C9.30118 5.00714 9.58561 4.55512 10.0106 4.30611C9.80956 4.11737 9.53658 4 9.23416 4C8.6228 3.99842 8.1226 4.48216 8.1226 5.07851Z"
        fill="white"
      />
    </g>
  ),
})

export const TableIcon = makeIcon({
  displayName: 'TableIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 0H13.75C14.9926 0 16 1.00736 16 2.25V5.6V10.4V13.75C16 14.9926 14.9926 16 13.75 16H8.25H2.25C1.00736 16 0 14.9926 0 13.75V10.4V5.6V2.25C0 1.00736 1.00736 0 2.25 0H8.25ZM1.5 6.35V9.65H7.5V6.35H1.5ZM1.5 11.15V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H7.5V11.15H1.5ZM9 14.5H13.75C14.1642 14.5 14.5 14.1642 14.5 13.75V11.15H9V14.5ZM14.5 9.65V6.35H9V9.65H14.5ZM14.5 4.85V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H9V4.85H14.5ZM7.5 1.5V4.85H1.5V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H7.5Z"
    />
  ),
  smallAlternative: TableSmallIcon,
})

export const NotificationBellStrikedThroughIcon = makeIcon({
  displayName: 'NotificationBellStrikedThrough',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.02817 1.5C4.88082 1.5 3.27417 3.12726 3.27417 5.5V8.75C3.27417 8.89143 3.23418 9.02997 3.15882 9.14964L3.13017 9.19529L3.05038 9.32301C2.9827 9.43165 2.88882 9.58305 2.78411 9.75395C2.57281 10.0988 2.32423 10.5121 2.15647 10.8141C1.95536 11.1763 1.49877 11.3068 1.13666 11.1056C0.774546 10.9045 0.644033 10.4479 0.84515 10.0858C1.02968 9.75359 1.29277 9.31686 1.50508 8.97033C1.6106 8.79809 1.70526 8.6454 1.77417 8.53477V5.5C1.77417 2.37274 3.98037 0 7.02817 0C8.2109 0 9.27369 0.399369 10.1258 1.05661C10.4538 1.30958 10.5146 1.78055 10.2617 2.10854C10.0087 2.43653 9.53773 2.49734 9.20974 2.24437C8.60636 1.779 7.86252 1.5 7.02817 1.5ZM12.0716 3.9899L13.7811 2.28035C14.074 1.98746 14.074 1.51258 13.7811 1.21969C13.4882 0.926798 13.0134 0.926798 12.7205 1.21969L0.69965 13.2405C0.406757 13.5334 0.406757 14.0083 0.69965 14.3012C0.992544 14.5941 1.46742 14.5941 1.76031 14.3012L3.56148 12.5H7.02834H12.0008C12.3824 12.5 12.7481 12.4123 13.0393 12.1794C13.3377 11.9407 13.4613 11.6271 13.5027 11.3687C13.5423 11.1214 13.5128 10.8985 13.4841 10.757C13.4689 10.6822 13.4516 10.6192 13.4374 10.5729C13.4302 10.5496 13.4237 10.5299 13.4183 10.5145L13.4111 10.4944L13.4083 10.4867L13.4071 10.4835L13.4065 10.4821L13.4062 10.4814C13.4061 10.481 13.406 10.4807 12.706 10.75L13.406 10.4807C13.3911 10.4419 13.373 10.4045 13.3518 10.3687L12.2753 8.54513V5.5C12.2753 4.98264 12.2047 4.47486 12.0716 3.9899ZM10.7701 5.29139L5.06148 11H7.02821H11.9826L10.8794 9.13128C10.8112 9.01579 10.7753 8.88412 10.7753 8.74999V5.5C10.7753 5.43022 10.7735 5.36067 10.7701 5.29139ZM5.59737 13.7954C5.34795 13.468 4.88067 13.4026 4.55084 13.65C4.21947 13.8985 4.15231 14.3686 4.40084 14.7L5.00084 14.25C4.40084 14.7 4.40102 14.7003 4.4012 14.7005L4.40158 14.701L4.4024 14.7021L4.40424 14.7045L4.40883 14.7105L4.42153 14.7268C4.43157 14.7394 4.44475 14.7557 4.46103 14.7751C4.49354 14.8139 4.53869 14.8653 4.59607 14.9252C4.7102 15.0443 4.87623 15.2004 5.09096 15.3566C5.51754 15.6668 6.16919 16 7.00084 16C7.83249 16 8.48414 15.6668 8.91072 15.3566C9.12545 15.2004 9.29148 15.0443 9.40561 14.9252C9.46299 14.8653 9.50815 14.8139 9.54065 14.7751C9.55693 14.7557 9.57012 14.7394 9.58015 14.7268L9.59285 14.7105L9.59744 14.7045L9.59929 14.7021L9.60048 14.7005C9.60066 14.7003 9.60084 14.7 9.00084 14.25L9.60084 14.7C9.84937 14.3686 9.78221 13.8985 9.45084 13.65C9.12101 13.4026 8.65374 13.468 8.40432 13.7954C8.40276 13.7974 8.39836 13.8029 8.39169 13.8108C8.3783 13.8268 8.3551 13.8535 8.32263 13.8873C8.25708 13.9557 8.15748 14.0496 8.02846 14.1435C7.76754 14.3332 7.41919 14.5 7.00084 14.5C6.58249 14.5 6.23414 14.3332 5.97322 14.1435C5.8442 14.0496 5.7446 13.9557 5.67905 13.8873C5.64658 13.8535 5.62338 13.8268 5.60999 13.8108C5.60332 13.8029 5.59893 13.7974 5.59737 13.7954Z"
    />
  ),
})

// WEBSITE ONLY

export const BurgerMenuIcon = makeIcon({
  displayName: 'BurgerMenuIcon',
  viewBox: 16,
  content: (
    <path d="M2 3.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.25ZM2 8a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8ZM2.75 12a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z" />
  ),
})

export const CollectionIcon = makeIcon({
  displayName: 'CollectionIcon',
  viewBox: 16,
  content: (
    <g width="16" height="16" fill="none">
      <rect
        x="1"
        y="9"
        width="14"
        height="6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="2" y="5" width="12" height="1.5" rx=".75" fill="currentColor" />
      <rect x="4" y="2" width="8" height="1.5" rx=".75" fill="currentColor" />
    </g>
  ),
  smallAlternative: CollectionSmallIcon,
})

export const CollectionTableIcon = makeIcon({
  displayName: 'CollectionTableIcon',
  viewBox: 16,
  content: (
    <g width="16" height="16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 2.75V5.75H8.75V2.75H14.5ZM8.75 7.25H14.5V10.25H8.75V7.25ZM7.25 10.25V7.25H1.5V10.25H7.25ZM1.5 11.75H7.25V14.5H2.25C1.83579 14.5 1.5 14.1642 1.5 13.75V11.75ZM8.75 11.75H14.5V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5H8.75V11.75ZM7.25 2.75V5.75H1.5V2.75H7.25ZM2.25 0C1.00736 0 0 1.00736 0 2.25V13.75C0 14.9926 1.00736 16 2.25 16H13.75C14.9926 16 16 14.9926 16 13.75V2.25C16 1.00736 14.9926 0 13.75 0H2.25Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: CollectionTableSmallIcon,
})

export const CollectionLinkIcon = makeIcon({
  displayName: 'CollectionLinkIcon',
  viewBox: 16,
  content: (
    <g width="16" height="16" fill="none">
      <g clipPath="url(#clip0)">
        <rect
          x="1"
          y="9"
          width="14"
          height="6"
          rx="1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect x="2" y="5" width="5" height="1.5" rx=".75" fill="currentColor" />
        <rect x="4" y="2" width="3" height="1.5" rx=".75" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.999 1.512a.75.75 0 110-1.5l5-.001a.75.75 0 01.75.75v5a.75.75 0 01-1.5 0V2.574L10.581 6.24a.75.75 0 11-1.06-1.06l3.668-3.67H10z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
  smallAlternative: CollectionLinkSmallIcon,
})

export const HomeIcon = makeIcon({
  displayName: 'Icon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5254 1.68147C7.80156 1.45579 8.19844 1.45579 8.4746 1.68147L14.2246 6.3806C14.3989 6.52305 14.5 6.73624 14.5 6.96134V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5H2.25C1.83579 14.5 1.5 14.1642 1.5 13.75V6.96134C1.5 6.73624 1.6011 6.52305 1.7754 6.3806L7.5254 1.68147ZM9.4238 0.52C8.59534 -0.157056 7.40467 -0.157058 6.5762 0.519999L0.826198 5.21913C0.303308 5.64646 0 6.28605 0 6.96134V13.75C0 14.9926 1.00736 16 2.25 16H13.75C14.9926 16 16 14.9926 16 13.75V6.96134C16 6.28605 15.6967 5.64646 15.1738 5.21913L9.4238 0.52ZM6.17083 9.6646C5.98559 9.29412 5.53509 9.14395 5.1646 9.32919C4.79412 9.51443 4.64395 9.96494 4.82919 10.3354C5.02365 10.7243 5.43557 11.1918 5.99024 11.5615C6.56055 11.9418 7.32791 12.25 8.25001 12.25C9.17211 12.25 9.93948 11.9418 10.5098 11.5615C11.0645 11.1918 11.4764 10.7243 11.6708 10.3354C11.8561 9.96494 11.7059 9.51443 11.3354 9.32919C10.9649 9.14395 10.5144 9.29412 10.3292 9.6646C10.2737 9.77568 10.0606 10.0583 9.67774 10.3135C9.31055 10.5583 8.82792 10.75 8.25001 10.75C7.67211 10.75 7.18948 10.5583 6.82229 10.3135C6.43946 10.0583 6.22637 9.77568 6.17083 9.6646Z"
    />
  ),
})

export const ArrowTopIcon = makeIcon({
  displayName: 'ArrowTopIcon',
  content: (
    <g transform="translate(16) rotate(90.000000)">
      <path d="M6.53712 5.87868C6.92765 5.48816 6.92765 4.85499 6.53712 4.46447C6.1466 4.07394 5.51343 4.07394 5.12291 4.46447L2.36 7.22738C2.14 7.41081 2 7.68695 2 7.99578C2 8.12256 2.02359 8.24383 2.06662 8.35544C2.11528 8.48364 2.19123 8.60386 2.29448 8.70711L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z" />
    </g>
  ),
  smallAlternative: ArrowTopSmallIcon,
})

export const ArrowBottomIcon = makeIcon({
  viewBox: 16,
  displayName: 'ArrowBottomIcon',
  content: (
    <g transform="translate(0, 16) rotate(270.000000)">
      <path d="M6.53712 5.87868C6.92765 5.48816 6.92765 4.85499 6.53712 4.46447C6.1466 4.07394 5.51343 4.07394 5.12291 4.46447L2.36 7.22738C2.14 7.41081 2 7.68695 2 7.99578C2 8.12256 2.02359 8.24383 2.06662 8.35544C2.11528 8.48364 2.19123 8.60386 2.29448 8.70711L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z" />
    </g>
  ),
  smallAlternative: ArrowBottomSmallIcon,
})

export const AttachmentIcon = makeIcon({
  displayName: 'AttachmentIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46967 1.46973C10.8671 0.072265 13.1329 0.0722649 14.5303 1.46973C15.9278 2.86719 15.9278 5.13293 14.5303 6.53039L14.0303 7.03039C13.7374 7.32329 13.2626 7.32329 12.9697 7.03039C12.6768 6.7375 12.6768 6.26263 12.9697 5.96973L13.4697 5.46973C14.2814 4.65805 14.2814 3.34207 13.4697 2.53039C12.658 1.71871 11.342 1.71871 10.5303 2.53039L2.53033 10.5304C1.71865 11.3421 1.71865 12.6581 2.53033 13.4697C3.34201 14.2814 4.65799 14.2814 5.46967 13.4697L7.34467 11.5947L8.40533 12.6554L6.53033 14.5304C5.13287 15.9279 2.86713 15.9279 1.46967 14.5304C0.0722036 13.1329 0.072204 10.8672 1.46967 9.46973L9.46967 1.46973Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.96967 6.96973C8.81485 6.12455 10.1852 6.12455 11.0303 6.96973C11.8755 7.81491 11.8755 9.18521 11.0303 10.0304L8.03033 13.0304L6.96967 11.9697L9.96968 8.96973C10.2291 8.71034 10.2291 8.28978 9.96968 8.03039C9.71028 7.771 9.28973 7.771 9.03033 8.03039L5.28033 11.7804C4.98744 12.0733 4.51256 12.0733 4.21967 11.7804C3.92678 11.4875 3.92678 11.0126 4.21967 10.7197L7.96967 6.96973Z"
      />
    </g>
  ),
  smallAlternative: AttachmentSmallIcon,
})

export const BoundNoteIcon = makeIcon({
  displayName: 'BoundNoteIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M0 2.25C0 1.00736 1.00736 0 2.25 0H10.75C11.9926 0 13 1.00736 13 2.25V3.25C13 3.66421 12.6642 4 12.25 4C11.8358 4 11.5 3.66421 11.5 3.25V2.25C11.5 1.83579 11.1642 1.5 10.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H10.75C11.1642 14.5 11.5 14.1642 11.5 13.75V12.75C11.5 12.3358 11.8358 12 12.25 12C12.6642 12 13 12.3358 13 12.75V13.75C13 14.9926 11.9926 16 10.75 16H2.25C1.00736 16 0 14.9926 0 13.75V2.25Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 10C9.5 10.4142 9.16421 10.75 8.75 10.75H7.75C6.23122 10.75 5 9.51878 5 8C5 6.48122 6.23122 5.25 7.75 5.25H8.75C9.16421 5.25 9.5 5.58579 9.5 6C9.5 6.41421 9.16421 6.75 8.75 6.75L7.75 6.75C7.05964 6.75 6.5 7.30964 6.5 8C6.5 8.69036 7.05964 9.25 7.75 9.25H8.75C9.16421 9.25 9.5 9.58579 9.5 10ZM11.5 6C11.5 5.58579 11.8358 5.25 12.25 5.25H13.25C14.7688 5.25 16 6.48122 16 8C16 9.51878 14.7688 10.75 13.25 10.75H12.25C11.8358 10.75 11.5 10.4142 11.5 10C11.5 9.58579 11.8358 9.25 12.25 9.25H13.25C13.9404 9.25 14.5 8.69036 14.5 8C14.5 7.30964 13.9404 6.75 13.25 6.75H12.25C11.8358 6.75 11.5 6.41421 11.5 6ZM9.5 7.25C9.08579 7.25 8.75 7.58579 8.75 8C8.75 8.41421 9.08579 8.75 9.5 8.75H11.5C11.9142 8.75 12.25 8.41421 12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25H9.5Z"
      />
    </g>
  ),
})

export const BrokenMediaIcon = makeIcon({
  displayName: 'BrokenMediaIcon',
  content: (
    <path d="M.293 14.293a1 1 0 1 0 1.414 1.414l1-1 12-12 1-1A1 1 0 0 0 14.293.293l-14 14zM12 15H5.243l2-2H12a1 1 0 0 0 1-1V7.243l2-2V12a3 3 0 0 1-3 3zM8.757 3H4a1 1 0 0 0-1 1v4.757l-2 2V4a3 3 0 0 1 3-3h6.757l-2 2z" />
  ),
})

export const BulbIcon = makeIcon({
  displayName: 'BulbIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C6.084 2 4.5 3.587 4.5 5.583c0 1.177.61 2.242 1.535 2.906.732.525 1.525 1.38 1.686 2.511h.558c.161-1.131.954-1.986 1.686-2.511.925-.664 1.535-1.73 1.535-2.906C11.5 3.587 9.916 2 8 2zM2.5 5.583C2.5 2.517 4.945 0 8 0s5.5 2.517 5.5 5.583c0 1.885-.974 3.53-2.369 4.53-.594.427-.881.904-.881 1.304V12a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1v-.583c0-.4-.287-.877-.881-1.303C3.474 9.113 2.5 7.468 2.5 5.584zM7.75 13.75a.25.25 0 1 0 .5 0h2a2.25 2.25 0 0 1-4.5 0h2z"
    />
  ),
})

export const CaretRightOutlineIcon = makeIcon({
  displayName: 'CaretRightOutlineIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.67408 12.041C6.54645 13.0713 4.75 12.2602 4.75 10.7457V5.25423C4.75 3.73974 6.54645 2.92866 7.67408 3.95888L10.6794 6.70462C11.4402 7.39967 11.4402 8.60025 10.6794 9.2953L7.67408 12.041ZM6.25 10.7457C6.25 10.9715 6.50864 11.074 6.66233 10.9336L9.66767 8.18789C9.77744 8.0876 9.77744 7.91232 9.66767 7.81203L6.66233 5.0663C6.50864 4.92589 6.25 5.02845 6.25 5.25423V10.7457Z"
    />
  ),
})

export const ChevronSmallDown = makeIcon({
  displayName: 'ChevronSmallDown',
  viewBox: 16,
  content: (
    <path d="M13.657 4.837a1 1 0 010 1.414l-4.95 4.95a1 1 0 01-1.414 0l-4.95-4.95a1 1 0 111.414-1.414L8 9.079l4.243-4.242a1 1 0 011.414 0z" />
  ),
})

export const CircledCross = makeIcon({
  displayName: 'CircledCross',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <path d="M11.0303 6.03033C11.3232 5.73744 11.3232 5.26256 11.0303 4.96967C10.7374 4.67678 10.2626 4.67678 9.96967 4.96967L8 6.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L6.93934 8L4.96967 9.96967C4.67678 10.2626 4.67678 10.7374 4.96967 11.0303C5.26256 11.3232 5.73744 11.3232 6.03033 11.0303L8 9.06066L9.96967 11.0303C10.2626 11.3232 10.7374 11.3232 11.0303 11.0303C11.3232 10.7374 11.3232 10.2626 11.0303 9.96967L9.06066 8L11.0303 6.03033Z" />
    </g>
  ),
})

export const CollapsedBlock = makeIcon({
  displayName: 'CollapsedBlock',
  viewBox: 16,
  content: (
    <g>
      <path d="M5.75 2.5C5.33579 2.5 5 2.83579 5 3.25C5 3.66421 5.33579 4 5.75 4L15.25 4C15.6642 4 16 3.66421 16 3.25C16 2.83579 15.6642 2.5 15.25 2.5L5.75 2.5Z" />
      <path d="M5.75 7.25C5.33579 7.25 5 7.58579 5 8C5 8.41421 5.33579 8.75 5.75 8.75L15.25 8.75C15.6642 8.75 16 8.41421 16 8C16 7.58579 15.6642 7.25 15.25 7.25L5.75 7.25Z" />
      <path d="M5 12.75C5 12.3358 5.33579 12 5.75 12H15.25C15.6642 12 16 12.3358 16 12.75C16 13.1642 15.6642 13.5 15.25 13.5H5.75C5.33579 13.5 5 13.1642 5 12.75Z" />
      <path d="M0.180806 3.53695C0.29183 3.47981 0.425474 3.48952 0.527079 3.56209L2.86041 5.22876C2.94801 5.29133 3 5.39235 3 5.5C3 5.60765 2.94801 5.70867 2.86041 5.77124L0.527079 7.43791C0.425474 7.51048 0.29183 7.52019 0.180806 7.46305C0.0697825 7.40592 0 7.29153 0 7.16667L0 3.83333C0 3.70847 0.0697825 3.59408 0.180806 3.53695Z" />
      <path d="M0.527079 8.56209C0.425474 8.48952 0.29183 8.47981 0.180806 8.53695C0.0697825 8.59408 0 8.70847 0 8.83333L0 12.1667C0 12.2915 0.0697825 12.4059 0.180806 12.4631C0.29183 12.5202 0.425474 12.5105 0.527079 12.4379L2.86041 10.7712C2.94801 10.7087 3 10.6077 3 10.5C3 10.3923 2.94801 10.2913 2.86041 10.2288L0.527079 8.56209Z" />
    </g>
  ),
  smallAlternative: CollapsedBlockSmallIcon,
})

export const DirectoryIcon = makeIcon({
  displayName: 'DirectoryIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2376 4.98994C14.3989 5.08003 14.4101 5.30789 14.2585 5.4134L8.60276 9.34878C8.36731 9.51261 8.05903 9.5278 7.80861 9.3879L1.76222 6.01003C1.60095 5.91993 1.58972 5.69208 1.74136 5.58657L7.39707 1.65118C7.63253 1.48735 7.94081 1.47216 8.19123 1.61206L14.2376 4.98994ZM15.1152 6.64466C16.1766 5.90609 16.0981 4.31109 14.9692 3.68043L8.92279 0.302555C8.17154 -0.117142 7.2467 -0.0715794 6.54033 0.419925L0.884616 4.35531C-0.176812 5.09387 -0.0982368 6.68887 1.03065 7.31953L7.07704 10.6974C7.8283 11.1171 8.75314 11.0715 9.4595 10.58L15.1152 6.64466Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6483 10.3601C15.4117 10.0201 14.9443 9.93623 14.6043 10.1728L8.60281 14.3488C8.36735 14.5126 8.05907 14.5278 7.80865 14.3879L1.39844 10.8068C1.03683 10.6048 0.579915 10.7341 0.377897 11.0957C0.175881 11.4574 0.305257 11.9143 0.666866 12.1163L7.07709 15.6974C7.82834 16.1171 8.75318 16.0715 9.45955 15.58L15.461 11.4041C15.801 11.1675 15.8849 10.7001 15.6483 10.3601Z"
      />
    </g>
  ),
  smallAlternative: DirectorySmallIcon,
})

export const AIGeneratedDirectoryIcon = makeIcon({
  displayName: 'AIGeneratedDirectoryIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1154 6.64469C16.1768 5.90612 16.0982 4.31113 14.9694 3.68047L8.92297 0.30259C8.17171 -0.117106 7.24687 -0.071544 6.5405 0.419962L0.884787 4.35534C-0.176642 5.09391 -0.0980667 6.68891 1.03082 7.31957L7.07721 10.6974C7.82847 11.1171 8.75331 11.0716 9.45968 10.5801L15.1154 6.64469ZM14.2378 4.98997C14.3991 5.08007 14.4103 5.30792 14.2586 5.41343L8.60294 9.34881C8.36748 9.51265 8.0592 9.52784 7.80878 9.38794L1.76239 6.01006C1.60112 5.91997 1.58989 5.69211 1.74153 5.5866L7.39724 1.65122C7.6327 1.48739 7.94098 1.4722 8.1914 1.6121L14.2378 4.98997Z"
      />
      <path d="M10.1348 14.1967C9.8982 13.8567 9.43078 13.7729 9.09078 14.0095L8.55185 14.3845C8.34767 14.5266 8.08035 14.5397 7.86319 14.4184L1.3986 10.8069C1.03699 10.6049 0.58008 10.7343 0.378062 11.0959C0.176045 11.4575 0.305421 11.9144 0.667031 12.1164L7.13163 15.7279C7.84961 16.129 8.7335 16.0855 9.40859 15.6157L9.94752 15.2407C10.2875 15.0042 10.3714 14.5367 10.1348 14.1967Z" />
      <path d="M12.6182 9.34801C12.6493 9.21738 12.8351 9.21738 12.8663 9.34801L13.1269 10.443C13.3597 11.4205 14.1448 12.1703 15.1321 12.3577L15.8802 12.4998C16.0184 12.526 16.0184 12.724 15.8801 12.7503L15.1321 12.8923C14.1448 13.0798 13.3597 13.8295 13.1269 14.8071L12.8663 15.9021C12.8351 16.0327 12.6493 16.0327 12.6182 15.9021L12.3575 14.8072C12.1247 13.8296 11.3396 13.0798 10.3523 12.8924L9.60378 12.7503C9.46547 12.7241 9.46547 12.526 9.60378 12.4998L10.3523 12.3577C11.3396 12.1703 12.1247 11.4205 12.3575 10.4429L12.6182 9.34801Z" />
    </g>
  ),
  smallAlternative: AIGeneratedDirectorySmallIcon,
})

export const FileClipIcon = makeIcon({
  displayName: 'FileClipIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M9.47 1.47a3.578 3.578 0 0 1 5.06 5.06l-.5.5a.75.75 0 0 1-1.06-1.06l.5-.5a2.078 2.078 0 1 0-2.94-2.94l-8 8a2.079 2.079 0 0 0 2.94 2.94l1.874-1.876 1.061 1.061L6.53 14.53a3.579 3.579 0 0 1-5.06-5.06l8-8Z" />
      <path d="M7.97 6.97a2.164 2.164 0 0 1 3.06 3.06l-3 3-1.06-1.06 3-3a.664.664 0 1 0-.94-.94l-3.75 3.75a.75.75 0 0 1-1.06-1.06l3.75-3.75Z" />
    </g>
  ),
})

export const ForbiddenIcon = makeIcon({
  displayName: 'ForbiddenIcon',
  viewBox: 16,
  content: (
    <path d="M4.5 12.9c1 .7 2.2 1.1 3.5 1.1 3.3 0 6-2.7 6-6 0-1.3-.4-2.5-1.1-3.5l-8.4 8.4zm-1.4-1.4l8.4-8.4C10.5 2.4 9.3 2 8 2 4.7 2 2 4.7 2 8c0 1.3.4 2.5 1.1 3.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
  ),
})

export const InviteIcon = makeIcon({
  viewBox: 16,
  displayName: 'InviteIcon',
  content: (
    <g>
      <path
        d="M13.5 10.25C13.5 9.83579 13.1642 9.5 12.75 9.5C12.3358 9.5 12 9.83579 12 10.25V12H10.25C9.88503 12 9.50003 12.385 9.50003 12.75C9.50003 13.165 9.88503 13.5 10.25 13.5H12V15.25C12 15.6642 12.3358 16 12.75 16C13.1642 16 13.5 15.6642 13.5 15.25V13.5H15.25C15.6642 13.5 16 13.1642 16 12.75C16 12.3358 15.6642 12 15.25 12H13.5V10.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75003 3.75C5.75003 2.50736 6.75739 1.5 8.00003 1.5C9.24267 1.5 10.25 2.50736 10.25 3.75C10.25 4.99264 9.24267 6 8.00003 6C6.75739 6 5.75003 4.99264 5.75003 3.75ZM8.00003 0C5.92896 0 4.25003 1.67893 4.25003 3.75C4.25003 5.82107 5.92896 7.5 8.00003 7.5C10.0711 7.5 11.75 5.82107 11.75 3.75C11.75 1.67893 10.0711 0 8.00003 0ZM3.03036 11.7803C3.50682 11.3039 4.27937 10.9703 5.2228 10.7639C6.15078 10.5609 7.1546 10.5 8.00003 10.5C8.22823 10.5 8.46919 10.5044 8.71806 10.5151C9.13189 10.5327 9.48169 10.2115 9.49935 9.79771C9.51701 9.38387 9.19584 9.03407 8.78201 9.01642C8.50986 9.0048 8.24748 9 8.00003 9C7.09546 9 5.97428 9.06407 4.90226 9.29858C3.84569 9.5297 2.74325 9.94613 1.9697 10.7197C1.27078 11.4186 0.808889 12.4457 0.517935 13.2685C0.00564634 14.7172 1.17991 16 2.54735 16H8.75003C9.16424 16 9.50003 15.6642 9.50003 15.25C9.50003 14.8358 9.16424 14.5 8.75003 14.5H2.54735C2.30896 14.5 2.11855 14.393 2.00875 14.2527C1.90443 14.1195 1.86681 13.9533 1.93212 13.7686C2.20509 12.9966 2.57688 12.2338 3.03036 11.7803Z"
        fill="currentColor"
      />
    </g>
  ),
  smallAlternative: InviteSmallIcon,
})

export const MentionIcon = makeIcon({
  displayName: 'MentionIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 9.1702 1.80923 10.2682 2.35044 11.2167C2.35748 11.2275 2.36428 11.2387 2.37083 11.25C2.95881 12.2684 3.78095 13.0676 4.73 13.6188C5.5152 14.0748 6.38726 14.361 7.28548 14.4612C7.52013 14.4868 7.75853 14.5 8 14.5C8.01418 14.5 8.02826 14.5004 8.04224 14.5012C8.7798 14.4971 9.52343 14.3673 10.2406 14.1029C10.6292 13.9596 11.0604 14.1585 11.2037 14.5472C11.347 14.9358 11.1481 15.367 10.7594 15.5103C9.6222 15.9295 8.43108 16.0742 7.27155 15.9673C6.09552 15.8611 4.9929 15.5005 4.01919 14.9408C3.0496 14.3859 2.18578 13.6217 1.5024 12.6681C0.556901 11.3543 0 9.74219 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 10.4681 14.8081 12.0777 13.2759 12.3924C12.5238 12.5469 11.7448 12.3591 11.1585 11.8241C10.9403 11.625 10.7585 11.3871 10.6164 11.1165C9.94906 11.8129 9.03398 12.25 8 12.25C5.87354 12.25 4.25 10.4015 4.25 8.25C4.25 6.09851 5.87354 4.25 8 4.25C8.86632 4.25 9.64916 4.5568 10.2728 5.06591C10.3548 4.7407 10.6493 4.5 11 4.5C11.4142 4.5 11.75 4.83579 11.75 5.25V9.5C11.75 10.1484 11.9584 10.5233 12.1696 10.7161C12.3802 10.9083 12.6637 10.9869 12.9741 10.9231C13.5669 10.8013 14.5 10.0359 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 5.75C9.18725 5.75 10.25 6.81164 10.25 8.25C10.25 9.68837 9.18725 10.75 8 10.75C6.81275 10.75 5.75 9.68837 5.75 8.25C5.75 6.81164 6.81275 5.75 8 5.75Z"
      />
    </g>
  ),
  smallAlternative: MentionSmallIcon,
})

export const DocCardIcon = makeIcon({
  displayName: 'DocCardIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4C0 2.75736 1.00736 1.75 2.25 1.75H13.75C14.9926 1.75 16 2.75736 16 4V12C16 13.2426 14.9926 14.25 13.75 14.25H2.25C1.00736 14.25 0 13.2426 0 12V4ZM2.25 3.25C1.83579 3.25 1.5 3.58579 1.5 4V12C1.5 12.4142 1.83579 12.75 2.25 12.75H13.75C14.1642 12.75 14.5 12.4142 14.5 12V4C14.5 3.58579 14.1642 3.25 13.75 3.25H2.25Z"
      />
      <path d="M6.25 6.5C6.25 7.19036 5.69036 7.75 5 7.75C4.30964 7.75 3.75 7.19036 3.75 6.5C3.75 5.80964 4.30964 5.25 5 5.25C5.69036 5.25 6.25 5.80964 6.25 6.5Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 10C3.75 9.58579 4.08579 9.25 4.5 9.25L10.5 9.25C10.9142 9.25 11.25 9.58579 11.25 10C11.25 10.4142 10.9142 10.75 10.5 10.75L4.5 10.75C4.08579 10.75 3.75 10.4142 3.75 10Z"
      />
    </g>
  ),
  smallAlternative: DocCardSmallIcon,
})

export const NumberIcon = makeIcon({
  displayName: 'NumberIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 2.38397e-08C10.9142 4.19455e-08 11.25 0.335786 11.25 0.75L11.25 15.25C11.25 15.6642 10.9142 16 10.5 16C10.0858 16 9.75 15.6642 9.75 15.25L9.75 0.75C9.75 0.335786 10.0858 5.73383e-09 10.5 2.38397e-08Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 16C5.08579 16 4.75 15.6642 4.75 15.25V0.75C4.75 0.335787 5.08579 -4.93945e-09 5.5 0C5.91421 4.93945e-09 6.25 0.335787 6.25 0.75V15.25C6.25 15.6642 5.91421 16 5.5 16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10.5C16 10.9142 15.6642 11.25 15.25 11.25L0.75 11.25C0.335787 11.25 -1.23718e-08 10.9142 2.38398e-08 10.5C6.00515e-08 10.0858 0.335787 9.75 0.75 9.75L15.25 9.75C15.6642 9.75 16 10.0858 16 10.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.5C2.30453e-08 5.08579 0.335786 4.75 0.75 4.75L15.25 4.75C15.6642 4.75 16 5.08579 16 5.5C16 5.91421 15.6642 6.25 15.25 6.25L0.75 6.25C0.335786 6.25 -2.30453e-08 5.91421 0 5.5Z"
      />
    </g>
  ),
  smallAlternative: NumberSmallIcon,
})

export const SubdocsIcon = makeIcon({
  displayName: 'SubdocsIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M3.75 4.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM4.5 6a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H4.5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 0A1.75 1.75 0 0 0 1 1.75V11c0 .966.784 1.75 1.75 1.75h7.5A1.75 1.75 0 0 0 12 11V1.75A1.75 1.75 0 0 0 10.25 0h-7.5ZM2.5 1.75a.25.25 0 0 1 .25-.25h7.5a.25.25 0 0 1 .25.25V11a.25.25 0 0 1-.25.25h-7.5A.25.25 0 0 1 2.5 11V1.75Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M15.25 5.25a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 1-.75.75H6.5a.75.75 0 0 0 0 1.5H13a2.25 2.25 0 0 0 2.25-2.25v-8.5Z"
      />
    </g>
  ),
})

export const SubscriptIcon = makeIcon({
  displayName: 'SubscriptIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 3.25C0.335786 3.25 0 3.58579 0 4V6.25C0 6.66421 0.335786 7 0.75 7C1.16421 7 1.5 6.66421 1.5 6.25V4.75H4V12.5H2.75C2.33579 12.5 2 12.8358 2 13.25C2 13.6642 2.33579 14 2.75 14H6.75C7.16421 14 7.5 13.6642 7.5 13.25C7.5 12.8358 7.16421 12.5 6.75 12.5H5.5V4.75H8V6.25C8 6.66421 8.33579 7 8.75 7C9.16421 7 9.5 6.66421 9.5 6.25V4C9.5 3.58579 9.16421 3.25 8.75 3.25H0.75ZM13.0396 11.2582C13.2652 10.9637 13.6717 10.9166 13.9536 11.1412C14.2442 11.3727 14.3005 11.8109 14.0682 12.114C13.8538 12.3938 13.2772 13.0357 12.7249 13.6372C12.4549 13.9312 12.1995 14.2061 12.0116 14.4076C11.9176 14.5083 11.8406 14.5905 11.7871 14.6476L11.7041 14.736C11.499 14.9539 11.443 15.2728 11.5617 15.5475C11.6804 15.8222 11.951 16.0001 12.2502 16.0001L15.2502 16.0001C15.6644 16.0001 16.0002 15.6643 16.0002 15.2501C16.0002 14.8359 15.6644 14.5001 15.2502 14.5001L13.9687 14.5001C14.4696 13.9526 15.0171 13.3418 15.2589 13.0262C15.9843 12.0795 15.8232 10.7129 14.8882 9.96796C13.9444 9.21603 12.581 9.3905 11.8489 10.3459C11.7253 10.5073 11.6271 10.6814 11.5542 10.8629C11.3999 11.2473 11.5863 11.684 11.9707 11.8384C12.3551 11.9928 12.7918 11.8063 12.9462 11.422C12.9691 11.365 13 11.3099 13.0396 11.2582Z"
    />
  ),
  smallAlternative: SubscriptSmallIcon,
})

export const SuperscriptIcon = makeIcon({
  displayName: 'SuperscriptIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0396 1.75819C13.2652 1.46375 13.6717 1.41663 13.9536 1.64116C14.2442 1.87273 14.3005 2.31087 14.0682 2.61396C13.8538 2.89379 13.2772 3.53573 12.7249 4.13717C12.4549 4.43123 12.1995 4.70612 12.0116 4.9076C11.9176 5.00829 11.8406 5.09055 11.7871 5.14756L11.7041 5.236C11.499 5.45388 11.443 5.77283 11.5617 6.04752C11.6804 6.32221 11.951 6.50008 12.2502 6.50008L15.2502 6.5001C15.6644 6.50011 16.0002 6.16432 16.0002 5.75011C16.0002 5.33589 15.6644 5.00011 15.2502 5.0001L13.9687 5.00009C14.4696 4.45259 15.0171 3.84182 15.2589 3.52625C15.9843 2.5795 15.8232 1.21287 14.8882 0.467962C13.9444 -0.283973 12.581 -0.109499 11.8489 0.845894C11.7253 1.00725 11.6271 1.18142 11.5542 1.36294C11.3999 1.74731 11.5863 2.18405 11.9707 2.33842C12.3551 2.49279 12.7918 2.30634 12.9462 1.92196C12.9691 1.86498 13 1.80992 13.0396 1.75819ZM0.75 3.25C0.335786 3.25 0 3.58579 0 4V6.25C0 6.66421 0.335786 7 0.75 7C1.16421 7 1.5 6.66421 1.5 6.25V4.75H4V12.5H2.75C2.33579 12.5 2 12.8358 2 13.25C2 13.6642 2.33579 14 2.75 14H6.75C7.16421 14 7.5 13.6642 7.5 13.25C7.5 12.8358 7.16421 12.5 6.75 12.5H5.5V4.75H8V6.25C8 6.66421 8.33579 7 8.75 7C9.16421 7 9.5 6.66421 9.5 6.25V4C9.5 3.58579 9.16421 3.25 8.75 3.25H0.75Z"
    />
  ),
  smallAlternative: SuperscriptSmallIcon,
})

export const SuperSymbol = makeIcon({
  displayName: 'SuperSymbol',
  viewBox: 22,
  content: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M12.446 9.592c.764.771.764 2.02 0 2.79a1.943 1.943 0 0 1-2.767 0 1.983 1.983 0 0 1 0-2.79 1.946 1.946 0 0 1 2.767 0Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M15.008 6.918a5.453 5.453 0 0 0-7.887 0c-2.179 2.248-2.179 5.892 0 8.14a5.453 5.453 0 0 0 7.886 0c2.18-2.248 2.18-5.892 0-8.14Zm-.682 7.31c-1.264 1.27-3.75.853-5.55-.935-1.8-1.789-2.234-4.27-.972-5.546 1.266-1.271 3.75-.853 5.55.935 1.8 1.788 2.238 4.27.972 5.545Z"
        clipRule="evenodd"
      />
      <path d="M12.446 9.592c.764.771.764 2.02 0 2.79a1.943 1.943 0 0 1-2.767 0 1.983 1.983 0 0 1 0-2.79 1.946 1.946 0 0 1 2.767 0Z" />
      <path d="M15.008 6.918a5.453 5.453 0 0 0-7.887 0c-2.179 2.248-2.179 5.892 0 8.14a5.453 5.453 0 0 0 7.886 0c2.18-2.248 2.18-5.892 0-8.14Zm-.682 7.31c-1.264 1.27-3.75.853-5.55-.935-1.8-1.789-2.234-4.27-.972-5.546 1.266-1.271 3.75-.853 5.55.935 1.8 1.788 2.238 4.27.972 5.545Z" />
      <path
        fillRule="evenodd"
        d="M12.446 9.592c.764.771.764 2.02 0 2.79a1.943 1.943 0 0 1-2.767 0 1.983 1.983 0 0 1 0-2.79 1.946 1.946 0 0 1 2.767 0Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M15.008 6.918a5.453 5.453 0 0 0-7.887 0c-2.179 2.248-2.179 5.892 0 8.14a5.453 5.453 0 0 0 7.886 0c2.18-2.248 2.18-5.892 0-8.14Zm-.682 7.31c-1.264 1.27-3.75.853-5.55-.935-1.8-1.789-2.234-4.27-.972-5.546 1.266-1.271 3.75-.853 5.55.935 1.8 1.788 2.238 4.27.972 5.545Z"
        clipRule="evenodd"
      />
      <path d="M12.446 12.382a1.943 1.943 0 0 1-2.767 0 1.983 1.983 0 0 1 0-2.79 1.946 1.946 0 0 1 2.767 0c.764.771.764 2.02 0 2.79Z" />
      <path
        fillRule="evenodd"
        d="M12.446 12.382a1.943 1.943 0 0 1-2.767 0 1.983 1.983 0 0 1 0-2.79 1.946 1.946 0 0 1 2.767 0c.764.771.764 2.02 0 2.79Z"
        clipRule="evenodd"
      />
      <path d="M11.005.682C5.31.682.692 5.3.692 10.995c0 5.696 4.617 10.313 10.313 10.313 5.696 0 10.313-4.617 10.313-10.313C21.318 5.299 16.7.682 11.005.682Zm5.246 14.995C13.154 19.1 8.325 19.774 5.46 17.186a5.931 5.931 0 0 1-.978-1.142c-1.413-2.148-1.398-5.138 0-7.763a9.836 9.836 0 0 1 1.396-1.982c3.095-3.423 7.924-4.098 10.789-1.508 2.864 2.59 2.677 7.463-.416 10.886Z" />
    </g>
  ),
})

export const TagsIcon = makeIcon({
  displayName: 'TagsIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7746 1.58519C10.7221 1.53273 10.649 1.50628 10.5752 1.513L8.16008 1.73255C8.10183 1.73785 8.04729 1.76339 8.00593 1.80475L1.74803 8.06265C1.6504 8.16028 1.6504 8.31857 1.74803 8.4162L5.34432 12.0125C5.44195 12.1101 5.60024 12.1101 5.69787 12.0125L5.83703 11.8733L5.85524 11.8395L5.86541 11.845L11.9558 5.75459C11.9971 5.71323 12.0227 5.65869 12.028 5.60045L12.2475 3.18537C12.2542 3.11148 12.2278 3.03842 12.1753 2.98596L10.7746 1.58519ZM4.28366 13.0732C4.71467 13.5042 5.31456 13.6633 5.87033 13.5507L9.87642 15.7049C10.7853 16.1937 11.9176 15.7939 12.3181 14.8428L15.5986 7.05221C15.7575 6.6749 15.7791 6.25384 15.6596 5.86228L15.0588 3.89361C14.8634 3.25329 14.3241 2.78941 13.6805 2.6794C13.5995 2.39771 13.4481 2.13745 13.236 1.9253L11.8352 0.524534C11.468 0.157288 10.9566 -0.027863 10.4393 0.019158L8.02427 0.23871C7.61656 0.275775 7.23475 0.454605 6.94527 0.744086L0.687368 7.00199C0.00395028 7.68541 0.00395033 8.79345 0.687368 9.47686L4.28366 13.0732ZM10.5868 14.3838L7.24492 12.5868L13.0164 6.81525C13.3059 6.52577 13.4847 6.14396 13.5218 5.73625L13.6437 4.3955L14.2249 6.30008C14.242 6.35602 14.2389 6.41617 14.2162 6.47007L10.9356 14.2607C10.8784 14.3965 10.7167 14.4537 10.5868 14.3838ZM9.46967 4.28033C9.76256 4.57322 10.2374 4.57322 10.5303 4.28033C10.8232 3.98744 10.8232 3.51256 10.5303 3.21967C10.2374 2.92678 9.76256 2.92678 9.46967 3.21967C9.17678 3.51256 9.17678 3.98744 9.46967 4.28033Z"
    />
  ),
  smallAlternative: TagsSmallIcon,
})

export const TextWrap = makeIcon({
  displayName: 'TextWrap',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2.75C1 2.33579 1.33579 2 1.75 2H14.25C14.6642 2 15 2.33579 15 2.75C15 3.16421 14.6642 3.5 14.25 3.5H1.75C1.33579 3.5 1 3.16421 1 2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8C1 7.58579 1.33579 7.25 1.75 7.25H11.75C13.5449 7.25 15 8.70507 15 10.5C15 12.2949 13.5449 13.75 11.75 13.75H10.3107L10.7803 14.2197C11.0732 14.5126 11.0732 14.9874 10.7803 15.2803C10.4874 15.5732 10.0126 15.5732 9.71967 15.2803L7.96967 13.5303C7.67678 13.2374 7.67678 12.7626 7.96967 12.4697L9.71967 10.7197C10.0126 10.4268 10.4874 10.4268 10.7803 10.7197C11.0732 11.0126 11.0732 11.4874 10.7803 11.7803L10.3107 12.25H11.75C12.7165 12.25 13.5 11.4665 13.5 10.5C13.5 9.5335 12.7165 8.75 11.75 8.75H1.75C1.33579 8.75 1 8.41421 1 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 13.25C1 12.8358 1.33579 12.5 1.75 12.5H4.75C5.16421 12.5 5.5 12.8358 5.5 13.25C5.5 13.6642 5.16421 14 4.75 14H1.75C1.33579 14 1 13.6642 1 13.25Z"
      />
    </g>
  ),
})

export const NarrowBlockIcon = makeIcon({
  displayName: 'NarrowBlockIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M13.5803 3.93354C13.8732 4.22643 13.8732 4.7013 13.5803 4.9942L11.3246 7.24996H15.25C15.6642 7.24996 16 7.58574 16 7.99996C16 8.41417 15.6642 8.74996 15.25 8.74996H11.3257L13.5803 11.0046C13.8732 11.2975 13.8732 11.7724 13.5803 12.0653C13.2874 12.3582 12.8126 12.3582 12.5197 12.0653L8.98412 8.52973C8.69123 8.23684 8.69123 7.76196 8.98412 7.46907L12.5197 3.93354C12.8126 3.64064 13.2874 3.64064 13.5803 3.93354Z" />
      <path d="M2.41968 12.0653C2.12679 11.7724 2.12679 11.2975 2.41968 11.0046L4.67435 8.74994H0.75C0.335786 8.74994 0 8.41415 0 7.99994C0 7.58573 0.335786 7.24994 0.75 7.24994H4.67542L2.41968 4.9942C2.12679 4.70131 2.12679 4.22643 2.41968 3.93354C2.71258 3.64065 3.18745 3.64065 3.48034 3.93354L7.01588 7.46907C7.30877 7.76196 7.30877 8.23684 7.01588 8.52973L3.48034 12.0653C3.18745 12.3582 2.71258 12.3582 2.41968 12.0653Z" />
    </g>
  ),
})

export const ExpandBlockIcon = makeIcon({
  displayName: 'ExpandBlockIcon',
  viewBox: 16,
  content: (
    <path d="M4.83024 4.9942C5.12313 4.7013 5.12313 4.22643 4.83024 3.93354C4.53734 3.64064 4.06247 3.64064 3.76957 3.93354L0.31215 7.39096C0.123089 7.52713 0 7.74917 0 7.99995C0 8.25245 0.124778 8.47581 0.316036 8.61173L3.76957 12.0653C4.06247 12.3582 4.53734 12.3582 4.83024 12.0653C5.12313 11.7724 5.12313 11.2975 4.83024 11.0046L2.57558 8.74995H13.4244L11.1697 11.0046C10.8768 11.2975 10.8768 11.7724 11.1697 12.0653C11.4626 12.3582 11.9375 12.3582 12.2303 12.0653L15.6837 8.61188C15.8751 8.47598 16 8.25255 16 7.99995C16 7.74901 15.8768 7.52685 15.6875 7.3907L12.2303 3.93356C11.9375 3.64066 11.4626 3.64066 11.1697 3.93356C10.8768 4.22645 10.8768 4.70132 11.1697 4.99422L13.4254 7.24995H2.57448L4.83024 4.9942Z" />
  ),
})

export const FitBlockIcon = makeIcon({
  displayName: 'FitBlockIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M10 13.25L10 11.75C10 11.3358 10.3358 11 10.75 11C11.1642 11 11.5 11.3358 11.5 11.75L11.5 13.25C11.5 14.7688 10.2688 16 8.75 16L7.25 16C5.73122 16 4.5 14.7688 4.5 13.25L4.5 11.75C4.5 11.3358 4.83579 11 5.25 11C5.66421 11 6 11.3358 6 11.75L6 13.25C6 13.9404 6.55965 14.5 7.25 14.5L8.75 14.5C9.44036 14.5 10 13.9404 10 13.25Z" />
      <path d="M11.5 2.75L11.5 4.25C11.5 4.66421 11.1642 5 10.75 5C10.3358 5 10 4.66421 10 4.25L10 2.75C10 2.05964 9.44036 1.5 8.75 1.5L7.25 1.5C6.55964 1.5 6 2.05964 6 2.75L6 4.25C6 4.66421 5.66421 5 5.25 5C4.83579 5 4.5 4.66421 4.5 4.25L4.5 2.75C4.5 1.23122 5.73122 0 7.25 0L8.75 0C10.2688 0 11.5 1.23122 11.5 2.75Z" />
      <path d="M12.7196 5.46961C13.0125 5.17671 13.4874 5.17671 13.7803 5.46961L15.7803 7.46964C15.8677 7.55704 15.9291 7.66066 15.9643 7.77081C15.9781 7.81386 15.9881 7.85859 15.9939 7.90463C16.002 7.96784 16.002 8.03187 15.994 8.09508C15.988 8.14198 15.9778 8.18753 15.9636 8.23131C15.9282 8.34064 15.8671 8.44347 15.7803 8.5303L13.7803 10.5303C13.4874 10.8232 13.0125 10.8232 12.7196 10.5303C12.4267 10.2374 12.4267 9.76256 12.7196 9.46966L13.4393 8.74997L11.2499 8.74997C10.8357 8.74997 10.4999 8.41419 10.4999 7.99997C10.4999 7.58576 10.8357 7.24997 11.2499 7.24997L13.4393 7.24997L12.7196 6.53027C12.4267 6.23737 12.4267 5.7625 12.7196 5.46961Z" />
      <path d="M3.28028 5.46961C2.98738 5.17672 2.51251 5.17672 2.21962 5.46961L0.219589 7.46964C0.132179 7.55705 0.0708546 7.66067 0.0356173 7.77082C0.0218243 7.81385 0.0118127 7.85858 0.00597141 7.90461C-0.00208809 7.96783 -0.00209763 8.03189 0.00594281 8.09512C0.0118785 8.142 0.0221424 8.18754 0.0363231 8.23132C0.0716706 8.34065 0.13276 8.44347 0.219589 8.5303L2.21962 10.5303C2.51251 10.8232 2.98738 10.8232 3.28028 10.5303C3.57317 10.2374 3.57317 9.76256 3.28028 9.46967L2.56058 8.74998L4.74997 8.74998C5.16418 8.74998 5.49997 8.41419 5.49997 7.99998C5.49997 7.58577 5.16418 7.24998 4.74997 7.24998L2.56058 7.24998L3.28028 6.53027C3.57317 6.23738 3.57317 5.76251 3.28028 5.46961Z" />
    </g>
  ),
})

export const VideoIcon = makeIcon({
  displayName: 'VideoIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 3.25C1.83579 3.25 1.5 3.58579 1.5 4L1.5 12C1.5 12.4142 1.83579 12.75 2.25 12.75H10.75C11.1642 12.75 11.5 12.4142 11.5 12V4C11.5 3.58579 11.1642 3.25 10.75 3.25L2.25 3.25ZM13 5.36579V4C13 2.75736 11.9926 1.75 10.75 1.75L2.25 1.75C1.00736 1.75 4.17233e-07 2.75736 3.57628e-07 4L0 12C-5.96046e-08 13.2426 1.00736 14.25 2.25 14.25H10.75C11.9926 14.25 13 13.2426 13 12V11.1342L14.1546 11.7596C14.9875 12.2108 16 11.6077 16 10.6605V5.83947C16 4.89226 14.9875 4.28922 14.1546 4.74036L13 5.36579ZM13 7.07171V9.42829L14.5 10.2408V6.25921L13 7.07171Z"
    />
  ),
  smallAlternative: VideoSmallIcon,
})

export const InsertRightIcon = makeIcon({
  displayName: 'InsertRight',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 16C14.9926 16 16 14.9926 16 13.75L16 2.25C16 1.00736 14.9926 -8.80664e-08 13.75 -1.96701e-07L7.75 -7.21238e-07L7 -7.86805e-07L7 0.749999L7 15.25L7 16L7.75 16L13.75 16ZM14.5 13.75C14.5 14.1642 14.1642 14.5 13.75 14.5L8.5 14.5L8.5 1.5L13.75 1.5C14.1642 1.5 14.5 1.83579 14.5 2.25L14.5 13.75ZM4.5 14.5C4.08579 14.5 3.75 14.8358 3.75 15.25C3.75 15.6642 4.08579 16 4.5 16C4.91421 16 5.25 15.6642 5.25 15.25C5.25 14.8358 4.91421 14.5 4.5 14.5ZM1.25 14C0.835787 14 0.5 14.3358 0.5 14.75C0.5 15.1642 0.835787 15.5 1.25 15.5C1.66421 15.5 2 15.1642 2 14.75C2 14.3358 1.66421 14 1.25 14ZM3.93402e-07 11.5C4.29614e-07 11.0858 0.335787 10.75 0.75 10.75C1.16421 10.75 1.5 11.0858 1.5 11.5C1.5 11.9142 1.16421 12.25 0.75 12.25C0.335787 12.25 3.57191e-07 11.9142 3.93402e-07 11.5ZM0.75 7.25C0.335787 7.25 7.35594e-07 7.58579 6.99382e-07 8C6.63171e-07 8.41421 0.335786 8.75 0.75 8.75C1.16421 8.75 1.5 8.41421 1.5 8C1.5 7.58579 1.16421 7.25 0.75 7.25ZM1.00536e-06 4.5C1.04157e-06 4.08579 0.335786 3.75 0.75 3.75C1.16421 3.75 1.5 4.08579 1.5 4.5C1.5 4.91421 1.16421 5.25 0.75 5.25C0.335786 5.25 9.6915e-07 4.91421 1.00536e-06 4.5ZM1.25 0.5C0.835786 0.5 0.5 0.835786 0.5 1.25C0.5 1.66421 0.835786 2 1.25 2C1.66421 2 2 1.66421 2 1.25C2 0.835787 1.66421 0.5 1.25 0.5ZM3.75 0.75C3.75 0.335787 4.08579 -8.78997e-08 4.5 -5.16879e-08C4.91421 -1.54763e-08 5.25 0.335787 5.25 0.75C5.25 1.16421 4.91421 1.5 4.5 1.5C4.08579 1.5 3.75 1.16421 3.75 0.75Z"
    />
  ),
})

export const InsertLeftIcon = makeIcon({
  displayName: 'InsertLeft',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 0C1.00736 0 0 1.00736 0 2.25V13.75C0 14.9926 1.00736 16 2.25 16H8.25H9V15.25V0.75V0H8.25H2.25ZM1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H7.5V14.5H2.25C1.83579 14.5 1.5 14.1642 1.5 13.75V2.25ZM11.5 1.5C11.9142 1.5 12.25 1.16421 12.25 0.75C12.25 0.335786 11.9142 0 11.5 0C11.0858 0 10.75 0.335786 10.75 0.75C10.75 1.16421 11.0858 1.5 11.5 1.5ZM14.75 2C15.1642 2 15.5 1.66421 15.5 1.25C15.5 0.835786 15.1642 0.5 14.75 0.5C14.3358 0.5 14 0.835786 14 1.25C14 1.66421 14.3358 2 14.75 2ZM16 4.5C16 4.91421 15.6642 5.25 15.25 5.25C14.8358 5.25 14.5 4.91421 14.5 4.5C14.5 4.08579 14.8358 3.75 15.25 3.75C15.6642 3.75 16 4.08579 16 4.5ZM15.25 8.75C15.6642 8.75 16 8.41421 16 8C16 7.58579 15.6642 7.25 15.25 7.25C14.8358 7.25 14.5 7.58579 14.5 8C14.5 8.41421 14.8358 8.75 15.25 8.75ZM16 11.5C16 11.9142 15.6642 12.25 15.25 12.25C14.8358 12.25 14.5 11.9142 14.5 11.5C14.5 11.0858 14.8358 10.75 15.25 10.75C15.6642 10.75 16 11.0858 16 11.5ZM14.75 15.5C15.1642 15.5 15.5 15.1642 15.5 14.75C15.5 14.3358 15.1642 14 14.75 14C14.3358 14 14 14.3358 14 14.75C14 15.1642 14.3358 15.5 14.75 15.5ZM12.25 15.25C12.25 15.6642 11.9142 16 11.5 16C11.0858 16 10.75 15.6642 10.75 15.25C10.75 14.8358 11.0858 14.5 11.5 14.5C11.9142 14.5 12.25 14.8358 12.25 15.25Z"
    />
  ),
})

export const InsertTopIcon = makeIcon({
  displayName: 'InsertTop',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2.25C16 1.00736 14.9926 -4.40331e-08 13.75 -9.83506e-08L2.25 -6.01031e-07C1.00736 -6.55349e-07 -4.40333e-08 1.00736 -9.83509e-08 2.25L-3.60619e-07 8.25L-3.93402e-07 9L0.75 9L15.25 9L16 9L16 8.25L16 2.25ZM13.75 1.5C14.1642 1.5 14.5 1.83579 14.5 2.25L14.5 7.5L1.5 7.5L1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5L13.75 1.5ZM14.5 11.5C14.5 11.9142 14.8358 12.25 15.25 12.25C15.6642 12.25 16 11.9142 16 11.5C16 11.0858 15.6642 10.75 15.25 10.75C14.8358 10.75 14.5 11.0858 14.5 11.5ZM14 14.75C14 15.1642 14.3358 15.5 14.75 15.5C15.1642 15.5 15.5 15.1642 15.5 14.75C15.5 14.3358 15.1642 14 14.75 14C14.3358 14 14 14.3358 14 14.75ZM11.5 16C11.0858 16 10.75 15.6642 10.75 15.25C10.75 14.8358 11.0858 14.5 11.5 14.5C11.9142 14.5 12.25 14.8358 12.25 15.25C12.25 15.6642 11.9142 16 11.5 16ZM7.25 15.25C7.25 15.6642 7.58579 16 8 16C8.41421 16 8.75 15.6642 8.75 15.25C8.75 14.8358 8.41421 14.5 8 14.5C7.58579 14.5 7.25 14.8358 7.25 15.25ZM4.5 16C4.08579 16 3.75 15.6642 3.75 15.25C3.75 14.8358 4.08579 14.5 4.5 14.5C4.91421 14.5 5.25 14.8358 5.25 15.25C5.25 15.6642 4.91421 16 4.5 16ZM0.499999 14.75C0.499999 15.1642 0.835786 15.5 1.25 15.5C1.66421 15.5 2 15.1642 2 14.75C2 14.3358 1.66421 14 1.25 14C0.835786 14 0.499999 14.3358 0.499999 14.75ZM0.749999 12.25C0.335786 12.25 -5.20787e-07 11.9142 -5.02681e-07 11.5C-4.84575e-07 11.0858 0.335786 10.75 0.75 10.75C1.16421 10.75 1.5 11.0858 1.5 11.5C1.5 11.9142 1.16421 12.25 0.749999 12.25Z"
    />
  ),
})

export const InsertBottomIcon = makeIcon({
  displayName: 'InsertBottom',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.68312e-08 13.75C1.20129e-08 14.9926 1.00736 16 2.25 16L13.75 16C14.9926 16 16 14.9926 16 13.75L16 7.75L16 7L15.25 7L0.75 7L1.07324e-07 7L9.83805e-08 7.75L2.68312e-08 13.75ZM2.25 14.5C1.83579 14.5 1.5 14.1642 1.5 13.75L1.5 8.5L14.5 8.5L14.5 13.75C14.5 14.1642 14.1642 14.5 13.75 14.5L2.25 14.5ZM1.5 4.5C1.5 4.08579 1.16421 3.75 0.75 3.75C0.335786 3.75 1.42076e-07 4.08579 1.37136e-07 4.5C1.32197e-07 4.91421 0.335786 5.25 0.75 5.25C1.16421 5.25 1.5 4.91421 1.5 4.5ZM2 1.25C2 0.835786 1.66421 0.5 1.25 0.5C0.835786 0.5 0.5 0.835786 0.5 1.25C0.5 1.66421 0.835786 2 1.25 2C1.66421 2 2 1.66421 2 1.25ZM4.5 5.36622e-08C4.91421 5.86016e-08 5.25 0.335786 5.25 0.75C5.25 1.16421 4.91421 1.5 4.5 1.5C4.08579 1.5 3.75 1.16421 3.75 0.75C3.75 0.335786 4.08579 4.87227e-08 4.5 5.36622e-08ZM8.75 0.75C8.75 0.335786 8.41421 1.00338e-07 8 9.5399e-08C7.58579 9.04596e-08 7.25 0.335787 7.25 0.75C7.25 1.16421 7.58579 1.5 8 1.5C8.41421 1.5 8.75 1.16421 8.75 0.75ZM11.5 1.37136e-07C11.9142 1.42076e-07 12.25 0.335787 12.25 0.75C12.25 1.16421 11.9142 1.5 11.5 1.5C11.0858 1.5 10.75 1.16421 10.75 0.75C10.75 0.335786 11.0858 1.32197e-07 11.5 1.37136e-07ZM15.5 1.25C15.5 0.835787 15.1642 0.5 14.75 0.5C14.3358 0.5 14 0.835787 14 1.25C14 1.66421 14.3358 2 14.75 2C15.1642 2 15.5 1.66421 15.5 1.25ZM15.25 3.75C15.6642 3.75 16 4.08579 16 4.5C16 4.91421 15.6642 5.25 15.25 5.25C14.8358 5.25 14.5 4.91421 14.5 4.5C14.5 4.08579 14.8358 3.75 15.25 3.75Z"
    />
  ),
})

export const FilterSortDescIcon = makeIcon({
  displayName: 'FilterSortDescIcon',
  viewBox: 16,
  content: (
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M14.293 10.537a1 1 0 001.414-1.414L12.944 6.36a.998.998 0 00-1.128-.293.996.996 0 00-.352.227L8.636 9.123a1 1 0 101.414 1.414l1.126-1.125V15a1 1 0 102 0V9.42l1.117 1.117z" />
      <path d="M0 1a1 1 0 011-1h14a1 1 0 011 1v2.5a1 1 0 01-.232.64l-.686.823a1 1 0 11-1.536-1.28L14 3.138V2H2v1.113l4.74 5.214A1 1 0 017 9v4.382l1.053-.526a1 1 0 11.894 1.788l-2.5 1.25A1 1 0 015 15V9.387L.26 4.173A1 1 0 010 3.5V1z" />
    </g>
  ),
  smallAlternative: FilterSortDescSmallIcon,
})

export const FilterSortAscIcon = makeIcon({
  displayName: 'FilterSortAscIcon',
  viewBox: 16,
  content: (
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M10.05 11.463a1 1 0 00-1.414 1.414l2.763 2.763a.998.998 0 001.128.293.997.997 0 00.352-.227l2.828-2.829a1 1 0 00-1.414-1.414l-1.126 1.125V7a1 1 0 00-2 0v5.58l-1.117-1.117z" />
      <path d="M0 1a1 1 0 011-1h14a1 1 0 011 1v2.5a1 1 0 01-.232.64l-.686.823a1 1 0 11-1.536-1.28L14 3.138V2H2v1.113l4.74 5.214A1 1 0 017 9v4.5a1 1 0 01.447 1.894l-1 .5A1 1 0 015 15V9.387L.26 4.173A1 1 0 010 3.5V1z" />
    </g>
  ),
  smallAlternative: FilterSortAscSmallIcon,
})

export const MailUnreadIcon = makeIcon({
  displayName: 'MailUnread',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 1.75C1.00736 1.75 0 2.75736 0 4V12C0 13.2426 1.00736 14.25 2.25 14.25H13.75C14.9926 14.25 16 13.2426 16 12V4C16 2.75736 14.9926 1.75 13.75 1.75H2.25ZM1.5 4.22568V12C1.5 12.4142 1.83579 12.75 2.25 12.75H13.75C14.1642 12.75 14.5 12.4142 14.5 12V4.2257L9.49483 8.67474C8.64233 9.43251 7.35768 9.43251 6.50519 8.67474L1.5 4.22568ZM13.3399 3.25H2.66016L7.50173 7.55362C7.7859 7.80622 8.21412 7.80622 8.49828 7.55363L13.3399 3.25Z"
    />
  ),
})

export const OpenDetachedModeIcon = makeIcon({
  displayName: 'OpenDetachedMode',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M4 3a.75.75 0 1 1-1.5 0A.75.75 0 0 1 4 3ZM6 3a.75.75 0 1 1-1.5 0A.75.75 0 0 1 6 3ZM7.25 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0 2.25A2.25 2.25 0 0 1 2.25 0h11.5A2.25 2.25 0 0 1 16 2.25v11.5A2.25 2.25 0 0 1 13.75 16H9.5a.75.75 0 0 1 0-1.5h4.25a.75.75 0 0 0 .75-.75V6h-13v1A.75.75 0 0 1 0 7V2.25ZM1.5 4.5h13V2.25a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75V4.5Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.086 10.75.47 14.366a.75.75 0 0 0 1.06 1.06l3.662-3.661c.021-.02.04-.043.058-.065V14a.75.75 0 0 0 1.5 0v-4A.75.75 0 0 0 6 9.25H2a.75.75 0 0 0 0 1.5h2.086Zm1.148 0 .016.019v-.019h-.016Z"
        clipRule="evenodd"
      />
    </g>
  ),
})

export const MailReadIcon = makeIcon({
  displayName: 'MailRead',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16557 1.81929C7.64041 1.39357 8.35959 1.39357 8.83443 1.81929L13.7309 6.20921L8.76215 10.0313C8.31283 10.3769 7.68718 10.3769 7.23787 10.0313L2.26913 6.2092L7.16557 1.81929ZM1.5 7.51001V13.0639C1.5 13.202 1.61193 13.3139 1.75 13.3139H14.25C14.3881 13.3139 14.5 13.202 14.5 13.0639V7.51002L9.67671 11.2202C8.68822 11.9806 7.31179 11.9806 6.3233 11.2202L1.5 7.51001ZM9.83575 0.702435C8.7911 -0.234143 7.2089 -0.234146 6.16425 0.702433L0.581796 5.70739C0.211548 6.03934 0 6.51313 0 7.01039V13.0639C0 14.0304 0.783501 14.8139 1.75 14.8139H14.25C15.2165 14.8139 16 14.0304 16 13.0639V7.01039C16 6.51313 15.7885 6.03934 15.4182 5.70739L9.83575 0.702435Z"
    />
  ),
})

export const EyeCrossedIcon = makeIcon({
  displayName: 'EyeCrossed',
  viewBox: 16,
  content: (
    <g>
      <path d="M8 9.99996C9.38071 9.99996 10.5 8.88067 10.5 7.49996C10.5 6.80061 10.2128 6.16833 9.75 5.7146L6.25 9.28532C6.70094 9.72738 7.31864 9.99996 8 9.99996Z" />
      <path d="M1.80877 7.66617C1.72682 7.79242 1.65822 7.90508 1.6028 8C1.63915 8.06226 1.68119 8.13218 1.72895 8.20857C1.94152 8.54854 2.26463 9.01207 2.70209 9.49846C2.97908 9.80643 2.95397 10.2806 2.646 10.5576C2.33803 10.8346 1.86382 10.8095 1.58682 10.5015C1.07974 9.93775 0.705625 9.40128 0.457098 9.0038C0.318968 8.78288 0.184066 8.55678 0.0721966 8.32106C-0.0240656 8.11784 -0.0240655 7.88216 0.0721967 7.67894C0.219762 7.39503 0.376196 7.11814 0.550603 6.84946C0.861107 6.37112 1.3306 5.73374 1.96967 5.09467C3.24804 3.8163 5.24029 2.5 8 2.5C8.37951 2.5 8.74571 2.52499 9.09857 2.57177C9.50919 2.62621 9.79793 3.00322 9.74349 3.41384C9.68905 3.82446 9.31205 4.1132 8.90143 4.05876C8.61381 4.02063 8.31346 4 8 4C5.75971 4 4.12696 5.0587 3.03033 6.15533C2.4819 6.70376 2.07639 7.25388 1.80877 7.66617Z" />
      <path d="M11.1022 3.88573C11.311 3.52797 11.7702 3.40716 12.128 3.61591C13.4345 4.37821 14.3795 5.39121 14.9942 6.20181C15.5349 6.91483 15.8317 7.48518 15.9084 7.63912C16.015 7.85325 16.0318 8.10148 15.9278 8.32106C15.7861 8.60732 15.6233 8.88271 15.4494 9.15054C15.1389 9.62888 14.6694 10.2663 14.0303 10.9053C12.752 12.1837 10.7597 13.5 8 13.5C6.37444 13.5 5.0083 13.0418 3.89786 12.3991C3.53937 12.1916 3.41697 11.7328 3.62448 11.3743C3.83198 11.0158 4.29081 10.8934 4.6493 11.1009C5.55966 11.6278 6.66919 12 8 12C10.2403 12 11.873 10.9413 12.9697 9.84467C13.5181 9.29624 13.9236 8.74612 14.1912 8.33383C14.2732 8.20758 14.3418 8.09491 14.3972 8C14.2686 7.77974 14.0698 7.4653 13.799 7.1082C13.2615 6.39944 12.4565 5.54429 11.372 4.9115C11.0143 4.70275 10.8935 4.2435 11.1022 3.88573Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2197 0.719671C14.5126 0.426779 14.9874 0.426779 15.2803 0.719672C15.5732 1.01257 15.5732 1.48744 15.2803 1.78033L1.78033 15.2803C1.48743 15.5732 1.01256 15.5732 0.719666 15.2803C0.426773 14.9874 0.426773 14.5126 0.719666 14.2197L14.2197 0.719671Z"
      />
    </g>
  ),
  smallAlternative: EyeCrossedSmallIcon,
})

export const BellIcon = makeIcon({
  displayName: 'BellIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59657 13.7954C6.34716 13.4681 5.87988 13.4027 5.55004 13.65C5.21867 13.8986 5.15152 14.3687 5.40004 14.7L6.00004 14.25C5.40004 14.7 5.40022 14.7003 5.4004 14.7005L5.40078 14.701L5.4016 14.7021L5.40345 14.7046L5.40803 14.7105C5.41148 14.715 5.41572 14.7205 5.42074 14.7268C5.43077 14.7395 5.44395 14.7558 5.46023 14.7752C5.49274 14.8139 5.5379 14.8654 5.59527 14.9252C5.70941 15.0443 5.87543 15.2004 6.09017 15.3566C6.51674 15.6668 7.1684 16 8.00004 16C8.83169 16 9.48334 15.6668 9.90992 15.3566C10.1247 15.2004 10.2907 15.0443 10.4048 14.9252C10.4622 14.8654 10.5073 14.8139 10.5399 14.7752C10.5561 14.7558 10.5693 14.7395 10.5794 14.7268C10.5844 14.7205 10.5886 14.715 10.5921 14.7105L10.5966 14.7046L10.5985 14.7021L10.5997 14.7005C10.5999 14.7003 10.6 14.7 10 14.25L10.6 14.7C10.8486 14.3687 10.7814 13.8986 10.45 13.65C10.1202 13.4027 9.65294 13.4681 9.40352 13.7954C9.40361 13.7953 9.40345 13.7955 9.40352 13.7954C9.40248 13.7968 9.40143 13.7982 9.40039 13.7996L9.40072 13.7992L9.40132 13.7983L9.40235 13.797L9.40352 13.7954C9.40196 13.7974 9.39757 13.8029 9.3909 13.8109C9.37751 13.8268 9.3543 13.8535 9.32183 13.8874C9.25628 13.9558 9.15668 14.0497 9.02767 14.1435C8.76674 14.3333 8.4184 14.5 8.00004 14.5C7.58169 14.5 7.23334 14.3333 6.97242 14.1435C6.84341 14.0497 6.74381 13.9558 6.67825 13.8874C6.64579 13.8535 6.62258 13.8268 6.60919 13.8109C6.60252 13.8029 6.59814 13.7974 6.59657 13.7954C6.59664 13.7955 6.59649 13.7953 6.59657 13.7954Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00235 1.5C5.855 1.5 4.24835 3.12726 4.24835 5.5V8.75C4.24835 8.89143 4.20837 9.02997 4.13301 9.14964L4.12284 9.16582L4.09301 9.2134C4.0671 9.25478 4.02973 9.31462 3.9841 9.38804C3.89277 9.53502 3.76874 9.73585 3.63763 9.95177C3.39293 10.3547 3.14851 10.7699 3.03059 11H8.00235V11.75V12.5H2.97502C2.4781 12.5 2.03579 12.2425 1.77178 11.8754C1.49506 11.4906 1.39285 10.9519 1.63948 10.4297C1.77787 10.1367 2.09637 9.59997 2.35549 9.17323C2.49004 8.95165 2.61691 8.74623 2.71006 8.59633C2.72355 8.57462 2.73634 8.55406 2.74835 8.53477V5.5C2.74835 2.37274 4.95456 0 8.00235 0C11.0763 0 13.2495 2.65084 13.2495 5.5V8.54513L14.326 10.3687C14.3471 10.4045 14.3653 10.4419 14.3802 10.4807L13.6802 10.75C14.3802 10.4807 14.3803 10.481 14.3804 10.4814L14.3807 10.4821L14.3812 10.4835L14.3825 10.4867L14.3853 10.4944C14.3864 10.4975 14.3877 10.5009 14.389 10.5047C14.3901 10.5077 14.3913 10.511 14.3925 10.5145C14.3979 10.5299 14.4044 10.5496 14.4116 10.5729C14.4258 10.6192 14.4431 10.6822 14.4583 10.757C14.487 10.8985 14.5165 11.1214 14.4769 11.3687C14.4354 11.6271 14.3119 11.9407 14.0135 12.1794C13.7223 12.4123 13.3566 12.5 12.975 12.5H8.00235V11.75V11H12.9568L11.8536 9.13128C11.7854 9.01579 11.7495 8.88412 11.7495 8.74999V5.5C11.7495 3.34916 10.1235 1.5 8.00235 1.5Z"
      />
    </g>
  ),
})

export const BellCrossedIcon = makeIcon({
  displayName: 'BellCrossedIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02817 1.5C4.88082 1.5 3.27417 3.12726 3.27417 5.5V8.75C3.27417 8.89143 3.23418 9.02997 3.15882 9.14964L3.13017 9.19529L3.05038 9.32301C2.9827 9.43165 2.88882 9.58305 2.78411 9.75395C2.57281 10.0988 2.32423 10.5121 2.15647 10.8141C1.95536 11.1763 1.49877 11.3068 1.13666 11.1056C0.774546 10.9045 0.644033 10.4479 0.84515 10.0858C1.02968 9.75359 1.29277 9.31686 1.50508 8.97033C1.6106 8.79809 1.70526 8.6454 1.77417 8.53477V5.5C1.77417 2.37274 3.98037 0 7.02817 0C8.2109 0 9.27369 0.399369 10.1258 1.05661C10.4538 1.30958 10.5146 1.78055 10.2617 2.10854C10.0087 2.43653 9.53773 2.49734 9.20974 2.24437C8.60636 1.779 7.86252 1.5 7.02817 1.5ZM12.0716 3.9899L13.7811 2.28035C14.074 1.98746 14.074 1.51258 13.7811 1.21969C13.4882 0.926798 13.0134 0.926798 12.7205 1.21969L0.69965 13.2405C0.406757 13.5334 0.406757 14.0083 0.69965 14.3012C0.992544 14.5941 1.46742 14.5941 1.76031 14.3012L3.56148 12.5H7.02834H12.0008C12.3824 12.5 12.7481 12.4123 13.0393 12.1794C13.3377 11.9407 13.4613 11.6271 13.5027 11.3687C13.5423 11.1214 13.5128 10.8985 13.4841 10.757C13.4689 10.6822 13.4516 10.6192 13.4374 10.5729C13.4302 10.5496 13.4237 10.5299 13.4183 10.5145L13.4111 10.4944L13.4083 10.4867L13.4071 10.4835L13.4065 10.4821L13.4062 10.4814C13.4061 10.481 13.406 10.4807 12.706 10.75L13.406 10.4807C13.3911 10.4419 13.373 10.4045 13.3518 10.3687L12.2753 8.54513V5.5C12.2753 4.98264 12.2047 4.47486 12.0716 3.9899ZM10.7701 5.29139L5.06148 11H7.02821H11.9826L10.8794 9.13128C10.8112 9.01579 10.7753 8.88412 10.7753 8.74999V5.5C10.7753 5.43022 10.7735 5.36067 10.7701 5.29139ZM5.59737 13.7954C5.34795 13.468 4.88067 13.4026 4.55084 13.65C4.21947 13.8985 4.15231 14.3686 4.40084 14.7L5.00084 14.25C4.40084 14.7 4.40102 14.7003 4.4012 14.7005L4.40158 14.701L4.4024 14.7021L4.40424 14.7045L4.40883 14.7105L4.42153 14.7268C4.43157 14.7394 4.44475 14.7557 4.46103 14.7751C4.49354 14.8139 4.53869 14.8653 4.59607 14.9252C4.7102 15.0443 4.87623 15.2004 5.09096 15.3566C5.51754 15.6668 6.16919 16 7.00084 16C7.83249 16 8.48414 15.6668 8.91072 15.3566C9.12545 15.2004 9.29148 15.0443 9.40561 14.9252C9.46299 14.8653 9.50815 14.8139 9.54065 14.7751C9.55693 14.7557 9.57012 14.7394 9.58015 14.7268L9.59285 14.7105L9.59744 14.7045L9.59929 14.7021L9.60048 14.7005C9.60066 14.7003 9.60084 14.7 9.00084 14.25L9.60084 14.7C9.84937 14.3686 9.78221 13.8985 9.45084 13.65C9.12101 13.4026 8.65374 13.468 8.40432 13.7954C8.40276 13.7974 8.39836 13.8029 8.39169 13.8108C8.3783 13.8268 8.3551 13.8535 8.32263 13.8873C8.25708 13.9557 8.15748 14.0496 8.02846 14.1435C7.76754 14.3332 7.41919 14.5 7.00084 14.5C6.58249 14.5 6.23414 14.3332 5.97322 14.1435C5.8442 14.0496 5.7446 13.9557 5.67905 13.8873C5.64658 13.8535 5.62338 13.8268 5.60999 13.8108C5.60332 13.8029 5.59893 13.7974 5.59737 13.7954Z"
      />
    </g>
  ),
})

export const BellSnoozeIcon = makeIcon({
  displayName: 'BellSnoozeIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.597 13.795A.75.75 0 004.4 14.7l.6-.45-.6.45v.001l.002.001.001.002.005.006.013.017.04.048a3.718 3.718 0 00.63.581C5.516 15.667 6.167 16 7 16c.832 0 1.483-.333 1.91-.643a3.718 3.718 0 00.67-.63l.012-.017.005-.006.001-.002.001-.001S9.6 14.7 9 14.25l.6.45a.75.75 0 00-1.2-.9l.001-.002.001-.001.001-.001a2.222 2.222 0 01-.376.348c-.26.19-.609.356-1.027.356-.418 0-.767-.167-1.028-.357a2.222 2.222 0 01-.375-.348zM8.25 1A.75.75 0 019 .25h3a.75.75 0 01.6 1.2l-2.1 2.8H12a.75.75 0 010 1.5H9a.75.75 0 01-.6-1.2l2.1-2.8H9A.75.75 0 018.25 1zM6.21.755a.75.75 0 01-.463.954C4.295 2.21 3.273 3.61 3.273 5.5v3.25a.75.75 0 01-.115.4l-.01.016-.03.047a65.06 65.06 0 00-.455.739c-.245.403-.49.818-.607 1.048h4.971v1.5H2c-.497 0-.94-.258-1.203-.625a1.414 1.414 0 01-.132-1.445c.138-.293.456-.83.716-1.257a66.995 66.995 0 01.392-.638V5.5c0-2.462 1.366-4.476 3.484-5.209a.75.75 0 01.954.464zM11.983 11H7.027v1.5H12c.382 0 .747-.088 1.039-.32.298-.24.421-.553.463-.811.04-.248.01-.47-.019-.612a1.965 1.965 0 00-.066-.242l-.007-.02-.002-.008-.002-.004s0-.002-.7.267l.7-.27a.755.755 0 00-.055-.111l-1.033-1.75a.75.75 0 00-1.292.762L11.982 11z"
      />
    </g>
  ),
})

export const BellWithDotIcon: React.FC<
  IconBaseProps & {
    decoratorClassName?: string
  }
> = ({ decoratorClassName, ...rest }) => (
  <IconBase {...rest}>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59655 13.7954C6.34714 13.468 5.87986 13.4026 5.55003 13.65C5.21866 13.8985 5.1515 14.3686 5.40003 14.7L6.00003 14.25C5.40003 14.7 5.40003 14.7 5.40003 14.7L5.40077 14.701L5.40158 14.702L5.40343 14.7045L5.40802 14.7105L5.42072 14.7267C5.43076 14.7394 5.44394 14.7557 5.46022 14.7751C5.49273 14.8138 5.53788 14.8653 5.59526 14.9252C5.70939 15.0443 5.87542 15.2004 6.09015 15.3565C6.51673 15.6668 7.16838 16 8.00003 16C8.83168 16 9.48333 15.6668 9.90991 15.3565C10.1246 15.2004 10.2907 15.0443 10.4048 14.9252C10.4622 14.8653 10.5073 14.8138 10.5398 14.7751C10.5561 14.7557 10.5693 14.7394 10.5793 14.7267L10.592 14.7105L10.5966 14.7045L10.5985 14.702L10.5993 14.701C10.5993 14.701 10.6 14.7 10 14.25L10.6 14.7C10.8486 14.3686 10.7814 13.8985 10.45 13.65C10.1188 13.4016 9.64899 13.4686 9.40037 13.7995L9.40131 13.7983L9.40234 13.7969L9.40327 13.7957C9.4017 13.7977 9.39755 13.8029 9.39088 13.8108C9.37749 13.8268 9.35429 13.8534 9.32182 13.8873C9.25627 13.9557 9.15667 14.0496 9.02765 14.1434C8.76673 14.3332 8.41838 14.5 8.00003 14.5C7.58168 14.5 7.23333 14.3332 6.97241 14.1434C6.84339 14.0496 6.74379 13.9557 6.67824 13.8873C6.64577 13.8534 6.62257 13.8268 6.60918 13.8108C6.60251 13.8029 6.59812 13.7974 6.59655 13.7954Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.21094 0.754883C7.34636 1.14633 7.13881 1.57345 6.74736 1.70887C5.29505 2.21128 4.27338 3.60999 4.27338 5.50003V8.75003C4.27338 8.89145 4.23339 9.03 4.15804 9.14966L4.14786 9.16585L4.11803 9.21343C4.09213 9.25481 4.05475 9.31465 4.00912 9.38807C3.91779 9.53505 3.79376 9.73588 3.66265 9.9518C3.41796 10.3548 3.17353 10.7699 3.05562 11H8.02738V12.5H3.00005C2.50312 12.5 2.06081 12.2425 1.7968 11.8754C1.52009 11.4906 1.41787 10.9519 1.66451 10.4297C1.80289 10.1367 2.12139 9.6 2.38051 9.17326C2.51506 8.95168 2.64193 8.74626 2.73508 8.59636C2.74857 8.57465 2.76136 8.55409 2.77338 8.5348V5.50003C2.77338 3.03811 4.13894 1.02401 6.25696 0.291297C6.64841 0.155877 7.07552 0.363431 7.21094 0.754883ZM12.9818 11H8.02738V12.5H13C13.3816 12.5 13.7474 12.4124 14.0385 12.1794C14.3369 11.9408 14.4605 11.6271 14.5019 11.3687C14.5415 11.1215 14.512 10.8985 14.4833 10.757C14.4681 10.6822 14.4508 10.6193 14.4366 10.573C14.4294 10.5496 14.4229 10.53 14.4175 10.5145L14.4103 10.4944L14.4075 10.4868L14.4063 10.4835L14.4057 10.4821C14.4057 10.4821 14.4052 10.4807 13.7052 10.75L14.4052 10.4807C14.3903 10.442 14.3722 10.4045 14.3511 10.3687L13.318 8.6188C13.1074 8.26211 12.6475 8.14365 12.2908 8.35423C11.9341 8.56481 11.8157 9.02467 12.0263 9.38136L12.9818 11Z"
      />
      <path
        d="M14.5 3.5C14.5 5.15685 13.1569 6.5 11.5 6.5C9.84315 6.5 8.5 5.15685 8.5 3.5C8.5 1.84315 9.84315 0.5 11.5 0.5C13.1569 0.5 14.5 1.84315 14.5 3.5Z"
        fill="currentColor"
        className={decoratorClassName}
      />
    </g>
  </IconBase>
)

export const DesktopIcon = makeIcon({
  displayName: 'DesktopIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.25C0 1.00736 1.00736 0 2.25 0H13.75C14.9926 0 16 1.00736 16 2.25V10.75C16 11.9926 14.9926 13 13.75 13H10.25V14.5H11.75C12.1642 14.5 12.5 14.8358 12.5 15.25C12.5 15.6642 12.1642 16 11.75 16H4.25C3.83579 16 3.5 15.6642 3.5 15.25C3.5 14.8358 3.83579 14.5 4.25 14.5H5.75V13H2.25C1.00736 13 0 11.9926 0 10.75V9.5V2.25ZM1.5 10.25V10.75C1.5 11.1642 1.83579 11.5 2.25 11.5H6.5H9.5H13.75C14.1642 11.5 14.5 11.1642 14.5 10.75V10.25H1.5ZM14.5 8.75H1.5V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H13.75C14.1642 1.5 14.5 1.83579 14.5 2.25V8.75ZM8.75 13V14.5H7.25V13H8.75Z"
      />
    </g>
  ),
})

export const MobileIcon = makeIcon({
  displayName: 'MobileIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0C3.25736 0 2.25 1.00736 2.25 2.25V13.75C2.25 14.9926 3.25736 16 4.5 16H11.5C12.7426 16 13.75 14.9926 13.75 13.75V2.25C13.75 1.00736 12.7426 0 11.5 0H4.5ZM3.75 2.25C3.75 1.83579 4.08579 1.5 4.5 1.5H11.5C11.9142 1.5 12.25 1.83579 12.25 2.25V13.75C12.25 14.1642 11.9142 14.5 11.5 14.5H4.5C4.08579 14.5 3.75 14.1642 3.75 13.75V2.25ZM8 11.5C7.30964 11.5 6.75 12.0596 6.75 12.75C6.75 13.4404 7.30964 14 8 14C8.69036 14 9.25 13.4404 9.25 12.75C9.25 12.0596 8.69036 11.5 8 11.5ZM8.25 12.75C8.25 12.8881 8.13807 13 8 13C7.86193 13 7.75 12.8881 7.75 12.75C7.75 12.6119 7.86193 12.5 8 12.5C8.13807 12.5 8.25 12.6119 8.25 12.75Z"
      />
    </g>
  ),
})

export const SettingsIcon = makeIcon({
  displayName: 'SettingsIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 3.25H13.3855C13.067 2.23572 12.1194 1.5 11 1.5C9.88059 1.5 8.93302 2.23572 8.61445 3.25H0.75C0.335786 3.25 0 3.58579 0 4C0 4.41421 0.335786 4.75 0.75 4.75H8.61445C8.93302 5.76428 9.88059 6.5 11 6.5C12.1194 6.5 13.067 5.76428 13.3855 4.75H15.25C15.6642 4.75 16 4.41421 16 4C16 3.58579 15.6642 3.25 15.25 3.25ZM11 5C10.7464 5 10.5148 4.90559 10.3385 4.75C10.1309 4.56676 10 4.29867 10 4C10 3.70133 10.1309 3.43324 10.3385 3.25C10.5148 3.09441 10.7464 3 11 3C11.2536 3 11.4852 3.09441 11.6615 3.25C11.8691 3.43324 12 3.70133 12 4C12 4.29867 11.8691 4.56676 11.6615 4.75C11.4852 4.90559 11.2536 5 11 5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 11.25H2.61445C2.93302 10.2357 3.88059 9.5 5 9.5C6.11941 9.5 7.06698 10.2357 7.38555 11.25H15.25C15.6642 11.25 16 11.5858 16 12C16 12.4142 15.6642 12.75 15.25 12.75H7.38555C7.06698 13.7643 6.11941 14.5 5 14.5C3.88059 14.5 2.93302 13.7643 2.61445 12.75H0.75C0.335787 12.75 0 12.4142 0 12C0 11.5858 0.335787 11.25 0.75 11.25ZM5 13C5.25361 13 5.48517 12.9056 5.66146 12.75C5.86906 12.5668 6 12.2987 6 12C6 11.7013 5.86906 11.4332 5.66146 11.25C5.48517 11.0944 5.25361 11 5 11C4.74639 11 4.51483 11.0944 4.33854 11.25C4.13094 11.4332 4 11.7013 4 12C4 12.2987 4.13094 12.5668 4.33854 12.75C4.51483 12.9056 4.74639 13 5 13Z"
      />
    </g>
  ),
  smallAlternative: SettingsSmallIcon,
})

export const GrabIcon = makeIcon({
  displayName: 'GrabIcon',
  content: (
    <g>
      <rect x="3.5" y="3.5" width="3" height="3" rx="1" fill="currentColor" />
      <rect x="3.5" y="9.5" width="3" height="3" rx="1" fill="currentColor" />
      <rect x="9.5" y="3.5" width="3" height="3" rx="1" fill="currentColor" />
      <rect x="9.5" y="9.5" width="3" height="3" rx="1" fill="currentColor" />
    </g>
  ),
  smallAlternative: GrabSmallIcon,
})

export const PrintIcon = makeIcon({
  displayName: 'PrintIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 1.5C5.11193 1.5 5 1.61193 5 1.75V4.25H11V2.93455C11 2.86526 10.9712 2.79907 10.9206 2.75179L9.65142 1.56724C9.60512 1.52403 9.54416 1.5 9.48084 1.5H5.25ZM3.5 1.75V4.25H1.75C0.783502 4.25 0 5.0335 0 6V11C0 11.9665 0.783502 12.75 1.75 12.75H2C2.41421 12.75 2.75 12.4142 2.75 12C2.75 11.5858 2.41421 11.25 2 11.25H1.75C1.61193 11.25 1.5 11.1381 1.5 11V6C1.5 5.86193 1.61193 5.75 1.75 5.75H14.25C14.3881 5.75 14.5 5.86193 14.5 6V11C14.5 11.1381 14.3881 11.25 14.25 11.25H14C13.5858 11.25 13.25 11.5858 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75H14.25C15.2165 12.75 16 11.9665 16 11V6C16 5.0335 15.2165 4.25 14.25 4.25H12.5V2.93455C12.5 2.44949 12.2987 1.98618 11.9441 1.65521L10.6749 0.470653C10.3508 0.168208 9.9241 0 9.48084 0H5.25C4.2835 0 3.5 0.783502 3.5 1.75ZM3.5 10.25H3C2.58579 10.25 2.25 9.91421 2.25 9.5C2.25 9.08579 2.58579 8.75 3 8.75H13C13.4142 8.75 13.75 9.08579 13.75 9.5C13.75 9.91421 13.4142 10.25 13 10.25H12.5V14.25C12.5 15.2165 11.7165 16 10.75 16H5.25C4.2835 16 3.5 15.2165 3.5 14.25V10.25ZM5 10.25V14.25C5 14.3881 5.11193 14.5 5.25 14.5H10.75C10.8881 14.5 11 14.3881 11 14.25V10.25H5Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const AlignCenterImageIcon = makeIcon({
  displayName: 'AlignCenterImageIcon',
  content: (
    <g>
      <rect
        x="8.75"
        width="16"
        height="1.5"
        rx="0.75"
        transform="rotate(90 8.75 0)"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 3C10.25 2.58579 10.5858 2.25 11 2.25H14C14.9665 2.25 15.75 3.0335 15.75 4V12C15.75 12.9665 14.9665 13.75 14 13.75H11C10.5858 13.75 10.25 13.4142 10.25 13C10.25 12.5858 10.5858 12.25 11 12.25H14C14.1381 12.25 14.25 12.1381 14.25 12V4C14.25 3.86193 14.1381 3.75 14 3.75H11C10.5858 3.75 10.25 3.41421 10.25 3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 3C5.75 2.58579 5.41421 2.25 5 2.25H2C1.0335 2.25 0.25 3.0335 0.25 4V12C0.25 12.9665 1.0335 13.75 2 13.75H5C5.41421 13.75 5.75 13.4142 5.75 13C5.75 12.5858 5.41421 12.25 5 12.25H2C1.86193 12.25 1.75 12.1381 1.75 12V4C1.75 3.86193 1.86193 3.75 2 3.75H5C5.41421 3.75 5.75 3.41421 5.75 3Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const AlignLeftImageIcon = makeIcon({
  displayName: 'AlignLeftImageIcon',
  content: (
    <g>
      <rect
        x="1.5"
        width="16"
        height="1.5"
        rx="0.75"
        transform="rotate(90 1.5 0)"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4C3 3.0335 3.7835 2.25 4.75 2.25H14C14.9665 2.25 15.75 3.0335 15.75 4V12C15.75 12.9665 14.9665 13.75 14 13.75H4.75C3.7835 13.75 3 12.9665 3 12V4ZM4.75 3.75C4.61193 3.75 4.5 3.86193 4.5 4V12C4.5 12.1381 4.61193 12.25 4.75 12.25H14C14.1381 12.25 14.25 12.1381 14.25 12V4C14.25 3.86193 14.1381 3.75 14 3.75H4.75Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ChartIcon = makeIcon({
  displayName: 'ChartIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 16.5C2.08579 16.5 1.75 16.1642 1.75 15.75L1.75 5.25C1.75 4.83579 2.08579 4.5 2.5 4.5C2.91421 4.5 3.25 4.83579 3.25 5.25L3.25 15.75C3.25 16.1642 2.91421 16.5 2.5 16.5ZM8 16.5C7.58579 16.5 7.25 16.1642 7.25 15.75L7.25 1.25C7.25 0.835787 7.58579 0.5 8 0.5C8.41421 0.5 8.75 0.835787 8.75 1.25L8.75 15.75C8.75 16.1642 8.41421 16.5 8 16.5ZM12.75 15.75C12.75 16.1642 13.0858 16.5 13.5 16.5C13.9142 16.5 14.25 16.1642 14.25 15.75L14.25 7.75C14.25 7.33579 13.9142 7 13.5 7C13.0858 7 12.75 7.33579 12.75 7.75L12.75 15.75Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const PlayIcon = makeIcon({
  displayName: 'PlayIcon',
  viewBox: 18,
  content: (
    <path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z" />
  ),
})

export const PauseIcon = makeIcon({
  displayName: 'PauseIcon',
  viewBox: 18,
  content: (
    <path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm6 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z" />
  ),
})

export const AutoSizeColumnSpacingIcon = makeIcon({
  displayName: 'AutoSizeColumnSpacing',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 16C1.33579 16 0.999999 15.6642 0.999999 15.25L1 0.75C1 0.335786 1.33579 -5.08893e-08 1.75 -3.27835e-08C2.16421 -1.46777e-08 2.5 0.335786 2.5 0.75L2.5 15.25C2.5 15.6642 2.16421 16 1.75 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 12C6.83579 12 6.5 11.6642 6.5 11.25L6.5 4.75C6.5 4.33579 6.83579 4 7.25 4C7.66421 4 8 4.33579 8 4.75L8 11.25C8 11.6642 7.66421 12 7.25 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 16C12.3358 16 12 15.6642 12 15.25L12 0.75C12 0.335786 12.3358 -5.08893e-08 12.75 -3.27835e-08C13.1642 -1.46777e-08 13.5 0.335786 13.5 0.75L13.5 15.25C13.5 15.6642 13.1642 16 12.75 16Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const TwoColumnsIcon = makeIcon({
  displayName: 'TwoColumns',
  content: (
    <g>
      <path
        d="M0 13.75V2.25C0 1.00736 1.00736 6.84522e-08 2.25 0H8.75V16H2.25V14.5H7.25V1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5V16L2.01953 15.9883C0.885159 15.8729 0 14.9148 0 13.75Z"
        fill="currentColor"
      />
      <path
        d="M16 13.75V2.25C16 1.00736 14.9926 6.84522e-08 13.75 0H7.25V16H13.75V14.5H8.75V1.5H13.75C14.1642 1.5 14.5 1.83579 14.5 2.25V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5V16L13.9805 15.9883C15.1148 15.8729 16 14.9148 16 13.75Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ThreeColumnsIcon = makeIcon({
  displayName: 'ThreeColumns',
  content: (
    <g>
      <path
        d="M0 13.75V2.25C0 1.00736 1.00736 4.83192e-08 2.25 0H6.25V16H2.25V14.5H4.75V1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5V16C1.00736 16 0 14.9926 0 13.75Z"
        fill="currentColor"
      />
      <path
        d="M16 13.75V2.25C16 1.00736 14.9926 4.83192e-08 13.75 0H9.75V16H13.75V14.5H11.25V1.5H13.75C14.1642 1.5 14.5 1.83579 14.5 2.25V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5V16C14.9926 16 16 14.9926 16 13.75Z"
        fill="currentColor"
      />
      <path d="M11 0V1.5H5V0H11Z" fill="currentColor" />
      <path d="M11 14.5V16H5V14.5H11Z" fill="currentColor" />
    </g>
  ),
})

export const FourColumnsIcon = makeIcon({
  displayName: 'FourColumns',
  content: (
    <g>
      <path
        d="M0 13.75V2.25C0 1.08517 0.885159 0.127137 2.01953 0.0117188L2.25 0H5V16H2.25V14.5H3.5V1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5V16L2.01953 15.9883C0.885159 15.8729 0 14.9148 0 13.75Z"
        fill="currentColor"
      />
      <path
        d="M16 13.75V2.25C16 1.08517 15.1148 0.127137 13.9805 0.0117188L13.75 0H11V16H13.75V14.5H12.5V1.5H13.75C14.1642 1.5 14.5 1.83579 14.5 2.25V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5V16L13.9805 15.9883C15.1148 15.8729 16 14.9148 16 13.75Z"
        fill="currentColor"
      />
      <path
        d="M13 8.74228e-07V1.5L3 1.5L3 0L13 8.74228e-07Z"
        fill="currentColor"
      />
      <path d="M13 14.5V16H3V14.5H13Z" fill="currentColor" />
      <path d="M7.25 0H8.75V16H7.25V0Z" fill="currentColor" />
    </g>
  ),
})

export const MoonIcon = makeIcon({
  displayName: 'Moon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.15564 0.7197C6.36866 0.93273 6.43354 1.25255 6.32037 1.53175C6.02693 2.25574 5.86494 3.04787 5.86494 3.87982C5.86494 7.33457 8.66549 10.1351 12.1201 10.1351C12.9519 10.1351 13.7442 9.97295 14.4683 9.67949C14.7475 9.56634 15.0673 9.63123 15.2803 9.84425C15.4934 10.0573 15.5582 10.3771 15.4451 10.6563C14.2944 13.4955 11.5098 15.5 8.2552 15.5C3.97213 15.5 0.5 12.028 0.5 7.74478C0.5 4.49015 2.50455 1.70556 5.34359 0.554938C5.6228 0.44178 5.94261 0.50667 6.15564 0.7197ZM4.44157 2.78598C2.95618 3.93007 2 5.72626 2 7.74478C2 11.1995 4.80055 14 8.2552 14C10.2737 14 12.0699 13.0439 13.214 11.5584C12.8565 11.6089 12.4912 11.6351 12.1201 11.6351C7.83706 11.6351 4.36494 8.163 4.36494 3.87982C4.36494 3.50874 4.39105 3.14353 4.44157 2.78598Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const SunIcon = makeIcon({
  displayName: 'Sun',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
        fill="currentColor"
      />
      <path
        d="M15.25 7.25C15.6642 7.25 16 7.58579 16 8C16 8.41421 15.6642 8.75 15.25 8.75H14.25C13.8358 8.75 13.5 8.41421 13.5 8C13.5 7.58579 13.8358 7.25 14.25 7.25H15.25Z"
        fill="currentColor"
      />
      <path
        d="M1.75 7.25C2.16421 7.25 2.5 7.58579 2.5 8C2.5 8.41421 2.16421 8.75 1.75 8.75H0.75C0.335786 8.75 -3.23873e-08 8.41421 0 8C3.23877e-08 7.58579 0.335787 7.25 0.75 7.25H1.75Z"
        fill="currentColor"
      />
      <path
        d="M8.75 1.75C8.75 2.16421 8.41421 2.5 8 2.5C7.58579 2.5 7.25 2.16421 7.25 1.75V0.75C7.25 0.335786 7.58579 -3.66711e-08 8 0C8.41421 3.66711e-08 8.75 0.335787 8.75 0.75V1.75Z"
        fill="currentColor"
      />
      <path
        d="M8.75 15.25C8.75 15.6642 8.41421 16 8 16C7.58579 16 7.25 15.6642 7.25 15.25V14.25C7.25 13.8358 7.58579 13.5 8 13.5C8.41421 13.5 8.75 13.8358 8.75 14.25V15.25Z"
        fill="currentColor"
      />
      <path
        d="M13.6569 12.5962C13.9497 12.8891 13.9497 13.364 13.6569 13.6569C13.364 13.9497 12.8891 13.9497 12.5962 13.6569L11.8891 12.9497C11.5962 12.6569 11.5962 12.182 11.8891 11.8891C12.182 11.5962 12.6569 11.5962 12.9497 11.8891L13.6569 12.5962Z"
        fill="currentColor"
      />
      <path
        d="M4.11091 3.05025C4.40381 3.34315 4.40381 3.81802 4.11091 4.11091C3.81802 4.40381 3.34315 4.40381 3.05025 4.11091L2.34315 3.40381C2.05025 3.11091 2.05025 2.63604 2.34315 2.34315C2.63604 2.05025 3.11091 2.05025 3.40381 2.34315L4.11091 3.05025Z"
        fill="currentColor"
      />
      <path
        d="M12.9497 4.11091C12.6569 4.40381 12.182 4.40381 11.8891 4.11091C11.5962 3.81802 11.5962 3.34315 11.8891 3.05025L12.5962 2.34315C12.8891 2.05025 13.364 2.05025 13.6569 2.34315C13.9497 2.63604 13.9497 3.11091 13.6569 3.40381L12.9497 4.11091Z"
        fill="currentColor"
      />
      <path
        d="M3.40381 13.6569C3.11091 13.9497 2.63604 13.9497 2.34315 13.6569C2.05025 13.364 2.05025 12.8891 2.34315 12.5962L3.05025 11.8891C3.34315 11.5962 3.81802 11.5962 4.11091 11.8891C4.40381 12.182 4.40381 12.6569 4.11091 12.9497L3.40381 13.6569Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const SunAndMoonIcon = makeIcon({
  displayName: 'SunAndMoonIcon',
  viewBox: 16,
  content: (
    <>
      <path
        d="M8.31372 2.81372C8.72793 2.81372 9.06372 2.47793 9.06372 2.06372V1.06372C9.06372 0.649507 8.72793 0.313721 8.31372 0.313721C7.89951 0.313721 7.56372 0.649507 7.56372 1.06372L7.56372 2.06372C7.56372 2.47793 7.89951 2.81372 8.31372 2.81372Z"
        fill="currentColor"
      />
      <path
        d="M4.42463 3.36397C4.71753 3.65687 4.71753 4.13174 4.42463 4.42463C4.13174 4.71753 3.65687 4.71753 3.36397 4.42463L2.65687 3.71753C2.36397 3.42463 2.36397 2.94976 2.65687 2.65687C2.94976 2.36397 3.42463 2.36397 3.71753 2.65687L4.42463 3.36397Z"
        fill="currentColor"
      />
      <path
        d="M13.4402 4.24786C13.1474 4.54075 12.6725 4.54075 12.3796 4.24786C12.0867 3.95496 12.0867 3.48009 12.3796 3.1872L12.9099 2.65687C13.2028 2.36397 13.6777 2.36397 13.9706 2.65687C14.2635 2.94976 14.2635 3.42463 13.9706 3.71753L13.4402 4.24786Z"
        fill="currentColor"
      />
      <path
        d="M1.06372 9.06372C0.649507 9.06372 0.313721 8.72793 0.313721 8.31372C0.313721 7.89951 0.649507 7.56372 1.06372 7.56372L2.06372 7.56372C2.47793 7.56372 2.81372 7.89951 2.81372 8.31372C2.81372 8.72793 2.47793 9.06372 2.06372 9.06372H1.06372Z"
        fill="currentColor"
      />
      <path
        d="M2.65687 12.9099C2.36397 13.2028 2.36397 13.6777 2.65687 13.9706C2.94976 14.2635 3.42463 14.2635 3.71753 13.9706L4.24786 13.4402C4.54075 13.1474 4.54075 12.6725 4.24786 12.3796C3.95496 12.0867 3.48009 12.0867 3.1872 12.3796L2.65687 12.9099Z"
        fill="currentColor"
      />
      <path
        d="M6.54595 10.0815C6.83885 10.3744 6.83885 10.8493 6.54595 11.1421C6.25306 11.435 5.77819 11.435 5.48529 11.1421C3.9232 9.58005 3.9232 7.04739 5.48529 5.48529C7.04739 3.9232 9.58005 3.9232 11.1421 5.48529C11.435 5.77819 11.435 6.25306 11.1421 6.54595C10.8493 6.83885 10.3744 6.83885 10.0815 6.54595C9.10518 5.56964 7.52226 5.56964 6.54595 6.54595C5.56964 7.52226 5.56964 9.10518 6.54595 10.0815Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1935 8.53658C15.7556 10.0987 15.7556 12.6313 14.1935 14.1934C12.6314 15.7555 10.0988 15.7555 8.53668 14.1934C8.14464 13.8014 7.84999 13.3466 7.65432 12.8606C7.55399 12.6114 7.5946 12.3276 7.76079 12.1165C7.92697 11.9054 8.19334 11.7994 8.45912 11.8384C9.36036 11.9709 10.3072 11.6904 10.9988 10.9987C11.6905 10.3071 11.971 9.36025 11.8385 8.45901C11.7995 8.19324 11.9055 7.92686 12.1166 7.76068C12.3277 7.5945 12.6115 7.55389 12.8607 7.65421C13.3467 7.84989 13.8015 8.14453 14.1935 8.53658ZM13.1329 13.1328C14.0554 12.2103 14.1062 10.7463 13.2855 9.76406C13.1197 10.6047 12.7112 11.4077 12.0595 12.0594C11.4078 12.7111 10.6048 13.1196 9.76416 13.2854C10.7464 14.1061 12.2104 14.0553 13.1329 13.1328Z"
        fill="currentColor"
      />
    </>
  ),
})

export const AskIcon = makeIcon({
  displayName: 'AskIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M11.9404 4.28638C12.4001 3.61405 13.0878 3.04457 14.0415 3.22583C14.5174 3.31634 14.8969 3.5376 15.1608 3.86841C15.4157 4.18806 15.5189 4.5553 15.5539 4.87134C15.6136 5.41219 15.4841 5.93274 15.3922 6.19946C15.3913 6.20377 15.3913 6.20894 15.3902 6.21411C15.3842 6.24265 15.3747 6.28404 15.3631 6.33716C15.3399 6.4439 15.306 6.59823 15.2624 6.78735C15.1754 7.16521 15.0505 7.68686 14.8964 8.26099C14.5944 9.38643 14.1621 10.7946 13.6706 11.6946C13.6577 11.7183 13.6427 11.7409 13.6271 11.7629C13.2869 12.2437 13.0659 12.926 12.9193 13.5706C12.8479 13.8842 12.7977 14.1709 12.7586 14.4006C12.7397 14.5114 12.7216 14.6198 12.7053 14.7043C12.6971 14.7468 12.6872 14.7933 12.6763 14.8372C12.6683 14.8689 12.6487 14.9483 12.6094 15.0295C12.4414 15.377 12.0254 15.5213 11.6809 15.3518C11.3367 15.1823 11.1937 14.7636 11.3614 14.4163C11.3435 14.4533 11.3336 14.4833 11.3304 14.4944C11.3321 14.4875 11.3367 14.4702 11.343 14.4377C11.3556 14.3723 11.3699 14.2846 11.3904 14.1643C11.4301 13.9313 11.4852 13.6121 11.5657 13.2581C11.7189 12.5847 11.9804 11.7102 12.4594 11.0071C12.8589 10.27 13.2544 9.02016 13.5564 7.89477C13.705 7.34091 13.8265 6.83602 13.9108 6.46997C13.9527 6.28755 13.9855 6.13997 14.0076 6.03833C14.0186 5.98747 14.0272 5.94747 14.0328 5.92114C14.0355 5.90817 14.0372 5.8983 14.0386 5.89185C14.0392 5.8888 14.0402 5.88653 14.0405 5.88501V5.88306L14.0773 5.76196C14.1122 5.67522 14.2078 5.33184 14.1741 5.02661C14.1585 4.88548 14.1203 4.79803 14.0792 4.74634C14.047 4.70595 13.9755 4.63822 13.7839 4.60181C13.5998 4.56688 13.2965 4.64379 12.9057 5.37524C12.5395 6.06085 12.254 7.0629 12.0556 8.13208C11.9946 8.4607 11.7122 8.70006 11.3807 8.70337C11.0493 8.70665 10.7616 8.47312 10.6943 8.14575C10.6196 7.78249 10.5883 7.03241 10.5713 6.21411C10.5536 5.36246 10.551 4.34387 10.551 3.38599C10.551 2.50627 10.3768 2.07492 10.2402 1.88208C10.1206 1.71341 10.0142 1.70048 9.96905 1.70044C9.90086 1.70044 9.70343 1.7578 9.47331 2.16528C9.25793 2.54671 9.10505 3.09545 9.07827 3.67212C9.0404 4.48951 9.0048 5.13188 8.99597 5.64282C8.98686 6.17084 9.01045 6.46448 9.0531 6.61743C9.14939 6.96234 8.97165 7.32469 8.64159 7.45727C8.31156 7.58978 7.93533 7.45026 7.77018 7.13306C7.66246 6.92617 7.59241 6.62934 7.53877 6.38989C7.48418 6.1462 7.40723 5.76522 7.33931 5.45532C7.18759 4.76312 6.99517 4.01907 6.70511 3.41821C6.50721 3.00834 6.24266 2.68825 5.99636 2.51099C5.74635 2.33108 5.62194 2.36149 5.58195 2.37915C5.45301 2.43675 5.40171 2.5011 5.37088 2.56372C5.33184 2.64314 5.29973 2.77617 5.30504 2.99341C5.31638 3.45367 5.47688 4.02385 5.66329 4.70923C5.80231 5.22038 6.03022 6.03674 6.20744 6.80981C6.29605 7.1964 6.37523 7.58464 6.42432 7.92798C6.47012 8.2483 6.50277 8.60902 6.45337 8.89966C6.41528 9.12304 6.27256 9.31427 6.06995 9.41235C5.86715 9.51047 5.62953 9.50287 5.43284 9.39282C5.22148 9.2746 4.5536 8.9836 3.80136 8.78052C3.42985 8.68023 3.05995 8.6075 2.73145 8.58423C2.39234 8.56024 2.15637 8.59358 2.01592 8.65161C1.8434 8.72297 1.77497 8.79956 1.74482 8.84595C1.71293 8.89508 1.6901 8.96288 1.68866 9.06372C1.68657 9.21685 1.73644 9.39404 1.80485 9.552C2.27336 9.69261 2.90467 9.89802 3.54478 10.1399C4.31485 10.4309 5.15185 10.7935 5.72816 11.176C6.51176 11.6962 6.73142 12.5898 6.76417 13.301C6.79774 14.0308 6.64822 14.7582 6.49984 15.217C6.38097 15.5846 5.98896 15.7852 5.62456 15.6653C5.26044 15.5453 5.06148 15.1508 5.18013 14.7834C5.29013 14.4434 5.40158 13.8879 5.37765 13.3665C5.35281 12.8264 5.19631 12.4995 4.96518 12.3459C4.52668 12.0548 3.81333 11.7369 3.05775 11.4514C2.31512 11.1708 1.58279 10.9405 1.1416 10.8157C0.97774 10.7693 0.836384 10.6634 0.744624 10.5188C0.536415 10.1907 0.291743 9.63804 0.300201 9.04321C0.304633 8.73281 0.379456 8.39183 0.583896 8.07739C0.790135 7.76034 1.09802 7.51752 1.4892 7.35571C1.91251 7.18072 2.39316 7.15697 2.82828 7.18774C3.27414 7.21929 3.73649 7.31349 4.16058 7.42798C4.44333 7.50432 4.71901 7.59253 4.97293 7.68286C4.93878 7.50685 4.90021 7.3191 4.85577 7.12524C4.68652 6.38693 4.46808 5.60474 4.32518 5.07935C4.15919 4.46906 3.93413 3.70148 3.91755 3.02856C3.90895 2.67946 3.95235 2.2963 4.12669 1.94165C4.30925 1.57036 4.61042 1.28259 5.01941 1.09985C5.6781 0.805624 6.33144 1.03288 6.80194 1.37134C7.21542 1.66888 7.57285 2.10289 7.83989 2.58618C7.93799 2.18477 8.08105 1.80372 8.26785 1.4729C8.59444 0.89455 9.15856 0.300049 9.96905 0.300049C10.4518 0.300123 10.9829 0.522837 11.3691 1.06763C11.7385 1.5888 11.9384 2.35021 11.9385 3.38599C11.9385 3.68372 11.9395 3.98605 11.9404 4.28638Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const AskLargeIcon = makeIcon({
  displayName: 'AskLargeIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.2599 5.56586C15.1821 5.36378 15.0618 5.18074 14.9073 5.02906C14.7527 4.87738 14.5673 4.76058 14.3638 4.68652C14.1183 4.59295 13.8557 4.55299 13.5934 4.5693C13.8195 3.36338 13.8028 2.2412 12.9905 1.68849C12.7509 1.51524 12.4697 1.40847 12.1755 1.37905C11.8814 1.34963 11.5847 1.3986 11.3156 1.52099C11.2586 1.17339 11.1028 0.849542 10.8666 0.58817C10.6305 0.326797 10.3241 0.138948 9.98401 0.0470823C9.73064 -0.0124649 9.46731 -0.0155618 9.2126 0.0379841C8.9579 0.0915299 8.71804 0.20043 8.5101 0.356958C8.28779 0.603268 8.12116 0.89455 8.02145 1.21101C7.92175 1.52748 7.89135 1.8617 7.93231 2.19096C7.93231 2.3752 7.93231 2.55106 7.93231 2.73529C7.93231 2.73529 7.93231 2.81065 7.93231 2.85252C7.88672 2.58998 7.78917 2.33919 7.64536 2.11485C7.50156 1.89052 7.3144 1.69716 7.09487 1.54611C6.87123 1.41016 6.62237 1.32081 6.36333 1.28339C6.1043 1.24597 5.8404 1.26126 5.58743 1.32837C4.21403 1.81409 4.38996 3.16239 4.61607 4.87915C4.79278 6.08554 4.88508 7.30279 4.89239 8.52203C4.44156 8.23399 3.92669 8.06142 3.39334 8.01956C3.07724 7.99889 2.76036 8.04486 2.46317 8.1545C2.16599 8.26414 1.89518 8.43499 1.66826 8.656C1.66826 8.656 1.61794 8.723 1.59281 8.76487C0.864237 9.95404 1.92786 10.7412 2.71506 11.3358L3.29285 11.7127C3.88808 12.094 4.4639 12.5048 5.01803 12.9437C5.39626 13.3149 5.7849 14.0993 5.79385 14.6292C5.80172 15.0951 5.79385 14.0202 5.79679 15.2023C5.78986 15.3572 5.8438 15.5088 5.94707 15.6246C6.05033 15.7403 6.19477 15.8112 6.34953 15.822C6.49802 15.8223 6.64115 15.7664 6.74996 15.6654C6.85876 15.5643 6.9251 15.4257 6.9357 15.2776C6.96856 14.8187 7.0118 14.6292 7.0118 14.6292L6.9357 13.8774C6.63777 13.2127 6.31266 12.6123 5.79679 12.0979C5.19248 11.6033 4.55753 11.1474 3.89578 10.7329L3.36819 10.3812C2.53074 9.73632 2.43863 9.59394 2.53074 9.4432C2.63729 9.35157 2.76114 9.28217 2.89488 9.23902C3.02862 9.19588 3.16961 9.17988 3.30961 9.19197C3.63853 9.23402 3.95589 9.34077 4.24335 9.50607C4.53081 9.67136 4.78269 9.89191 4.9845 10.155C5.05783 10.2488 5.15835 10.3176 5.27227 10.3521C5.38618 10.3865 5.50795 10.385 5.62096 10.3476C5.73214 10.3111 5.82983 10.2421 5.90147 10.1496C5.97311 10.0571 6.01539 9.94522 6.02292 9.82844C6.11755 8.1246 6.03613 6.41555 5.78003 4.72841C5.56229 3.05353 5.56233 2.58456 5.92243 2.45057C6.10813 2.41631 6.29997 2.4458 6.46679 2.53429C6.56558 2.61396 6.64695 2.71304 6.706 2.82538C6.76505 2.93772 6.80056 3.06094 6.81017 3.18749C6.81017 3.18749 7.08651 5.55748 7.321 7.47522C7.321 7.47522 7.321 7.52547 7.321 7.55059C7.321 7.55059 7.321 7.60922 7.321 7.63434C7.35743 7.73858 7.42208 7.83059 7.50787 7.90011C7.59366 7.96962 7.69715 8.01388 7.80668 8.02791H8.06633L8.1752 7.98605C8.19649 7.96202 8.22201 7.94214 8.25055 7.92743C8.27973 7.90672 8.30518 7.88124 8.32589 7.85206C8.33171 7.83295 8.33171 7.81254 8.32589 7.79343C8.35614 7.75944 8.37893 7.71952 8.39285 7.6762C8.39766 7.63727 8.39766 7.59788 8.39285 7.55895C8.39758 7.52281 8.39758 7.48624 8.39285 7.4501C8.69872 5.9337 8.8947 4.39716 8.97912 2.85252C8.97912 2.65154 8.97912 2.43382 8.97912 2.21608C8.97912 1.85598 8.97907 1.37862 9.13818 1.253C9.28405 1.17347 9.4548 1.15252 9.61558 1.1944C10.2855 1.37864 10.185 2.86927 10.1096 3.81558L9.61558 7.29099C9.61143 7.32716 9.61143 7.36366 9.61558 7.39983C9.62245 7.54451 9.68266 7.68153 9.78456 7.78446C9.88647 7.88739 10.0228 7.94898 10.1674 7.9573C10.312 7.96562 10.4546 7.9201 10.5676 7.82954C10.6807 7.73898 10.7562 7.60978 10.7796 7.46684L11.2737 4.20918V3.89933C11.2737 3.55597 11.3239 3.16239 11.3239 2.76042C11.5835 2.59293 11.9269 2.4673 12.1613 2.64316C12.3958 2.81902 12.6136 3.31312 12.0525 5.37323V5.44022L11.3156 8.11166C11.2746 8.26158 11.2947 8.42168 11.3716 8.55673C11.4486 8.69179 11.576 8.79077 11.726 8.83188C11.7787 8.84005 11.8323 8.84005 11.885 8.83188C11.9908 8.83438 12.095 8.80548 12.1844 8.74884C12.2739 8.69221 12.3445 8.61038 12.3875 8.51365C12.3922 8.48031 12.3922 8.44649 12.3875 8.41316L13.091 5.90083C13.1808 5.8333 13.2857 5.7888 13.3966 5.77128C13.5076 5.75376 13.6211 5.76375 13.7274 5.80034C13.9367 5.87571 13.9619 5.95944 13.9702 5.99293C14.1126 6.36141 13.6018 7.29934 13.2333 7.97767C12.5671 8.98246 12.2386 10.1735 12.2954 11.3777C12.3237 11.8823 12.2259 12.386 12.0107 12.8432C11.8115 13.173 11.5463 13.4581 11.2318 13.6807C11.1625 13.7361 11.1064 13.8061 11.0673 13.8857C11.0282 13.9653 11.0072 14.0526 11.0057 14.1413L10.855 15.2525C10.857 15.4067 10.918 15.5543 11.0255 15.6649C11.133 15.7755 11.2788 15.8407 11.4329 15.8471C11.5861 15.8471 11.733 15.7862 11.8414 15.6778C11.9497 15.5695 12.0107 15.4225 12.0107 15.2693L12.1613 14.426C12.5987 14.0667 12.9435 13.6076 13.1664 13.0873C13.3894 12.5671 13.4841 12.0008 13.4427 11.4363C13.4625 10.8729 13.5325 10.3124 13.652 9.76143C13.8232 9.35482 14.022 8.96031 14.2467 8.58063C15.0004 7.49195 15.5782 6.4368 15.2599 5.56586Z"
        fill="currentColor"
      />
      <path
        d="M7.55547 9.99591H7.47175C7.31756 9.97163 7.16 10.009 7.03309 10.0998C6.90618 10.1907 6.82015 10.3278 6.79347 10.4816C6.78036 10.5576 6.78256 10.6355 6.80001 10.7106C6.81746 10.7857 6.84982 10.8566 6.89508 10.919C6.94035 10.9815 6.99758 11.0342 7.06355 11.0741C7.12952 11.1141 7.20285 11.1404 7.27915 11.1516H7.40479C7.60551 11.1916 7.79799 11.2652 7.97419 11.3693C8.32793 11.5814 8.5838 11.9245 8.6861 12.324C8.77293 12.6318 8.81515 12.9505 8.81163 13.2703C8.81163 13.4258 8.87344 13.5749 8.98338 13.6848C9.09331 13.7948 9.24243 13.8565 9.39791 13.8565C9.55338 13.8565 9.7025 13.7948 9.81244 13.6848C9.92237 13.5749 9.98408 13.4258 9.98408 13.2703C10.0008 11.4698 9.13824 10.2974 7.55547 9.99591Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const MagicPenIcon = makeIcon({
  displayName: 'MagicPenIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0703 1.73098C11.3637 1.43696 11.8402 1.43739 12.1331 1.73194L13.5398 3.14671C13.8317 3.44031 13.8305 3.91491 13.5371 4.20702L12.9314 4.81004L10.462 2.34064L11.0703 1.73098ZM11.6035 6.13205L11.8684 5.86836L9.40243 3.40243L1.58456 11.2369C1.53779 11.2838 1.51153 11.3473 1.51153 11.4135L1.51148 13.75L3.84861 13.7499C3.91472 13.7499 3.97814 13.7237 4.02499 13.6771L5.47084 12.2376C5.76438 11.9454 6.23925 11.9464 6.5315 12.24C6.82374 12.5335 6.82269 13.0084 6.52915 13.3006L5.0833 14.7401C4.75535 15.0666 4.31141 15.2499 3.84864 15.2499L0.961491 15.25C0.436808 15.25 0.0114655 14.8247 0.0114746 14.3L0.0115251 11.4135C0.0115331 10.95 0.195397 10.5055 0.522774 10.1774L10.0085 0.671443C10.8887 -0.210616 12.3182 -0.209324 13.1968 0.674322L14.6035 2.0891C15.4792 2.96988 15.4756 4.3937 14.5954 5.27002L12.6618 7.19506C12.3683 7.4873 11.8934 7.48625 11.6012 7.19271C11.3089 6.89917 11.31 6.4243 11.6035 6.13205ZM2.6289 0.109758C2.65934 -0.0180624 2.84121 -0.0180631 2.87164 0.109757L3.03254 0.785559C3.26027 1.74206 4.02848 2.47565 4.99446 2.65906L5.35446 2.72742C5.48978 2.75311 5.48977 2.94687 5.35446 2.97256L4.99446 3.04092C4.02848 3.22433 3.26027 3.95792 3.03254 4.91442L2.87164 5.59022C2.84121 5.71804 2.65934 5.71804 2.6289 5.59022L2.46802 4.91449C2.24028 3.95795 1.47203 3.22435 0.506006 3.04096L0.145685 2.97256C0.0103606 2.94687 0.0103606 2.75311 0.145685 2.72742L0.506006 2.65902C1.47203 2.47563 2.24028 1.74203 2.46802 0.785494L2.6289 0.109758ZM10.3247 6.73781C10.3688 6.55281 10.632 6.55281 10.6761 6.73781L10.9688 7.96714C11.2984 9.35155 12.4103 10.4133 13.8084 10.6788L14.5657 10.8226C14.7615 10.8598 14.7615 11.1402 14.5657 11.1774L13.8084 11.3212C12.4103 11.5866 11.2984 12.6484 10.9688 14.0328L10.6761 15.2622C10.632 15.4472 10.3688 15.4472 10.3247 15.2622L10.0321 14.0329C9.70246 12.6485 8.59051 11.5867 7.19232 11.3212L6.43454 11.1774C6.23867 11.1402 6.23868 10.8598 6.43454 10.8226L7.19233 10.6787C8.59051 10.4133 9.70246 9.35151 10.0321 7.96705L10.3247 6.73781Z"
      fill="currentColor"
    />
  ),
  smallAlternative: MagicPenSmallIcon,
})

export const TextPlaceholderIcon = makeIcon({
  displayName: 'TextPlaceholderIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75.5a.75.75 0 0 0-.75.75v2.527a.75.75 0 0 0 1.5 0V2h2.75v7H5.375a.75.75 0 0 0 0 1.5h5.25a.75.75 0 0 0 0-1.5H8.75V2h2.75v1.777a.75.75 0 0 0 1.5 0V1.25a.75.75 0 0 0-.75-.75h-8.5Zm0 13a.75.75 0 0 0 0 1.5h1.063a.75.75 0 0 0 0-1.5H3.75Zm3.188 0a.75.75 0 0 0 0 1.5h2.125a.75.75 0 0 0 0-1.5H6.937Zm4.25 0a.75.75 0 0 0 0 1.5h1.062a.75.75 0 0 0 0-1.5h-1.063Z"
      fill="currentColor"
    />
  ),
  smallAlternative: TextPlaceholderSmallIcon,
})

export const RequestVerificationIcon = makeIcon({
  displayName: 'RequestVerification',
  viewBox: 16,
  content: (
    <g>
      <path d="M6.808.088C7.198.03 7.595 0 8 0a7.97 7.97 0 0 1 5.864 2.558A7.97 7.97 0 0 1 16 8.151a7.97 7.97 0 0 1-2.557 5.713A7.97 7.97 0 0 1 8 16c-.405 0-.803-.03-1.192-.088a.75.75 0 1 1 .222-1.484 6.55 6.55 0 0 0 1.093.07 6.475 6.475 0 0 0 4.642-2.077 6.475 6.475 0 0 0 1.734-4.544 6.475 6.475 0 0 0-2.078-4.642A6.476 6.476 0 0 0 8 1.5c-.33 0-.654.025-.97.072A.75.75 0 0 1 6.808.088ZM4.298 1.72a.75.75 0 0 1-.158 1.05 6.542 6.542 0 0 0-1.37 1.37.75.75 0 0 1-1.207-.891A8.042 8.042 0 0 1 3.25 1.563a.75.75 0 0 1 1.049.157ZM1.572 7.03a.75.75 0 0 0-1.484-.222 8.058 8.058 0 0 0 0 2.384.75.75 0 0 0 1.484-.222 6.557 6.557 0 0 1 0-1.94ZM1.72 11.702a.75.75 0 0 1 1.05.158c.385.522.848.985 1.37 1.37a.75.75 0 1 1-.891 1.207 8.042 8.042 0 0 1-1.686-1.686.75.75 0 0 1 .157-1.049Z" />
      <path d="M12.5 7a.75.75 0 1 0-1.06-1.06l-3.94 4-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0L12.5 7Z" />
    </g>
  ),
  smallAlternative: RequestVerificationSmallIcon,
})

export const RemoveTemplateIcon = makeIcon({
  displayName: 'RemoveTemplateIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.496152 2C0.496153 1.0335 1.27965 0.250001 2.24615 0.25L5.74615 0.25C6.71265 0.25 7.49615 1.0335 7.49615 2L7.49615 5.5C7.49615 6.4665 6.71265 7.25 5.74615 7.25H2.24615C1.27965 7.25 0.496152 6.4665 0.496152 5.5L0.496152 2ZM2.24615 1.75C2.10808 1.75 1.99615 1.86193 1.99615 2L1.99615 5.5C1.99615 5.63807 2.10808 5.75 2.24615 5.75H5.74615C5.88422 5.75 5.99615 5.63807 5.99615 5.5V2C5.99615 1.86193 5.88422 1.75 5.74615 1.75L2.24615 1.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75872 8.67689C3.44213 7.99347 4.55017 7.99347 5.23359 8.67689L7.31983 10.7631C8.00325 11.4465 8.00324 12.5546 7.31983 13.238L5.23359 15.3242C4.55017 16.0077 3.44213 16.0077 2.75871 15.3242L0.672475 13.238C-0.0109436 12.5546 -0.0109409 11.4465 0.672476 10.7631L2.75872 8.67689ZM4.17293 9.73755C4.0753 9.63992 3.91701 9.63992 3.81938 9.73755L1.73314 11.8238C1.6355 11.9214 1.6355 12.0797 1.73314 12.1773L3.81938 14.2636C3.91701 14.3612 4.0753 14.3612 4.17293 14.2636L6.25917 12.1773C6.3568 12.0797 6.3568 11.9214 6.25917 11.8238L4.17293 9.73755Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2462 8.5C10.3132 8.5 8.74615 10.067 8.74615 12C8.74615 13.933 10.3132 15.5 12.2462 15.5C14.1791 15.5 15.7462 13.933 15.7462 12C15.7462 10.067 14.1791 8.5 12.2462 8.5ZM10.2462 12C10.2462 10.8954 11.1416 10 12.2462 10C13.3507 10 14.2462 10.8954 14.2462 12C14.2462 13.1046 13.3507 14 12.2462 14C11.1416 14 10.2462 13.1046 10.2462 12Z"
      />
      <path d="M9.77138 6.22445C9.45595 5.90902 9.45595 5.39762 9.77138 5.0822L11.1038 3.74976L9.77134 2.41728C9.45591 2.10185 9.45591 1.59045 9.77134 1.27503C10.0868 0.959604 10.5982 0.959603 10.9136 1.27503L12.2461 2.60751L13.5789 1.2747C13.8943 0.959275 14.4057 0.959275 14.7211 1.2747C15.0365 1.59012 15.0365 2.10152 14.7211 2.41695L13.3883 3.74976L14.7211 5.08252C15.0365 5.39795 15.0365 5.90935 14.7211 6.22477C14.4057 6.5402 13.8943 6.5402 13.5788 6.22477L12.2461 4.89201L10.9136 6.22445C10.5982 6.53987 10.0868 6.53987 9.77138 6.22445Z" />
    </g>
  ),
})

export const CommentResolveIcon = makeIcon({
  displayName: 'CommentResolveIcon',
  content: (
    <g>
      <path d="M11.0303 6.03033C11.3232 5.73744 11.3232 5.26256 11.0303 4.96967C10.7374 4.67678 10.2625 4.67678 9.96965 4.96967L7.08113 7.85819L6.09998 6.55C5.85145 6.21863 5.38135 6.15147 5.04998 6.4C4.71861 6.64853 4.65145 7.11863 4.89998 7.45L6.39998 9.45C6.53043 9.62393 6.72994 9.7327 6.94682 9.74811C7.16369 9.76353 7.37657 9.68407 7.53031 9.53033L11.0303 6.03033Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 0.75C3.52208 0.75 0.5 3.77208 0.5 7.5V14.1014C0.5 15.0813 1.57625 15.6802 2.40895 15.1636L5.47177 13.2636C5.59049 13.1899 5.72743 13.1509 5.86714 13.1509H9.29955C12.724 13.1509 15.5 10.3749 15.5 6.95045C15.5 3.52604 12.724 0.75 9.29955 0.75H7.25ZM2 7.5C2 4.60051 4.35051 2.25 7.25 2.25H9.29955C11.8955 2.25 14 4.35446 14 6.95045C14 9.54644 11.8955 11.6509 9.29955 11.6509H5.86714C5.448 11.6509 5.03719 11.768 4.68103 11.9889L2 13.6521V7.5Z"
      />
    </g>
  ),
})

export const CoverBadgeIcon = makeIcon({
  displayName: 'CoverBadgeIcon',
  content: (
    <g>
      <rect
        x="1"
        y="2"
        width="6"
        height="6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M1 12L15 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 15L11 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
})

export const CoverBannerIcon = makeIcon({
  displayName: 'CoverBannerIcon',
  content: (
    <g>
      <rect
        x="1"
        y="2"
        width="14"
        height="6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M1 12L15 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 15L11 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
})

export const IdCodeIcon = makeIcon({
  displayName: 'IdCodeIcon',
  viewBox: 16,
  content: (
    <>
      <path d="M7.432.033a.75.75 0 0 1 .496.938l-2.153 7A.75.75 0 1 1 4.34 7.53l2.154-7a.75.75 0 0 1 .937-.497ZM3.434 2.627a.75.75 0 1 0-1.06-1.061L.22 3.72a.75.75 0 0 0 0 1.06l2.153 2.154a.75.75 0 1 0 1.061-1.06L1.811 4.25l1.623-1.623Zm5.401 0a.75.75 0 1 1 1.06-1.06L12.05 3.72a.75.75 0 0 1 0 1.06L9.896 6.936a.75.75 0 1 1-1.06-1.061l1.623-1.624-1.624-1.623Z" />
      <path d="M12.5 0a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75V9A.75.75 0 0 0 0 9v4.75A2.25 2.25 0 0 0 2.25 16h11.5A2.25 2.25 0 0 0 16 13.75V2.25A2.25 2.25 0 0 0 13.75 0H12.5Z" />
    </>
  ),
  smallAlternative: IdCodeSmallIcon,
})

export const CaretDownIcon = CaretDownSmallIcon // TODO add 16px variant
export const ChannelIcon = ChannelSmallIcon // TODO add 16px variant
export const ChevronDownIcon = ChevronDownSmallIcon // TODO add 16px variant
export const ChevronLeftIcon = ChevronLeftSmallIcon // TODO add 16px variant
export const ChevronRightIcon = ChevronRightSmallIcon // TODO add 16px variant
export const ChevronUpIcon = ChevronUpSmallIcon // TODO add 16px variant

export const CheckmarkIcon = makeIcon({
  displayName: 'CheckmarkIcon',
  viewBox: 16,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4874 2.92139C14.7803 3.19598 14.7803 3.64118 14.4874 3.91576L6.03028 11.8443C5.73739 12.1189 5.26252 12.1189 4.96962 11.8443L1.26252 8.36889C0.969623 8.0943 0.969623 7.64911 1.26252 7.37452C1.55541 7.09993 2.03028 7.09993 2.32318 7.37452L5.49995 10.3527L13.4267 2.92139C13.7196 2.64681 14.1945 2.64681 14.4874 2.92139Z"
      />
    </>
  ),
  smallAlternative: CheckmarkSmallIcon,
})

export const DoubleCheckmarkIcon = makeIcon({
  displayName: 'DoubleCheckmarkIcon',
  viewBox: 16,
  content: (
    <path
      d="M12 4 4.67 11.33 1.33 8M14.67 6.67l-5 5-1-1"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
})

export const EraserIcon = makeIcon({
  displayName: 'EraserIcon',
  viewBox: 16,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9264 1.10651C10.9011 0.0811965 9.23872 0.0811965 8.21341 1.10651L1.13825 8.18167C0.112935 9.20699 0.112935 10.8693 1.13825 11.8947L3.80566 14.5621C4.29803 15.0544 4.96583 15.3311 5.66215 15.3311H5.86934V15.35H15.1693C15.5836 15.35 15.9193 15.0142 15.9193 14.6C15.9193 14.1858 15.5836 13.85 15.1693 13.85H9.39361L15.1753 8.06835C16.2006 7.04304 16.2006 5.38068 15.1753 4.35537L11.9264 1.10651ZM14.1146 5.41603L10.8657 2.16717C10.4262 1.72764 9.7136 1.72764 9.27407 2.16717L4.51875 6.92249L9.35927 11.763L14.1146 7.00769C14.5541 6.56817 14.5541 5.85555 14.1146 5.41603ZM2.19891 9.24233L3.45809 7.98315L8.29861 12.8237L7.62087 13.5014C7.40981 13.7125 7.12354 13.8311 6.82504 13.8311H5.66215C5.36366 13.8311 5.07739 13.7125 4.86632 13.5014L2.19891 10.834C1.75938 10.3945 1.75938 9.68186 2.19891 9.24233Z"
        fill="currentColor"
      />
    </>
  ),
  smallAlternative: EraserSmallIcon,
})

export const PianoIcon = makeIcon({
  displayName: 'PianoIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V1ZM1.5 14.5V1.5L4.09998 1.5V9.5C4.09998 9.77614 4.32383 10 4.59998 10H4.84998V14.5H1.5ZM6.34998 14.5H9.70001V10H9.5C9.22386 10 9 9.77614 9 9.5V1.5L7.09998 1.5V9.5C7.09998 9.77614 6.87612 10 6.59998 10H6.34998V14.5ZM12 1.5V9.5C12 9.77614 11.7761 10 11.5 10H11.2V14.5H14.5V1.5H12Z"
      fill="currentColor"
    />
  ),
  smallAlternative: PianoSmallIcon,
})
export const ScissorsIcon = makeIcon({
  displayName: 'ScissorsIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.955 6.91C4.52342 6.91 5.05436 6.7495 5.50497 6.47136L7.40932 8.24872L5.76229 9.70707C5.26267 9.32028 4.63569 9.09009 3.95496 9.09009C2.32298 9.09009 1 10.4131 1 12.045C1 13.677 2.32298 15 3.95496 15C5.58693 15 6.90991 13.677 6.90991 12.045C6.90991 11.639 6.828 11.252 6.6798 10.8998L8.51442 9.28012L12.5001 13L12.8049 13.265C13.4301 13.8085 14.3775 13.7422 14.921 13.117L9.66429 8.26494L14.9999 3.5543C14.4565 2.92908 13.509 2.86283 12.8838 3.40632L12.579 3.67128L8.55127 7.2376L6.54245 5.38341C6.77667 4.96004 6.91 4.47309 6.91 3.955C6.91 2.323 5.587 1 3.955 1C2.323 1 1 2.323 1 3.955C1 5.587 2.323 6.91 3.955 6.91ZM3.955 5.60633C4.86701 5.60633 5.60633 4.86701 5.60633 3.955C5.60633 3.04299 4.86701 2.30367 3.955 2.30367C3.04299 2.30367 2.30367 3.04299 2.30367 3.955C2.30367 4.86701 3.04299 5.60633 3.955 5.60633ZM5.60626 12.045C5.60626 12.957 4.86695 13.6964 3.95496 13.6964C3.04296 13.6964 2.30365 12.957 2.30365 12.045C2.30365 11.1331 3.04296 10.3937 3.95496 10.3937C4.86695 10.3937 5.60626 11.1331 5.60626 12.045Z"
      fill="currentColor"
    />
  ),
  smallAlternative: ScissorsSmallIcon,
})

export const SortingIcon = SortingSmallIcon // TODO add 16px variant
export const SpellcheckIcon = makeIcon({
  displayName: 'SpellcheckIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 1C0.335786 1 0 1.33579 0 1.75C0 2.16421 0.335786 2.5 0.75 2.5H15.203C15.6172 2.5 15.953 2.16421 15.953 1.75C15.953 1.33579 15.6172 1 15.203 1H0.75ZM0.75 5.75C0.335786 5.75 0 6.08579 0 6.5C0 6.91421 0.335786 7.25 0.75 7.25H11.25C11.6642 7.25 12 6.91421 12 6.5C12 6.08579 11.6642 5.75 11.25 5.75H0.75ZM0.75 10.5C0.335786 10.5 0 10.8358 0 11.25C0 11.6642 0.335786 12 0.75 12H3.75C4.16421 12 4.5 11.6642 4.5 11.25C4.5 10.8358 4.16421 10.5 3.75 10.5H0.75ZM15.8482 8.45236C16.0981 8.12197 16.0328 7.65161 15.7024 7.40178C15.372 7.15195 14.9016 7.21725 14.6518 7.54764L10.5012 13.0365L7.98172 10.9252C7.66424 10.6591 7.1912 10.7008 6.92515 11.0183C6.65911 11.3358 6.7008 11.8088 7.01828 12.0748L9.98099 14.5576C10.3974 14.9065 11.0212 14.8358 11.3489 14.4024L15.8482 8.45236Z"
      fill="currentColor"
    />
  ),
  smallAlternative: SpellcheckSmallIcon,
})

export const StopIcon = makeIcon({
  displayName: 'StopIcon',
  viewBox: 16,
  content: (
    <svg width="16" height="16" fill="none">
      <path
        fill="currentColor"
        d="M6 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
        clipRule="evenodd"
      />
    </svg>
  ),
})

export const CircledCrossFilledIcon = CircledCrossFilledSmallIcon // TODO add 16px variant
export const ClockFilledIcon = ClockFilledSmallIcon // TODO add 16px variant
export const SuccessFilledIcon = SuccessFilledSmallIcon // TODO add 16px variant

export const ApplyFormatIcon = makeIcon({
  displayName: 'ApplyFormatIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0.75C0.585786 0.75 0.25 1.08579 0.25 1.5C0.25 1.91421 0.585786 2.25 1 2.25H15C15.4142 2.25 15.75 1.91421 15.75 1.5C15.75 1.08579 15.4142 0.75 15 0.75H1ZM13.2307 4.89466C13.2931 4.55944 13.133 4.22206 12.8413 4.07407C12.5496 3.92607 12.2 4.00486 11.991 4.26571L7.16803 10.2849C6.99787 10.4973 6.95302 10.7916 7.05151 11.0496C7.15001 11.3075 7.37566 11.4868 7.63778 11.5153L10.3653 11.8116L9.7686 15.1093C9.70801 15.4441 9.86897 15.7799 10.1604 15.9268C10.4519 16.0736 10.8005 15.9946 11.009 15.7343L15.832 9.7151C15.9996 9.50589 16.0458 9.21685 15.9525 8.96116C15.8592 8.70548 15.6412 8.52386 15.3839 8.48744L12.6343 8.09814L13.2307 4.89466ZM11.2813 10.4033L9.12232 10.1687L11.3085 7.4402L11.0943 8.59091C11.0565 8.79384 11.0998 9.00423 11.2139 9.17234C11.328 9.34046 11.5029 9.45137 11.697 9.47887L13.9091 9.79206L11.6723 12.5837L11.9064 11.29C11.9438 11.0836 11.8974 10.8701 11.7785 10.7016C11.6597 10.533 11.4793 10.4248 11.2813 10.4033ZM0.25 5C0.25 4.58579 0.585786 4.25 1 4.25H8C8.41421 4.25 8.75 4.58579 8.75 5C8.75 5.41421 8.41421 5.75 8 5.75H1C0.585786 5.75 0.25 5.41421 0.25 5ZM1 7.75C0.585786 7.75 0.25 8.08579 0.25 8.5C0.25 8.91421 0.585786 9.25 1 9.25H5C5.41421 9.25 5.75 8.91421 5.75 8.5C5.75 8.08579 5.41421 7.75 5 7.75H1Z"
      fill="currentColor"
    />
  ),
  smallAlternative: ApplyFormatSmallIcon,
})

export const DefaultFileIcon = makeIcon({
  displayName: 'DefaultFileIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.74995 0.174951C2.60396 0.174951 1.67495 1.10396 1.67495 2.24995V13.75C1.67495 14.8959 2.60396 15.825 3.74995 15.825H12.25C13.3959 15.825 14.325 14.8959 14.325 13.75V5.37127C14.325 4.82095 14.1063 4.29316 13.7172 3.90403L10.5959 0.782705C10.2067 0.393567 9.67896 0.174951 9.12863 0.174951H3.74995ZM2.82495 2.24995C2.82495 1.73909 3.23909 1.32495 3.74995 1.32495H8.17495V4.99995C8.17495 5.8698 8.8801 6.57495 9.74995 6.57495H13.175V13.75C13.175 14.2608 12.7608 14.675 12.25 14.675H3.74995C3.23909 14.675 2.82495 14.2608 2.82495 13.75V2.24995ZM13.175 5.42495V5.37127C13.175 5.12595 13.0775 4.89067 12.904 4.7172L9.7827 1.59588C9.65627 1.46944 9.49701 1.38339 9.32495 1.34602V4.99995C9.32495 5.23467 9.51523 5.42495 9.74995 5.42495H13.175Z"
    />
  ),
})

export const DOCFileIcon = makeIcon({
  displayName: 'DOCFileIcon',
  content: (
    <g fill="#27549B" transform="translate(2.000000, 1.000000)">
      <path d="M12.1120192,14.1481481 L12.1120192,5.01195289 L8.84575855,1.85185185 L1.88798077,1.85185185 L1.88798077,14.1481481 L12.1120192,14.1481481 Z M12.81875,15.4814815 L1.18125,15.4814815 C0.790933374,15.4814815 0.474519231,15.1830046 0.474519231,14.8148148 L0.474519231,1.18518519 C0.474519231,0.816995352 0.790933374,0.518518519 1.18125,0.518518519 L9.14375,0.518518519 C9.33428842,0.518518519 9.51675443,0.591093431 9.64976933,0.719785094 L13.3247693,4.27534065 C13.4534563,4.39984501 13.5254808,4.566852 13.5254808,4.74074074 L13.5254808,14.8148148 C13.5254808,15.1830046 13.2090666,15.4814815 12.81875,15.4814815 Z" />
      <path d="M9.85048077,4.07407407 L9.85048077,1.18518519 C9.85048077,0.816995352 9.53406663,0.518518519 9.14375,0.518518519 C8.75343337,0.518518519 8.43701923,0.816995352 8.43701923,1.18518519 L8.43701923,4.74074074 C8.43701923,5.10893057 8.75343337,5.40740741 9.14375,5.40740741 L12.81875,5.40740741 C13.2090666,5.40740741 13.5254808,5.10893057 13.5254808,4.74074074 C13.5254808,4.37255091 13.2090666,4.07407407 12.81875,4.07407407 L9.85048077,4.07407407 Z" />
      <g transform="translate(2.476923, 8.000000)">
        <path
          d="M1.32531337,3.51792593 C1.67442184,3.51792593 1.93828452,3.11622645 1.93828452,2.42518519 C1.93828452,1.73466629 1.67439771,1.33303704 1.32531337,1.33303704 L1.22255471,1.33303704 L1.22255471,3.51792593 L1.32531337,3.51792593 Z M0.280247019,3.96237037 L0.280247019,0.888592593 C0.280247019,0.643132704 0.491189781,0.444148148 0.751400865,0.444148148 L1.32531337,0.444148148 C2.31413308,0.444148148 2.88059221,1.30628504 2.88059221,2.42518519 C2.88059221,3.54459498 2.31422941,4.40681481 1.32531337,4.40681481 L0.751400865,4.40681481 C0.491189781,4.40681481 0.280247019,4.20783026 0.280247019,3.96237037 Z"
          id="Stroke-1236"
        />
        <path
          d="M8.62953462,1.53208229 C8.48016383,0.860083085 8.06945521,0.44402963 7.37399587,0.44402963 C6.35300505,0.44402963 6.03921702,1.16353071 6.03921702,2.45943704 C6.03921702,3.75445447 6.35313427,4.47425185 7.37399587,4.47425185 C8.06947769,4.47425185 8.48012478,4.05778146 8.62953462,3.3856066 C8.6829338,3.14537084 8.51976913,2.9097867 8.26509613,2.85941469 C8.01042313,2.80904268 7.76068129,2.96295765 7.70728211,3.2031934 C7.64052643,3.50351827 7.55982613,3.58536296 7.37399587,3.58536296 C7.10238923,3.58536296 6.98152471,3.30822634 6.98152471,2.45943704 C6.98152471,1.60975884 7.10226001,1.33291852 7.37399587,1.33291852 C7.56009902,1.33291852 7.64059011,1.4144571 7.70728211,1.71449549 C7.76068129,1.95473124 8.01042313,2.10864621 8.26509613,2.0582742 C8.51976913,2.00790219 8.6829338,1.77231805 8.62953462,1.53208229 Z"
          id="Stroke-1237"
        />
        <path
          d="M4.88655327,2.4592 C4.88655327,1.60766343 4.76184617,1.33268148 4.45978212,1.33268148 C4.15739398,1.33268148 4.03301096,1.60711179 4.03301096,2.4592 C4.03301096,3.31021153 4.15740962,3.58453333 4.45978212,3.58453333 C4.76183049,3.58453333 4.88655327,3.30966012 4.88655327,2.4592 Z M5.82886096,2.4592 C5.82886096,3.75061584 5.50089004,4.47342222 4.45978212,4.47342222 C3.41819628,4.47342222 3.09070327,3.75124025 3.09070327,2.4592 C3.09070327,1.16601887 3.4180457,0.443792593 4.45978212,0.443792593 C5.50104068,0.443792593 5.82886096,1.16664367 5.82886096,2.4592 Z"
          id="Stroke-1238"
        />
      </g>
    </g>
  ),
})

export const KEYFileIcon = makeIcon({
  displayName: 'KEYFileIcon',
  content: (
    <g fill="#0C89FB" transform="translate(2.000000, 1.000000)">
      <path
        d="M12.1120192,5.01195289 L8.84575855,1.85185185 L1.88798077,1.85185185 L1.88798077,14.1481481 L12.1120192,14.1481481 L12.1120192,5.01195289 Z M12.81875,15.4814815 L1.18125,15.4814815 C0.790933374,15.4814815 0.474519231,15.1830046 0.474519231,14.8148148 L0.474519231,1.18518519 C0.474519231,0.816995352 0.790933374,0.518518519 1.18125,0.518518519 L9.14375,0.518518519 C9.33428842,0.518518519 9.51675443,0.591093431 9.64976933,0.719785094 L13.3247693,4.27534065 C13.4534563,4.39984501 13.5254808,4.566852 13.5254808,4.74074074 L13.5254808,14.8148148 C13.5254808,15.1830046 13.2090666,15.4814815 12.81875,15.4814815 Z"
        id="Stroke-8"
      />
      <path
        d="M9.85048077,1.18518519 C9.85048077,0.816995352 9.53406663,0.518518519 9.14375,0.518518519 C8.75343337,0.518518519 8.43701923,0.816995352 8.43701923,1.18518519 L8.43701923,4.74074074 C8.43701923,5.10893057 8.75343337,5.40740741 9.14375,5.40740741 L12.81875,5.40740741 C13.2090666,5.40740741 13.5254808,5.10893057 13.5254808,4.74074074 C13.5254808,4.37255091 13.2090666,4.07407407 12.81875,4.07407407 L9.85048077,4.07407407 L9.85048077,1.18518519 Z"
        id="Stroke-9"
      />
      <path
        d="M7.20728885,9.35099259 L8.1173225,9.35099259 C8.37753358,9.35099259 8.58847635,9.15200804 8.58847635,8.90654815 C8.58847635,8.66108826 8.37753358,8.4621037 8.1173225,8.4621037 L6.736135,8.4621037 C6.47592392,8.4621037 6.26498115,8.66108826 6.26498115,8.90654815 L6.26498115,11.9803259 C6.26498115,12.2257858 6.47592392,12.4247704 6.736135,12.4247704 L8.1173225,12.4247704 C8.37753358,12.4247704 8.58847635,12.2257858 8.58847635,11.9803259 C8.58847635,11.734866 8.37753358,11.5358815 8.1173225,11.5358815 L7.20728885,11.5358815 L7.20728885,9.35099259 Z"
        id="Stroke-10"
      />
      <path
        d="M6.73619625,10.8030318 L7.74069625,10.8030318 C8.00090733,10.8030318 8.2118501,10.6040472 8.2118501,10.3585873 C8.2118501,10.1131275 8.00090733,9.9141429 7.74069625,9.9141429 L6.73619625,9.9141429 C6.47598517,9.9141429 6.2650424,10.1131275 6.2650424,10.3585873 C6.2650424,10.6040472 6.47598517,10.8030318 6.73619625,10.8030318 Z"
        id="Stroke-11"
      />
      <path
        d="M4.17307692,11.9626667 L4.17307692,8.88888889 C4.17307692,8.643429 3.96213416,8.44444444 3.70192308,8.44444444 C3.44171199,8.44444444 3.23076923,8.643429 3.23076923,8.88888889 L3.23076923,11.9626667 C3.23076923,12.2081266 3.44171199,12.4071111 3.70192308,12.4071111 C3.96213416,12.4071111 4.17307692,12.2081266 4.17307692,11.9626667 Z"
        id="Stroke-12"
      />
      <path
        d="M5.56659973,9.19212917 C5.74413931,9.01267809 5.73384732,8.73143896 5.54361193,8.56396398 C5.35337654,8.396489 5.05523601,8.40619754 4.87769643,8.58564861 L3.35747143,10.1222412 C3.18855898,10.2929723 3.18853197,10.5578976 3.35740961,10.7286593 L4.87763461,12.2658444 C5.0551376,12.4453277 5.35327614,12.4550904 5.54354568,12.2876499 C5.73381521,12.1202094 5.74416454,11.8389722 5.56666155,11.6594889 L4.34632709,10.4255399 L5.56659973,9.19212917 Z"
        id="Stroke-13"
      />
      <path
        d="M10.8094832,11.9791407 L10.8094832,10.3804597 C10.8094832,10.1349998 10.5985404,9.93601528 10.3383294,9.93601528 C10.0781183,9.93601528 9.86717551,10.1349998 9.86717551,10.3804597 L9.86717551,11.9791407 C9.86717551,12.2246006 10.0781183,12.4235852 10.3383294,12.4235852 C10.5985404,12.4235852 10.8094832,12.2246006 10.8094832,11.9791407 Z"
        id="Stroke-14"
      />
      <path
        d="M10.0355019,8.71837395 C9.92550408,8.49592399 9.6451647,8.39970847 9.40934636,8.50347057 C9.17352801,8.60723267 9.07153031,8.8716798 9.18152812,9.09412975 L9.94164062,10.6313149 C10.1108266,10.9734619 10.6266019,10.9733868 10.7956759,10.6311906 L11.5551759,9.09400539 C11.6651008,8.8715234 11.5630166,8.607106 11.3271643,8.50341259 C11.091312,8.39971917 10.8110041,8.49601633 10.7010791,8.71849832 L10.3684554,9.39171005 L10.0355019,8.71837395 Z"
        id="Stroke-15"
      />
    </g>
  ),
})

export const PDFFileIcon = makeIcon({
  displayName: 'PDFFileIcon',
  content: (
    <g fill="#FF655A">
      <path d="M9.12012 0.00390625C9.9448 0.0430671 10.7374 0.374816 11.3398 0.953125L13.9814 3.48926C14.6261 4.10827 15 4.96149 15 5.86426V12.6719C15 14.5667 13.4176 16 11.5957 16H4.4043C2.58236 16 1 14.5667 1 12.6719V3.32812C1 1.43326 2.58236 0 4.4043 0H8.95508L9.12012 0.00390625ZM4.4043 1.5C3.35283 1.5 2.5 2.31848 2.5 3.32812V12.6719C2.5 13.6815 3.35283 14.5 4.4043 14.5H11.5957C12.6472 14.5 13.5 13.6815 13.5 12.6719V5.86426C13.5 5.84139 13.497 5.81867 13.4961 5.7959H10.8848C9.76428 5.7959 8.75 4.90875 8.75 3.68652V1.5H4.4043ZM10.25 3.68652C10.25 4.02307 10.5343 4.2959 10.8848 4.2959H12.6553L10.3008 2.03516C10.2845 2.01949 10.2668 2.00527 10.25 1.99023V3.68652Z" />
      <path d="M3.87293 12V8.45H5.04293C5.28626 8.45 5.50126 8.5 5.68793 8.6C5.87793 8.69667 6.02626 8.83167 6.13293 9.005C6.2396 9.17833 6.29293 9.38 6.29293 9.61C6.29293 9.84 6.2396 10.0417 6.13293 10.215C6.02626 10.385 5.87793 10.52 5.68793 10.62C5.50126 10.7167 5.28626 10.765 5.04293 10.765H4.67793V12H3.87293ZM4.67793 10.05H4.95793C5.12793 10.05 5.2546 10.0133 5.33793 9.94C5.4246 9.86333 5.46793 9.75333 5.46793 9.61C5.46793 9.46333 5.4246 9.35333 5.33793 9.28C5.2546 9.20333 5.12793 9.165 4.95793 9.165H4.67793V10.05ZM6.80598 12V8.45H7.74098C8.08431 8.45 8.37431 8.51833 8.61098 8.655C8.85098 8.79167 9.03431 8.99333 9.16098 9.26C9.28764 9.52333 9.35098 9.845 9.35098 10.225C9.35098 10.605 9.28764 10.9267 9.16098 11.19C9.03431 11.4533 8.85098 11.655 8.61098 11.795C8.37431 11.9317 8.08431 12 7.74098 12H6.80598ZM7.61098 11.285H7.76098C8.01098 11.285 8.20098 11.1967 8.33098 11.02C8.46098 10.8433 8.52598 10.5783 8.52598 10.225C8.52598 9.87167 8.46098 9.60667 8.33098 9.43C8.20098 9.25333 8.01098 9.165 7.76098 9.165H7.61098V11.285ZM9.95902 12V8.45H12.239V9.165H10.234L10.764 8.655V10.28L10.234 9.91H12.149V10.61H10.234L10.764 10.25V12H9.95902Z" />
    </g>
  ),
})

export const XLSIcon = makeIcon({
  displayName: 'XLSIcon',
  content: (
    <g fill="#007339" transform="translate(2.000000, 1.000000)">
      <path
        d="M12.0633333,5.01195289 L8.82817989,1.85185185 L1.93666667,1.85185185 L1.93666667,14.1481481 L12.0633333,14.1481481 L12.0633333,5.01195289 Z M12.7633333,15.4814815 L1.23666667,15.4814815 C0.850067342,15.4814815 0.536666667,15.1830046 0.536666667,14.8148148 L0.536666667,1.18518519 C0.536666667,0.816995352 0.850067342,0.518518519 1.23666667,0.518518519 L9.12333333,0.518518519 C9.3120571,0.518518519 9.49278534,0.591093431 9.62453343,0.719785094 L13.2645334,4.27534065 C13.3919948,4.39984501 13.4633333,4.566852 13.4633333,4.74074074 L13.4633333,14.8148148 C13.4633333,15.1830046 13.1499327,15.4814815 12.7633333,15.4814815 Z"
        id="Stroke-1223"
      />
      <path
        d="M9.82333333,1.18518519 C9.82333333,0.816995352 9.50993266,0.518518519 9.12333333,0.518518519 C8.73673401,0.518518519 8.42333333,0.816995352 8.42333333,1.18518519 L8.42333333,4.74074074 C8.42333333,5.10893057 8.73673401,5.40740741 9.12333333,5.40740741 L12.7633333,5.40740741 C13.1499327,5.40740741 13.4633333,5.10893057 13.4633333,4.74074074 C13.4633333,4.37255091 13.1499327,4.07407407 12.7633333,4.07407407 L9.82333333,4.07407407 L9.82333333,1.18518519 Z"
        id="Stroke-1224"
      />
      <path
        d="M7.17370733,8.88859259 C7.17370733,8.6431327 6.96477355,8.44414815 6.70704067,8.44414815 C6.44930778,8.44414815 6.240374,8.6431327 6.240374,8.88859259 L6.240374,11.9623704 C6.240374,12.2078303 6.44930778,12.4068148 6.70704067,12.4068148 L8.211574,12.4068148 C8.46930688,12.4068148 8.67824067,12.2078303 8.67824067,11.9623704 C8.67824067,11.7169105 8.46930688,11.5179259 8.211574,11.5179259 L7.17370733,11.5179259 L7.17370733,8.88859259 Z"
        id="Stroke-1225"
      />
      <path
        d="M3.09173356,9.07620394 L4.59748023,12.1499817 C4.70644768,12.372424 4.98412462,12.46862 5.21768903,12.3648415 C5.45125344,12.2610629 5.55225923,11.9966087 5.44329177,11.7741664 L3.93754511,8.70038865 C3.82857765,8.47794635 3.55090071,8.38175037 3.3173363,8.48552889 C3.08377189,8.58930742 2.98276611,8.85376165 3.09173356,9.07620394 Z"
        id="Stroke-1226"
      />
      <path
        d="M4.59772289,8.70038865 L3.09197623,11.7741664 C2.98300877,11.9966087 3.08401456,12.2610629 3.31757897,12.3648415 C3.55114338,12.46862 3.82882032,12.372424 3.93778777,12.1499817 L5.44353444,9.07620394 C5.55250189,8.85376165 5.45149611,8.58930742 5.2179317,8.48552889 C4.98436729,8.38175037 4.70669035,8.47794635 4.59772289,8.70038865 Z"
        id="Stroke-1227"
      />
      <path
        d="M8.91873471,11.3196168 C8.95749972,11.958716 9.48163149,12.4744296 10.1368913,12.4744296 C10.8208426,12.4744296 11.3558247,11.914865 11.3558247,11.2436148 C11.3558247,10.7616227 11.1147002,10.4105879 10.7332247,10.2026642 C10.634915,10.1490804 10.5341829,10.108538 10.4282285,10.0758123 C10.3696444,10.0577177 10.243249,10.0252323 10.2693382,10.0325134 C9.90649098,9.92796368 10.0729341,9.97963254 10.005079,9.94269765 C9.89834119,9.88459812 9.85129133,9.81635734 9.85129133,9.67383704 C9.85129133,9.47713718 9.99002846,9.3325037 10.1381047,9.3325037 C10.2784803,9.3325037 10.4120356,9.46391506 10.423268,9.64909831 C10.4381318,9.89414966 10.6587673,10.0813274 10.9160712,10.0671714 C11.1733751,10.0530154 11.3699117,9.84288638 11.355048,9.59783502 C11.3163022,8.95905308 10.7924546,8.44361481 10.1381047,8.44361481 C9.45478402,8.44361481 8.917958,9.00325606 8.917958,9.67383704 C8.917958,10.1557352 9.1597121,10.5063737 9.54195036,10.7144336 C9.6402284,10.7679283 9.74080348,10.8084382 9.84690619,10.8413756 C9.90442647,10.8592316 10.0207257,10.8895399 10.0029876,10.8844298 C10.2902085,10.9646065 10.2023278,10.9374632 10.2696274,10.9741449 C10.3755142,11.0318586 10.4224913,11.1002491 10.4224913,11.2436148 C10.4224913,11.4415684 10.284844,11.5855407 10.1368913,11.5855407 C9.99560394,11.5855407 9.8617662,11.4538526 9.85051463,11.2683535 C9.83565086,11.0233022 9.61501536,10.8361245 9.35771144,10.8502805 C9.10040752,10.8644364 8.90387094,11.0745655 8.91873471,11.3196168 Z"
        id="Stroke-1228"
      />
    </g>
  ),
})

export const ZIPIcon = makeIcon({
  displayName: 'ZIPIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M9.12012 0.00390625C9.9448 0.0430671 10.7374 0.374816 11.3398 0.953125L13.9814 3.48926C14.6261 4.10827 15 4.96149 15 5.86426V12.6719C15 14.5667 13.4176 16 11.5957 16H4.4043C2.58236 16 1 14.5667 1 12.6719V3.32812C1 1.43326 2.58236 0 4.4043 0H8.95508L9.12012 0.00390625ZM4.4043 1.5C3.35283 1.5 2.5 2.31848 2.5 3.32812V12.6719C2.5 13.6815 3.35283 14.5 4.4043 14.5H11.5957C12.6472 14.5 13.5 13.6815 13.5 12.6719V5.86426C13.5 5.84139 13.497 5.81867 13.4961 5.7959H10.8848C9.76428 5.7959 8.75 4.90875 8.75 3.68652V1.5H4.4043ZM10.25 3.68652C10.25 4.02307 10.5343 4.2959 10.8848 4.2959H12.6553L10.3008 2.03516C10.2845 2.01949 10.2668 2.00527 10.25 1.99023V3.68652Z"
        fill="currentColor"
      />
      <path
        d="M3.71293 12V11.29L5.30293 9.165H3.80293V8.45H6.25293V9.16L4.68793 11.285H6.29293V12H3.71293ZM6.86098 12V11.285H7.59598V9.165H6.86098V8.45H9.14098V9.165H8.40598V11.285H9.14098V12H6.86098ZM9.86902 12V8.45H11.039C11.2824 8.45 11.4974 8.5 11.684 8.6C11.874 8.69667 12.0224 8.83167 12.129 9.005C12.2357 9.17833 12.289 9.38 12.289 9.61C12.289 9.84 12.2357 10.0417 12.129 10.215C12.0224 10.385 11.874 10.52 11.684 10.62C11.4974 10.7167 11.2824 10.765 11.039 10.765H10.674V12H9.86902ZM10.674 10.05H10.954C11.124 10.05 11.2507 10.0133 11.334 9.94C11.4207 9.86333 11.464 9.75333 11.464 9.61C11.464 9.46333 11.4207 9.35333 11.334 9.28C11.2507 9.20333 11.124 9.165 10.954 9.165H10.674V10.05Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const PPTFileIcon = makeIcon({
  displayName: 'PPTFileIcon',
  content: (
    <g fill="#D2461C" transform="translate(2.000000, 1.000000)">
      <path
        d="M9.4444444,9.31230758 L11.5182222,9.31230758 C11.7636821,9.31230758 11.9626666,9.10136482 11.9626666,8.84115374 C11.9626666,8.58094265 11.7636821,8.36999989 11.5182222,8.36999989 L9.4444444,8.36999989 C9.1989845,8.36999989 9,8.58094265 9,8.84115374 C9,9.10136482 9.1989845,9.31230758 9.4444444,9.31230758 Z"
        id="Stroke-38"
      />
      <path
        d="M10.9423077,11.8882221 L10.9423077,8.81444433 C10.9423077,8.56898444 10.7313649,8.36999989 10.4711539,8.36999989 C10.2109428,8.36999989 10,8.56898444 10,8.81444433 L10,11.8882221 C10,12.133682 10.2109428,12.3326665 10.4711539,12.3326665 C10.7313649,12.3326665 10.9423077,12.133682 10.9423077,11.8882221 Z"
        id="Stroke-38"
      />
      <path
        d="M7.08230804,11.8882221 C7.08230804,12.133682 6.87136527,12.3326665 6.61115419,12.3326665 C6.35094311,12.3326665 6.14000034,12.133682 6.14000034,11.8882221 L6.14000034,8.81444433 C6.14000034,8.56898444 6.35094311,8.36999989 6.61115419,8.36999989 L7.37126669,8.36999989 C8.23576354,8.36999989 8.60130804,8.83682587 8.60130804,9.58244433 C8.60130804,10.3289517 8.23599554,10.7954813 7.37126669,10.7954813 L7.08230804,10.7954813 L7.08230804,11.8882221 Z M7.37126669,9.90659248 C7.64309074,9.90659248 7.65900034,9.88627485 7.65900034,9.58244433 C7.65900034,9.2795027 7.64285874,9.25888878 7.37126669,9.25888878 L7.08230804,9.25888878 L7.08230804,9.90659248 L7.37126669,9.90659248 Z"
        id="Stroke-39"
      />
      <path
        d="M4.14230751,11.8888889 C4.14230751,12.1343488 3.93136474,12.3333333 3.67115366,12.3333333 C3.41094258,12.3333333 3.19999981,12.1343488 3.19999981,11.8888889 L3.19999981,8.81511111 C3.19999981,8.56965122 3.41094258,8.37066667 3.67115366,8.37066667 L4.43126616,8.37066667 C5.29576301,8.37066667 5.66130751,8.83749265 5.66130751,9.58311111 C5.66130751,10.3296185 5.29599501,10.7961481 4.43126616,10.7961481 L4.14230751,10.7961481 L4.14230751,11.8888889 Z M4.43126616,9.90725926 C4.70309021,9.90725926 4.71899981,9.88694163 4.71899981,9.58311111 C4.71899981,9.28016948 4.70285821,9.25955556 4.43126616,9.25955556 L4.14230751,9.25955556 L4.14230751,9.90725926 L4.43126616,9.90725926 Z"
        id="Stroke-39"
      />
      <path
        d="M12.1121417,14.1851852 L12.1121417,5.04898993 L8.84588105,1.88888889 L1.88810327,1.88888889 L1.88810327,14.1851852 L12.1121417,14.1851852 Z M12.8188725,15.5185185 L1.1813725,15.5185185 C0.791055874,15.5185185 0.474641731,15.2200417 0.474641731,14.8518519 L0.474641731,1.22222222 C0.474641731,0.854032389 0.791055874,0.555555556 1.1813725,0.555555556 L9.1438725,0.555555556 C9.33441092,0.555555556 9.51687693,0.628130468 9.64989183,0.756822131 L13.3248918,4.31237769 C13.4535788,4.43688205 13.5256033,4.60388904 13.5256033,4.77777778 L13.5256033,14.8518519 C13.5256033,15.2200417 13.2091891,15.5185185 12.8188725,15.5185185 Z"
        id="Stroke-41"
      />
      <path
        d="M9.85060327,4.11111111 L9.85060327,1.22222222 C9.85060327,0.854032389 9.53418913,0.555555556 9.1438725,0.555555556 C8.75355587,0.555555556 8.43714173,0.854032389 8.43714173,1.22222222 L8.43714173,4.77777778 C8.43714173,5.14596761 8.75355587,5.44444444 9.1438725,5.44444444 L12.8188725,5.44444444 C13.2091891,5.44444444 13.5256033,5.14596761 13.5256033,4.77777778 C13.5256033,4.40958794 13.2091891,4.11111111 12.8188725,4.11111111 L9.85060327,4.11111111 Z"
        id="Stroke-42"
      />
    </g>
  ),
})

export const AudioIcon = makeIcon({
  displayName: 'AudioIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.75C6.34932 1.75 4.76183 2.42427 3.588 3.63164C2.41347 4.83973 1.75 6.48264 1.75 8.2V9.25H3.33333C3.92517 9.25 4.50427 9.46532 4.94058 9.86602C5.37904 10.2687 5.63889 10.8292 5.63889 11.4286V13.5714C5.63889 14.1708 5.37904 14.7313 4.94058 15.134C4.50427 15.5347 3.92517 15.75 3.33333 15.75H2.55556C1.96372 15.75 1.38462 15.5347 0.948308 15.134C0.509852 14.7313 0.25 14.1708 0.25 13.5714V8.2C0.25 6.09824 1.06153 4.07845 2.51251 2.58602C3.96418 1.09287 5.93765 0.25 8 0.25C10.0624 0.25 12.0358 1.09287 13.4875 2.58602C14.9385 4.07845 15.75 6.09824 15.75 8.2V13.5714C15.75 14.1708 15.4901 14.7313 15.0517 15.134C14.6154 15.5347 14.0363 15.75 13.4444 15.75H12.6667C12.0748 15.75 11.4957 15.5347 11.0594 15.134C10.621 14.7313 10.3611 14.1708 10.3611 13.5714V11.4286C10.3611 10.8292 10.621 10.2687 11.0594 9.86602C11.4957 9.46532 12.0748 9.25 12.6667 9.25H14.25V8.2C14.25 6.48264 13.5865 4.83973 12.412 3.63164C11.2382 2.42427 9.65068 1.75 8 1.75ZM14.25 10.75H12.6667C12.4334 10.75 12.2212 10.8357 12.074 10.9708C11.929 11.104 11.8611 11.2702 11.8611 11.4286V13.5714C11.8611 13.7298 11.929 13.896 12.074 14.0292C12.2212 14.1643 12.4334 14.25 12.6667 14.25H13.4444C13.6777 14.25 13.89 14.1643 14.0371 14.0292C14.1821 13.896 14.25 13.7298 14.25 13.5714V10.75ZM1.75 13.5714C1.75 13.7298 1.81793 13.896 1.96292 14.0292C2.11005 14.1643 2.32227 14.25 2.55556 14.25H3.33333C3.56662 14.25 3.77884 14.1643 3.92597 14.0292C4.07096 13.896 4.13889 13.7298 4.13889 13.5714V11.4286C4.13889 11.2702 4.07096 11.104 3.92597 10.9708C3.77884 10.8357 3.56662 10.75 3.33333 10.75H1.75V13.5714Z"
      fill="currentColor"
    />
  ),
  smallAlternative: AudioSmallIcon,
})

export const ForbiddenSquareIcon = makeIcon({
  displayName: 'ForbiddenSquareIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.06047 15.4992C2.63495 15.8183 3.29625 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4C1.79086 0 0 1.79086 0 4V12C0 13.4622 0.784609 14.7412 1.95579 15.4389L2.0402 15.5202L2.06047 15.4992ZM4 1.5H12C12.4252 1.5 12.8256 1.60615 13.1762 1.79341L1.95816 13.4429C1.66959 13.0353 1.5 12.5374 1.5 12V4C1.5 2.61929 2.61929 1.5 4 1.5ZM3.1614 14.3559L14.2276 2.86404C14.4018 3.20488 14.5 3.59097 14.5 4V12C14.5 13.3807 13.3807 14.5 12 14.5H4C3.70583 14.5 3.42353 14.4492 3.1614 14.3559Z"
      fill="currentColor"
    />
  ),
})

export const RescueBeltIcon = makeIcon({
  displayName: 'RescueBeltIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.261627C3.58172 0.261627 0 3.84335 0 8.26163C0 12.6799 3.58172 16.2616 8 16.2616C12.4183 16.2616 16 12.6799 16 8.26163C16 3.84335 12.4183 0.261627 8 0.261627ZM1.5 8.26163C1.5 6.72143 2.03569 5.30635 2.93092 4.19254L4.53643 5.79808C4.04126 6.49301 3.75 7.34331 3.75 8.26163C3.75 9.14873 4.02179 9.97236 4.48665 10.6538L2.87731 12.2631C2.01435 11.1599 1.5 9.77083 1.5 8.26163ZM3.93098 13.3308C5.04478 14.226 6.45983 14.7616 8 14.7616C9.54018 14.7616 10.9553 14.2259 12.0691 13.3307L10.4696 11.7312L10.5071 11.6938C9.80426 12.208 8.93759 12.5116 8 12.5116C7.0817 12.5116 6.23143 12.2204 5.53651 11.7252L3.93098 13.3308ZM13.1227 12.2631C13.9857 11.1599 14.5 9.77081 14.5 8.26163C14.5 6.72144 13.9643 5.30636 13.0691 4.19255L11.4636 5.79806C11.9587 6.493 12.25 7.3433 12.25 8.26163C12.25 9.19927 11.9464 10.066 11.432 10.7688L11.5303 10.6706L13.1227 12.2631ZM8 1.76163C9.50918 1.76163 10.8982 2.27596 12.0014 3.1389L10.3921 4.74822C9.71067 4.2834 8.88707 4.01163 8 4.01163C7.11292 4.01163 6.28931 4.28341 5.60791 4.74824L3.99859 3.13889C5.10178 2.27596 6.49083 1.76163 8 1.76163ZM5.25 8.26163C5.25 6.74284 6.48122 5.51163 8 5.51163C9.51878 5.51163 10.75 6.74284 10.75 8.26163C10.75 9.78041 9.51878 11.0116 8 11.0116C6.48122 11.0116 5.25 9.78041 5.25 8.26163Z"
      fill="currentColor"
    />
  ),
})

export const AudioRecorderIcon = makeIcon({
  displayName: 'AudioRecorderIcon',
  content: (
    <>
      <path
        d="M4.25 3.75C4.25 1.67893 5.92893 0 8 0C10.0711 0 11.75 1.67893 11.75 3.75V7.25C11.75 9.32107 10.0711 11 8 11C5.92893 11 4.25 9.32107 4.25 7.25V3.75ZM8 1.5C6.75736 1.5 5.75 2.50736 5.75 3.75V7.25C5.75 8.49264 6.75736 9.5 8 9.5C9.24264 9.5 10.25 8.49264 10.25 7.25V3.75C10.25 2.50736 9.24264 1.5 8 1.5Z"
        fill="currentColor"
      />
      <path
        d="M5 15.25C5 14.8358 5.33579 14.5 5.75 14.5H10.25C10.6642 14.5 11 14.8358 11 15.25C11 15.6642 10.6642 16 10.25 16H5.75C5.33579 16 5 15.6642 5 15.25Z"
        fill="currentColor"
      />
      <path
        d="M3.25 7C3.25 6.58579 2.91421 6.25 2.5 6.25C2.08579 6.25 1.75 6.58579 1.75 7V7.5C1.75 10.9518 4.54822 13.75 8 13.75C11.4518 13.75 14.25 10.9518 14.25 7.5V7C14.25 6.58579 13.9142 6.25 13.5 6.25C13.0858 6.25 12.75 6.58579 12.75 7V7.5C12.75 10.1234 10.6234 12.25 8 12.25C5.37665 12.25 3.25 10.1234 3.25 7.5V7Z"
        fill="currentColor"
      />
    </>
  ),
})

export const AnimatedThreeDotsIcon = makeIcon({
  displayName: 'AnimatedThreeDotsIcon',
  viewBox: 24,
  content: (
    <>
      <circle cx="4" cy="12" r="2.25" fill="currentColor">
        <animate
          id="svgSpinners3DotsBounce0"
          attributeName="cy"
          begin="0;svgSpinners3DotsBounce1.end+0.25s"
          calcMode="spline"
          dur="0.6s"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
          values="12;6;12"
        />
      </circle>
      <circle cx="12" cy="12" r="2.25" fill="currentColor">
        <animate
          attributeName="cy"
          begin="svgSpinners3DotsBounce0.begin+0.1s"
          calcMode="spline"
          dur="0.6s"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
          values="12;6;12"
        />
      </circle>
      <circle cx="20" cy="12" r="2.25" fill="currentColor">
        <animate
          id="svgSpinners3DotsBounce1"
          attributeName="cy"
          begin="svgSpinners3DotsBounce0.begin+0.2s"
          calcMode="spline"
          dur="0.6s"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
          values="12;6;12"
        />
      </circle>
    </>
  ),
})

export const PenInBoxIcon = makeIcon({
  displayName: 'PenInBoxIcon',
  viewBox: 16,
  content: (
    <>
      <path
        d="M6.6875 1C7.04994 1 7.34375 1.29381 7.34375 1.65625C7.34375 2.01869 7.04994 2.3125 6.6875 2.3125H3.84375C2.99806 2.3125 2.3125 2.99806 2.3125 3.84375V12.1562C2.3125 13.0019 2.99806 13.6875 3.84375 13.6875H12.1562C13.0019 13.6875 13.6875 13.0019 13.6875 12.1562V9.44666C13.6876 9.08429 13.9814 8.79041 14.3438 8.79041C14.7061 8.79041 14.9999 9.08429 15 9.44666V12.1562C15 13.7268 13.7268 15 12.1562 15H3.84375C2.27319 15 1 13.7268 1 12.1562V3.84375C1 2.27319 2.27319 1 3.84375 1H6.6875Z"
        fill="#currentColor"
      />
      <path
        d="M11.271 1.70068C12.1221 0.849577 13.5029 0.849579 14.354 1.70068C15.2048 2.55181 15.2042 3.93183 14.3531 4.78284L9.151 9.98499C9.04024 10.0957 8.89354 10.1635 8.73743 10.1755L6.40466 10.3533C6.214 10.3678 6.0264 10.2987 5.89111 10.1636C5.75576 10.0282 5.68602 9.84003 5.70056 9.64917L5.8783 7.31726C5.89024 7.16102 5.95808 7.01367 6.06885 6.90283L11.271 1.70068ZM13.426 2.62866C13.0875 2.29012 12.5375 2.29012 12.199 2.62866L7.16943 7.65906L7.06689 8.98608L8.39478 8.88525L13.4252 3.85486C13.7636 3.51641 13.7643 2.96723 13.426 2.62866Z"
        fill="#currentColor"
      />
      <path
        d="M0.919922 12.1562V3.84375C0.919922 2.22901 2.22901 0.919922 3.84375 0.919922V1C2.27319 1 1 2.27319 1 3.84375V12.1562C1 13.7268 2.27319 15 3.84375 15H12.1562C13.7268 15 15 13.7268 15 12.1562V9.44666C14.9999 9.08429 14.7061 8.79041 14.3438 8.79041C13.9814 8.79041 13.6876 9.08429 13.6875 9.44666V12.1562C13.6875 13.0019 13.0019 13.6875 12.1562 13.6875V13.6074C12.9578 13.6074 13.6074 12.9578 13.6074 12.1562V9.44629C13.6077 9.03994 13.9373 8.70996 14.3438 8.70996C14.7502 8.70996 15.0798 9.03994 15.0801 9.44629V12.1562C15.0801 13.771 13.771 15.0801 12.1562 15.0801H3.84375C2.22901 15.0801 0.919922 13.771 0.919922 12.1562ZM12.1562 13.6074V13.6875H3.84375V13.6074H12.1562ZM2.3125 12.1562V3.84375C2.3125 2.99806 2.99806 2.3125 3.84375 2.3125H6.6875C7.04994 2.3125 7.34375 2.01869 7.34375 1.65625C7.34375 1.29381 7.04994 1 6.6875 1V0.919922C7.09412 0.919922 7.42383 1.24963 7.42383 1.65625C7.42383 2.06287 7.09412 2.39258 6.6875 2.39258H3.84375C3.04225 2.39258 2.39258 3.04225 2.39258 3.84375V12.1562C2.39258 12.9578 3.04225 13.6074 3.84375 13.6074V13.6875C2.99806 13.6875 2.3125 13.0019 2.3125 12.1562ZM11.2148 1.64453C12.0972 0.762183 13.5278 0.762185 14.4102 1.64453C15.2922 2.52693 15.2924 3.95762 14.4102 4.83984L9.20801 10.042C9.08385 10.1661 8.91845 10.2414 8.74316 10.2549L6.41113 10.4326C6.19733 10.4489 5.98682 10.3714 5.83496 10.2197C5.68323 10.068 5.60492 9.85754 5.62109 9.64355L5.79883 7.31152C5.81223 7.13618 5.88846 6.97099 6.0127 6.84668L11.2148 1.64453ZM14.354 1.70068C13.5029 0.849579 12.1221 0.849577 11.271 1.70068L6.06885 6.90283L5.99414 6.99219C5.9277 7.08775 5.88726 7.20001 5.8783 7.31726L5.70056 9.64917L5.69922 9.7207C5.70472 9.88637 5.77273 10.0452 5.89111 10.1636C6.00934 10.2814 6.1679 10.349 6.33301 10.3545L6.40466 10.3533L8.73743 10.1755C8.85453 10.1665 8.96621 10.1259 9.06152 10.0596L9.151 9.98499L14.3531 4.78284C15.1509 3.98507 15.2016 2.72225 14.5039 1.86621L14.354 1.70068ZM12.199 2.62866C12.5375 2.29012 13.0875 2.29012 13.426 2.62866C13.7643 2.96723 13.7636 3.51641 13.4252 3.85486L8.39478 8.88525L7.06689 8.98608L7.16943 7.65906L12.199 2.62866ZM13.3691 2.68555C13.0618 2.37825 12.5632 2.37825 12.2559 2.68555L7.24609 7.69434L7.15332 8.89844L8.3584 8.80762L13.3682 3.79785C13.6754 3.49058 13.6761 2.9928 13.3691 2.68555ZM6.6875 0.919922V1H3.84375V0.919922H6.6875Z"
        fill="#currentColor"
      />
    </>
  ),
})

export const MaintenanceProgramIcon = makeIcon({
  displayName: 'MaintenanceProgramIcon',
  viewBox: 32,
  content: (
    <g fill="none" stroke="currentColor" strokeWidth="3">
      <path
        d="M27.4814 11.9613C29.0746 12.0853 30.1111 12.5139 30.3501 13.2618C30.7372 14.4733 28.9468 16.2581 25.8423 18.0538C23.5634 19.3722 20.5762 20.6965 17.2226 21.8043C13.8688 22.9122 10.6861 23.6261 8.08005 23.9214C4.53076 24.3237 2.05075 23.9498 1.66358 22.7383C1.35326 21.7673 2.44179 20.4281 4.48445 19.0101"
        strokeLinecap="round"
      />
      <path
        d="M7.5 30H24.5C26.1569 30 27.5 28.6569 27.5 27V9.55655C27.5 8.70711 27.1399 7.89749 26.5091 7.32863L21.4562 2.77208C20.905 2.27508 20.1892 2 19.4471 2H7.5C5.84314 2 4.5 3.34315 4.5 5V27C4.5 28.6569 5.84315 30 7.5 30Z"
        strokeLinejoin="round"
      />
      <path d="M20 2V7C20 8.10457 20.8954 9 22 9H27" />
    </g>
  ),
})

export const ChangeRequestIcon = makeIcon({
  displayName: 'ChangeRequestIcon',
  viewBox: 32,
  content: (
    <>
      <g fill="none" stroke="currentColor" strokeWidth="3">
        <path
          d="M7.5 30H24.5C26.1569 30 27.5 28.6569 27.5 27V9.55655C27.5 8.70711 27.1399 7.89749 26.5091 7.32863L21.4562 2.77208C20.905 2.27508 20.1892 2 19.4471 2H7.5C5.84314 2 4.5 3.34315 4.5 5V27C4.5 28.6569 5.84315 30 7.5 30Z"
          strokeLinejoin="round"
        />
        <path d="M20 2V7C20 8.10457 20.8954 9 22 9H27" />
      </g>
      <path d="M19.5 22.25C20.3284 22.25 21 22.9216 21 23.75C21 24.5784 20.3284 25.25 19.5 25.25H12.5C11.6716 25.25 11 24.5784 11 23.75C11 22.9216 11.6716 22.25 12.5 22.25H19.5ZM16 9.5C16.8284 9.5 17.5 10.1716 17.5 11V13H19.5C20.3284 13 21 13.6716 21 14.5C21 15.3284 20.3284 16 19.5 16H17.5V18C17.5 18.8284 16.8284 19.5 16 19.5C15.1716 19.5 14.5 18.8284 14.5 18V16H12.5C11.6716 16 11 15.3284 11 14.5C11 13.6716 11.6716 13 12.5 13H14.5V11C14.5 10.1716 15.1716 9.5 16 9.5Z" />
    </>
  ),
})
